export default {
	getItems() {
		return [this.toPixelStyleData(this.lady(), 'lady'), this.toPixelStyleData(this.ladyR(), 'ladyR')];
	},

	lady() {
		return {
			w: 25.0,
			h: 14.0,
			points: [
				{ x: 0.2311, y: 0.9621, s: 0.064, c: '6C6C6C', a: 1.0 },
				{ x: 0.24, y: 0.9426, s: 0.102, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2322, y: 0.9502, s: 0.078, c: '767676', a: 1.0 },
				{ x: 0.2332, y: 0.9449, s: 0.13, c: 'CECECE', a: 1.0 },
				{ x: 0.231, y: 0.9371, s: 0.049, c: '404040', a: 1.0 },
				{ x: 0.2365, y: 0.9209, s: 0.032, c: '3C3C3C', a: 1.0 },
				{ x: 0.2454, y: 0.9489, s: 0.07, c: '8B8B8B', a: 1.0 },
				{ x: 0.2353, y: 0.9249, s: 0.112, c: '8B8B8B', a: 1.0 },
				{ x: 0.2409, y: 0.9333, s: 0.023, c: '282828', a: 1.0 },
				{ x: 0.2464, y: 0.9171, s: 0.033, c: '4A4A4A', a: 1.0 },
				{ x: 0.2441, y: 0.9098, s: 0.036, c: '3C3C3C', a: 1.0 },
				{ x: 0.2396, y: 0.9548, s: 0.133, c: 'B8B8B8', a: 1.0 },
				{ x: 0.2451, y: 0.9397, s: 0.086, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2428, y: 0.9311, s: 0.154, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2484, y: 0.9391, s: 0.064, c: '818181', a: 1.0 },
				{ x: 0.2462, y: 0.9081, s: 0.054, c: '666666', a: 1.0 },
				{ x: 0.2384, y: 0.9154, s: 0.044, c: '585858', a: 1.0 },
				{ x: 0.2439, y: 0.8996, s: 0.053, c: '686868', a: 1.0 },
				{ x: 0.2405, y: 0.9198, s: 0.102, c: 'ABABAB', a: 1.0 },
				{ x: 0.2516, y: 0.9127, s: 0.032, c: '1E1E1E', a: 1.0 },
				{ x: 0.2436, y: 0.8962, s: 0.086, c: '737373', a: 1.0 },
				{ x: 0.2493, y: 0.9046, s: 0.05, c: '616161', a: 1.0 },
				{ x: 0.2446, y: 0.9616, s: 0.072, c: 'BABABA', a: 1.0 },
				{ x: 0.2481, y: 0.9387, s: 0.139, c: 'CDCDCD', a: 1.0 },
				{ x: 0.2537, y: 0.9222, s: 0.135, c: 'FDFDFD', a: 1.0 },
				{ x: 0.2457, y: 0.9302, s: 0.11, c: 'AFAFAF', a: 1.0 },
				{ x: 0.2514, y: 0.9152, s: 0.051, c: '707070', a: 1.0 },
				{ x: 0.2433, y: 0.9221, s: 0.054, c: '464646', a: 1.0 },
				{ x: 0.2491, y: 0.9006, s: 0.058, c: '616161', a: 1.0 },
				{ x: 0.2545, y: 0.8852, s: 0.038, c: '4F4F4F', a: 1.0 },
				{ x: 0.2502, y: 0.948, s: 0.136, c: 'E7E7E7', a: 1.0 },
				{ x: 0.2555, y: 0.9563, s: 0.099, c: 'E7E7E7', a: 1.0 },
				{ x: 0.2532, y: 0.9254, s: 0.066, c: '797979', a: 1.0 },
				{ x: 0.2588, y: 0.9323, s: 0.125, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2512, y: 0.9172, s: 0.146, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2489, y: 0.9086, s: 0.039, c: '464646', a: 1.0 },
				{ x: 0.2542, y: 0.8873, s: 0.046, c: '616161', a: 1.0 },
				{ x: 0.2599, y: 0.8956, s: 0.052, c: '858585', a: 1.0 },
				{ x: 0.2586, y: 0.9359, s: 0.118, c: 'DFDFDF', a: 1.0 },
				{ x: 0.251, y: 0.9192, s: 0.111, c: 'E3E3E3', a: 1.0 },
				{ x: 0.2563, y: 0.9275, s: 0.129, c: 'E3E3E3', a: 1.0 },
				{ x: 0.262, y: 0.912, s: 0.05, c: '787878', a: 1.0 },
				{ x: 0.254, y: 0.9189, s: 0.032, c: '444444', a: 1.0 },
				{ x: 0.2597, y: 0.9036, s: 0.037, c: '363636', a: 1.0 },
				{ x: 0.2521, y: 0.8882, s: 0.032, c: '3E3E3E', a: 1.0 },
				{ x: 0.2572, y: 0.8965, s: 0.084, c: '858585', a: 1.0 },
				{ x: 0.2627, y: 0.8796, s: 0.059, c: '4F4F4F', a: 1.0 },
				{ x: 0.2559, y: 0.9415, s: 0.116, c: '939393', a: 1.0 },
				{ x: 0.2619, y: 0.926, s: 0.074, c: 'BABABA', a: 1.0 },
				{ x: 0.2541, y: 0.9344, s: 0.186, c: 'EBEBEB', a: 1.0 },
				{ x: 0.2629, y: 0.8832, s: 0.043, c: '515151', a: 1.0 },
				{ x: 0.2546, y: 0.8912, s: 0.038, c: '515151', a: 1.0 },
				{ x: 0.264, y: 0.9607, s: 0.045, c: '383838', a: 1.0 },
				{ x: 0.2695, y: 0.9449, s: 0.129, c: 'C6C6C6', a: 1.0 },
				{ x: 0.2613, y: 0.9514, s: 0.101, c: 'D3D3D3', a: 1.0 },
				{ x: 0.2669, y: 0.937, s: 0.041, c: '6C6C6C', a: 1.0 },
				{ x: 0.2594, y: 0.9197, s: 0.135, c: 'D9D9D9', a: 1.0 },
				{ x: 0.2567, y: 0.9134, s: 0.043, c: '3C3C3C', a: 1.0 },
				{ x: 0.2622, y: 0.9198, s: 0.04, c: '1B1B1B', a: 1.0 },
				{ x: 0.2682, y: 0.898, s: 0.029, c: '1F1F1F', a: 1.0 },
				{ x: 0.2601, y: 0.8837, s: 0.064, c: '606060', a: 1.0 },
				{ x: 0.2656, y: 0.8901, s: 0.032, c: '595959', a: 1.0 },
				{ x: 0.2671, y: 0.944, s: 0.094, c: 'BABABA', a: 1.0 },
				{ x: 0.2702, y: 0.9203, s: 0.097, c: '8E8E8E', a: 1.0 },
				{ x: 0.2603, y: 0.9203, s: 0.057, c: '474747', a: 1.0 },
				{ x: 0.2656, y: 0.9059, s: 0.025, c: '2A2A2A', a: 1.0 },
				{ x: 0.271, y: 0.8827, s: 0.03, c: '2C2C2C', a: 1.0 },
				{ x: 0.2629, y: 0.8922, s: 0.043, c: '606060', a: 1.0 },
				{ x: 0.2644, y: 0.946, s: 0.088, c: 'DFDFDF', a: 1.0 },
				{ x: 0.2697, y: 0.9299, s: 0.189, c: 'EEEEEE', a: 1.0 },
				{ x: 0.2751, y: 0.9367, s: 0.086, c: 'EEEEEE', a: 1.0 },
				{ x: 0.2679, y: 0.922, s: 0.124, c: 'A0A0A0', a: 1.0 },
				{ x: 0.2731, y: 0.9289, s: 0.047, c: '5C5C5C', a: 1.0 },
				{ x: 0.265, y: 0.9127, s: 0.045, c: '515151', a: 1.0 },
				{ x: 0.2712, y: 0.9225, s: 0.025, c: '3C3C3C', a: 1.0 },
				{ x: 0.2765, y: 0.9048, s: 0.021, c: '131313', a: 1.0 },
				{ x: 0.2684, y: 0.8908, s: 0.028, c: '252525', a: 1.0 },
				{ x: 0.2739, y: 0.8985, s: 0.048, c: '3B3B3B', a: 1.0 },
				{ x: 0.2666, y: 0.8811, s: 0.036, c: '606060', a: 1.0 },
				{ x: 0.2753, y: 0.9521, s: 0.107, c: 'A6A6A6', a: 1.0 },
				{ x: 0.2672, y: 0.9352, s: 0.128, c: 'DBDBDB', a: 1.0 },
				{ x: 0.2725, y: 0.9444, s: 0.065, c: '707070', a: 1.0 },
				{ x: 0.2786, y: 0.9273, s: 0.106, c: 'C4C4C4', a: 1.0 },
				{ x: 0.2759, y: 0.9211, s: 0.02, c: '373737', a: 1.0 },
				{ x: 0.2687, y: 0.9212, s: 0.039, c: '1B1B1B', a: 1.0 },
				{ x: 0.274, y: 0.9013, s: 0.037, c: '323232', a: 1.0 },
				{ x: 0.2793, y: 0.8853, s: 0.041, c: '3F3F3F', a: 1.0 },
				{ x: 0.2713, y: 0.8914, s: 0.048, c: '484848', a: 1.0 },
				{ x: 0.2774, y: 0.8774, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.2727, y: 0.9516, s: 0.047, c: '707070', a: 1.0 },
				{ x: 0.2708, y: 0.9438, s: 0.1, c: '7C7C7C', a: 1.0 },
				{ x: 0.2761, y: 0.9276, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.2814, y: 0.9375, s: 0.134, c: 'BCBCBC', a: 1.0 },
				{ x: 0.2734, y: 0.9198, s: 0.03, c: '2E2E2E', a: 1.0 },
				{ x: 0.2796, y: 0.9215, s: 0.027, c: '252525', a: 1.0 },
				{ x: 0.271, y: 0.8957, s: 0.02, c: '292929', a: 1.0 },
				{ x: 0.2774, y: 0.8781, s: 0.057, c: '484848', a: 1.0 },
				{ x: 0.2821, y: 0.8881, s: 0.034, c: '404040', a: 1.0 },
				{ x: 0.2776, y: 0.9614, s: 0.075, c: 'B8B8B8', a: 1.0 },
				{ x: 0.284, y: 0.9478, s: 0.096, c: 'E7E7E7', a: 1.0 },
				{ x: 0.2753, y: 0.9305, s: 0.12, c: 'C4C4C4', a: 1.0 },
				{ x: 0.2809, y: 0.9376, s: 0.069, c: '8D8D8D', a: 1.0 },
				{ x: 0.2739, y: 0.9241, s: 0.107, c: 'ABABAB', a: 1.0 },
				{ x: 0.2786, y: 0.9305, s: 0.044, c: '404040', a: 1.0 },
				{ x: 0.285, y: 0.9141, s: 0.023, c: '252525', a: 1.0 },
				{ x: 0.2771, y: 0.8997, s: 0.041, c: '373737', a: 1.0 },
				{ x: 0.2818, y: 0.9009, s: 0.02, c: '323232', a: 1.0 },
				{ x: 0.2749, y: 0.8865, s: 0.035, c: '323232', a: 1.0 },
				{ x: 0.2805, y: 0.8939, s: 0.03, c: '292929', a: 1.0 },
				{ x: 0.2851, y: 0.8766, s: 0.026, c: '383838', a: 1.0 },
				{ x: 0.2862, y: 0.9361, s: 0.069, c: '8D8D8D', a: 1.0 },
				{ x: 0.2783, y: 0.9463, s: 0.091, c: '9F9F9F', a: 1.0 },
				{ x: 0.2847, y: 0.9289, s: 0.17, c: 'E7E7E7', a: 1.0 },
				{ x: 0.2824, y: 0.9101, s: 0.032, c: '252525', a: 1.0 },
				{ x: 0.288, y: 0.8935, s: 0.034, c: '131313', a: 1.0 },
				{ x: 0.2794, y: 0.903, s: 0.04, c: '131313', a: 1.0 },
				{ x: 0.2858, y: 0.8865, s: 0.038, c: '212121', a: 1.0 },
				{ x: 0.278, y: 0.8934, s: 0.036, c: '3F3F3F', a: 1.0 },
				{ x: 0.2827, y: 0.8791, s: 0.02, c: '323232', a: 1.0 },
				{ x: 0.2923, y: 0.9524, s: 0.177, c: 'EFEFEF', a: 1.0 },
				{ x: 0.2837, y: 0.9389, s: 0.093, c: '929292', a: 1.0 },
				{ x: 0.2892, y: 0.9454, s: 0.046, c: '4E4E4E', a: 1.0 },
				{ x: 0.2854, y: 0.9049, s: 0.024, c: '161616', a: 1.0 },
				{ x: 0.2903, y: 0.9148, s: 0.045, c: '414141', a: 1.0 },
				{ x: 0.2832, y: 0.8978, s: 0.027, c: '373737', a: 1.0 },
				{ x: 0.2889, y: 0.9077, s: 0.032, c: '282828', a: 1.0 },
				{ x: 0.2801, y: 0.8908, s: 0.025, c: '191919', a: 1.0 },
				{ x: 0.2866, y: 0.8976, s: 0.037, c: '303030', a: 1.0 },
				{ x: 0.2911, y: 0.8836, s: 0.035, c: '393939', a: 1.0 },
				{ x: 0.2933, y: 0.9432, s: 0.135, c: 'D8D8D8', a: 1.0 },
				{ x: 0.2844, y: 0.9501, s: 0.039, c: '656565', a: 1.0 },
				{ x: 0.2963, y: 0.9192, s: 0.112, c: 'D0D0D0', a: 1.0 },
				{ x: 0.2941, y: 0.912, s: 0.056, c: '525252', a: 1.0 },
				{ x: 0.2864, y: 0.9191, s: 0.044, c: '414141', a: 1.0 },
				{ x: 0.2909, y: 0.9021, s: 0.026, c: '282828', a: 1.0 },
				{ x: 0.2841, y: 0.8881, s: 0.027, c: '464646', a: 1.0 },
				{ x: 0.2886, y: 0.8952, s: 0.031, c: '373737', a: 1.0 },
				{ x: 0.2942, y: 0.8782, s: 0.031, c: '191919', a: 1.0 },
				{ x: 0.2875, y: 0.8881, s: 0.036, c: '3F3F3F', a: 1.0 },
				{ x: 0.292, y: 0.8711, s: 0.05, c: '424242', a: 1.0 },
				{ x: 0.2877, y: 0.9534, s: 0.079, c: '929292', a: 1.0 },
				{ x: 0.2938, y: 0.9365, s: 0.104, c: 'C2C2C2', a: 1.0 },
				{ x: 0.2987, y: 0.9464, s: 0.105, c: '929292', a: 1.0 },
				{ x: 0.2915, y: 0.9295, s: 0.084, c: 'ABABAB', a: 1.0 },
				{ x: 0.2883, y: 0.9225, s: 0.135, c: 'D0D0D0', a: 1.0 },
				{ x: 0.2873, y: 0.9125, s: 0.02, c: '161616', a: 1.0 },
				{ x: 0.2917, y: 0.8902, s: 0.029, c: '202020', a: 1.0 },
				{ x: 0.2983, y: 0.9011, s: 0.035, c: '191919', a: 1.0 },
				{ x: 0.2893, y: 0.8764, s: 0.036, c: '232323', a: 1.0 },
				{ x: 0.2953, y: 0.8844, s: 0.056, c: '4C4C4C', a: 1.0 },
				{ x: 0.2916, y: 0.945, s: 0.03, c: '232323', a: 1.0 },
				{ x: 0.2959, y: 0.9499, s: 0.037, c: '191919', a: 1.0 },
				{ x: 0.3023, y: 0.9371, s: 0.031, c: '4F4F4F', a: 1.0 },
				{ x: 0.2949, y: 0.9451, s: 0.073, c: '5A5A5A', a: 1.0 },
				{ x: 0.2992, y: 0.9263, s: 0.025, c: '2A2A2A', a: 1.0 },
				{ x: 0.2922, y: 0.9135, s: 0.083, c: '9A9A9A', a: 1.0 },
				{ x: 0.2955, y: 0.9076, s: 0.034, c: '2C2C2C', a: 1.0 },
				{ x: 0.2928, y: 0.8967, s: 0.04, c: '2C2C2C', a: 1.0 },
				{ x: 0.2991, y: 0.8838, s: 0.02, c: '383838', a: 1.0 },
				{ x: 0.2902, y: 0.868, s: 0.036, c: '303030', a: 1.0 },
				{ x: 0.2961, y: 0.873, s: 0.04, c: '2A2A2A', a: 1.0 },
				{ x: 0.3025, y: 0.8572, s: 0.03, c: '424242', a: 1.0 },
				{ x: 0.2956, y: 0.9339, s: 0.038, c: '272727', a: 1.0 },
				{ x: 0.3063, y: 0.9228, s: 0.156, c: 'C2C2C2', a: 1.0 },
				{ x: 0.2976, y: 0.91, s: 0.083, c: 'E1E1E1', a: 1.0 },
				{ x: 0.3036, y: 0.9151, s: 0.129, c: 'A7A7A7', a: 1.0 },
				{ x: 0.2963, y: 0.8993, s: 0.049, c: '4A4A4A', a: 1.0 },
				{ x: 0.301, y: 0.8865, s: 0.034, c: '161616', a: 1.0 },
				{ x: 0.2936, y: 0.8945, s: 0.031, c: '393939', a: 1.0 },
				{ x: 0.3, y: 0.8757, s: 0.041, c: '343434', a: 1.0 },
				{ x: 0.3042, y: 0.8867, s: 0.018, c: '242424', a: 1.0 },
				{ x: 0.2972, y: 0.8706, s: 0.037, c: '2C2C2C', a: 1.0 },
				{ x: 0.3032, y: 0.8517, s: 0.066, c: '545454', a: 1.0 },
				{ x: 0.2945, y: 0.8631, s: 0.051, c: '5A5A5A', a: 1.0 },
				{ x: 0.3039, y: 0.9594, s: 0.029, c: '1F1F1F', a: 1.0 },
				{ x: 0.3099, y: 0.9342, s: 0.023, c: '232323', a: 1.0 },
				{ x: 0.3011, y: 0.9188, s: 0.02, c: '141414', a: 1.0 },
				{ x: 0.3072, y: 0.9234, s: 0.041, c: '272727', a: 1.0 },
				{ x: 0.2984, y: 0.908, s: 0.046, c: '646464', a: 1.0 },
				{ x: 0.3045, y: 0.9186, s: 0.074, c: '858585', a: 1.0 },
				{ x: 0.2974, y: 0.8997, s: 0.068, c: '7F7F7F', a: 1.0 },
				{ x: 0.3018, y: 0.9081, s: 0.074, c: '7F7F7F', a: 1.0 },
				{ x: 0.3008, y: 0.8765, s: 0.04, c: '161616', a: 1.0 },
				{ x: 0.3051, y: 0.8841, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.298, y: 0.8716, s: 0.034, c: '101010', a: 1.0 },
				{ x: 0.3041, y: 0.8763, s: 0.041, c: '454545', a: 1.0 },
				{ x: 0.3086, y: 0.8608, s: 0.085, c: '6C6C6C', a: 1.0 },
				{ x: 0.3014, y: 0.8476, s: 0.035, c: '4B4B4B', a: 1.0 },
				{ x: 0.3059, y: 0.8464, s: 0.046, c: '525252', a: 1.0 },
				{ x: 0.2987, y: 0.831, s: 0.044, c: '646464', a: 1.0 },
				{ x: 0.3048, y: 0.8416, s: 0.044, c: '727272', a: 1.0 },
				{ x: 0.3054, y: 0.9553, s: 0.019, c: '232323', a: 1.0 },
				{ x: 0.3115, y: 0.9391, s: 0.043, c: '363636', a: 1.0 },
				{ x: 0.3027, y: 0.9446, s: 0.025, c: '2A2A2A', a: 1.0 },
				{ x: 0.3017, y: 0.9278, s: 0.032, c: '424242', a: 1.0 },
				{ x: 0.3061, y: 0.9087, s: 0.025, c: '080808', a: 1.0 },
				{ x: 0.3122, y: 0.8895, s: 0.133, c: 'A7A7A7', a: 1.0 },
				{ x: 0.3033, y: 0.8974, s: 0.099, c: 'A7A7A7', a: 1.0 },
				{ x: 0.3095, y: 0.8794, s: 0.042, c: '6C6C6C', a: 1.0 },
				{ x: 0.3068, y: 0.8738, s: 0.042, c: '3C3C3C', a: 1.0 },
				{ x: 0.3129, y: 0.8788, s: 0.031, c: '1C1C1C', a: 1.0 },
				{ x: 0.3115, y: 0.839, s: 0.049, c: '525252', a: 1.0 },
				{ x: 0.302, y: 0.8432, s: 0.075, c: '646464', a: 1.0 },
				{ x: 0.3092, y: 0.8281, s: 0.047, c: '787878', a: 1.0 },
				{ x: 0.3014, y: 0.8391, s: 0.1, c: '8C8C8C', a: 1.0 },
				{ x: 0.3053, y: 0.8195, s: 0.074, c: '8C8C8C', a: 1.0 },
				{ x: 0.3108, y: 0.8037, s: 0.062, c: '686868', a: 1.0 },
				{ x: 0.308, y: 0.9424, s: 0.035, c: '303030', a: 1.0 },
				{ x: 0.3119, y: 0.9467, s: 0.034, c: '232323', a: 1.0 },
				{ x: 0.3041, y: 0.9279, s: 0.029, c: '272727', a: 1.0 },
				{ x: 0.3113, y: 0.9127, s: 0.028, c: '141414', a: 1.0 },
				{ x: 0.3151, y: 0.9169, s: 0.033, c: '272727', a: 1.0 },
				{ x: 0.3146, y: 0.9068, s: 0.054, c: '6C6C6C', a: 1.0 },
				{ x: 0.3051, y: 0.888, s: 0.036, c: '424242', a: 1.0 },
				{ x: 0.3106, y: 0.8984, s: 0.054, c: '7F7F7F', a: 1.0 },
				{ x: 0.3045, y: 0.8826, s: 0.076, c: '5F5F5F', a: 1.0 },
				{ x: 0.3084, y: 0.8645, s: 0.022, c: '101010', a: 1.0 },
				{ x: 0.3139, y: 0.8725, s: 0.038, c: '373737', a: 1.0 },
				{ x: 0.3078, y: 0.8587, s: 0.039, c: '454545', a: 1.0 },
				{ x: 0.3133, y: 0.8585, s: 0.03, c: '3C3C3C', a: 1.0 },
				{ x: 0.3038, y: 0.8427, s: 0.05, c: '525252', a: 1.0 },
				{ x: 0.3109, y: 0.8291, s: 0.047, c: '646464', a: 1.0 },
				{ x: 0.3165, y: 0.8342, s: 0.089, c: '787878', a: 1.0 },
				{ x: 0.307, y: 0.8191, s: 0.077, c: '858585', a: 1.0 },
				{ x: 0.3065, y: 0.8103, s: 0.115, c: '9F9F9F', a: 1.0 },
				{ x: 0.3104, y: 0.8187, s: 0.12, c: '999999', a: 1.0 },
				{ x: 0.3042, y: 0.8062, s: 0.056, c: '5C5C5C', a: 1.0 },
				{ x: 0.3131, y: 0.9498, s: 0.033, c: '1A1A1A', a: 1.0 },
				{ x: 0.3169, y: 0.9372, s: 0.038, c: '1A1A1A', a: 1.0 },
				{ x: 0.3091, y: 0.9397, s: 0.035, c: '2A2A2A', a: 1.0 },
				{ x: 0.3068, y: 0.8953, s: 0.018, c: '262626', a: 1.0 },
				{ x: 0.3125, y: 0.9037, s: 0.04, c: '262626', a: 1.0 },
				{ x: 0.3197, y: 0.8853, s: 0.038, c: '1E1E1E', a: 1.0 },
				{ x: 0.31, y: 0.8951, s: 0.074, c: '818181', a: 1.0 },
				{ x: 0.3158, y: 0.88, s: 0.088, c: 'B6B6B6', a: 1.0 },
				{ x: 0.3094, y: 0.8794, s: 0.073, c: '5C5C5C', a: 1.0 },
				{ x: 0.3129, y: 0.8493, s: 0.039, c: '585858', a: 1.0 },
				{ x: 0.3089, y: 0.8439, s: 0.064, c: '767676', a: 1.0 },
				{ x: 0.3082, y: 0.81, s: 0.095, c: '8C8C8C', a: 1.0 },
				{ x: 0.3122, y: 0.82, s: 0.075, c: '989898', a: 1.0 },
				{ x: 0.3116, y: 0.81, s: 0.087, c: 'B8B8B8', a: 1.0 },
				{ x: 0.3126, y: 0.911, s: 0.023, c: '272727', a: 1.0 },
				{ x: 0.3179, y: 0.8985, s: 0.03, c: '262626', a: 1.0 },
				{ x: 0.322, y: 0.895, s: 0.074, c: 'A5A5A5', a: 1.0 },
				{ x: 0.316, y: 0.8752, s: 0.113, c: 'CFCFCF', a: 1.0 },
				{ x: 0.3213, y: 0.8865, s: 0.079, c: '848484', a: 1.0 },
				{ x: 0.312, y: 0.8711, s: 0.091, c: 'B6B6B6', a: 1.0 },
				{ x: 0.3174, y: 0.8526, s: 0.048, c: '3C3C3C', a: 1.0 },
				{ x: 0.3114, y: 0.8562, s: 0.037, c: '4B4B4B', a: 1.0 },
				{ x: 0.3208, y: 0.8453, s: 0.052, c: '666666', a: 1.0 },
				{ x: 0.3144, y: 0.8325, s: 0.089, c: '737373', a: 1.0 },
				{ x: 0.3104, y: 0.8216, s: 0.085, c: '858585', a: 1.0 },
				{ x: 0.3219, y: 0.8182, s: 0.062, c: '9E9E9E', a: 1.0 },
				{ x: 0.3131, y: 0.7946, s: 0.127, c: 'ADADAD', a: 1.0 },
				{ x: 0.3207, y: 0.9206, s: 0.019, c: '161616', a: 1.0 },
				{ x: 0.3145, y: 0.9063, s: 0.024, c: '212121', a: 1.0 },
				{ x: 0.3197, y: 0.8994, s: 0.042, c: '1E1E1E', a: 1.0 },
				{ x: 0.3235, y: 0.8851, s: 0.027, c: '484848', a: 1.0 },
				{ x: 0.3178, y: 0.8706, s: 0.092, c: '848484', a: 1.0 },
				{ x: 0.323, y: 0.8756, s: 0.085, c: '848484', a: 1.0 },
				{ x: 0.3134, y: 0.8613, s: 0.097, c: 'B6B6B6', a: 1.0 },
				{ x: 0.3211, y: 0.8707, s: 0.028, c: '373737', a: 1.0 },
				{ x: 0.3266, y: 0.8564, s: 0.046, c: '3A3A3A', a: 1.0 },
				{ x: 0.3168, y: 0.8616, s: 0.03, c: '545454', a: 1.0 },
				{ x: 0.3223, y: 0.8473, s: 0.068, c: '5D5D5D', a: 1.0 },
				{ x: 0.3165, y: 0.8329, s: 0.079, c: '666666', a: 1.0 },
				{ x: 0.3204, y: 0.8365, s: 0.08, c: '707070', a: 1.0 },
				{ x: 0.3199, y: 0.8328, s: 0.056, c: '808080', a: 1.0 },
				{ x: 0.3237, y: 0.8125, s: 0.053, c: '888888', a: 1.0 },
				{ x: 0.3136, y: 0.789, s: 0.079, c: 'B8B8B8', a: 1.0 },
				{ x: 0.3191, y: 0.7986, s: 0.154, c: 'C9C9C9', a: 1.0 },
				{ x: 0.3214, y: 0.9055, s: 0.025, c: '1E1E1E', a: 1.0 },
				{ x: 0.3258, y: 0.8926, s: 0.042, c: '363636', a: 1.0 },
				{ x: 0.3193, y: 0.8966, s: 0.044, c: '3E3E3E', a: 1.0 },
				{ x: 0.3248, y: 0.8818, s: 0.029, c: '242424', a: 1.0 },
				{ x: 0.329, y: 0.8857, s: 0.029, c: '373737', a: 1.0 },
				{ x: 0.3229, y: 0.8665, s: 0.036, c: '505050', a: 1.0 },
				{ x: 0.3185, y: 0.8616, s: 0.04, c: '474747', a: 1.0 },
				{ x: 0.3262, y: 0.8477, s: 0.046, c: '585858', a: 1.0 },
				{ x: 0.3182, y: 0.8524, s: 0.065, c: '616161', a: 1.0 },
				{ x: 0.3219, y: 0.8379, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.3215, y: 0.8286, s: 0.041, c: '707070', a: 1.0 },
				{ x: 0.3171, y: 0.8237, s: 0.079, c: '838383', a: 1.0 },
				{ x: 0.325, y: 0.8039, s: 0.068, c: '8D8D8D', a: 1.0 },
				{ x: 0.3286, y: 0.8145, s: 0.118, c: '959595', a: 1.0 },
				{ x: 0.3206, y: 0.8005, s: 0.067, c: 'A6A6A6', a: 1.0 },
				{ x: 0.3276, y: 0.7799, s: 0.14, c: 'B8B8B8', a: 1.0 },
				{ x: 0.3187, y: 0.7906, s: 0.096, c: 'D1D1D1', a: 1.0 },
				{ x: 0.3239, y: 0.7767, s: 0.089, c: 'ADADAD', a: 1.0 },
				{ x: 0.3209, y: 0.9028, s: 0.036, c: '222222', a: 1.0 },
				{ x: 0.3253, y: 0.8896, s: 0.03, c: '262626', a: 1.0 },
				{ x: 0.3306, y: 0.8936, s: 0.039, c: '1D1D1D', a: 1.0 },
				{ x: 0.3244, y: 0.861, s: 0.057, c: '484848', a: 1.0 },
				{ x: 0.3208, y: 0.8517, s: 0.038, c: '505050', a: 1.0 },
				{ x: 0.3277, y: 0.8609, s: 0.072, c: '5A5A5A', a: 1.0 },
				{ x: 0.3331, y: 0.8473, s: 0.044, c: '636363', a: 1.0 },
				{ x: 0.3311, y: 0.8372, s: 0.063, c: '686868', a: 1.0 },
				{ x: 0.3231, y: 0.8236, s: 0.042, c: '6B6B6B', a: 1.0 },
				{ x: 0.3267, y: 0.833, s: 0.072, c: '747474', a: 1.0 },
				{ x: 0.3221, y: 0.7891, s: 0.106, c: '9A9A9A', a: 1.0 },
				{ x: 0.3299, y: 0.7992, s: 0.109, c: 'ACACAC', a: 1.0 },
				{ x: 0.3202, y: 0.7856, s: 0.116, c: 'BEBEBE', a: 1.0 },
				{ x: 0.3272, y: 0.8726, s: 0.043, c: '3F3F3F', a: 1.0 },
				{ x: 0.3319, y: 0.8583, s: 0.028, c: '4A4A4A', a: 1.0 },
				{ x: 0.3266, y: 0.8686, s: 0.062, c: '535353', a: 1.0 },
				{ x: 0.3305, y: 0.8483, s: 0.055, c: '5A5A5A', a: 1.0 },
				{ x: 0.3352, y: 0.8345, s: 0.068, c: '606060', a: 1.0 },
				{ x: 0.3299, y: 0.8447, s: 0.056, c: '606060', a: 1.0 },
				{ x: 0.3346, y: 0.8244, s: 0.063, c: '616161', a: 1.0 },
				{ x: 0.3332, y: 0.8204, s: 0.042, c: '6D6D6D', a: 1.0 },
				{ x: 0.3245, y: 0.8247, s: 0.078, c: '747474', a: 1.0 },
				{ x: 0.3284, y: 0.8104, s: 0.084, c: '7C7C7C', a: 1.0 },
				{ x: 0.3278, y: 0.8063, s: 0.094, c: '919191', a: 1.0 },
				{ x: 0.3263, y: 0.7967, s: 0.081, c: 'ACACAC', a: 1.0 },
				{ x: 0.331, y: 0.7824, s: 0.153, c: 'C6C6C6', a: 1.0 },
				{ x: 0.3297, y: 0.7724, s: 0.058, c: '838383', a: 1.0 },
				{ x: 0.3377, y: 0.8816, s: 0.034, c: '3A3A3A', a: 1.0 },
				{ x: 0.3291, y: 0.8676, s: 0.038, c: '505050', a: 1.0 },
				{ x: 0.3337, y: 0.8536, s: 0.063, c: '505050', a: 1.0 },
				{ x: 0.3275, y: 0.8579, s: 0.031, c: '545454', a: 1.0 },
				{ x: 0.3322, y: 0.8439, s: 0.054, c: '575757', a: 1.0 },
				{ x: 0.3316, y: 0.8338, s: 0.07, c: '5C5C5C', a: 1.0 },
				{ x: 0.3356, y: 0.8437, s: 0.059, c: '5D5D5D', a: 1.0 },
				{ x: 0.327, y: 0.8297, s: 0.065, c: '636363', a: 1.0 },
				{ x: 0.335, y: 0.8097, s: 0.079, c: '666666', a: 1.0 },
				{ x: 0.3388, y: 0.8196, s: 0.082, c: '6B6B6B', a: 1.0 },
				{ x: 0.3302, y: 0.8057, s: 0.054, c: '737373', a: 1.0 },
				{ x: 0.3295, y: 0.7959, s: 0.062, c: '898989', a: 1.0 },
				{ x: 0.3335, y: 0.7819, s: 0.067, c: '969696', a: 1.0 },
				{ x: 0.328, y: 0.7858, s: 0.096, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3329, y: 0.7718, s: 0.11, c: 'B4B4B4', a: 1.0 },
				{ x: 0.3368, y: 0.7818, s: 0.164, c: 'CFCFCF', a: 1.0 },
				{ x: 0.3395, y: 0.8768, s: 0.047, c: '3A3A3A', a: 1.0 },
				{ x: 0.3307, y: 0.8628, s: 0.032, c: '505050', a: 1.0 },
				{ x: 0.3381, y: 0.8669, s: 0.04, c: '505050', a: 1.0 },
				{ x: 0.3426, y: 0.8529, s: 0.053, c: '515151', a: 1.0 },
				{ x: 0.3342, y: 0.8628, s: 0.05, c: '515151', a: 1.0 },
				{ x: 0.3386, y: 0.8429, s: 0.05, c: '515151', a: 1.0 },
				{ x: 0.3327, y: 0.8289, s: 0.033, c: '565656', a: 1.0 },
				{ x: 0.3374, y: 0.8388, s: 0.068, c: '585858', a: 1.0 },
				{ x: 0.3419, y: 0.819, s: 0.039, c: '5D5D5D', a: 1.0 },
				{ x: 0.336, y: 0.8288, s: 0.073, c: '5D5D5D', a: 1.0 },
				{ x: 0.3405, y: 0.8149, s: 0.071, c: '636363', a: 1.0 },
				{ x: 0.3321, y: 0.8181, s: 0.064, c: '6A6A6A', a: 1.0 },
				{ x: 0.3398, y: 0.8082, s: 0.054, c: '737373', a: 1.0 },
				{ x: 0.3305, y: 0.7864, s: 0.103, c: '808080', a: 1.0 },
				{ x: 0.3351, y: 0.7944, s: 0.051, c: '8D8D8D', a: 1.0 },
				{ x: 0.3433, y: 0.7845, s: 0.126, c: '9B9B9B', a: 1.0 },
				{ x: 0.3339, y: 0.7865, s: 0.065, c: 'ACACAC', a: 1.0 },
				{ x: 0.3333, y: 0.7608, s: 0.138, c: 'D7D7D7', a: 1.0 },
				{ x: 0.3452, y: 0.8919, s: 0.02, c: '282828', a: 1.0 },
				{ x: 0.3396, y: 0.8701, s: 0.058, c: '474747', a: 1.0 },
				{ x: 0.3445, y: 0.8603, s: 0.032, c: '4A4A4A', a: 1.0 },
				{ x: 0.3356, y: 0.8683, s: 0.048, c: '4A4A4A', a: 1.0 },
				{ x: 0.343, y: 0.8464, s: 0.049, c: '4D4D4D', a: 1.0 },
				{ x: 0.3346, y: 0.8603, s: 0.046, c: '4D4D4D', a: 1.0 },
				{ x: 0.3389, y: 0.8446, s: 0.045, c: '4D4D4D', a: 1.0 },
				{ x: 0.3465, y: 0.8467, s: 0.058, c: '4E4E4E', a: 1.0 },
				{ x: 0.3378, y: 0.8368, s: 0.031, c: '525252', a: 1.0 },
				{ x: 0.3421, y: 0.8208, s: 0.045, c: '565656', a: 1.0 },
				{ x: 0.3335, y: 0.8228, s: 0.055, c: '575757', a: 1.0 },
				{ x: 0.3411, y: 0.8129, s: 0.075, c: '5D5D5D', a: 1.0 },
				{ x: 0.3458, y: 0.8209, s: 0.044, c: '636363', a: 1.0 },
				{ x: 0.3368, y: 0.7993, s: 0.069, c: '6D6D6D', a: 1.0 },
				{ x: 0.3358, y: 0.7974, s: 0.052, c: '868686', a: 1.0 },
				{ x: 0.3347, y: 0.7896, s: 0.06, c: '9F9F9F', a: 1.0 },
				{ x: 0.346, y: 0.8772, s: 0.037, c: '434343', a: 1.0 },
				{ x: 0.3369, y: 0.8669, s: 0.049, c: '434343', a: 1.0 },
				{ x: 0.3449, y: 0.8693, s: 0.052, c: '434343', a: 1.0 },
				{ x: 0.3493, y: 0.8531, s: 0.047, c: '464646', a: 1.0 },
				{ x: 0.3403, y: 0.8436, s: 0.029, c: '474747', a: 1.0 },
				{ x: 0.3483, y: 0.8456, s: 0.049, c: '494949', a: 1.0 },
				{ x: 0.3393, y: 0.8294, s: 0.057, c: '4B4B4B', a: 1.0 },
				{ x: 0.3439, y: 0.8437, s: 0.046, c: '4F4F4F', a: 1.0 },
				{ x: 0.3381, y: 0.8216, s: 0.053, c: '525252', a: 1.0 },
				{ x: 0.3429, y: 0.8299, s: 0.04, c: '555555', a: 1.0 },
				{ x: 0.3471, y: 0.8196, s: 0.07, c: '585858', a: 1.0 },
				{ x: 0.3385, y: 0.7982, s: 0.036, c: '5D5D5D', a: 1.0 },
				{ x: 0.3462, y: 0.8059, s: 0.076, c: '666666', a: 1.0 },
				{ x: 0.3408, y: 0.7726, s: 0.084, c: '999999', a: 1.0 },
				{ x: 0.3452, y: 0.7742, s: 0.078, c: 'AAAAAA', a: 1.0 },
				{ x: 0.3397, y: 0.7587, s: 0.146, c: 'BCBCBC', a: 1.0 },
				{ x: 0.3442, y: 0.7725, s: 0.082, c: 'D9D9D9', a: 1.0 },
				{ x: 0.3486, y: 0.7511, s: 0.123, c: '9A9A9A', a: 1.0 },
				{ x: 0.3463, y: 0.892, s: 0.024, c: '1B1B1B', a: 1.0 },
				{ x: 0.3419, y: 0.8717, s: 0.042, c: '3C3C3C', a: 1.0 },
				{ x: 0.3497, y: 0.8622, s: 0.046, c: '3C3C3C', a: 1.0 },
				{ x: 0.3409, y: 0.8639, s: 0.028, c: '444444', a: 1.0 },
				{ x: 0.3454, y: 0.8544, s: 0.044, c: '454545', a: 1.0 },
				{ x: 0.3532, y: 0.8382, s: 0.046, c: '444444', a: 1.0 },
				{ x: 0.3443, y: 0.8407, s: 0.043, c: '474747', a: 1.0 },
				{ x: 0.3488, y: 0.8305, s: 0.039, c: '4C4C4C', a: 1.0 },
				{ x: 0.3433, y: 0.8389, s: 0.042, c: '4F4F4F', a: 1.0 },
				{ x: 0.3476, y: 0.8164, s: 0.057, c: '535353', a: 1.0 },
				{ x: 0.3521, y: 0.8073, s: 0.041, c: '545454', a: 1.0 },
				{ x: 0.3466, y: 0.8153, s: 0.063, c: '595959', a: 1.0 },
				{ x: 0.3422, y: 0.8067, s: 0.084, c: '6A6A6A', a: 1.0 },
				{ x: 0.3467, y: 0.7916, s: 0.082, c: '737373', a: 1.0 },
				{ x: 0.3412, y: 0.7936, s: 0.075, c: '818181', a: 1.0 },
				{ x: 0.3457, y: 0.783, s: 0.091, c: '909090', a: 1.0 },
				{ x: 0.3491, y: 0.7592, s: 0.074, c: 'CDCDCD', a: 1.0 },
				{ x: 0.3513, y: 0.8792, s: 0.04, c: '242424', a: 1.0 },
				{ x: 0.3558, y: 0.8687, s: 0.03, c: '3C3C3C', a: 1.0 },
				{ x: 0.3469, y: 0.8467, s: 0.041, c: '424242', a: 1.0 },
				{ x: 0.3547, y: 0.8616, s: 0.051, c: '444444', a: 1.0 },
				{ x: 0.3459, y: 0.8398, s: 0.054, c: '464646', a: 1.0 },
				{ x: 0.3503, y: 0.847, s: 0.038, c: '494949', a: 1.0 },
				{ x: 0.3452, y: 0.8371, s: 0.039, c: '4C4C4C', a: 1.0 },
				{ x: 0.3474, y: 0.8159, s: 0.06, c: '4D4D4D', a: 1.0 },
				{ x: 0.3563, y: 0.8232, s: 0.049, c: '515151', a: 1.0 },
				{ x: 0.3485, y: 0.8132, s: 0.049, c: '545454', a: 1.0 },
				{ x: 0.3462, y: 0.8004, s: 0.041, c: '595959', a: 1.0 },
				{ x: 0.3517, y: 0.7897, s: 0.068, c: '606060', a: 1.0 },
				{ x: 0.354, y: 0.7918, s: 0.065, c: '6A6A6A', a: 1.0 },
				{ x: 0.3516, y: 0.7907, s: 0.054, c: '868686', a: 1.0 },
				{ x: 0.3439, y: 0.7679, s: 0.097, c: '999999', a: 1.0 },
				{ x: 0.3528, y: 0.7766, s: 0.084, c: 'A5A5A5', a: 1.0 },
				{ x: 0.3549, y: 0.7668, s: 0.085, c: 'C0C0C0', a: 1.0 },
				{ x: 0.3471, y: 0.7442, s: 0.105, c: 'D9D9D9', a: 1.0 },
				{ x: 0.356, y: 0.7525, s: 0.066, c: '818181', a: 1.0 },
				{ x: 0.3482, y: 0.8644, s: 0.049, c: '404040', a: 1.0 },
				{ x: 0.3537, y: 0.8475, s: 0.043, c: '464646', a: 1.0 },
				{ x: 0.3492, y: 0.838, s: 0.032, c: '464646', a: 1.0 },
				{ x: 0.3514, y: 0.8407, s: 0.042, c: '484848', a: 1.0 },
				{ x: 0.357, y: 0.8238, s: 0.056, c: '4C4C4C', a: 1.0 },
				{ x: 0.3526, y: 0.8381, s: 0.051, c: '4E4E4E', a: 1.0 },
				{ x: 0.3548, y: 0.8168, s: 0.06, c: '515151', a: 1.0 },
				{ x: 0.347, y: 0.8073, s: 0.043, c: '515151', a: 1.0 },
				{ x: 0.358, y: 0.7926, s: 0.036, c: '585858', a: 1.0 },
				{ x: 0.3501, y: 0.807, s: 0.051, c: '5E5E5E', a: 1.0 },
				{ x: 0.359, y: 0.7916, s: 0.069, c: '666666', a: 1.0 },
				{ x: 0.3478, y: 0.7925, s: 0.044, c: '6E6E6E', a: 1.0 },
				{ x: 0.3535, y: 0.7832, s: 0.053, c: '7D7D7D', a: 1.0 },
				{ x: 0.349, y: 0.7677, s: 0.114, c: '8D8D8D', a: 1.0 },
				{ x: 0.3512, y: 0.7686, s: 0.058, c: '9D9D9D', a: 1.0 },
				{ x: 0.3521, y: 0.7676, s: 0.104, c: 'C9C9C9', a: 1.0 },
				{ x: 0.3545, y: 0.7463, s: 0.107, c: 'B2B2B2', a: 1.0 },
				{ x: 0.3532, y: 0.9579, s: 0.097, c: 'DADADA', a: 1.0 },
				{ x: 0.3589, y: 0.883, s: 0.062, c: '4D4D4D', a: 1.0 },
				{ x: 0.3565, y: 0.8506, s: 0.047, c: '484848', a: 1.0 },
				{ x: 0.3508, y: 0.8437, s: 0.033, c: '4E4E4E', a: 1.0 },
				{ x: 0.3599, y: 0.8267, s: 0.047, c: '4E4E4E', a: 1.0 },
				{ x: 0.3519, y: 0.8292, s: 0.055, c: '515151', a: 1.0 },
				{ x: 0.3554, y: 0.8064, s: 0.059, c: '545454', a: 1.0 },
				{ x: 0.3574, y: 0.795, s: 0.046, c: '575757', a: 1.0 },
				{ x: 0.3531, y: 0.7985, s: 0.072, c: '5C5C5C', a: 1.0 },
				{ x: 0.3587, y: 0.7827, s: 0.068, c: '616161', a: 1.0 },
				{ x: 0.3564, y: 0.7749, s: 0.085, c: '717171', a: 1.0 },
				{ x: 0.3618, y: 0.7813, s: 0.08, c: '828282', a: 1.0 },
				{ x: 0.3518, y: 0.7577, s: 0.11, c: 'C1C1C1', a: 1.0 },
				{ x: 0.3585, y: 0.9399, s: 0.091, c: 'BBBBBB', a: 1.0 },
				{ x: 0.3605, y: 0.942, s: 0.087, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3562, y: 0.9247, s: 0.065, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3582, y: 0.9103, s: 0.104, c: '808080', a: 1.0 },
				{ x: 0.3592, y: 0.8712, s: 0.056, c: '474747', a: 1.0 },
				{ x: 0.3616, y: 0.8628, s: 0.052, c: '4C4C4C', a: 1.0 },
				{ x: 0.3536, y: 0.8393, s: 0.042, c: '4C4C4C', a: 1.0 },
				{ x: 0.3628, y: 0.8474, s: 0.061, c: '515151', a: 1.0 },
				{ x: 0.3568, y: 0.8395, s: 0.063, c: '555555', a: 1.0 },
				{ x: 0.3661, y: 0.8312, s: 0.043, c: '555555', a: 1.0 },
				{ x: 0.36, y: 0.8159, s: 0.062, c: '535353', a: 1.0 },
				{ x: 0.3556, y: 0.8076, s: 0.051, c: '545454', a: 1.0 },
				{ x: 0.3582, y: 0.8142, s: 0.061, c: '575757', a: 1.0 },
				{ x: 0.3588, y: 0.7837, s: 0.047, c: '5F5F5F', a: 1.0 },
				{ x: 0.3615, y: 0.7905, s: 0.051, c: '636363', a: 1.0 },
				{ x: 0.3537, y: 0.7683, s: 0.087, c: '6C6C6C', a: 1.0 },
				{ x: 0.3621, y: 0.7841, s: 0.053, c: '787878', a: 1.0 },
				{ x: 0.3643, y: 0.7665, s: 0.091, c: '888888', a: 1.0 },
				{ x: 0.3542, y: 0.7432, s: 0.091, c: 'CBCBCB', a: 1.0 },
				{ x: 0.3631, y: 0.7466, s: 0.07, c: '656565', a: 1.0 },
				{ x: 0.3698, y: 0.9319, s: 0.096, c: 'DADADA', a: 1.0 },
				{ x: 0.3623, y: 0.9394, s: 0.109, c: 'BBBBBB', a: 1.0 },
				{ x: 0.3646, y: 0.9195, s: 0.069, c: '787878', a: 1.0 },
				{ x: 0.3597, y: 0.9316, s: 0.043, c: '565656', a: 1.0 },
				{ x: 0.3651, y: 0.9117, s: 0.048, c: '676767', a: 1.0 },
				{ x: 0.3677, y: 0.9195, s: 0.081, c: '686868', a: 1.0 },
				{ x: 0.3633, y: 0.9019, s: 0.069, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3683, y: 0.8819, s: 0.118, c: '999999', a: 1.0 },
				{ x: 0.3572, y: 0.8836, s: 0.048, c: '474747', a: 1.0 },
				{ x: 0.3667, y: 0.8726, s: 0.049, c: '4C4C4C', a: 1.0 },
				{ x: 0.3584, y: 0.8759, s: 0.039, c: '525252', a: 1.0 },
				{ x: 0.3606, y: 0.859, s: 0.051, c: '525252', a: 1.0 },
				{ x: 0.3619, y: 0.8527, s: 0.041, c: '585858', a: 1.0 },
				{ x: 0.3639, y: 0.835, s: 0.063, c: '585858', a: 1.0 },
				{ x: 0.3592, y: 0.8486, s: 0.065, c: '595959', a: 1.0 },
				{ x: 0.3687, y: 0.8048, s: 0.039, c: '585858', a: 1.0 },
				{ x: 0.3573, y: 0.8117, s: 0.061, c: '575757', a: 1.0 },
				{ x: 0.3659, y: 0.8034, s: 0.058, c: '575757', a: 1.0 },
				{ x: 0.3695, y: 0.7798, s: 0.062, c: '636363', a: 1.0 },
				{ x: 0.3595, y: 0.7792, s: 0.068, c: '7D7D7D', a: 1.0 },
				{ x: 0.3629, y: 0.7554, s: 0.143, c: 'CBCBCB', a: 1.0 },
				{ x: 0.3649, y: 0.7322, s: 0.076, c: '808080', a: 1.0 },
				{ x: 0.3601, y: 0.9519, s: 0.15, c: 'CDCDCD', a: 1.0 },
				{ x: 0.3716, y: 0.9449, s: 0.054, c: '707070', a: 1.0 },
				{ x: 0.3636, y: 0.9217, s: 0.089, c: '818181', a: 1.0 },
				{ x: 0.367, y: 0.9218, s: 0.085, c: '9A9A9A', a: 1.0 },
				{ x: 0.3622, y: 0.8956, s: 0.098, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3642, y: 0.885, s: 0.101, c: '838383', a: 1.0 },
				{ x: 0.3704, y: 0.8915, s: 0.059, c: '4E4E4E', a: 1.0 },
				{ x: 0.3657, y: 0.8717, s: 0.054, c: '565656', a: 1.0 },
				{ x: 0.3629, y: 0.8676, s: 0.056, c: '5D5D5D', a: 1.0 },
				{ x: 0.3715, y: 0.8606, s: 0.056, c: '606060', a: 1.0 },
				{ x: 0.3662, y: 0.844, s: 0.059, c: '656565', a: 1.0 },
				{ x: 0.3717, y: 0.8476, s: 0.037, c: '626262', a: 1.0 },
				{ x: 0.3614, y: 0.837, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.3694, y: 0.8406, s: 0.059, c: '636363', a: 1.0 },
				{ x: 0.3625, y: 0.8237, s: 0.036, c: '616161', a: 1.0 },
				{ x: 0.3647, y: 0.813, s: 0.071, c: '5E5E5E', a: 1.0 },
				{ x: 0.3727, y: 0.8169, s: 0.049, c: '5C5C5C', a: 1.0 },
				{ x: 0.3657, y: 0.8, s: 0.062, c: '5C5C5C', a: 1.0 },
				{ x: 0.368, y: 0.8128, s: 0.072, c: '5C5C5C', a: 1.0 },
				{ x: 0.3626, y: 0.7928, s: 0.069, c: '5C5C5C', a: 1.0 },
				{ x: 0.3703, y: 0.7887, s: 0.038, c: '656565', a: 1.0 },
				{ x: 0.3658, y: 0.7688, s: 0.079, c: '6E6E6E', a: 1.0 },
				{ x: 0.3699, y: 0.769, s: 0.059, c: '898989', a: 1.0 },
				{ x: 0.3635, y: 0.744, s: 0.083, c: 'C1C1C1', a: 1.0 },
				{ x: 0.3733, y: 0.7448, s: 0.098, c: '9F9F9F', a: 1.0 },
				{ x: 0.3702, y: 0.9411, s: 0.164, c: 'EBEBEB', a: 1.0 },
				{ x: 0.3665, y: 0.9482, s: 0.088, c: '919191', a: 1.0 },
				{ x: 0.3734, y: 0.9173, s: 0.06, c: '9A9A9A', a: 1.0 },
				{ x: 0.3697, y: 0.9241, s: 0.067, c: '9A9A9A', a: 1.0 },
				{ x: 0.3711, y: 0.9161, s: 0.074, c: '818181', a: 1.0 },
				{ x: 0.3641, y: 0.9053, s: 0.084, c: '6B6B6B', a: 1.0 },
				{ x: 0.3745, y: 0.8744, s: 0.063, c: '5B5B5B', a: 1.0 },
				{ x: 0.3673, y: 0.8753, s: 0.054, c: '626262', a: 1.0 },
				{ x: 0.3764, y: 0.8673, s: 0.043, c: '646464', a: 1.0 },
				{ x: 0.3642, y: 0.8743, s: 0.077, c: '686868', a: 1.0 },
				{ x: 0.3708, y: 0.8514, s: 0.04, c: '696969', a: 1.0 },
				{ x: 0.3653, y: 0.8434, s: 0.075, c: '6B6B6B', a: 1.0 },
				{ x: 0.3677, y: 0.8503, s: 0.075, c: '6B6B6B', a: 1.0 },
				{ x: 0.3686, y: 0.8442, s: 0.058, c: '686868', a: 1.0 },
				{ x: 0.3638, y: 0.8274, s: 0.07, c: '666666', a: 1.0 },
				{ x: 0.372, y: 0.8205, s: 0.068, c: '616161', a: 1.0 },
				{ x: 0.3748, y: 0.8017, s: 0.059, c: '616161', a: 1.0 },
				{ x: 0.3673, y: 0.8037, s: 0.037, c: '606060', a: 1.0 },
				{ x: 0.3751, y: 0.7968, s: 0.076, c: '616161', a: 1.0 },
				{ x: 0.3651, y: 0.7731, s: 0.046, c: '6C6C6C', a: 1.0 },
				{ x: 0.3683, y: 0.7781, s: 0.092, c: '727272', a: 1.0 },
				{ x: 0.3761, y: 0.7564, s: 0.045, c: '7B7B7B', a: 1.0 },
				{ x: 0.3685, y: 0.7733, s: 0.099, c: '898989', a: 1.0 },
				{ x: 0.3713, y: 0.7544, s: 0.102, c: '999999', a: 1.0 },
				{ x: 0.3662, y: 0.7565, s: 0.137, c: 'B9B9B9', a: 1.0 },
				{ x: 0.3781, y: 0.9529, s: 0.086, c: 'AFAFAF', a: 1.0 },
				{ x: 0.3791, y: 0.9483, s: 0.128, c: 'CDCDCD', a: 1.0 },
				{ x: 0.3681, y: 0.9294, s: 0.065, c: '949494', a: 1.0 },
				{ x: 0.3759, y: 0.8868, s: 0.061, c: '4E4E4E', a: 1.0 },
				{ x: 0.3691, y: 0.8886, s: 0.047, c: '535353', a: 1.0 },
				{ x: 0.3703, y: 0.8698, s: 0.047, c: '5F5F5F', a: 1.0 },
				{ x: 0.3793, y: 0.8867, s: 0.066, c: '666666', a: 1.0 },
				{ x: 0.3721, y: 0.865, s: 0.07, c: '6C6C6C', a: 1.0 },
				{ x: 0.3734, y: 0.87, s: 0.044, c: '737373', a: 1.0 },
				{ x: 0.3698, y: 0.8602, s: 0.093, c: '747474', a: 1.0 },
				{ x: 0.3757, y: 0.8415, s: 0.05, c: '767676', a: 1.0 },
				{ x: 0.379, y: 0.8417, s: 0.07, c: '747474', a: 1.0 },
				{ x: 0.367, y: 0.8229, s: 0.066, c: '717171', a: 1.0 },
				{ x: 0.3763, y: 0.8127, s: 0.084, c: '6D6D6D', a: 1.0 },
				{ x: 0.3777, y: 0.818, s: 0.056, c: '686868', a: 1.0 },
				{ x: 0.3703, y: 0.7988, s: 0.053, c: '6B6B6B', a: 1.0 },
				{ x: 0.38, y: 0.8131, s: 0.085, c: '696969', a: 1.0 },
				{ x: 0.3676, y: 0.794, s: 0.043, c: '686868', a: 1.0 },
				{ x: 0.3736, y: 0.7845, s: 0.061, c: '696969', a: 1.0 },
				{ x: 0.3699, y: 0.7891, s: 0.06, c: '6A6A6A', a: 1.0 },
				{ x: 0.3709, y: 0.7707, s: 0.06, c: '6E6E6E', a: 1.0 },
				{ x: 0.3772, y: 0.7845, s: 0.092, c: '747474', a: 1.0 },
				{ x: 0.3732, y: 0.7654, s: 0.045, c: '7D7D7D', a: 1.0 },
				{ x: 0.3671, y: 0.7606, s: 0.122, c: '999999', a: 1.0 },
				{ x: 0.3751, y: 0.7422, s: 0.079, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3741, y: 0.9622, s: 0.111, c: 'AFAFAF', a: 1.0 },
				{ x: 0.3711, y: 0.9337, s: 0.053, c: '747474', a: 1.0 },
				{ x: 0.3775, y: 0.9383, s: 0.065, c: '747474', a: 1.0 },
				{ x: 0.3717, y: 0.9169, s: 0.081, c: '686868', a: 1.0 },
				{ x: 0.3747, y: 0.9036, s: 0.059, c: '535353', a: 1.0 },
				{ x: 0.3807, y: 0.8853, s: 0.05, c: '585858', a: 1.0 },
				{ x: 0.3753, y: 0.887, s: 0.057, c: '646464', a: 1.0 },
				{ x: 0.3779, y: 0.8805, s: 0.044, c: '6C6C6C', a: 1.0 },
				{ x: 0.3726, y: 0.8614, s: 0.08, c: '767676', a: 1.0 },
				{ x: 0.3814, y: 0.8565, s: 0.059, c: '818181', a: 1.0 },
				{ x: 0.382, y: 0.8399, s: 0.09, c: '818181', a: 1.0 },
				{ x: 0.3715, y: 0.8326, s: 0.077, c: '818181', a: 1.0 },
				{ x: 0.3721, y: 0.8157, s: 0.05, c: '7E7E7E', a: 1.0 },
				{ x: 0.375, y: 0.8327, s: 0.059, c: '7B7B7B', a: 1.0 },
				{ x: 0.3828, y: 0.8116, s: 0.079, c: '767676', a: 1.0 },
				{ x: 0.3754, y: 0.8166, s: 0.086, c: '757575', a: 1.0 },
				{ x: 0.3783, y: 0.809, s: 0.047, c: '737373', a: 1.0 },
				{ x: 0.3727, y: 0.7879, s: 0.059, c: '717171', a: 1.0 },
				{ x: 0.3789, y: 0.793, s: 0.078, c: '737373', a: 1.0 },
				{ x: 0.38, y: 0.7853, s: 0.063, c: '747474', a: 1.0 },
				{ x: 0.3762, y: 0.7874, s: 0.086, c: '767676', a: 1.0 },
				{ x: 0.3824, y: 0.7692, s: 0.081, c: '7D7D7D', a: 1.0 },
				{ x: 0.3702, y: 0.7593, s: 0.058, c: '838383', a: 1.0 },
				{ x: 0.3796, y: 0.7636, s: 0.054, c: '898989', a: 1.0 },
				{ x: 0.3724, y: 0.7449, s: 0.087, c: '999999', a: 1.0 },
				{ x: 0.383, y: 0.7399, s: 0.089, c: 'CBCBCB', a: 1.0 },
				{ x: 0.377, y: 0.5214, s: 0.064, c: '686868', a: 1.0 },
				{ x: 0.373, y: 0.5026, s: 0.059, c: '898989', a: 1.0 },
				{ x: 0.3742, y: 0.5069, s: 0.141, c: 'B0B0B0', a: 1.0 },
				{ x: 0.381, y: 0.9378, s: 0.075, c: '989898', a: 1.0 },
				{ x: 0.3737, y: 0.9433, s: 0.122, c: 'A9A9A9', a: 1.0 },
				{ x: 0.3832, y: 0.9334, s: 0.059, c: '9E9E9E', a: 1.0 },
				{ x: 0.3771, y: 0.8892, s: 0.082, c: '656565', a: 1.0 },
				{ x: 0.3739, y: 0.8852, s: 0.073, c: '6B6B6B', a: 1.0 },
				{ x: 0.3767, y: 0.8796, s: 0.055, c: '7F7F7F', a: 1.0 },
				{ x: 0.3772, y: 0.8616, s: 0.108, c: '868686', a: 1.0 },
				{ x: 0.3844, y: 0.8637, s: 0.062, c: '8A8A8A', a: 1.0 },
				{ x: 0.3799, y: 0.856, s: 0.082, c: '8B8B8B', a: 1.0 },
				{ x: 0.3743, y: 0.84, s: 0.105, c: '8B8B8B', a: 1.0 },
				{ x: 0.3831, y: 0.832, s: 0.088, c: '8C8C8C', a: 1.0 },
				{ x: 0.3837, y: 0.8373, s: 0.095, c: '888888', a: 1.0 },
				{ x: 0.3776, y: 0.8159, s: 0.068, c: '868686', a: 1.0 },
				{ x: 0.3736, y: 0.8133, s: 0.078, c: '808080', a: 1.0 },
				{ x: 0.3809, y: 0.7919, s: 0.076, c: '808080', a: 1.0 },
				{ x: 0.3764, y: 0.8095, s: 0.08, c: '7E7E7E', a: 1.0 },
				{ x: 0.3797, y: 0.7855, s: 0.061, c: '858585', a: 1.0 },
				{ x: 0.3801, y: 0.7641, s: 0.053, c: '888888', a: 1.0 },
				{ x: 0.3756, y: 0.7679, s: 0.111, c: '8B8B8B', a: 1.0 },
				{ x: 0.3829, y: 0.7615, s: 0.055, c: '919191', a: 1.0 },
				{ x: 0.379, y: 0.7455, s: 0.129, c: 'ADADAD', a: 1.0 },
				{ x: 0.3862, y: 0.7376, s: 0.123, c: 'C7C7C7', a: 1.0 },
				{ x: 0.3734, y: 0.74, s: 0.092, c: '868686', a: 1.0 },
				{ x: 0.3822, y: 0.5489, s: 0.023, c: '3C3C3C', a: 1.0 },
				{ x: 0.3761, y: 0.5647, s: 0.1, c: 'A1A1A1', a: 1.0 },
				{ x: 0.3783, y: 0.5434, s: 0.049, c: '5A5A5A', a: 1.0 },
				{ x: 0.3855, y: 0.525, s: 0.053, c: '525252', a: 1.0 },
				{ x: 0.3793, y: 0.5155, s: 0.101, c: '818181', a: 1.0 },
				{ x: 0.3753, y: 0.5011, s: 0.132, c: 'CFCFCF', a: 1.0 },
				{ x: 0.3825, y: 0.4916, s: 0.118, c: '9C9C9C', a: 1.0 },
				{ x: 0.3786, y: 0.3879, s: 0.054, c: '727272', a: 1.0 },
				{ x: 0.386, y: 0.3784, s: 0.087, c: '727272', a: 1.0 },
				{ x: 0.3747, y: 0.3825, s: 0.067, c: '787878', a: 1.0 },
				{ x: 0.3821, y: 0.3637, s: 0.058, c: '737373', a: 1.0 },
				{ x: 0.384, y: 0.3792, s: 0.063, c: '696969', a: 1.0 },
				{ x: 0.3815, y: 0.9457, s: 0.089, c: '7C7C7C', a: 1.0 },
				{ x: 0.3773, y: 0.9304, s: 0.103, c: '9D9D9D', a: 1.0 },
				{ x: 0.3847, y: 0.9459, s: 0.085, c: 'AFAFAF', a: 1.0 },
				{ x: 0.3783, y: 0.9271, s: 0.103, c: '868686', a: 1.0 },
				{ x: 0.3807, y: 0.9306, s: 0.055, c: '8A8A8A', a: 1.0 },
				{ x: 0.3819, y: 0.8899, s: 0.045, c: '535353', a: 1.0 },
				{ x: 0.3778, y: 0.8866, s: 0.04, c: '6D6D6D', a: 1.0 },
				{ x: 0.3865, y: 0.8902, s: 0.09, c: '757575', a: 1.0 },
				{ x: 0.3871, y: 0.8712, s: 0.065, c: '7B7B7B', a: 1.0 },
				{ x: 0.3812, y: 0.8628, s: 0.052, c: '868686', a: 1.0 },
				{ x: 0.3898, y: 0.8663, s: 0.063, c: '8D8D8D', a: 1.0 },
				{ x: 0.3773, y: 0.846, s: 0.085, c: '929292', a: 1.0 },
				{ x: 0.3843, y: 0.8629, s: 0.073, c: '969696', a: 1.0 },
				{ x: 0.3799, y: 0.8428, s: 0.073, c: '939393', a: 1.0 },
				{ x: 0.3803, y: 0.8463, s: 0.088, c: '939393', a: 1.0 },
				{ x: 0.3876, y: 0.8379, s: 0.098, c: '939393', a: 1.0 },
				{ x: 0.3829, y: 0.8191, s: 0.061, c: '919191', a: 1.0 },
				{ x: 0.3837, y: 0.8224, s: 0.112, c: '909090', a: 1.0 },
				{ x: 0.3863, y: 0.819, s: 0.076, c: '898989', a: 1.0 },
				{ x: 0.3871, y: 0.7988, s: 0.096, c: '8B8B8B', a: 1.0 },
				{ x: 0.3824, y: 0.7904, s: 0.052, c: '8B8B8B', a: 1.0 },
				{ x: 0.377, y: 0.7752, s: 0.104, c: '888888', a: 1.0 },
				{ x: 0.3794, y: 0.7701, s: 0.081, c: '949494', a: 1.0 },
				{ x: 0.3826, y: 0.7464, s: 0.062, c: 'A5A5A5', a: 1.0 },
				{ x: 0.3836, y: 0.7503, s: 0.082, c: 'AFAFAF', a: 1.0 },
				{ x: 0.3791, y: 0.7431, s: 0.16, c: 'C4C4C4', a: 1.0 },
				{ x: 0.3859, y: 0.7469, s: 0.065, c: 'A6A6A6', a: 1.0 },
				{ x: 0.3881, y: 0.5477, s: 0.079, c: 'A1A1A1', a: 1.0 },
				{ x: 0.3824, y: 0.5397, s: 0.089, c: 'A8A8A8', a: 1.0 },
				{ x: 0.3895, y: 0.5444, s: 0.097, c: '919191', a: 1.0 },
				{ x: 0.378, y: 0.5244, s: 0.07, c: '727272', a: 1.0 },
				{ x: 0.3857, y: 0.5278, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.3813, y: 0.5126, s: 0.102, c: '9F9F9F', a: 1.0 },
				{ x: 0.3885, y: 0.5039, s: 0.077, c: 'BBBBBB', a: 1.0 },
				{ x: 0.3828, y: 0.4838, s: 0.118, c: 'C5C5C5', a: 1.0 },
				{ x: 0.3849, y: 0.4886, s: 0.103, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3783, y: 0.4211, s: 0.054, c: '525252', a: 1.0 },
				{ x: 0.3806, y: 0.4123, s: 0.07, c: '585858', a: 1.0 },
				{ x: 0.3882, y: 0.4043, s: 0.075, c: '6C6C6C', a: 1.0 },
				{ x: 0.3817, y: 0.3853, s: 0.045, c: '747474', a: 1.0 },
				{ x: 0.384, y: 0.3885, s: 0.082, c: '747474', a: 1.0 },
				{ x: 0.3782, y: 0.3804, s: 0.099, c: '828282', a: 1.0 },
				{ x: 0.3854, y: 0.3851, s: 0.085, c: '878787', a: 1.0 },
				{ x: 0.3872, y: 0.3652, s: 0.075, c: '8D8D8D', a: 1.0 },
				{ x: 0.381, y: 0.3565, s: 0.06, c: '979797', a: 1.0 },
				{ x: 0.3886, y: 0.3604, s: 0.098, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3774, y: 0.3413, s: 0.108, c: '969696', a: 1.0 },
				{ x: 0.3842, y: 0.3571, s: 0.042, c: '757575', a: 1.0 },
				{ x: 0.383, y: 0.9602, s: 0.097, c: '7C7C7C', a: 1.0 },
				{ x: 0.384, y: 0.9522, s: 0.058, c: '7C7C7C', a: 1.0 },
				{ x: 0.3863, y: 0.9358, s: 0.11, c: '949494', a: 1.0 },
				{ x: 0.3811, y: 0.9316, s: 0.102, c: '959595', a: 1.0 },
				{ x: 0.3845, y: 0.8961, s: 0.045, c: '6D6D6D', a: 1.0 },
				{ x: 0.3932, y: 0.8765, s: 0.075, c: '767676', a: 1.0 },
				{ x: 0.38, y: 0.8918, s: 0.062, c: '7F7F7F', a: 1.0 },
				{ x: 0.3831, y: 0.8759, s: 0.053, c: '909090', a: 1.0 },
				{ x: 0.3834, y: 0.8682, s: 0.114, c: '969696', a: 1.0 },
				{ x: 0.3921, y: 0.8479, s: 0.078, c: '999999', a: 1.0 },
				{ x: 0.3867, y: 0.8522, s: 0.068, c: '9A9A9A', a: 1.0 },
				{ x: 0.3822, y: 0.8481, s: 0.095, c: '999999', a: 1.0 },
				{ x: 0.3892, y: 0.8284, s: 0.065, c: '999999', a: 1.0 },
				{ x: 0.3856, y: 0.8243, s: 0.119, c: '939393', a: 1.0 },
				{ x: 0.3926, y: 0.804, s: 0.06, c: '909090', a: 1.0 },
				{ x: 0.3804, y: 0.8203, s: 0.094, c: '909090', a: 1.0 },
				{ x: 0.389, y: 0.8, s: 0.062, c: '929292', a: 1.0 },
				{ x: 0.3826, y: 0.8043, s: 0.092, c: '949494', a: 1.0 },
				{ x: 0.3924, y: 0.7764, s: 0.093, c: '979797', a: 1.0 },
				{ x: 0.3861, y: 0.7803, s: 0.061, c: '9A9A9A', a: 1.0 },
				{ x: 0.388, y: 0.772, s: 0.096, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3825, y: 0.7763, s: 0.124, c: 'A6A6A6', a: 1.0 },
				{ x: 0.3895, y: 0.756, s: 0.132, c: 'A9A9A9', a: 1.0 },
				{ x: 0.3858, y: 0.752, s: 0.106, c: 'B2B2B2', a: 1.0 },
				{ x: 0.393, y: 0.7325, s: 0.121, c: 'BDBDBD', a: 1.0 },
				{ x: 0.381, y: 0.748, s: 0.114, c: 'BBBBBB', a: 1.0 },
				{ x: 0.389, y: 0.5912, s: 0.051, c: '505050', a: 1.0 },
				{ x: 0.3904, y: 0.5954, s: 0.093, c: '9D9D9D', a: 1.0 },
				{ x: 0.3843, y: 0.5874, s: 0.034, c: '5B5B5B', a: 1.0 },
				{ x: 0.3923, y: 0.5437, s: 0.089, c: '797979', a: 1.0 },
				{ x: 0.3803, y: 0.5595, s: 0.094, c: '9E9E9E', a: 1.0 },
				{ x: 0.3875, y: 0.5396, s: 0.063, c: '868686', a: 1.0 },
				{ x: 0.3822, y: 0.5434, s: 0.079, c: '656565', a: 1.0 },
				{ x: 0.3836, y: 0.5234, s: 0.022, c: '3C3C3C', a: 1.0 },
				{ x: 0.3855, y: 0.5075, s: 0.112, c: '969696', a: 1.0 },
				{ x: 0.3815, y: 0.5036, s: 0.088, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3902, y: 0.4758, s: 0.128, c: 'BBBBBB', a: 1.0 },
				{ x: 0.3849, y: 0.4797, s: 0.074, c: '787878', a: 1.0 },
				{ x: 0.3929, y: 0.4479, s: 0.038, c: '5A5A5A', a: 1.0 },
				{ x: 0.3801, y: 0.4637, s: 0.071, c: '616161', a: 1.0 },
				{ x: 0.388, y: 0.42, s: 0.049, c: '474747', a: 1.0 },
				{ x: 0.3827, y: 0.4239, s: 0.033, c: '4C4C4C', a: 1.0 },
				{ x: 0.3841, y: 0.4159, s: 0.054, c: '5E5E5E', a: 1.0 },
				{ x: 0.3913, y: 0.3961, s: 0.058, c: '686868', a: 1.0 },
				{ x: 0.3861, y: 0.4, s: 0.041, c: '6C6C6C', a: 1.0 },
				{ x: 0.3875, y: 0.3919, s: 0.086, c: '707070', a: 1.0 },
				{ x: 0.3813, y: 0.3959, s: 0.046, c: '707070', a: 1.0 },
				{ x: 0.3893, y: 0.376, s: 0.09, c: '777777', a: 1.0 },
				{ x: 0.3854, y: 0.3719, s: 0.071, c: '8D8D8D', a: 1.0 },
				{ x: 0.3805, y: 0.3679, s: 0.098, c: '969696', a: 1.0 },
				{ x: 0.3887, y: 0.348, s: 0.087, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3832, y: 0.352, s: 0.129, c: 'AEAEAE', a: 1.0 },
				{ x: 0.3838, y: 0.3465, s: 0.076, c: 'AEAEAE', a: 1.0 },
				{ x: 0.392, y: 0.3307, s: 0.066, c: '818181', a: 1.0 },
				{ x: 0.3898, y: 0.9418, s: 0.074, c: '7C7C7C', a: 1.0 },
				{ x: 0.3906, y: 0.9498, s: 0.078, c: '858585', a: 1.0 },
				{ x: 0.3933, y: 0.9301, s: 0.096, c: '7C7C7C', a: 1.0 },
				{ x: 0.3944, y: 0.938, s: 0.061, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3885, y: 0.9222, s: 0.112, c: 'B1B1B1', a: 1.0 },
				{ x: 0.3844, y: 0.8906, s: 0.049, c: '767676', a: 1.0 },
				{ x: 0.3897, y: 0.8591, s: 0.077, c: '969696', a: 1.0 },
				{ x: 0.3908, y: 0.8671, s: 0.126, c: '9D9D9D', a: 1.0 },
				{ x: 0.3858, y: 0.8511, s: 0.069, c: '9E9E9E', a: 1.0 },
				{ x: 0.3903, y: 0.8356, s: 0.086, c: '9F9F9F', a: 1.0 },
				{ x: 0.3844, y: 0.8198, s: 0.119, c: '9B9B9B', a: 1.0 },
				{ x: 0.3922, y: 0.8158, s: 0.077, c: '939393', a: 1.0 },
				{ x: 0.3882, y: 0.808, s: 0.071, c: '929292', a: 1.0 },
				{ x: 0.3833, y: 0.788, s: 0.074, c: '959595', a: 1.0 },
				{ x: 0.3916, y: 0.796, s: 0.061, c: '999999', a: 1.0 },
				{ x: 0.3856, y: 0.7921, s: 0.129, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3903, y: 0.7647, s: 0.084, c: 'B6B6B6', a: 1.0 },
				{ x: 0.385, y: 0.7485, s: 0.11, c: 'B6B6B6', a: 1.0 },
				{ x: 0.3882, y: 0.7368, s: 0.142, c: 'C5C5C5', a: 1.0 },
				{ x: 0.3959, y: 0.5963, s: 0.044, c: '5C5C5C', a: 1.0 },
				{ x: 0.3839, y: 0.5801, s: 0.064, c: '878787', a: 1.0 },
				{ x: 0.3862, y: 0.5841, s: 0.05, c: '5C5C5C', a: 1.0 },
				{ x: 0.3952, y: 0.5585, s: 0.114, c: '919191', a: 1.0 },
				{ x: 0.3895, y: 0.5311, s: 0.049, c: '5A5A5A', a: 1.0 },
				{ x: 0.3928, y: 0.4955, s: 0.085, c: '878787', a: 1.0 },
				{ x: 0.3941, y: 0.503, s: 0.08, c: '878787', a: 1.0 },
				{ x: 0.3884, y: 0.4877, s: 0.086, c: '9B9B9B', a: 1.0 },
				{ x: 0.384, y: 0.468, s: 0.16, c: 'CDCDCD', a: 1.0 },
				{ x: 0.3863, y: 0.472, s: 0.078, c: '606060', a: 1.0 },
				{ x: 0.3877, y: 0.456, s: 0.042, c: '6B6B6B', a: 1.0 },
				{ x: 0.3952, y: 0.4636, s: 0.055, c: '7E7E7E', a: 1.0 },
				{ x: 0.3897, y: 0.4184, s: 0.039, c: '474747', a: 1.0 },
				{ x: 0.391, y: 0.4261, s: 0.062, c: '5A5A5A', a: 1.0 },
				{ x: 0.3853, y: 0.4106, s: 0.071, c: '5A5A5A', a: 1.0 },
				{ x: 0.3933, y: 0.4063, s: 0.04, c: '5E5E5E', a: 1.0 },
				{ x: 0.3942, y: 0.4147, s: 0.081, c: '686868', a: 1.0 },
				{ x: 0.3889, y: 0.3986, s: 0.041, c: '707070', a: 1.0 },
				{ x: 0.3965, y: 0.395, s: 0.085, c: '6C6C6C', a: 1.0 },
				{ x: 0.3845, y: 0.3789, s: 0.075, c: '6C6C6C', a: 1.0 },
				{ x: 0.3923, y: 0.3865, s: 0.072, c: '727272', a: 1.0 },
				{ x: 0.3866, y: 0.3826, s: 0.058, c: '777777', a: 1.0 },
				{ x: 0.3877, y: 0.3675, s: 0.055, c: '828282', a: 1.0 },
				{ x: 0.3912, y: 0.355, s: 0.103, c: '969696', a: 1.0 },
				{ x: 0.3857, y: 0.3518, s: 0.07, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3869, y: 0.336, s: 0.107, c: 'AEAEAE', a: 1.0 },
				{ x: 0.3946, y: 0.3431, s: 0.092, c: 'C1C1C1', a: 1.0 },
				{ x: 0.3891, y: 0.3161, s: 0.07, c: 'B4B4B4', a: 1.0 },
				{ x: 0.388, y: 0.9466, s: 0.058, c: '828282', a: 1.0 },
				{ x: 0.3969, y: 0.9394, s: 0.103, c: '838383', a: 1.0 },
				{ x: 0.3914, y: 0.9348, s: 0.085, c: '7C7C7C', a: 1.0 },
				{ x: 0.3992, y: 0.919, s: 0.078, c: '7D7D7D', a: 1.0 },
				{ x: 0.3948, y: 0.9229, s: 0.078, c: 'A3A3A3', a: 1.0 },
				{ x: 0.3893, y: 0.9071, s: 0.079, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3904, y: 0.9158, s: 0.089, c: '6E6E6E', a: 1.0 },
				{ x: 0.3938, y: 0.8796, s: 0.078, c: '878787', a: 1.0 },
				{ x: 0.3883, y: 0.8764, s: 0.098, c: '919191', a: 1.0 },
				{ x: 0.3961, y: 0.8844, s: 0.116, c: '969696', a: 1.0 },
				{ x: 0.3972, y: 0.8679, s: 0.059, c: '9F9F9F', a: 1.0 },
				{ x: 0.3917, y: 0.8644, s: 0.111, c: 'A5A5A5', a: 1.0 },
				{ x: 0.3873, y: 0.8559, s: 0.082, c: '9F9F9F', a: 1.0 },
				{ x: 0.3951, y: 0.852, s: 0.106, c: '9D9D9D', a: 1.0 },
				{ x: 0.3896, y: 0.8369, s: 0.103, c: '9E9E9E', a: 1.0 },
				{ x: 0.3893, y: 0.8451, s: 0.065, c: '9F9F9F', a: 1.0 },
				{ x: 0.387, y: 0.8246, s: 0.072, c: '959595', a: 1.0 },
				{ x: 0.3914, y: 0.8045, s: 0.054, c: '919191', a: 1.0 },
				{ x: 0.397, y: 0.8128, s: 0.1, c: '8F8F8F', a: 1.0 },
				{ x: 0.388, y: 0.7939, s: 0.096, c: '969696', a: 1.0 },
				{ x: 0.3924, y: 0.7852, s: 0.113, c: 'ACACAC', a: 1.0 },
				{ x: 0.389, y: 0.7731, s: 0.076, c: 'BFBFBF', a: 1.0 },
				{ x: 0.3911, y: 0.7338, s: 0.101, c: 'C5C5C5', a: 1.0 },
				{ x: 0.3967, y: 0.7422, s: 0.085, c: '858585', a: 1.0 },
				{ x: 0.3956, y: 0.5841, s: 0.04, c: '4E4E4E', a: 1.0 },
				{ x: 0.3878, y: 0.5909, s: 0.084, c: '6B6B6B', a: 1.0 },
				{ x: 0.4, y: 0.5755, s: 0.063, c: '6B6B6B', a: 1.0 },
				{ x: 0.3921, y: 0.5719, s: 0.067, c: '727272', a: 1.0 },
				{ x: 0.3976, y: 0.5624, s: 0.067, c: '727272', a: 1.0 },
				{ x: 0.3965, y: 0.5457, s: 0.035, c: '5B5B5B', a: 1.0 },
				{ x: 0.3887, y: 0.5123, s: 0.088, c: '6E6E6E', a: 1.0 },
				{ x: 0.3932, y: 0.5038, s: 0.071, c: '808080', a: 1.0 },
				{ x: 0.3987, y: 0.5003, s: 0.073, c: '727272', a: 1.0 },
				{ x: 0.3909, y: 0.4849, s: 0.079, c: '838383', a: 1.0 },
				{ x: 0.3953, y: 0.4645, s: 0.072, c: 'B6B6B6', a: 1.0 },
				{ x: 0.3997, y: 0.4577, s: 0.163, c: 'C8C8C8', a: 1.0 },
				{ x: 0.3918, y: 0.4539, s: 0.059, c: '919191', a: 1.0 },
				{ x: 0.3975, y: 0.4603, s: 0.056, c: '5E5E5E', a: 1.0 },
				{ x: 0.3964, y: 0.4341, s: 0.037, c: '444444', a: 1.0 },
				{ x: 0.3884, y: 0.4287, s: 0.048, c: '505050', a: 1.0 },
				{ x: 0.3941, y: 0.4128, s: 0.041, c: '505050', a: 1.0 },
				{ x: 0.3927, y: 0.4223, s: 0.031, c: '505050', a: 1.0 },
				{ x: 0.3985, y: 0.4169, s: 0.047, c: '585858', a: 1.0 },
				{ x: 0.3905, y: 0.4026, s: 0.066, c: '5D5D5D', a: 1.0 },
				{ x: 0.3873, y: 0.3908, s: 0.066, c: '666666', a: 1.0 },
				{ x: 0.3992, y: 0.375, s: 0.069, c: '707070', a: 1.0 },
				{ x: 0.3915, y: 0.3696, s: 0.091, c: '747474', a: 1.0 },
				{ x: 0.3972, y: 0.3789, s: 0.095, c: '7E7E7E', a: 1.0 },
				{ x: 0.3958, y: 0.3616, s: 0.049, c: '818181', a: 1.0 },
				{ x: 0.3883, y: 0.3578, s: 0.101, c: '818181', a: 1.0 },
				{ x: 0.3936, y: 0.3435, s: 0.054, c: '898989', a: 1.0 },
				{ x: 0.3926, y: 0.35, s: 0.104, c: '949494', a: 1.0 },
				{ x: 0.3979, y: 0.3459, s: 0.09, c: '9F9F9F', a: 1.0 },
				{ x: 0.3903, y: 0.3315, s: 0.079, c: 'B4B4B4', a: 1.0 },
				{ x: 0.389, y: 0.338, s: 0.089, c: 'C0C0C0', a: 1.0 },
				{ x: 0.3946, y: 0.3118, s: 0.156, c: 'C4C4C4', a: 1.0 },
				{ x: 0.3871, y: 0.3199, s: 0.072, c: '8D8D8D', a: 1.0 },
				{ x: 0.4024, y: 0.949, s: 0.05, c: '7F7F7F', a: 1.0 },
				{ x: 0.3947, y: 0.9555, s: 0.055, c: '828282', a: 1.0 },
				{ x: 0.4001, y: 0.9397, s: 0.08, c: '858585', a: 1.0 },
				{ x: 0.3991, y: 0.937, s: 0.085, c: '818181', a: 1.0 },
				{ x: 0.3911, y: 0.9197, s: 0.1, c: '808080', a: 1.0 },
				{ x: 0.3954, y: 0.9253, s: 0.063, c: '7D7D7D', a: 1.0 },
				{ x: 0.4011, y: 0.9078, s: 0.085, c: '909090', a: 1.0 },
				{ x: 0.3936, y: 0.9057, s: 0.066, c: 'ABABAB', a: 1.0 },
				{ x: 0.3924, y: 0.8896, s: 0.119, c: 'ABABAB', a: 1.0 },
				{ x: 0.4023, y: 0.8778, s: 0.056, c: '969696', a: 1.0 },
				{ x: 0.3946, y: 0.8846, s: 0.11, c: '9A9A9A', a: 1.0 },
				{ x: 0.403, y: 0.8466, s: 0.091, c: 'A1A1A1', a: 1.0 },
				{ x: 0.3951, y: 0.8527, s: 0.076, c: 'A0A0A0', a: 1.0 },
				{ x: 0.3999, y: 0.8345, s: 0.129, c: '9F9F9F', a: 1.0 },
				{ x: 0.3917, y: 0.8171, s: 0.061, c: '9F9F9F', a: 1.0 },
				{ x: 0.3973, y: 0.827, s: 0.118, c: '979797', a: 1.0 },
				{ x: 0.3965, y: 0.8226, s: 0.057, c: '929292', a: 1.0 },
				{ x: 0.402, y: 0.8056, s: 0.098, c: '8F8F8F', a: 1.0 },
				{ x: 0.3932, y: 0.7861, s: 0.074, c: '919191', a: 1.0 },
				{ x: 0.3987, y: 0.7937, s: 0.055, c: '8B8B8B', a: 1.0 },
				{ x: 0.3905, y: 0.7797, s: 0.074, c: '909090', a: 1.0 },
				{ x: 0.4007, y: 0.7677, s: 0.084, c: 'C2C2C2', a: 1.0 },
				{ x: 0.3992, y: 0.7619, s: 0.118, c: 'C6C6C6', a: 1.0 },
				{ x: 0.3914, y: 0.748, s: 0.11, c: 'C6C6C6', a: 1.0 },
				{ x: 0.3973, y: 0.7557, s: 0.11, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4015, y: 0.736, s: 0.135, c: 'BCBCBC', a: 1.0 },
				{ x: 0.394, y: 0.7429, s: 0.062, c: 'AAAAAA', a: 1.0 },
				{ x: 0.3929, y: 0.5839, s: 0.045, c: '3A3A3A', a: 1.0 },
				{ x: 0.398, y: 0.593, s: 0.043, c: '414141', a: 1.0 },
				{ x: 0.3901, y: 0.5764, s: 0.06, c: '727272', a: 1.0 },
				{ x: 0.3949, y: 0.5693, s: 0.026, c: '484848', a: 1.0 },
				{ x: 0.4002, y: 0.5527, s: 0.064, c: '797979', a: 1.0 },
				{ x: 0.3995, y: 0.5503, s: 0.063, c: '5B5B5B', a: 1.0 },
				{ x: 0.3915, y: 0.5337, s: 0.055, c: '454545', a: 1.0 },
				{ x: 0.4016, y: 0.4975, s: 0.081, c: '8B8B8B', a: 1.0 },
				{ x: 0.3923, y: 0.4791, s: 0.052, c: '787878', a: 1.0 },
				{ x: 0.3976, y: 0.4857, s: 0.109, c: '888888', a: 1.0 },
				{ x: 0.3904, y: 0.4691, s: 0.068, c: '9F9F9F', a: 1.0 },
				{ x: 0.4004, y: 0.4477, s: 0.115, c: 'CECECE', a: 1.0 },
				{ x: 0.391, y: 0.4376, s: 0.075, c: '757575', a: 1.0 },
				{ x: 0.4029, y: 0.4357, s: 0.066, c: '656565', a: 1.0 },
				{ x: 0.3957, y: 0.443, s: 0.039, c: '545454', a: 1.0 },
				{ x: 0.4011, y: 0.4257, s: 0.046, c: '404040', a: 1.0 },
				{ x: 0.3997, y: 0.424, s: 0.029, c: '404040', a: 1.0 },
				{ x: 0.3917, y: 0.4066, s: 0.042, c: '484848', a: 1.0 },
				{ x: 0.3978, y: 0.414, s: 0.049, c: '505050', a: 1.0 },
				{ x: 0.4017, y: 0.3951, s: 0.077, c: '606060', a: 1.0 },
				{ x: 0.3945, y: 0.4045, s: 0.042, c: '606060', a: 1.0 },
				{ x: 0.3985, y: 0.383, s: 0.077, c: '6D6D6D', a: 1.0 },
				{ x: 0.3952, y: 0.3708, s: 0.084, c: '757575', a: 1.0 },
				{ x: 0.3992, y: 0.3518, s: 0.084, c: '868686', a: 1.0 },
				{ x: 0.3922, y: 0.3349, s: 0.066, c: '919191', a: 1.0 },
				{ x: 0.3969, y: 0.3447, s: 0.066, c: 'A1A1A1', a: 1.0 },
				{ x: 0.3966, y: 0.3397, s: 0.12, c: 'AEAEAE', a: 1.0 },
				{ x: 0.4021, y: 0.3231, s: 0.109, c: 'BABABA', a: 1.0 },
				{ x: 0.3935, y: 0.3329, s: 0.114, c: 'C5C5C5', a: 1.0 },
				{ x: 0.3935, y: 0.9466, s: 0.099, c: '7F7F7F', a: 1.0 },
				{ x: 0.4065, y: 0.9565, s: 0.061, c: '828282', a: 1.0 },
				{ x: 0.3978, y: 0.9396, s: 0.085, c: '7F7F7F', a: 1.0 },
				{ x: 0.403, y: 0.9209, s: 0.061, c: '7A7A7A', a: 1.0 },
				{ x: 0.4008, y: 0.9227, s: 0.096, c: '808080', a: 1.0 },
				{ x: 0.3996, y: 0.9087, s: 0.064, c: '737373', a: 1.0 },
				{ x: 0.4043, y: 0.9156, s: 0.069, c: '838383', a: 1.0 },
				{ x: 0.3973, y: 0.8899, s: 0.097, c: 'A2A2A2', a: 1.0 },
				{ x: 0.3963, y: 0.8967, s: 0.084, c: 'B5B5B5', a: 1.0 },
				{ x: 0.401, y: 0.8798, s: 0.097, c: 'ABABAB', a: 1.0 },
				{ x: 0.4054, y: 0.8847, s: 0.128, c: '9F9F9F', a: 1.0 },
				{ x: 0.3975, y: 0.8678, s: 0.101, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4019, y: 0.8488, s: 0.071, c: 'A7A7A7', a: 1.0 },
				{ x: 0.3949, y: 0.8557, s: 0.069, c: 'A5A5A5', a: 1.0 },
				{ x: 0.3986, y: 0.8368, s: 0.079, c: '9F9F9F', a: 1.0 },
				{ x: 0.405, y: 0.8348, s: 0.091, c: '9E9E9E', a: 1.0 },
				{ x: 0.3971, y: 0.816, s: 0.118, c: '9C9C9C', a: 1.0 },
				{ x: 0.3952, y: 0.827, s: 0.072, c: '949494', a: 1.0 },
				{ x: 0.4016, y: 0.8231, s: 0.084, c: '919191', a: 1.0 },
				{ x: 0.3995, y: 0.8043, s: 0.1, c: '8D8D8D', a: 1.0 },
				{ x: 0.4052, y: 0.8152, s: 0.072, c: '888888', a: 1.0 },
				{ x: 0.3946, y: 0.7757, s: 0.074, c: '9C9C9C', a: 1.0 },
				{ x: 0.399, y: 0.765, s: 0.149, c: 'C9C9C9', a: 1.0 },
				{ x: 0.4047, y: 0.7639, s: 0.143, c: 'D0D0D0', a: 1.0 },
				{ x: 0.3958, y: 0.7532, s: 0.109, c: 'BCBCBC', a: 1.0 },
				{ x: 0.3969, y: 0.6393, s: 0.029, c: '484848', a: 1.0 },
				{ x: 0.396, y: 0.6443, s: 0.046, c: '585858', a: 1.0 },
				{ x: 0.4022, y: 0.6285, s: 0.048, c: '626262', a: 1.0 },
				{ x: 0.3937, y: 0.6273, s: 0.056, c: '585858', a: 1.0 },
				{ x: 0.4065, y: 0.6025, s: 0.038, c: '2C2C2C', a: 1.0 },
				{ x: 0.3989, y: 0.5867, s: 0.037, c: '323232', a: 1.0 },
				{ x: 0.4034, y: 0.5858, s: 0.059, c: '565656', a: 1.0 },
				{ x: 0.4033, y: 0.57, s: 0.031, c: '565656', a: 1.0 },
				{ x: 0.3944, y: 0.5632, s: 0.082, c: '686868', a: 1.0 },
				{ x: 0.4001, y: 0.5623, s: 0.084, c: '727272', a: 1.0 },
				{ x: 0.4044, y: 0.5515, s: 0.04, c: '545454', a: 1.0 },
				{ x: 0.3968, y: 0.5089, s: 0.044, c: '3E3E3E', a: 1.0 },
				{ x: 0.3963, y: 0.5166, s: 0.088, c: '7D7D7D', a: 1.0 },
				{ x: 0.4012, y: 0.4978, s: 0.056, c: '8D8D8D', a: 1.0 },
				{ x: 0.394, y: 0.4968, s: 0.107, c: '858585', a: 1.0 },
				{ x: 0.4064, y: 0.5051, s: 0.045, c: '727272', a: 1.0 },
				{ x: 0.3979, y: 0.4859, s: 0.08, c: '757575', a: 1.0 },
				{ x: 0.4031, y: 0.4692, s: 0.11, c: '919191', a: 1.0 },
				{ x: 0.3945, y: 0.4746, s: 0.078, c: '979797', a: 1.0 },
				{ x: 0.4005, y: 0.4702, s: 0.131, c: 'ADADAD', a: 1.0 },
				{ x: 0.3985, y: 0.4574, s: 0.063, c: 'ADADAD', a: 1.0 },
				{ x: 0.3975, y: 0.4347, s: 0.086, c: '757575', a: 1.0 },
				{ x: 0.3951, y: 0.446, s: 0.04, c: '444444', a: 1.0 },
				{ x: 0.4014, y: 0.409, s: 0.03, c: '404040', a: 1.0 },
				{ x: 0.3941, y: 0.4053, s: 0.028, c: '464646', a: 1.0 },
				{ x: 0.405, y: 0.4159, s: 0.036, c: '4F4F4F', a: 1.0 },
				{ x: 0.398, y: 0.3887, s: 0.071, c: '585858', a: 1.0 },
				{ x: 0.404, y: 0.3933, s: 0.037, c: '5D5D5D', a: 1.0 },
				{ x: 0.402, y: 0.3803, s: 0.055, c: '636363', a: 1.0 },
				{ x: 0.3947, y: 0.3768, s: 0.057, c: '666666', a: 1.0 },
				{ x: 0.4059, y: 0.3813, s: 0.063, c: '696969', a: 1.0 },
				{ x: 0.3986, y: 0.3689, s: 0.069, c: '696969', a: 1.0 },
				{ x: 0.4027, y: 0.3463, s: 0.048, c: '818181', a: 1.0 },
				{ x: 0.3953, y: 0.3569, s: 0.095, c: '818181', a: 1.0 },
				{ x: 0.4016, y: 0.3534, s: 0.089, c: '8E8E8E', a: 1.0 },
				{ x: 0.4056, y: 0.3449, s: 0.098, c: 'A9A9A9', a: 1.0 },
				{ x: 0.3962, y: 0.3222, s: 0.077, c: 'C0C0C0', a: 1.0 },
				{ x: 0.4061, y: 0.311, s: 0.066, c: 'B5B5B5', a: 1.0 },
				{ x: 0.4022, y: 0.955, s: 0.095, c: '7C7C7C', a: 1.0 },
				{ x: 0.399, y: 0.9432, s: 0.049, c: '7A7A7A', a: 1.0 },
				{ x: 0.4035, y: 0.9237, s: 0.061, c: '767676', a: 1.0 },
				{ x: 0.403, y: 0.9317, s: 0.09, c: '767676', a: 1.0 },
				{ x: 0.4091, y: 0.9077, s: 0.059, c: '808080', a: 1.0 },
				{ x: 0.3998, y: 0.8961, s: 0.07, c: '707070', a: 1.0 },
				{ x: 0.3969, y: 0.9039, s: 0.105, c: '989898', a: 1.0 },
				{ x: 0.4097, y: 0.8851, s: 0.071, c: 'ABABAB', a: 1.0 },
				{ x: 0.4066, y: 0.8733, s: 0.063, c: 'A8A8A8', a: 1.0 },
				{ x: 0.3977, y: 0.8716, s: 0.115, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4038, y: 0.8557, s: 0.094, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4033, y: 0.8616, s: 0.095, c: 'A6A6A6', a: 1.0 },
				{ x: 0.4076, y: 0.8339, s: 0.128, c: 'A6A6A6', a: 1.0 },
				{ x: 0.3973, y: 0.8321, s: 0.101, c: '959595', a: 1.0 },
				{ x: 0.4083, y: 0.8133, s: 0.099, c: '909090', a: 1.0 },
				{ x: 0.4073, y: 0.7973, s: 0.056, c: '7F7F7F', a: 1.0 },
				{ x: 0.4052, y: 0.8016, s: 0.048, c: '7B7B7B', a: 1.0 },
				{ x: 0.3979, y: 0.7978, s: 0.094, c: '747474', a: 1.0 },
				{ x: 0.4041, y: 0.7857, s: 0.049, c: '7A7A7A', a: 1.0 },
				{ x: 0.4019, y: 0.7818, s: 0.103, c: '909090', a: 1.0 },
				{ x: 0.408, y: 0.7622, s: 0.101, c: 'B2B2B2', a: 1.0 },
				{ x: 0.4008, y: 0.7736, s: 0.113, c: 'C9C9C9', a: 1.0 },
				{ x: 0.3986, y: 0.7701, s: 0.113, c: 'D7D7D7', a: 1.0 },
				{ x: 0.3991, y: 0.7255, s: 0.148, c: 'C5C5C5', a: 1.0 },
				{ x: 0.4063, y: 0.7219, s: 0.1, c: '8D8D8D', a: 1.0 },
				{ x: 0.3968, y: 0.6559, s: 0.045, c: '4D4D4D', a: 1.0 },
				{ x: 0.409, y: 0.6422, s: 0.059, c: '4F4F4F', a: 1.0 },
				{ x: 0.4067, y: 0.5786, s: 0.032, c: '323232', a: 1.0 },
				{ x: 0.4056, y: 0.5871, s: 0.029, c: '323232', a: 1.0 },
				{ x: 0.3994, y: 0.567, s: 0.042, c: '727272', a: 1.0 },
				{ x: 0.405, y: 0.5486, s: 0.079, c: '686868', a: 1.0 },
				{ x: 0.4022, y: 0.5569, s: 0.067, c: '6A6A6A', a: 1.0 },
				{ x: 0.4094, y: 0.5326, s: 0.063, c: '5B5B5B', a: 1.0 },
				{ x: 0.4016, y: 0.5187, s: 0.031, c: '484848', a: 1.0 },
				{ x: 0.3988, y: 0.5034, s: 0.094, c: '757575', a: 1.0 },
				{ x: 0.406, y: 0.5029, s: 0.07, c: '757575', a: 1.0 },
				{ x: 0.3981, y: 0.5067, s: 0.048, c: '727272', a: 1.0 },
				{ x: 0.4087, y: 0.4913, s: 0.05, c: '6F6F6F', a: 1.0 },
				{ x: 0.4054, y: 0.4793, s: 0.109, c: '919191', a: 1.0 },
				{ x: 0.402, y: 0.4673, s: 0.109, c: '979797', a: 1.0 },
				{ x: 0.4074, y: 0.4429, s: 0.047, c: '757575', a: 1.0 },
				{ x: 0.4013, y: 0.4513, s: 0.036, c: '545454', a: 1.0 },
				{ x: 0.3985, y: 0.3913, s: 0.042, c: '4C4C4C', a: 1.0 },
				{ x: 0.404, y: 0.3892, s: 0.049, c: '545454', a: 1.0 },
				{ x: 0.3978, y: 0.3976, s: 0.035, c: '5A5A5A', a: 1.0 },
				{ x: 0.4084, y: 0.3782, s: 0.051, c: '585858', a: 1.0 },
				{ x: 0.4007, y: 0.3757, s: 0.061, c: '646464', a: 1.0 },
				{ x: 0.4051, y: 0.3665, s: 0.088, c: '707070', a: 1.0 },
				{ x: 0.3971, y: 0.364, s: 0.065, c: '797979', a: 1.0 },
				{ x: 0.4032, y: 0.3547, s: 0.061, c: '919191', a: 1.0 },
				{ x: 0.4073, y: 0.3284, s: 0.129, c: '9F9F9F', a: 1.0 },
				{ x: 0.4009, y: 0.3378, s: 0.105, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4, y: 0.3191, s: 0.09, c: 'B4B4B4', a: 1.0 },
				{ x: 0.3975, y: 0.3261, s: 0.089, c: 'CBCBCB', a: 1.0 },
				{ x: 0.4002, y: 0.3048, s: 0.109, c: 'D7D7D7', a: 1.0 },
				{ x: 0.4097, y: 0.9597, s: 0.039, c: '6D6D6D', a: 1.0 },
				{ x: 0.4004, y: 0.9455, s: 0.078, c: '808080', a: 1.0 },
				{ x: 0.4123, y: 0.943, s: 0.108, c: '858585', a: 1.0 },
				{ x: 0.4104, y: 0.9337, s: 0.076, c: '767676', a: 1.0 },
				{ x: 0.409, y: 0.9313, s: 0.061, c: '717171', a: 1.0 },
				{ x: 0.4031, y: 0.9108, s: 0.053, c: '6F6F6F', a: 1.0 },
				{ x: 0.4058, y: 0.8955, s: 0.094, c: '7A7A7A', a: 1.0 },
				{ x: 0.4035, y: 0.8848, s: 0.086, c: '6D6D6D', a: 1.0 },
				{ x: 0.4021, y: 0.8838, s: 0.095, c: '828282', a: 1.0 },
				{ x: 0.4095, y: 0.8874, s: 0.095, c: '9E9E9E', a: 1.0 },
				{ x: 0.4002, y: 0.8731, s: 0.109, c: 'ADADAD', a: 1.0 },
				{ x: 0.4115, y: 0.861, s: 0.105, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4025, y: 0.8398, s: 0.075, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4083, y: 0.8496, s: 0.106, c: '9F9F9F', a: 1.0 },
				{ x: 0.4052, y: 0.823, s: 0.088, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4128, y: 0.8328, s: 0.066, c: '9F9F9F', a: 1.0 },
				{ x: 0.405, y: 0.8136, s: 0.127, c: '9D9D9D', a: 1.0 },
				{ x: 0.4018, y: 0.8116, s: 0.089, c: '939393', a: 1.0 },
				{ x: 0.4016, y: 0.8018, s: 0.06, c: '7C7C7C', a: 1.0 },
				{ x: 0.4117, y: 0.7998, s: 0.057, c: '757575', a: 1.0 },
				{ x: 0.4039, y: 0.7851, s: 0.063, c: '6C6C6C', a: 1.0 },
				{ x: 0.4115, y: 0.789, s: 0.049, c: '6D6D6D', a: 1.0 },
				{ x: 0.4087, y: 0.7876, s: 0.07, c: '898989', a: 1.0 },
				{ x: 0.4043, y: 0.7411, s: 0.127, c: 'C1C1C1', a: 1.0 },
				{ x: 0.4019, y: 0.7391, s: 0.1, c: 'B5B5B5', a: 1.0 },
				{ x: 0.4008, y: 0.7297, s: 0.146, c: 'B3B3B3', a: 1.0 },
				{ x: 0.404, y: 0.6358, s: 0.052, c: '444444', a: 1.0 },
				{ x: 0.4112, y: 0.6404, s: 0.03, c: '444444', a: 1.0 },
				{ x: 0.4097, y: 0.5967, s: 0.028, c: '2E2E2E', a: 1.0 },
				{ x: 0.4007, y: 0.582, s: 0.029, c: '2B2B2B', a: 1.0 },
				{ x: 0.4079, y: 0.5688, s: 0.062, c: '676767', a: 1.0 },
				{ x: 0.4063, y: 0.543, s: 0.077, c: '616161', a: 1.0 },
				{ x: 0.4102, y: 0.5521, s: 0.076, c: '6C6C6C', a: 1.0 },
				{ x: 0.4067, y: 0.5283, s: 0.048, c: '3F3F3F', a: 1.0 },
				{ x: 0.4131, y: 0.5063, s: 0.054, c: '5F5F5F', a: 1.0 },
				{ x: 0.4034, y: 0.4928, s: 0.058, c: '5D5D5D', a: 1.0 },
				{ x: 0.4021, y: 0.491, s: 0.037, c: '5D5D5D', a: 1.0 },
				{ x: 0.4099, y: 0.4946, s: 0.076, c: '6F6F6F', a: 1.0 },
				{ x: 0.4002, y: 0.481, s: 0.086, c: '898989', a: 1.0 },
				{ x: 0.4123, y: 0.4785, s: 0.058, c: '909090', a: 1.0 },
				{ x: 0.4059, y: 0.4591, s: 0.085, c: '909090', a: 1.0 },
				{ x: 0.409, y: 0.4667, s: 0.095, c: '828282', a: 1.0 },
				{ x: 0.4027, y: 0.4465, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.407, y: 0.4567, s: 0.037, c: '454545', a: 1.0 },
				{ x: 0.4057, y: 0.3888, s: 0.039, c: '404040', a: 1.0 },
				{ x: 0.4126, y: 0.393, s: 0.049, c: '4C4C4C', a: 1.0 },
				{ x: 0.4046, y: 0.3794, s: 0.037, c: '585858', a: 1.0 },
				{ x: 0.4095, y: 0.3812, s: 0.048, c: '626262', a: 1.0 },
				{ x: 0.4015, y: 0.367, s: 0.081, c: '676767', a: 1.0 },
				{ x: 0.4117, y: 0.3653, s: 0.061, c: '6F6F6F', a: 1.0 },
				{ x: 0.4062, y: 0.351, s: 0.074, c: '767676', a: 1.0 },
				{ x: 0.4084, y: 0.3528, s: 0.056, c: '8E8E8E', a: 1.0 },
				{ x: 0.4029, y: 0.339, s: 0.1, c: '9C9C9C', a: 1.0 },
				{ x: 0.4049, y: 0.307, s: 0.102, c: 'C3C3C3', a: 1.0 },
				{ x: 0.4019, y: 0.3054, s: 0.113, c: 'CACACA', a: 1.0 },
				{ x: 0.4017, y: 0.2954, s: 0.108, c: 'CACACA', a: 1.0 },
				{ x: 0.412, y: 0.2929, s: 0.081, c: '949494', a: 1.0 },
				{ x: 0.4073, y: 0.9559, s: 0.064, c: '5C5C5C', a: 1.0 },
				{ x: 0.404, y: 0.9437, s: 0.046, c: '7C7C7C', a: 1.0 },
				{ x: 0.4115, y: 0.9179, s: 0.08, c: '6C6C6C', a: 1.0 },
				{ x: 0.4134, y: 0.9078, s: 0.073, c: '6A6A6A', a: 1.0 },
				{ x: 0.4062, y: 0.9156, s: 0.083, c: '6D6D6D', a: 1.0 },
				{ x: 0.41, y: 0.8959, s: 0.089, c: '727272', a: 1.0 },
				{ x: 0.4161, y: 0.88, s: 0.043, c: '676767', a: 1.0 },
				{ x: 0.4075, y: 0.8779, s: 0.072, c: '707070', a: 1.0 },
				{ x: 0.4147, y: 0.8817, s: 0.066, c: '898989', a: 1.0 },
				{ x: 0.404, y: 0.8659, s: 0.121, c: 'ADADAD', a: 1.0 },
				{ x: 0.4093, y: 0.8558, s: 0.132, c: 'ABABAB', a: 1.0 },
				{ x: 0.414, y: 0.8539, s: 0.061, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4059, y: 0.8438, s: 0.065, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4105, y: 0.8179, s: 0.088, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4071, y: 0.8059, s: 0.083, c: '868686', a: 1.0 },
				{ x: 0.4038, y: 0.7939, s: 0.043, c: '636363', a: 1.0 },
				{ x: 0.4152, y: 0.774, s: 0.075, c: '666666', a: 1.0 },
				{ x: 0.4145, y: 0.7819, s: 0.117, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4064, y: 0.7698, s: 0.176, c: 'D9D9D9', a: 1.0 },
				{ x: 0.4091, y: 0.75, s: 0.156, c: 'C1C1C1', a: 1.0 },
				{ x: 0.4078, y: 0.7362, s: 0.108, c: 'ACACAC', a: 1.0 },
				{ x: 0.4056, y: 0.7383, s: 0.089, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4131, y: 0.7224, s: 0.078, c: 'BEBEBE', a: 1.0 },
				{ x: 0.4042, y: 0.7245, s: 0.043, c: '6C6C6C', a: 1.0 },
				{ x: 0.4158, y: 0.5539, s: 0.067, c: '525252', a: 1.0 },
				{ x: 0.4069, y: 0.5618, s: 0.035, c: '595959', a: 1.0 },
				{ x: 0.4144, y: 0.5638, s: 0.06, c: '595959', a: 1.0 },
				{ x: 0.4037, y: 0.5501, s: 0.067, c: '727272', a: 1.0 },
				{ x: 0.411, y: 0.5283, s: 0.055, c: '626262', a: 1.0 },
				{ x: 0.4088, y: 0.5124, s: 0.059, c: '4A4A4A', a: 1.0 },
				{ x: 0.4081, y: 0.4985, s: 0.049, c: '4C4C4C', a: 1.0 },
				{ x: 0.4056, y: 0.5006, s: 0.067, c: '5D5D5D', a: 1.0 },
				{ x: 0.4101, y: 0.4849, s: 0.093, c: '787878', a: 1.0 },
				{ x: 0.405, y: 0.4869, s: 0.072, c: '898989', a: 1.0 },
				{ x: 0.4068, y: 0.4732, s: 0.055, c: '878787', a: 1.0 },
				{ x: 0.415, y: 0.4752, s: 0.051, c: '7D7D7D', a: 1.0 },
				{ x: 0.4128, y: 0.4531, s: 0.089, c: '707070', a: 1.0 },
				{ x: 0.4035, y: 0.4612, s: 0.034, c: '585858', a: 1.0 },
				{ x: 0.4113, y: 0.3858, s: 0.06, c: '4C4C4C', a: 1.0 },
				{ x: 0.4096, y: 0.3879, s: 0.052, c: '585858', a: 1.0 },
				{ x: 0.414, y: 0.3899, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.4081, y: 0.3742, s: 0.041, c: '5C5C5C', a: 1.0 },
				{ x: 0.4059, y: 0.3762, s: 0.078, c: '646464', a: 1.0 },
				{ x: 0.4107, y: 0.3545, s: 0.074, c: '696969', a: 1.0 },
				{ x: 0.4048, y: 0.3626, s: 0.06, c: '6F6F6F', a: 1.0 },
				{ x: 0.4075, y: 0.3424, s: 0.091, c: '878787', a: 1.0 },
				{ x: 0.4041, y: 0.331, s: 0.114, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4098, y: 0.3172, s: 0.146, c: 'BCBCBC', a: 1.0 },
				{ x: 0.4117, y: 0.3035, s: 0.151, c: 'CACACA', a: 1.0 },
				{ x: 0.4106, y: 0.2832, s: 0.096, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4196, y: 0.9505, s: 0.037, c: '454545', a: 1.0 },
				{ x: 0.411, y: 0.958, s: 0.049, c: '646464', a: 1.0 },
				{ x: 0.4086, y: 0.9368, s: 0.094, c: '7C7C7C', a: 1.0 },
				{ x: 0.4166, y: 0.9383, s: 0.049, c: '808080', a: 1.0 },
				{ x: 0.4076, y: 0.917, s: 0.082, c: '6C6C6C', a: 1.0 },
				{ x: 0.4133, y: 0.9264, s: 0.072, c: '6A6A6A', a: 1.0 },
				{ x: 0.4175, y: 0.905, s: 0.081, c: '686868', a: 1.0 },
				{ x: 0.4099, y: 0.8912, s: 0.041, c: '676767', a: 1.0 },
				{ x: 0.4145, y: 0.893, s: 0.082, c: '727272', a: 1.0 },
				{ x: 0.4121, y: 0.8775, s: 0.074, c: '6D6D6D', a: 1.0 },
				{ x: 0.4168, y: 0.8792, s: 0.057, c: '5F5F5F', a: 1.0 },
				{ x: 0.4135, y: 0.8672, s: 0.098, c: '898989', a: 1.0 },
				{ x: 0.4078, y: 0.8458, s: 0.08, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4191, y: 0.8535, s: 0.131, c: 'BBBBBB', a: 1.0 },
				{ x: 0.407, y: 0.8206, s: 0.106, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4146, y: 0.8226, s: 0.1, c: '9A9A9A', a: 1.0 },
				{ x: 0.4126, y: 0.806, s: 0.084, c: '939393', a: 1.0 },
				{ x: 0.4114, y: 0.8108, s: 0.044, c: '797979', a: 1.0 },
				{ x: 0.4092, y: 0.7942, s: 0.081, c: '676767', a: 1.0 },
				{ x: 0.4137, y: 0.7963, s: 0.064, c: '5B5B5B', a: 1.0 },
				{ x: 0.4161, y: 0.7655, s: 0.092, c: 'D3D3D3', a: 1.0 },
				{ x: 0.4073, y: 0.7497, s: 0.113, c: 'CCCCCC', a: 1.0 },
				{ x: 0.4127, y: 0.7536, s: 0.107, c: 'B5B5B5', a: 1.0 },
				{ x: 0.415, y: 0.7391, s: 0.098, c: 'ACACAC', a: 1.0 },
				{ x: 0.4096, y: 0.7174, s: 0.089, c: 'BABABA', a: 1.0 },
				{ x: 0.4141, y: 0.7261, s: 0.12, c: 'A8A8A8', a: 1.0 },
				{ x: 0.4118, y: 0.5556, s: 0.036, c: '464646', a: 1.0 },
				{ x: 0.4108, y: 0.5649, s: 0.04, c: '525252', a: 1.0 },
				{ x: 0.4163, y: 0.5449, s: 0.054, c: '828282', a: 1.0 },
				{ x: 0.4075, y: 0.5291, s: 0.053, c: '777777', a: 1.0 },
				{ x: 0.4186, y: 0.5319, s: 0.055, c: '626262', a: 1.0 },
				{ x: 0.413, y: 0.534, s: 0.036, c: '3A3A3A', a: 1.0 },
				{ x: 0.4153, y: 0.5135, s: 0.051, c: '555555', a: 1.0 },
				{ x: 0.4098, y: 0.4922, s: 0.053, c: '5D5D5D', a: 1.0 },
				{ x: 0.4143, y: 0.4946, s: 0.052, c: '6F6F6F', a: 1.0 },
				{ x: 0.411, y: 0.4828, s: 0.092, c: '909090', a: 1.0 },
				{ x: 0.4088, y: 0.4659, s: 0.049, c: '747474', a: 1.0 },
				{ x: 0.4134, y: 0.4683, s: 0.037, c: '5D5D5D', a: 1.0 },
				{ x: 0.4089, y: 0.4469, s: 0.042, c: '535353', a: 1.0 },
				{ x: 0.4178, y: 0.4552, s: 0.047, c: '4B4B4B', a: 1.0 },
				{ x: 0.4133, y: 0.4026, s: 0.062, c: '515151', a: 1.0 },
				{ x: 0.4144, y: 0.3898, s: 0.049, c: '5C5C5C', a: 1.0 },
				{ x: 0.4099, y: 0.3669, s: 0.072, c: '595959', a: 1.0 },
				{ x: 0.4154, y: 0.3693, s: 0.036, c: '5F5F5F', a: 1.0 },
				{ x: 0.4198, y: 0.3564, s: 0.061, c: '686868', a: 1.0 },
				{ x: 0.4121, y: 0.3573, s: 0.081, c: '767676', a: 1.0 },
				{ x: 0.4164, y: 0.3442, s: 0.115, c: '8E8E8E', a: 1.0 },
				{ x: 0.4086, y: 0.3228, s: 0.056, c: '9A9A9A', a: 1.0 },
				{ x: 0.4175, y: 0.3297, s: 0.126, c: 'A5A5A5', a: 1.0 },
				{ x: 0.413, y: 0.3323, s: 0.138, c: 'B2B2B2', a: 1.0 },
				{ x: 0.4142, y: 0.3177, s: 0.11, c: 'C2C2C2', a: 1.0 },
				{ x: 0.4195, y: 0.2844, s: 0.117, c: '999999', a: 1.0 },
				{ x: 0.4117, y: 0.2868, s: 0.058, c: '686868', a: 1.0 },
				{ x: 0.4106, y: 0.9569, s: 0.044, c: '3C3C3C', a: 1.0 },
				{ x: 0.4196, y: 0.9355, s: 0.049, c: '535353', a: 1.0 },
				{ x: 0.4118, y: 0.9385, s: 0.049, c: '6D6D6D', a: 1.0 },
				{ x: 0.4206, y: 0.9451, s: 0.095, c: '777777', a: 1.0 },
				{ x: 0.4161, y: 0.9233, s: 0.061, c: '6C6C6C', a: 1.0 },
				{ x: 0.4116, y: 0.9268, s: 0.056, c: '5E5E5E', a: 1.0 },
				{ x: 0.4127, y: 0.913, s: 0.06, c: '6A6A6A', a: 1.0 },
				{ x: 0.4215, y: 0.915, s: 0.057, c: '656565', a: 1.0 },
				{ x: 0.4136, y: 0.8977, s: 0.06, c: '5A5A5A', a: 1.0 },
				{ x: 0.4102, y: 0.8859, s: 0.046, c: '5F5F5F', a: 1.0 },
				{ x: 0.4193, y: 0.8657, s: 0.072, c: '595959', a: 1.0 },
				{ x: 0.4146, y: 0.8661, s: 0.03, c: '4E4E4E', a: 1.0 },
				{ x: 0.4204, y: 0.8741, s: 0.052, c: '484848', a: 1.0 },
				{ x: 0.4114, y: 0.8544, s: 0.072, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4167, y: 0.8384, s: 0.155, c: 'C1C1C1', a: 1.0 },
				{ x: 0.4123, y: 0.842, s: 0.06, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4177, y: 0.8071, s: 0.094, c: '919191', a: 1.0 },
				{ x: 0.4102, y: 0.8106, s: 0.073, c: '868686', a: 1.0 },
				{ x: 0.4188, y: 0.7933, s: 0.091, c: '757575', a: 1.0 },
				{ x: 0.4145, y: 0.7954, s: 0.076, c: '646464', a: 1.0 },
				{ x: 0.4232, y: 0.7989, s: 0.037, c: '525252', a: 1.0 },
				{ x: 0.4156, y: 0.7813, s: 0.052, c: '585858', a: 1.0 },
				{ x: 0.4112, y: 0.7833, s: 0.098, c: '7B7B7B', a: 1.0 },
				{ x: 0.4199, y: 0.7631, s: 0.082, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4123, y: 0.7696, s: 0.113, c: 'C6C6C6', a: 1.0 },
				{ x: 0.4176, y: 0.7374, s: 0.131, c: 'BABABA', a: 1.0 },
				{ x: 0.4129, y: 0.7383, s: 0.09, c: 'B0B0B0', a: 1.0 },
				{ x: 0.4154, y: 0.5853, s: 0.029, c: '2B2B2B', a: 1.0 },
				{ x: 0.4106, y: 0.5594, s: 0.041, c: '525252', a: 1.0 },
				{ x: 0.4198, y: 0.5357, s: 0.062, c: '727272', a: 1.0 },
				{ x: 0.4121, y: 0.5397, s: 0.104, c: '878787', a: 1.0 },
				{ x: 0.416, y: 0.5244, s: 0.083, c: '777777', a: 1.0 },
				{ x: 0.422, y: 0.5278, s: 0.053, c: '5F5F5F', a: 1.0 },
				{ x: 0.4186, y: 0.5158, s: 0.069, c: '6B6B6B', a: 1.0 },
				{ x: 0.4141, y: 0.4987, s: 0.077, c: '808080', a: 1.0 },
				{ x: 0.4181, y: 0.4806, s: 0.119, c: 'ABABAB', a: 1.0 },
				{ x: 0.4107, y: 0.4867, s: 0.11, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4195, y: 0.4668, s: 0.096, c: '909090', a: 1.0 },
				{ x: 0.4146, y: 0.4685, s: 0.057, c: '5D5D5D', a: 1.0 },
				{ x: 0.4202, y: 0.4034, s: 0.035, c: '515151', a: 1.0 },
				{ x: 0.4162, y: 0.3834, s: 0.054, c: '5E5E5E', a: 1.0 },
				{ x: 0.4113, y: 0.3851, s: 0.072, c: '5D5D5D', a: 1.0 },
				{ x: 0.4169, y: 0.3682, s: 0.059, c: '5C5C5C', a: 1.0 },
				{ x: 0.4128, y: 0.3714, s: 0.044, c: '5A5A5A', a: 1.0 },
				{ x: 0.4134, y: 0.3562, s: 0.071, c: '686868', a: 1.0 },
				{ x: 0.4222, y: 0.3601, s: 0.091, c: '737373', a: 1.0 },
				{ x: 0.4182, y: 0.3365, s: 0.045, c: '7D7D7D', a: 1.0 },
				{ x: 0.4103, y: 0.3442, s: 0.093, c: '878787', a: 1.0 },
				{ x: 0.4204, y: 0.3286, s: 0.105, c: 'ACACAC', a: 1.0 },
				{ x: 0.4155, y: 0.312, s: 0.131, c: 'B9B9B9', a: 1.0 },
				{ x: 0.4169, y: 0.293, s: 0.129, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4223, y: 0.2877, s: 0.068, c: '898989', a: 1.0 },
				{ x: 0.4176, y: 0.2652, s: 0.064, c: '686868', a: 1.0 },
				{ x: 0.4163, y: 0.9427, s: 0.029, c: '383838', a: 1.0 },
				{ x: 0.4224, y: 0.9461, s: 0.054, c: '444444', a: 1.0 },
				{ x: 0.4178, y: 0.9474, s: 0.063, c: '606060', a: 1.0 },
				{ x: 0.4184, y: 0.9345, s: 0.04, c: '696969', a: 1.0 },
				{ x: 0.4146, y: 0.9117, s: 0.052, c: '575757', a: 1.0 },
				{ x: 0.4232, y: 0.9182, s: 0.055, c: '5B5B5B', a: 1.0 },
				{ x: 0.415, y: 0.9225, s: 0.057, c: '666666', a: 1.0 },
				{ x: 0.4198, y: 0.9065, s: 0.037, c: '5B5B5B', a: 1.0 },
				{ x: 0.4204, y: 0.8876, s: 0.045, c: '595959', a: 1.0 },
				{ x: 0.4166, y: 0.8912, s: 0.041, c: '656565', a: 1.0 },
				{ x: 0.4219, y: 0.8746, s: 0.062, c: '5C5C5C', a: 1.0 },
				{ x: 0.4172, y: 0.8752, s: 0.053, c: '515151', a: 1.0 },
				{ x: 0.4226, y: 0.8436, s: 0.085, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4193, y: 0.8314, s: 0.089, c: '999999', a: 1.0 },
				{ x: 0.4146, y: 0.8144, s: 0.079, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4208, y: 0.8183, s: 0.059, c: '999999', a: 1.0 },
				{ x: 0.416, y: 0.8196, s: 0.113, c: '8B8B8B', a: 1.0 },
				{ x: 0.4247, y: 0.8026, s: 0.046, c: '737373', a: 1.0 },
				{ x: 0.4175, y: 0.8065, s: 0.068, c: '626262', a: 1.0 },
				{ x: 0.4229, y: 0.7714, s: 0.131, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4177, y: 0.7783, s: 0.073, c: 'C9C9C9', a: 1.0 },
				{ x: 0.424, y: 0.7584, s: 0.114, c: 'CDCDCD', a: 1.0 },
				{ x: 0.4187, y: 0.7596, s: 0.137, c: 'C1C1C1', a: 1.0 },
				{ x: 0.4143, y: 0.7427, s: 0.152, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4206, y: 0.7467, s: 0.1, c: 'B8B8B8', a: 1.0 },
				{ x: 0.4153, y: 0.7474, s: 0.104, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4172, y: 0.7345, s: 0.07, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4139, y: 0.5438, s: 0.07, c: '5A5A5A', a: 1.0 },
				{ x: 0.4218, y: 0.5449, s: 0.084, c: '787878', a: 1.0 },
				{ x: 0.4238, y: 0.5318, s: 0.081, c: '787878', a: 1.0 },
				{ x: 0.4185, y: 0.5328, s: 0.073, c: '656565', a: 1.0 },
				{ x: 0.4148, y: 0.5129, s: 0.062, c: '5D5D5D', a: 1.0 },
				{ x: 0.4229, y: 0.5198, s: 0.064, c: '666666', a: 1.0 },
				{ x: 0.4151, y: 0.5237, s: 0.06, c: '787878', a: 1.0 },
				{ x: 0.4247, y: 0.5009, s: 0.055, c: '898989', a: 1.0 },
				{ x: 0.4194, y: 0.5078, s: 0.117, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4258, y: 0.4879, s: 0.11, c: 'BEBEBE', a: 1.0 },
				{ x: 0.4213, y: 0.4903, s: 0.127, c: 'C5C5C5', a: 1.0 },
				{ x: 0.4159, y: 0.4715, s: 0.066, c: 'ADADAD', a: 1.0 },
				{ x: 0.4225, y: 0.4735, s: 0.112, c: '898989', a: 1.0 },
				{ x: 0.418, y: 0.4785, s: 0.029, c: '505050', a: 1.0 },
				{ x: 0.426, y: 0.3883, s: 0.07, c: '595959', a: 1.0 },
				{ x: 0.419, y: 0.3903, s: 0.069, c: '696969', a: 1.0 },
				{ x: 0.4137, y: 0.3715, s: 0.068, c: '6A6A6A', a: 1.0 },
				{ x: 0.4225, y: 0.3735, s: 0.067, c: '626262', a: 1.0 },
				{ x: 0.4155, y: 0.3786, s: 0.04, c: '5C5C5C', a: 1.0 },
				{ x: 0.4237, y: 0.3597, s: 0.072, c: '5F5F5F', a: 1.0 },
				{ x: 0.4254, y: 0.343, s: 0.055, c: '727272', a: 1.0 },
				{ x: 0.4203, y: 0.348, s: 0.1, c: '7F7F7F', a: 1.0 },
				{ x: 0.4165, y: 0.35, s: 0.077, c: '868686', a: 1.0 },
				{ x: 0.4222, y: 0.3311, s: 0.09, c: '929292', a: 1.0 },
				{ x: 0.4167, y: 0.3361, s: 0.116, c: '9B9B9B', a: 1.0 },
				{ x: 0.4267, y: 0.3145, s: 0.106, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4135, y: 0.3005, s: 0.151, c: 'BBBBBB', a: 1.0 },
				{ x: 0.4177, y: 0.3075, s: 0.124, c: 'C4C4C4', a: 1.0 },
				{ x: 0.4235, y: 0.2858, s: 0.109, c: 'BBBBBB', a: 1.0 },
				{ x: 0.4145, y: 0.2721, s: 0.092, c: '9D9D9D', a: 1.0 },
				{ x: 0.4207, y: 0.2741, s: 0.084, c: '6E6E6E', a: 1.0 },
				{ x: 0.4275, y: 0.9589, s: 0.036, c: '404040', a: 1.0 },
				{ x: 0.4208, y: 0.9398, s: 0.054, c: '444444', a: 1.0 },
				{ x: 0.4286, y: 0.9448, s: 0.041, c: '545454', a: 1.0 },
				{ x: 0.4243, y: 0.9231, s: 0.064, c: '6C6C6C', a: 1.0 },
				{ x: 0.4175, y: 0.9281, s: 0.057, c: '696969', a: 1.0 },
				{ x: 0.4253, y: 0.9303, s: 0.046, c: '545454', a: 1.0 },
				{ x: 0.421, y: 0.9112, s: 0.06, c: '4F4F4F', a: 1.0 },
				{ x: 0.4271, y: 0.9165, s: 0.035, c: '606060', a: 1.0 },
				{ x: 0.4182, y: 0.8998, s: 0.067, c: '595959', a: 1.0 },
				{ x: 0.4183, y: 0.8826, s: 0.035, c: '3C3C3C', a: 1.0 },
				{ x: 0.4206, y: 0.8688, s: 0.092, c: '7A7A7A', a: 1.0 },
				{ x: 0.4286, y: 0.8711, s: 0.042, c: '626262', a: 1.0 },
				{ x: 0.4246, y: 0.8519, s: 0.041, c: '404040', a: 1.0 },
				{ x: 0.4216, y: 0.8407, s: 0.098, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4223, y: 0.8234, s: 0.06, c: '999999', a: 1.0 },
				{ x: 0.4182, y: 0.8287, s: 0.094, c: '848484', a: 1.0 },
				{ x: 0.4259, y: 0.8304, s: 0.106, c: 'B2B2B2', a: 1.0 },
				{ x: 0.4189, y: 0.812, s: 0.064, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4228, y: 0.7954, s: 0.07, c: '737373', a: 1.0 },
				{ x: 0.4288, y: 0.8, s: 0.064, c: '5A5A5A', a: 1.0 },
				{ x: 0.4235, y: 0.8024, s: 0.032, c: '525252', a: 1.0 },
				{ x: 0.4258, y: 0.788, s: 0.083, c: '878787', a: 1.0 },
				{ x: 0.42, y: 0.7666, s: 0.128, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4167, y: 0.7546, s: 0.125, c: 'C1C1C1', a: 1.0 },
				{ x: 0.4264, y: 0.76, s: 0.144, c: 'BDBDBD', a: 1.0 },
				{ x: 0.4191, y: 0.7409, s: 0.096, c: 'B6B6B6', a: 1.0 },
				{ x: 0.4229, y: 0.7246, s: 0.093, c: 'B1B1B1', a: 1.0 },
				{ x: 0.4176, y: 0.7288, s: 0.069, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4236, y: 0.7308, s: 0.086, c: 'C0C0C0', a: 1.0 },
				{ x: 0.4199, y: 0.7127, s: 0.112, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4277, y: 0.566, s: 0.046, c: '404040', a: 1.0 },
				{ x: 0.4203, y: 0.5464, s: 0.035, c: '5A5A5A', a: 1.0 },
				{ x: 0.43, y: 0.5514, s: 0.086, c: '6B6B6B', a: 1.0 },
				{ x: 0.4242, y: 0.5304, s: 0.051, c: '656565', a: 1.0 },
				{ x: 0.4172, y: 0.5354, s: 0.041, c: '585858', a: 1.0 },
				{ x: 0.4266, y: 0.5397, s: 0.064, c: '525252', a: 1.0 },
				{ x: 0.4273, y: 0.5236, s: 0.061, c: '666666', a: 1.0 },
				{ x: 0.4218, y: 0.5041, s: 0.051, c: '7E7E7E', a: 1.0 },
				{ x: 0.4239, y: 0.5118, s: 0.072, c: 'B8B8B8', a: 1.0 },
				{ x: 0.4184, y: 0.49, s: 0.144, c: 'CBCBCB', a: 1.0 },
				{ x: 0.4279, y: 0.4944, s: 0.163, c: 'CBCBCB', a: 1.0 },
				{ x: 0.4285, y: 0.4784, s: 0.075, c: '7F7F7F', a: 1.0 },
				{ x: 0.4247, y: 0.3812, s: 0.065, c: '595959', a: 1.0 },
				{ x: 0.4175, y: 0.3862, s: 0.043, c: '737373', a: 1.0 },
				{ x: 0.4213, y: 0.3702, s: 0.042, c: '666666', a: 1.0 },
				{ x: 0.4274, y: 0.3745, s: 0.063, c: '5F5F5F', a: 1.0 },
				{ x: 0.4181, y: 0.3586, s: 0.066, c: '656565', a: 1.0 },
				{ x: 0.4259, y: 0.3606, s: 0.058, c: '727272', a: 1.0 },
				{ x: 0.4187, y: 0.3411, s: 0.096, c: '7B7B7B', a: 1.0 },
				{ x: 0.4281, y: 0.3466, s: 0.062, c: '818181', a: 1.0 },
				{ x: 0.4226, y: 0.3248, s: 0.083, c: '8C8C8C', a: 1.0 },
				{ x: 0.4288, y: 0.3291, s: 0.094, c: '959595', a: 1.0 },
				{ x: 0.4248, y: 0.3103, s: 0.095, c: '9E9E9E', a: 1.0 },
				{ x: 0.4193, y: 0.313, s: 0.101, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4255, y: 0.3183, s: 0.108, c: 'B4B4B4', a: 1.0 },
				{ x: 0.4216, y: 0.2985, s: 0.085, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4167, y: 0.2848, s: 0.123, c: '989898', a: 1.0 },
				{ x: 0.4262, y: 0.2891, s: 0.056, c: '8D8D8D', a: 1.0 },
				{ x: 0.419, y: 0.2706, s: 0.084, c: '6E6E6E', a: 1.0 },
				{ x: 0.4268, y: 0.273, s: 0.055, c: '555555', a: 1.0 },
				{ x: 0.4254, y: 0.9548, s: 0.034, c: '444444', a: 1.0 },
				{ x: 0.4326, y: 0.9572, s: 0.051, c: '444444', a: 1.0 },
				{ x: 0.4282, y: 0.9388, s: 0.028, c: '4C4C4C', a: 1.0 },
				{ x: 0.422, y: 0.9428, s: 0.063, c: '5C5C5C', a: 1.0 },
				{ x: 0.4248, y: 0.927, s: 0.056, c: '545454', a: 1.0 },
				{ x: 0.4275, y: 0.9094, s: 0.048, c: '4F4F4F', a: 1.0 },
				{ x: 0.4286, y: 0.8934, s: 0.063, c: '505050', a: 1.0 },
				{ x: 0.4241, y: 0.8975, s: 0.031, c: '444444', a: 1.0 },
				{ x: 0.4251, y: 0.8815, s: 0.072, c: '5A5A5A', a: 1.0 },
				{ x: 0.4206, y: 0.8868, s: 0.081, c: '919191', a: 1.0 },
				{ x: 0.4279, y: 0.867, s: 0.076, c: '878787', a: 1.0 },
				{ x: 0.4244, y: 0.855, s: 0.038, c: '5E5E5E', a: 1.0 },
				{ x: 0.4317, y: 0.8336, s: 0.09, c: '828282', a: 1.0 },
				{ x: 0.43, y: 0.8216, s: 0.059, c: '7C7C7C', a: 1.0 },
				{ x: 0.4238, y: 0.8263, s: 0.093, c: 'A0A0A0', a: 1.0 },
				{ x: 0.4309, y: 0.8059, s: 0.082, c: 'AAAAAA', a: 1.0 },
				{ x: 0.4265, y: 0.811, s: 0.103, c: '838383', a: 1.0 },
				{ x: 0.4203, y: 0.8145, s: 0.051, c: '8B8B8B', a: 1.0 },
				{ x: 0.4275, y: 0.7942, s: 0.097, c: '7B7B7B', a: 1.0 },
				{ x: 0.4304, y: 0.7789, s: 0.041, c: '616161', a: 1.0 },
				{ x: 0.4243, y: 0.7824, s: 0.068, c: '7C7C7C', a: 1.0 },
				{ x: 0.4331, y: 0.7621, s: 0.107, c: '9C9C9C', a: 1.0 },
				{ x: 0.4269, y: 0.7657, s: 0.077, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4224, y: 0.7707, s: 0.101, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4325, y: 0.7351, s: 0.079, c: 'B3B3B3', a: 1.0 },
				{ x: 0.42, y: 0.742, s: 0.107, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4291, y: 0.7219, s: 0.09, c: 'B1B1B1', a: 1.0 },
				{ x: 0.4301, y: 0.7066, s: 0.08, c: 'CCCCCC', a: 1.0 },
				{ x: 0.4329, y: 0.5483, s: 0.053, c: '454545', a: 1.0 },
				{ x: 0.4282, y: 0.5518, s: 0.038, c: '505050', a: 1.0 },
				{ x: 0.4223, y: 0.5553, s: 0.048, c: '525252', a: 1.0 },
				{ x: 0.4292, y: 0.535, s: 0.041, c: '464646', a: 1.0 },
				{ x: 0.4248, y: 0.5401, s: 0.052, c: '424242', a: 1.0 },
				{ x: 0.4217, y: 0.5269, s: 0.08, c: '626262', a: 1.0 },
				{ x: 0.4286, y: 0.5081, s: 0.05, c: '7E7E7E', a: 1.0 },
				{ x: 0.4226, y: 0.5114, s: 0.086, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4313, y: 0.4911, s: 0.121, c: 'BEBEBE', a: 1.0 },
				{ x: 0.4207, y: 0.4999, s: 0.125, c: 'D1D1D1', a: 1.0 },
				{ x: 0.4221, y: 0.4831, s: 0.082, c: '6E6E6E', a: 1.0 },
				{ x: 0.4307, y: 0.4402, s: 0.051, c: '545454', a: 1.0 },
				{ x: 0.4248, y: 0.3964, s: 0.041, c: '595959', a: 1.0 },
				{ x: 0.4317, y: 0.3758, s: 0.071, c: '787878', a: 1.0 },
				{ x: 0.4274, y: 0.3797, s: 0.064, c: '7E7E7E', a: 1.0 },
				{ x: 0.4211, y: 0.3847, s: 0.076, c: '6E6E6E', a: 1.0 },
				{ x: 0.4284, y: 0.364, s: 0.074, c: '636363', a: 1.0 },
				{ x: 0.4238, y: 0.3679, s: 0.055, c: '636363', a: 1.0 },
				{ x: 0.4309, y: 0.3488, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.4276, y: 0.3358, s: 0.067, c: '7D7D7D', a: 1.0 },
				{ x: 0.4231, y: 0.3405, s: 0.064, c: '868686', a: 1.0 },
				{ x: 0.4307, y: 0.3205, s: 0.057, c: '8F8F8F', a: 1.0 },
				{ x: 0.4246, y: 0.3239, s: 0.099, c: '959595', a: 1.0 },
				{ x: 0.433, y: 0.3048, s: 0.103, c: '9E9E9E', a: 1.0 },
				{ x: 0.4268, y: 0.3086, s: 0.064, c: 'ACACAC', a: 1.0 },
				{ x: 0.4211, y: 0.3118, s: 0.134, c: 'B9B9B9', a: 1.0 },
				{ x: 0.4296, y: 0.292, s: 0.112, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4235, y: 0.2967, s: 0.115, c: 'B4B4B4', a: 1.0 },
				{ x: 0.4311, y: 0.2767, s: 0.124, c: '9D9D9D', a: 1.0 },
				{ x: 0.4266, y: 0.2799, s: 0.094, c: '838383', a: 1.0 },
				{ x: 0.4201, y: 0.2838, s: 0.056, c: '686868', a: 1.0 },
				{ x: 0.4337, y: 0.9551, s: 0.031, c: '3C3C3C', a: 1.0 },
				{ x: 0.4288, y: 0.9351, s: 0.033, c: '404040', a: 1.0 },
				{ x: 0.4365, y: 0.9384, s: 0.03, c: '484848', a: 1.0 },
				{ x: 0.4304, y: 0.9423, s: 0.061, c: '4C4C4C', a: 1.0 },
				{ x: 0.4255, y: 0.9228, s: 0.032, c: '575757', a: 1.0 },
				{ x: 0.427, y: 0.9068, s: 0.03, c: '3E3E3E', a: 1.0 },
				{ x: 0.4292, y: 0.9146, s: 0.058, c: '646464', a: 1.0 },
				{ x: 0.4247, y: 0.895, s: 0.065, c: '595959', a: 1.0 },
				{ x: 0.4323, y: 0.8985, s: 0.027, c: '474747', a: 1.0 },
				{ x: 0.4259, y: 0.879, s: 0.028, c: '3C3C3C', a: 1.0 },
				{ x: 0.4291, y: 0.8868, s: 0.06, c: '9C9C9C', a: 1.0 },
				{ x: 0.4314, y: 0.8708, s: 0.064, c: '7A7A7A', a: 1.0 },
				{ x: 0.4251, y: 0.8511, s: 0.047, c: '5E5E5E', a: 1.0 },
				{ x: 0.4282, y: 0.8352, s: 0.073, c: '727272', a: 1.0 },
				{ x: 0.4305, y: 0.843, s: 0.128, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4248, y: 0.8227, s: 0.099, c: '7F7F7F', a: 1.0 },
				{ x: 0.4318, y: 0.827, s: 0.101, c: '8E8E8E', a: 1.0 },
				{ x: 0.4271, y: 0.8067, s: 0.106, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4349, y: 0.8109, s: 0.088, c: '8F8F8F', a: 1.0 },
				{ x: 0.4286, y: 0.815, s: 0.095, c: '929292', a: 1.0 },
				{ x: 0.4239, y: 0.7947, s: 0.083, c: '8D8D8D', a: 1.0 },
				{ x: 0.4309, y: 0.799, s: 0.077, c: '818181', a: 1.0 },
				{ x: 0.4254, y: 0.7787, s: 0.106, c: 'C9C9C9', a: 1.0 },
				{ x: 0.434, y: 0.783, s: 0.084, c: 'C9C9C9', a: 1.0 },
				{ x: 0.4275, y: 0.7627, s: 0.114, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4354, y: 0.7671, s: 0.101, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4307, y: 0.7706, s: 0.075, c: 'BDBDBD', a: 1.0 },
				{ x: 0.4244, y: 0.7511, s: 0.152, c: 'BDBDBD', a: 1.0 },
				{ x: 0.4274, y: 0.7348, s: 0.131, c: 'B1B1B1', a: 1.0 },
				{ x: 0.4344, y: 0.739, s: 0.13, c: 'A8A8A8', a: 1.0 },
				{ x: 0.4297, y: 0.7429, s: 0.117, c: 'A6A6A6', a: 1.0 },
				{ x: 0.4234, y: 0.723, s: 0.107, c: 'ADADAD', a: 1.0 },
				{ x: 0.4311, y: 0.7268, s: 0.078, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4264, y: 0.7069, s: 0.136, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4334, y: 0.7108, s: 0.111, c: 'BFBFBF', a: 1.0 },
				{ x: 0.4279, y: 0.548, s: 0.031, c: '404040', a: 1.0 },
				{ x: 0.4365, y: 0.5523, s: 0.055, c: '454545', a: 1.0 },
				{ x: 0.4301, y: 0.5561, s: 0.041, c: '3E3E3E', a: 1.0 },
				{ x: 0.4255, y: 0.5362, s: 0.029, c: '363636', a: 1.0 },
				{ x: 0.4332, y: 0.5402, s: 0.04, c: '3A3A3A', a: 1.0 },
				{ x: 0.4273, y: 0.5203, s: 0.037, c: '464646', a: 1.0 },
				{ x: 0.4353, y: 0.524, s: 0.028, c: '464646', a: 1.0 },
				{ x: 0.4292, y: 0.5279, s: 0.073, c: '5D5D5D', a: 1.0 },
				{ x: 0.4239, y: 0.5081, s: 0.053, c: '7E7E7E', a: 1.0 },
				{ x: 0.4338, y: 0.4961, s: 0.128, c: 'CBCBCB', a: 1.0 },
				{ x: 0.4365, y: 0.4801, s: 0.11, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4251, y: 0.4464, s: 0.065, c: '5E5E5E', a: 1.0 },
				{ x: 0.4332, y: 0.4503, s: 0.037, c: '5E5E5E', a: 1.0 },
				{ x: 0.4279, y: 0.3828, s: 0.047, c: '595959', a: 1.0 },
				{ x: 0.435, y: 0.3867, s: 0.071, c: '787878', a: 1.0 },
				{ x: 0.4297, y: 0.3906, s: 0.067, c: '7E7E7E', a: 1.0 },
				{ x: 0.4245, y: 0.3707, s: 0.049, c: '727272', a: 1.0 },
				{ x: 0.4263, y: 0.3548, s: 0.04, c: '686868', a: 1.0 },
				{ x: 0.4363, y: 0.3428, s: 0.063, c: '7F7F7F', a: 1.0 },
				{ x: 0.4257, y: 0.3399, s: 0.078, c: '808080', a: 1.0 },
				{ x: 0.4337, y: 0.3241, s: 0.093, c: '868686', a: 1.0 },
				{ x: 0.4302, y: 0.3003, s: 0.133, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4249, y: 0.3084, s: 0.083, c: 'AEAEAE', a: 1.0 },
				{ x: 0.427, y: 0.3005, s: 0.085, c: 'B0B0B0', a: 1.0 },
				{ x: 0.435, y: 0.2847, s: 0.059, c: '989898', a: 1.0 },
				{ x: 0.4288, y: 0.2688, s: 0.076, c: '838383', a: 1.0 },
				{ x: 0.4234, y: 0.2768, s: 0.071, c: '626262', a: 1.0 },
				{ x: 0.4316, y: 0.2551, s: 0.04, c: '606060', a: 1.0 },
				{ x: 0.4295, y: 0.9496, s: 0.022, c: '343434', a: 1.0 },
				{ x: 0.4368, y: 0.9575, s: 0.031, c: '393939', a: 1.0 },
				{ x: 0.4313, y: 0.9416, s: 0.04, c: '3D3D3D', a: 1.0 },
				{ x: 0.4396, y: 0.9259, s: 0.024, c: '3A3A3A', a: 1.0 },
				{ x: 0.4341, y: 0.9339, s: 0.028, c: '454545', a: 1.0 },
				{ x: 0.4279, y: 0.9181, s: 0.066, c: '515151', a: 1.0 },
				{ x: 0.4362, y: 0.9261, s: 0.027, c: '484848', a: 1.0 },
				{ x: 0.4306, y: 0.9103, s: 0.073, c: '606060', a: 1.0 },
				{ x: 0.4326, y: 0.9022, s: 0.063, c: '6C6C6C', a: 1.0 },
				{ x: 0.4353, y: 0.8944, s: 0.036, c: '484848', a: 1.0 },
				{ x: 0.4293, y: 0.8787, s: 0.062, c: '595959', a: 1.0 },
				{ x: 0.4319, y: 0.8709, s: 0.066, c: 'A6A6A6', a: 1.0 },
				{ x: 0.4393, y: 0.855, s: 0.069, c: '8B8B8B', a: 1.0 },
				{ x: 0.4305, y: 0.8391, s: 0.114, c: '949494', a: 1.0 },
				{ x: 0.4384, y: 0.8236, s: 0.082, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4333, y: 0.8312, s: 0.063, c: '727272', a: 1.0 },
				{ x: 0.43, y: 0.8079, s: 0.101, c: 'ABABAB', a: 1.0 },
				{ x: 0.4378, y: 0.7858, s: 0.042, c: '5F5F5F', a: 1.0 },
				{ x: 0.4318, y: 0.7937, s: 0.066, c: '5F5F5F', a: 1.0 },
				{ x: 0.4397, y: 0.7783, s: 0.142, c: 'C2C2C2', a: 1.0 },
				{ x: 0.429, y: 0.7704, s: 0.133, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4366, y: 0.778, s: 0.045, c: '6E6E6E', a: 1.0 },
				{ x: 0.4312, y: 0.7625, s: 0.073, c: '8B8B8B', a: 1.0 },
				{ x: 0.4389, y: 0.7464, s: 0.093, c: '8B8B8B', a: 1.0 },
				{ x: 0.4331, y: 0.7547, s: 0.082, c: '6B6B6B', a: 1.0 },
				{ x: 0.4278, y: 0.7386, s: 0.072, c: '5E5E5E', a: 1.0 },
				{ x: 0.4355, y: 0.747, s: 0.037, c: '5B5B5B', a: 1.0 },
				{ x: 0.4301, y: 0.7309, s: 0.062, c: '525252', a: 1.0 },
				{ x: 0.4378, y: 0.7147, s: 0.04, c: '696969', a: 1.0 },
				{ x: 0.4325, y: 0.7231, s: 0.114, c: '9E9E9E', a: 1.0 },
				{ x: 0.4348, y: 0.7153, s: 0.143, c: 'C3C3C3', a: 1.0 },
				{ x: 0.429, y: 0.6992, s: 0.066, c: '909090', a: 1.0 },
				{ x: 0.4367, y: 0.5706, s: 0.03, c: '3D3D3D', a: 1.0 },
				{ x: 0.4314, y: 0.5545, s: 0.039, c: '3C3C3C', a: 1.0 },
				{ x: 0.439, y: 0.539, s: 0.038, c: '353535', a: 1.0 },
				{ x: 0.4337, y: 0.5408, s: 0.036, c: '363636', a: 1.0 },
				{ x: 0.4279, y: 0.5246, s: 0.032, c: '3D3D3D', a: 1.0 },
				{ x: 0.4359, y: 0.5329, s: 0.035, c: '464646', a: 1.0 },
				{ x: 0.4302, y: 0.5168, s: 0.035, c: '565656', a: 1.0 },
				{ x: 0.4325, y: 0.5095, s: 0.103, c: '8D8D8D', a: 1.0 },
				{ x: 0.4269, y: 0.4937, s: 0.083, c: 'A9A9A9', a: 1.0 },
				{ x: 0.435, y: 0.501, s: 0.141, c: 'B4B4B4', a: 1.0 },
				{ x: 0.4372, y: 0.4938, s: 0.095, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4395, y: 0.4436, s: 0.025, c: '444444', a: 1.0 },
				{ x: 0.4338, y: 0.3988, s: 0.047, c: '545454', a: 1.0 },
				{ x: 0.4284, y: 0.3829, s: 0.074, c: '7A7A7A', a: 1.0 },
				{ x: 0.4361, y: 0.3902, s: 0.1, c: '7E7E7E', a: 1.0 },
				{ x: 0.4385, y: 0.3592, s: 0.061, c: '6E6E6E', a: 1.0 },
				{ x: 0.4328, y: 0.3672, s: 0.07, c: '6D6D6D', a: 1.0 },
				{ x: 0.4273, y: 0.3506, s: 0.077, c: '6A6A6A', a: 1.0 },
				{ x: 0.4351, y: 0.3593, s: 0.084, c: '717171', a: 1.0 },
				{ x: 0.4297, y: 0.3436, s: 0.045, c: '787878', a: 1.0 },
				{ x: 0.4398, y: 0.3199, s: 0.072, c: '838383', a: 1.0 },
				{ x: 0.4286, y: 0.3114, s: 0.115, c: '999999', a: 1.0 },
				{ x: 0.4364, y: 0.3193, s: 0.058, c: '9D9D9D', a: 1.0 },
				{ x: 0.4308, y: 0.3043, s: 0.099, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4386, y: 0.2874, s: 0.102, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4332, y: 0.2955, s: 0.132, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4277, y: 0.2804, s: 0.06, c: '8F8F8F', a: 1.0 },
				{ x: 0.4355, y: 0.2883, s: 0.078, c: '7F7F7F', a: 1.0 },
				{ x: 0.43, y: 0.2719, s: 0.066, c: '626262', a: 1.0 },
				{ x: 0.4377, y: 0.2442, s: 0.07, c: '6A6A6A', a: 1.0 },
				{ x: 0.4355, y: 0.9454, s: 0.02, c: '343434', a: 1.0 },
				{ x: 0.4323, y: 0.9396, s: 0.025, c: '404040', a: 1.0 },
				{ x: 0.4423, y: 0.9157, s: 0.042, c: '636363', a: 1.0 },
				{ x: 0.4368, y: 0.9001, s: 0.116, c: '939393', a: 1.0 },
				{ x: 0.4313, y: 0.907, s: 0.058, c: '797979', a: 1.0 },
				{ x: 0.4391, y: 0.8916, s: 0.057, c: '585858', a: 1.0 },
				{ x: 0.4335, y: 0.8761, s: 0.046, c: '545454', a: 1.0 },
				{ x: 0.4413, y: 0.8833, s: 0.066, c: '595959', a: 1.0 },
				{ x: 0.4358, y: 0.8679, s: 0.069, c: '757575', a: 1.0 },
				{ x: 0.4303, y: 0.8763, s: 0.107, c: '9A9A9A', a: 1.0 },
				{ x: 0.438, y: 0.8608, s: 0.087, c: '959595', a: 1.0 },
				{ x: 0.4408, y: 0.8677, s: 0.048, c: '777777', a: 1.0 },
				{ x: 0.433, y: 0.8522, s: 0.084, c: '696969', a: 1.0 },
				{ x: 0.4385, y: 0.8368, s: 0.048, c: '737373', a: 1.0 },
				{ x: 0.4418, y: 0.8366, s: 0.066, c: '727272', a: 1.0 },
				{ x: 0.4317, y: 0.8127, s: 0.092, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4373, y: 0.7973, s: 0.099, c: '7A7A7A', a: 1.0 },
				{ x: 0.4428, y: 0.7938, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.4327, y: 0.7698, s: 0.039, c: '373737', a: 1.0 },
				{ x: 0.4382, y: 0.7544, s: 0.03, c: '3E3E3E', a: 1.0 },
				{ x: 0.4305, y: 0.7614, s: 0.027, c: '3E3E3E', a: 1.0 },
				{ x: 0.436, y: 0.746, s: 0.041, c: '3E3E3E', a: 1.0 },
				{ x: 0.4415, y: 0.7543, s: 0.061, c: '545454', a: 1.0 },
				{ x: 0.4392, y: 0.7229, s: 0.037, c: '3D3D3D', a: 1.0 },
				{ x: 0.4314, y: 0.7294, s: 0.027, c: '2D2D2D', a: 1.0 },
				{ x: 0.4369, y: 0.715, s: 0.059, c: '5B5B5B', a: 1.0 },
				{ x: 0.4426, y: 0.7231, s: 0.098, c: '7D7D7D', a: 1.0 },
				{ x: 0.4348, y: 0.7058, s: 0.098, c: '9A9A9A', a: 1.0 },
				{ x: 0.4403, y: 0.6913, s: 0.063, c: 'AAAAAA', a: 1.0 },
				{ x: 0.4325, y: 0.5624, s: 0.044, c: '3A3A3A', a: 1.0 },
				{ x: 0.4379, y: 0.5452, s: 0.025, c: '383838', a: 1.0 },
				{ x: 0.4301, y: 0.5427, s: 0.031, c: '353535', a: 1.0 },
				{ x: 0.4356, y: 0.5254, s: 0.026, c: '3A3A3A', a: 1.0 },
				{ x: 0.4412, y: 0.5334, s: 0.026, c: '424242', a: 1.0 },
				{ x: 0.4334, y: 0.519, s: 0.041, c: '4E4E4E', a: 1.0 },
				{ x: 0.439, y: 0.5017, s: 0.079, c: '676767', a: 1.0 },
				{ x: 0.4311, y: 0.5112, s: 0.051, c: '7E7E7E', a: 1.0 },
				{ x: 0.4368, y: 0.4953, s: 0.06, c: '939393', a: 1.0 },
				{ x: 0.4421, y: 0.5018, s: 0.085, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4345, y: 0.4874, s: 0.101, c: 'B0B0B0', a: 1.0 },
				{ x: 0.4399, y: 0.4716, s: 0.121, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4323, y: 0.4781, s: 0.082, c: '6A6A6A', a: 1.0 },
				{ x: 0.4376, y: 0.3865, s: 0.056, c: '5A5A5A', a: 1.0 },
				{ x: 0.4433, y: 0.393, s: 0.052, c: '7A7A7A', a: 1.0 },
				{ x: 0.4355, y: 0.3772, s: 0.069, c: '7C7C7C', a: 1.0 },
				{ x: 0.4332, y: 0.3694, s: 0.067, c: '737373', a: 1.0 },
				{ x: 0.4386, y: 0.3533, s: 0.083, c: '727272', a: 1.0 },
				{ x: 0.431, y: 0.3628, s: 0.077, c: '707070', a: 1.0 },
				{ x: 0.4363, y: 0.3455, s: 0.045, c: '737373', a: 1.0 },
				{ x: 0.4341, y: 0.3393, s: 0.059, c: '737373', a: 1.0 },
				{ x: 0.4397, y: 0.322, s: 0.066, c: '767676', a: 1.0 },
				{ x: 0.4317, y: 0.3315, s: 0.083, c: '808080', a: 1.0 },
				{ x: 0.4374, y: 0.3141, s: 0.09, c: '8A8A8A', a: 1.0 },
				{ x: 0.4431, y: 0.3219, s: 0.059, c: '949494', a: 1.0 },
				{ x: 0.4408, y: 0.3143, s: 0.13, c: 'A0A0A0', a: 1.0 },
				{ x: 0.4328, y: 0.2982, s: 0.058, c: '9D9D9D', a: 1.0 },
				{ x: 0.4385, y: 0.2842, s: 0.116, c: '999999', a: 1.0 },
				{ x: 0.4304, y: 0.2904, s: 0.061, c: '858585', a: 1.0 },
				{ x: 0.4362, y: 0.2762, s: 0.069, c: '7A7A7A', a: 1.0 },
				{ x: 0.4415, y: 0.2839, s: 0.077, c: '686868', a: 1.0 },
				{ x: 0.4338, y: 0.2491, s: 0.048, c: '636363', a: 1.0 },
				{ x: 0.4349, y: 0.9397, s: 0.033, c: '2F2F2F', a: 1.0 },
				{ x: 0.4406, y: 0.9488, s: 0.04, c: '2F2F2F', a: 1.0 },
				{ x: 0.4459, y: 0.9318, s: 0.044, c: '3A3A3A', a: 1.0 },
				{ x: 0.4435, y: 0.9255, s: 0.046, c: '545454', a: 1.0 },
				{ x: 0.4361, y: 0.9078, s: 0.048, c: '595959', a: 1.0 },
				{ x: 0.4416, y: 0.9178, s: 0.059, c: '656565', a: 1.0 },
				{ x: 0.4335, y: 0.9016, s: 0.076, c: '868686', a: 1.0 },
				{ x: 0.4394, y: 0.9078, s: 0.077, c: '737373', a: 1.0 },
				{ x: 0.4367, y: 0.8776, s: 0.062, c: '585858', a: 1.0 },
				{ x: 0.4422, y: 0.8845, s: 0.054, c: '606060', a: 1.0 },
				{ x: 0.4348, y: 0.8699, s: 0.05, c: '757575', a: 1.0 },
				{ x: 0.4404, y: 0.8768, s: 0.116, c: '959595', a: 1.0 },
				{ x: 0.4455, y: 0.8607, s: 0.055, c: '959595', a: 1.0 },
				{ x: 0.4377, y: 0.8467, s: 0.082, c: '7A7A7A', a: 1.0 },
				{ x: 0.4437, y: 0.8528, s: 0.081, c: '696969', a: 1.0 },
				{ x: 0.4354, y: 0.8388, s: 0.087, c: '737373', a: 1.0 },
				{ x: 0.4409, y: 0.8466, s: 0.077, c: '8C8C8C', a: 1.0 },
				{ x: 0.4336, y: 0.829, s: 0.084, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4391, y: 0.8387, s: 0.073, c: '7C7C7C', a: 1.0 },
				{ x: 0.4442, y: 0.8225, s: 0.047, c: '5C5C5C', a: 1.0 },
				{ x: 0.4423, y: 0.8153, s: 0.126, c: '9D9D9D', a: 1.0 },
				{ x: 0.4345, y: 0.798, s: 0.07, c: 'ABABAB', a: 1.0 },
				{ x: 0.4457, y: 0.791, s: 0.092, c: '929292', a: 1.0 },
				{ x: 0.4379, y: 0.7743, s: 0.043, c: '545454', a: 1.0 },
				{ x: 0.443, y: 0.7756, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.4352, y: 0.7613, s: 0.038, c: '373737', a: 1.0 },
				{ x: 0.4411, y: 0.7507, s: 0.033, c: '383838', a: 1.0 },
				{ x: 0.4466, y: 0.7363, s: 0.046, c: '626262', a: 1.0 },
				{ x: 0.4383, y: 0.7436, s: 0.083, c: '797979', a: 1.0 },
				{ x: 0.4439, y: 0.7263, s: 0.046, c: '525252', a: 1.0 },
				{ x: 0.4418, y: 0.7192, s: 0.052, c: '545454', a: 1.0 },
				{ x: 0.4338, y: 0.7025, s: 0.054, c: '7D7D7D', a: 1.0 },
				{ x: 0.4372, y: 0.5538, s: 0.035, c: '383838', a: 1.0 },
				{ x: 0.4426, y: 0.5633, s: 0.036, c: '383838', a: 1.0 },
				{ x: 0.4354, y: 0.523, s: 0.036, c: '383838', a: 1.0 },
				{ x: 0.4407, y: 0.5325, s: 0.026, c: '3E3E3E', a: 1.0 },
				{ x: 0.446, y: 0.516, s: 0.058, c: '4E4E4E', a: 1.0 },
				{ x: 0.4387, y: 0.5225, s: 0.065, c: '5F5F5F', a: 1.0 },
				{ x: 0.444, y: 0.5088, s: 0.053, c: '6E6E6E', a: 1.0 },
				{ x: 0.4341, y: 0.485, s: 0.097, c: 'A0A0A0', a: 1.0 },
				{ x: 0.4394, y: 0.4915, s: 0.085, c: 'A0A0A0', a: 1.0 },
				{ x: 0.4447, y: 0.475, s: 0.065, c: '717171', a: 1.0 },
				{ x: 0.4367, y: 0.3834, s: 0.075, c: '676767', a: 1.0 },
				{ x: 0.4428, y: 0.3905, s: 0.048, c: '7A7A7A', a: 1.0 },
				{ x: 0.4462, y: 0.3666, s: 0.074, c: '757575', a: 1.0 },
				{ x: 0.4382, y: 0.3526, s: 0.073, c: '767676', a: 1.0 },
				{ x: 0.4355, y: 0.3426, s: 0.05, c: '737373', a: 1.0 },
				{ x: 0.4416, y: 0.3523, s: 0.086, c: '717171', a: 1.0 },
				{ x: 0.4336, y: 0.3354, s: 0.055, c: '717171', a: 1.0 },
				{ x: 0.4389, y: 0.3423, s: 0.061, c: '747474', a: 1.0 },
				{ x: 0.4442, y: 0.3283, s: 0.076, c: '808080', a: 1.0 },
				{ x: 0.4369, y: 0.3114, s: 0.082, c: '8D8D8D', a: 1.0 },
				{ x: 0.4343, y: 0.3047, s: 0.059, c: '999999', a: 1.0 },
				{ x: 0.4351, y: 0.2736, s: 0.062, c: '7A7A7A', a: 1.0 },
				{ x: 0.4414, y: 0.2805, s: 0.059, c: '626262', a: 1.0 },
				{ x: 0.4462, y: 0.2397, s: 0.041, c: '636363', a: 1.0 },
				{ x: 0.4417, y: 0.953, s: 0.033, c: '373737', a: 1.0 },
				{ x: 0.448, y: 0.936, s: 0.039, c: '373737', a: 1.0 },
				{ x: 0.4394, y: 0.9459, s: 0.022, c: '2F2F2F', a: 1.0 },
				{ x: 0.4458, y: 0.929, s: 0.038, c: '404040', a: 1.0 },
				{ x: 0.438, y: 0.939, s: 0.051, c: '4C4C4C', a: 1.0 },
				{ x: 0.446, y: 0.898, s: 0.051, c: '797979', a: 1.0 },
				{ x: 0.439, y: 0.905, s: 0.06, c: '666666', a: 1.0 },
				{ x: 0.4437, y: 0.8911, s: 0.061, c: '4F4F4F', a: 1.0 },
				{ x: 0.4423, y: 0.8839, s: 0.06, c: '606060', a: 1.0 },
				{ x: 0.4399, y: 0.873, s: 0.083, c: '909090', a: 1.0 },
				{ x: 0.4454, y: 0.8572, s: 0.118, c: '959595', a: 1.0 },
				{ x: 0.4368, y: 0.8682, s: 0.042, c: '737373', a: 1.0 },
				{ x: 0.4431, y: 0.8494, s: 0.078, c: '616161', a: 1.0 },
				{ x: 0.4488, y: 0.8334, s: 0.043, c: '6F6F6F', a: 1.0 },
				{ x: 0.4402, y: 0.8445, s: 0.072, c: '858585', a: 1.0 },
				{ x: 0.4465, y: 0.8256, s: 0.105, c: 'AFAFAF', a: 1.0 },
				{ x: 0.4379, y: 0.8336, s: 0.109, c: '949494', a: 1.0 },
				{ x: 0.4434, y: 0.8208, s: 0.061, c: '4E4E4E', a: 1.0 },
				{ x: 0.4411, y: 0.81, s: 0.08, c: '8F8F8F', a: 1.0 },
				{ x: 0.4398, y: 0.8051, s: 0.149, c: 'C3C3C3', a: 1.0 },
				{ x: 0.4445, y: 0.7861, s: 0.11, c: 'ABABAB', a: 1.0 },
				{ x: 0.4373, y: 0.7971, s: 0.057, c: '545454', a: 1.0 },
				{ x: 0.443, y: 0.7754, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.4475, y: 0.7268, s: 0.038, c: '343434', a: 1.0 },
				{ x: 0.4407, y: 0.7378, s: 0.061, c: '626262', a: 1.0 },
				{ x: 0.4438, y: 0.7142, s: 0.039, c: '545454', a: 1.0 },
				{ x: 0.4487, y: 0.6984, s: 0.047, c: '545454', a: 1.0 },
				{ x: 0.4409, y: 0.7032, s: 0.048, c: '6F6F6F', a: 1.0 },
				{ x: 0.4387, y: 0.6984, s: 0.048, c: '646464', a: 1.0 },
				{ x: 0.4448, y: 0.5605, s: 0.039, c: '383838', a: 1.0 },
				{ x: 0.4372, y: 0.5387, s: 0.02, c: '373737', a: 1.0 },
				{ x: 0.4417, y: 0.526, s: 0.047, c: '3E3E3E', a: 1.0 },
				{ x: 0.4394, y: 0.515, s: 0.053, c: '585858', a: 1.0 },
				{ x: 0.4451, y: 0.5025, s: 0.043, c: '6E6E6E', a: 1.0 },
				{ x: 0.4383, y: 0.5071, s: 0.055, c: '7F7F7F', a: 1.0 },
				{ x: 0.4428, y: 0.4912, s: 0.076, c: '838383', a: 1.0 },
				{ x: 0.4485, y: 0.4787, s: 0.116, c: '8F8F8F', a: 1.0 },
				{ x: 0.4413, y: 0.4834, s: 0.059, c: '989898', a: 1.0 },
				{ x: 0.4462, y: 0.468, s: 0.069, c: '7A7A7A', a: 1.0 },
				{ x: 0.439, y: 0.4784, s: 0.049, c: '525252', a: 1.0 },
				{ x: 0.4447, y: 0.3976, s: 0.055, c: '5A5A5A', a: 1.0 },
				{ x: 0.4492, y: 0.4022, s: 0.076, c: '737373', a: 1.0 },
				{ x: 0.4424, y: 0.3897, s: 0.083, c: '737373', a: 1.0 },
				{ x: 0.4469, y: 0.3735, s: 0.043, c: '757575', a: 1.0 },
				{ x: 0.4392, y: 0.3785, s: 0.093, c: '777777', a: 1.0 },
				{ x: 0.437, y: 0.3736, s: 0.077, c: '7B7B7B', a: 1.0 },
				{ x: 0.4427, y: 0.3552, s: 0.083, c: '787878', a: 1.0 },
				{ x: 0.4491, y: 0.342, s: 0.046, c: '777777', a: 1.0 },
				{ x: 0.4464, y: 0.3312, s: 0.067, c: '727272', a: 1.0 },
				{ x: 0.439, y: 0.3397, s: 0.096, c: '767676', a: 1.0 },
				{ x: 0.4437, y: 0.3264, s: 0.051, c: '838383', a: 1.0 },
				{ x: 0.4497, y: 0.3311, s: 0.095, c: '8A8A8A', a: 1.0 },
				{ x: 0.447, y: 0.3025, s: 0.09, c: '929292', a: 1.0 },
				{ x: 0.4396, y: 0.3079, s: 0.056, c: '959595', a: 1.0 },
				{ x: 0.4443, y: 0.2917, s: 0.087, c: '929292', a: 1.0 },
				{ x: 0.4369, y: 0.3032, s: 0.087, c: '787878', a: 1.0 },
				{ x: 0.4406, y: 0.2434, s: 0.063, c: '6A6A6A', a: 1.0 },
				{ x: 0.4409, y: 0.9463, s: 0.041, c: '383838', a: 1.0 },
				{ x: 0.4532, y: 0.9349, s: 0.047, c: '444444', a: 1.0 },
				{ x: 0.4445, y: 0.9219, s: 0.052, c: '535353', a: 1.0 },
				{ x: 0.4505, y: 0.9307, s: 0.034, c: '555555', a: 1.0 },
				{ x: 0.4418, y: 0.9119, s: 0.053, c: '525252', a: 1.0 },
				{ x: 0.4477, y: 0.9221, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.4407, y: 0.9063, s: 0.066, c: '797979', a: 1.0 },
				{ x: 0.445, y: 0.8882, s: 0.079, c: '646464', a: 1.0 },
				{ x: 0.4511, y: 0.8984, s: 0.035, c: '3F3F3F', a: 1.0 },
				{ x: 0.4441, y: 0.8826, s: 0.037, c: '464646', a: 1.0 },
				{ x: 0.4484, y: 0.8883, s: 0.055, c: '5C5C5C', a: 1.0 },
				{ x: 0.4414, y: 0.8725, s: 0.076, c: '747474', a: 1.0 },
				{ x: 0.4473, y: 0.8589, s: 0.089, c: '959595', a: 1.0 },
				{ x: 0.452, y: 0.8639, s: 0.104, c: '959595', a: 1.0 },
				{ x: 0.4446, y: 0.8488, s: 0.039, c: '646464', a: 1.0 },
				{ x: 0.442, y: 0.8401, s: 0.091, c: '707070', a: 1.0 },
				{ x: 0.448, y: 0.8488, s: 0.05, c: '838383', a: 1.0 },
				{ x: 0.4525, y: 0.836, s: 0.114, c: 'A2A2A2', a: 1.0 },
				{ x: 0.4515, y: 0.8245, s: 0.054, c: '565656', a: 1.0 },
				{ x: 0.4427, y: 0.8124, s: 0.047, c: '636363', a: 1.0 },
				{ x: 0.4488, y: 0.8204, s: 0.054, c: '898989', a: 1.0 },
				{ x: 0.4416, y: 0.8009, s: 0.12, c: '9A9A9A', a: 1.0 },
				{ x: 0.4449, y: 0.7175, s: 0.051, c: '484848', a: 1.0 },
				{ x: 0.4494, y: 0.7285, s: 0.07, c: '767676', a: 1.0 },
				{ x: 0.4422, y: 0.7134, s: 0.071, c: '808080', a: 1.0 },
				{ x: 0.4467, y: 0.7184, s: 0.071, c: '5A5A5A', a: 1.0 },
				{ x: 0.4457, y: 0.6892, s: 0.049, c: '5E5E5E', a: 1.0 },
				{ x: 0.4501, y: 0.6947, s: 0.062, c: '7D7D7D', a: 1.0 },
				{ x: 0.4429, y: 0.6792, s: 0.04, c: '646464', a: 1.0 },
				{ x: 0.4491, y: 0.5402, s: 0.036, c: '373737', a: 1.0 },
				{ x: 0.4402, y: 0.5221, s: 0.031, c: '3D3D3D', a: 1.0 },
				{ x: 0.4463, y: 0.5066, s: 0.055, c: '484848', a: 1.0 },
				{ x: 0.4525, y: 0.5165, s: 0.035, c: '575757', a: 1.0 },
				{ x: 0.4436, y: 0.4981, s: 0.08, c: '646464', a: 1.0 },
				{ x: 0.4498, y: 0.5064, s: 0.055, c: '777777', a: 1.0 },
				{ x: 0.4408, y: 0.4939, s: 0.048, c: '7E7E7E', a: 1.0 },
				{ x: 0.447, y: 0.4978, s: 0.067, c: '878787', a: 1.0 },
				{ x: 0.4532, y: 0.4824, s: 0.088, c: '979797', a: 1.0 },
				{ x: 0.4443, y: 0.4699, s: 0.089, c: '878787', a: 1.0 },
				{ x: 0.4504, y: 0.4741, s: 0.078, c: '636363', a: 1.0 },
				{ x: 0.4432, y: 0.4587, s: 0.042, c: '434343', a: 1.0 },
				{ x: 0.4477, y: 0.47, s: 0.03, c: '3E3E3E', a: 1.0 },
				{ x: 0.4411, y: 0.4069, s: 0.054, c: '4E4E4E', a: 1.0 },
				{ x: 0.445, y: 0.387, s: 0.042, c: '656565', a: 1.0 },
				{ x: 0.4506, y: 0.3984, s: 0.058, c: '6E6E6E', a: 1.0 },
				{ x: 0.4445, y: 0.3829, s: 0.074, c: '6E6E6E', a: 1.0 },
				{ x: 0.45, y: 0.3884, s: 0.064, c: '707070', a: 1.0 },
				{ x: 0.4405, y: 0.3744, s: 0.046, c: '757575', a: 1.0 },
				{ x: 0.4477, y: 0.359, s: 0.081, c: '7A7A7A', a: 1.0 },
				{ x: 0.4533, y: 0.3644, s: 0.079, c: '7E7E7E', a: 1.0 },
				{ x: 0.4438, y: 0.3505, s: 0.073, c: '7C7C7C', a: 1.0 },
				{ x: 0.451, y: 0.3589, s: 0.086, c: '797979', a: 1.0 },
				{ x: 0.4432, y: 0.3404, s: 0.072, c: '787878', a: 1.0 },
				{ x: 0.447, y: 0.3489, s: 0.087, c: '767676', a: 1.0 },
				{ x: 0.4409, y: 0.335, s: 0.047, c: '7C7C7C', a: 1.0 },
				{ x: 0.4464, y: 0.3165, s: 0.104, c: '7F7F7F', a: 1.0 },
				{ x: 0.4503, y: 0.3249, s: 0.068, c: '868686', a: 1.0 },
				{ x: 0.4403, y: 0.3016, s: 0.076, c: '8D8D8D', a: 1.0 },
				{ x: 0.4458, y: 0.2874, s: 0.102, c: '959595', a: 1.0 },
				{ x: 0.453, y: 0.2924, s: 0.051, c: '6F6F6F', a: 1.0 },
				{ x: 0.449, y: 0.2874, s: 0.037, c: '686868', a: 1.0 },
				{ x: 0.4428, y: 0.2731, s: 0.064, c: '565656', a: 1.0 },
				{ x: 0.45, y: 0.9543, s: 0.089, c: '707070', a: 1.0 },
				{ x: 0.4556, y: 0.9399, s: 0.024, c: '313131', a: 1.0 },
				{ x: 0.4495, y: 0.9449, s: 0.029, c: '313131', a: 1.0 },
				{ x: 0.4534, y: 0.9306, s: 0.031, c: '444444', a: 1.0 },
				{ x: 0.4528, y: 0.9197, s: 0.051, c: '5A5A5A', a: 1.0 },
				{ x: 0.445, y: 0.9069, s: 0.064, c: '585858', a: 1.0 },
				{ x: 0.4488, y: 0.9164, s: 0.034, c: '5E5E5E', a: 1.0 },
				{ x: 0.4559, y: 0.8962, s: 0.092, c: '797979', a: 1.0 },
				{ x: 0.4483, y: 0.9056, s: 0.063, c: '646464', a: 1.0 },
				{ x: 0.4519, y: 0.8866, s: 0.03, c: '3F3F3F', a: 1.0 },
				{ x: 0.446, y: 0.8901, s: 0.06, c: '5C5C5C', a: 1.0 },
				{ x: 0.4516, y: 0.8758, s: 0.047, c: '787878', a: 1.0 },
				{ x: 0.4552, y: 0.863, s: 0.09, c: '999999', a: 1.0 },
				{ x: 0.4546, y: 0.8522, s: 0.065, c: '535353', a: 1.0 },
				{ x: 0.4454, y: 0.8618, s: 0.039, c: '4B4B4B', a: 1.0 },
				{ x: 0.4448, y: 0.8286, s: 0.061, c: '7D7D7D', a: 1.0 },
				{ x: 0.4542, y: 0.8191, s: 0.143, c: 'B1B1B1', a: 1.0 },
				{ x: 0.448, y: 0.8286, s: 0.055, c: '727272', a: 1.0 },
				{ x: 0.4517, y: 0.8142, s: 0.034, c: '4E4E4E', a: 1.0 },
				{ x: 0.4441, y: 0.7999, s: 0.06, c: '767676', a: 1.0 },
				{ x: 0.4511, y: 0.8047, s: 0.083, c: '939393', a: 1.0 },
				{ x: 0.4471, y: 0.7999, s: 0.066, c: 'AAAAAA', a: 1.0 },
				{ x: 0.4545, y: 0.78, s: 0.052, c: '5F5F5F', a: 1.0 },
				{ x: 0.4465, y: 0.7313, s: 0.049, c: '484848', a: 1.0 },
				{ x: 0.4505, y: 0.7166, s: 0.059, c: '797979', a: 1.0 },
				{ x: 0.4446, y: 0.6967, s: 0.111, c: '8F8F8F', a: 1.0 },
				{ x: 0.4499, y: 0.7074, s: 0.029, c: '3C3C3C', a: 1.0 },
				{ x: 0.4476, y: 0.6906, s: 0.069, c: '868686', a: 1.0 },
				{ x: 0.4533, y: 0.6766, s: 0.044, c: '707070', a: 1.0 },
				{ x: 0.4436, y: 0.5145, s: 0.05, c: '3D3D3D', a: 1.0 },
				{ x: 0.451, y: 0.5184, s: 0.025, c: '444444', a: 1.0 },
				{ x: 0.4563, y: 0.5038, s: 0.062, c: '525252', a: 1.0 },
				{ x: 0.447, y: 0.5147, s: 0.048, c: '646464', a: 1.0 },
				{ x: 0.4543, y: 0.4948, s: 0.066, c: '727272', a: 1.0 },
				{ x: 0.4463, y: 0.5038, s: 0.058, c: '7E7E7E', a: 1.0 },
				{ x: 0.4501, y: 0.4898, s: 0.081, c: '848484', a: 1.0 },
				{ x: 0.4555, y: 0.4707, s: 0.113, c: '939393', a: 1.0 },
				{ x: 0.4537, y: 0.4659, s: 0.045, c: '727272', a: 1.0 },
				{ x: 0.4455, y: 0.4758, s: 0.05, c: '5E5E5E', a: 1.0 },
				{ x: 0.4527, y: 0.4566, s: 0.056, c: '535353', a: 1.0 },
				{ x: 0.4436, y: 0.4003, s: 0.046, c: '474747', a: 1.0 },
				{ x: 0.4491, y: 0.4102, s: 0.052, c: '606060', a: 1.0 },
				{ x: 0.4559, y: 0.391, s: 0.067, c: '6A6A6A', a: 1.0 },
				{ x: 0.4469, y: 0.4009, s: 0.044, c: '656565', a: 1.0 },
				{ x: 0.4524, y: 0.3862, s: 0.08, c: '6A6A6A', a: 1.0 },
				{ x: 0.4459, y: 0.3902, s: 0.067, c: '6F6F6F', a: 1.0 },
				{ x: 0.4514, y: 0.377, s: 0.054, c: '777777', a: 1.0 },
				{ x: 0.4495, y: 0.3662, s: 0.056, c: '7C7C7C', a: 1.0 },
				{ x: 0.4547, y: 0.353, s: 0.097, c: '7D7D7D', a: 1.0 },
				{ x: 0.4451, y: 0.3625, s: 0.071, c: '7D7D7D', a: 1.0 },
				{ x: 0.4529, y: 0.3429, s: 0.068, c: '7C7C7C', a: 1.0 },
				{ x: 0.4447, y: 0.3287, s: 0.079, c: '7C7C7C', a: 1.0 },
				{ x: 0.4485, y: 0.3389, s: 0.078, c: '7C7C7C', a: 1.0 },
				{ x: 0.4561, y: 0.3185, s: 0.066, c: '818181', a: 1.0 },
				{ x: 0.4483, y: 0.3287, s: 0.071, c: '898989', a: 1.0 },
				{ x: 0.4439, y: 0.3187, s: 0.114, c: '8D8D8D', a: 1.0 },
				{ x: 0.4515, y: 0.3043, s: 0.068, c: '898989', a: 1.0 },
				{ x: 0.4554, y: 0.2907, s: 0.085, c: '8B8B8B', a: 1.0 },
				{ x: 0.4473, y: 0.295, s: 0.051, c: '616161', a: 1.0 },
				{ x: 0.4549, y: 0.2806, s: 0.047, c: '686868', a: 1.0 },
				{ x: 0.4454, y: 0.2909, s: 0.061, c: '686868', a: 1.0 },
				{ x: 0.4477, y: 0.9391, s: 0.029, c: '3E3E3E', a: 1.0 },
				{ x: 0.4519, y: 0.9256, s: 0.06, c: '585858', a: 1.0 },
				{ x: 0.4574, y: 0.9291, s: 0.049, c: '5E5E5E', a: 1.0 },
				{ x: 0.451, y: 0.9152, s: 0.059, c: '5E5E5E', a: 1.0 },
				{ x: 0.4563, y: 0.9016, s: 0.076, c: '636363', a: 1.0 },
				{ x: 0.4475, y: 0.9052, s: 0.075, c: '848484', a: 1.0 },
				{ x: 0.4543, y: 0.8916, s: 0.067, c: '646464', a: 1.0 },
				{ x: 0.4596, y: 0.8952, s: 0.049, c: '3F3F3F', a: 1.0 },
				{ x: 0.4497, y: 0.8716, s: 0.055, c: '959595', a: 1.0 },
				{ x: 0.4534, y: 0.8513, s: 0.122, c: '9D9D9D', a: 1.0 },
				{ x: 0.4479, y: 0.8613, s: 0.053, c: '4B4B4B', a: 1.0 },
				{ x: 0.4569, y: 0.8512, s: 0.049, c: '636363', a: 1.0 },
				{ x: 0.4512, y: 0.8376, s: 0.095, c: '767676', a: 1.0 },
				{ x: 0.4565, y: 0.8236, s: 0.099, c: '8E8E8E', a: 1.0 },
				{ x: 0.4522, y: 0.8134, s: 0.057, c: '959595', a: 1.0 },
				{ x: 0.4599, y: 0.8234, s: 0.045, c: '474747', a: 1.0 },
				{ x: 0.4556, y: 0.8135, s: 0.087, c: '808080', a: 1.0 },
				{ x: 0.4492, y: 0.7996, s: 0.114, c: '939393', a: 1.0 },
				{ x: 0.4537, y: 0.7857, s: 0.111, c: 'BBBBBB', a: 1.0 },
				{ x: 0.4526, y: 0.7756, s: 0.042, c: '747474', a: 1.0 },
				{ x: 0.4571, y: 0.7854, s: 0.075, c: '5F5F5F', a: 1.0 },
				{ x: 0.449, y: 0.7655, s: 0.045, c: '5F5F5F', a: 1.0 },
				{ x: 0.4479, y: 0.7614, s: 0.048, c: '707070', a: 1.0 },
				{ x: 0.4524, y: 0.7415, s: 0.111, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4594, y: 0.7278, s: 0.048, c: '515151', a: 1.0 },
				{ x: 0.4514, y: 0.7137, s: 0.055, c: '707070', a: 1.0 },
				{ x: 0.4497, y: 0.7037, s: 0.028, c: '3C3C3C', a: 1.0 },
				{ x: 0.4544, y: 0.6839, s: 0.049, c: '4E4E4E', a: 1.0 },
				{ x: 0.4529, y: 0.6739, s: 0.105, c: '868686', a: 1.0 },
				{ x: 0.449, y: 0.521, s: 0.046, c: '3A3A3A', a: 1.0 },
				{ x: 0.4537, y: 0.5071, s: 0.023, c: '3F3F3F', a: 1.0 },
				{ x: 0.4476, y: 0.517, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.4523, y: 0.4971, s: 0.046, c: '606060', a: 1.0 },
				{ x: 0.457, y: 0.5069, s: 0.065, c: '727272', a: 1.0 },
				{ x: 0.4555, y: 0.4791, s: 0.051, c: '818181', a: 1.0 },
				{ x: 0.4469, y: 0.4831, s: 0.071, c: '8E8E8E', a: 1.0 },
				{ x: 0.4502, y: 0.4635, s: 0.071, c: '6C6C6C', a: 1.0 },
				{ x: 0.4495, y: 0.42, s: 0.037, c: '3F3F3F', a: 1.0 },
				{ x: 0.4535, y: 0.4042, s: 0.048, c: '595959', a: 1.0 },
				{ x: 0.4482, y: 0.4062, s: 0.083, c: '6A6A6A', a: 1.0 },
				{ x: 0.4529, y: 0.3962, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.4567, y: 0.4042, s: 0.073, c: '616161', a: 1.0 },
				{ x: 0.4514, y: 0.3825, s: 0.075, c: '656565', a: 1.0 },
				{ x: 0.4561, y: 0.3726, s: 0.077, c: '6F6F6F', a: 1.0 },
				{ x: 0.4474, y: 0.3806, s: 0.074, c: '757575', a: 1.0 },
				{ x: 0.4546, y: 0.3588, s: 0.049, c: '777777', a: 1.0 },
				{ x: 0.458, y: 0.3589, s: 0.101, c: '7D7D7D', a: 1.0 },
				{ x: 0.4493, y: 0.349, s: 0.051, c: '808080', a: 1.0 },
				{ x: 0.4541, y: 0.3332, s: 0.095, c: '7F7F7F', a: 1.0 },
				{ x: 0.4587, y: 0.3354, s: 0.074, c: '7E7E7E', a: 1.0 },
				{ x: 0.4527, y: 0.3255, s: 0.07, c: '828282', a: 1.0 },
				{ x: 0.4487, y: 0.3114, s: 0.109, c: '898989', a: 1.0 },
				{ x: 0.4565, y: 0.3016, s: 0.074, c: '808080', a: 1.0 },
				{ x: 0.4471, y: 0.3036, s: 0.055, c: '808080', a: 1.0 },
				{ x: 0.4598, y: 0.3019, s: 0.057, c: '5A5A5A', a: 1.0 },
				{ x: 0.4505, y: 0.2801, s: 0.051, c: '616161', a: 1.0 },
				{ x: 0.455, y: 0.2881, s: 0.057, c: '5C5C5C', a: 1.0 },
				{ x: 0.4533, y: 0.935, s: 0.038, c: '363636', a: 1.0 },
				{ x: 0.4578, y: 0.9368, s: 0.023, c: '313131', a: 1.0 },
				{ x: 0.4619, y: 0.927, s: 0.058, c: '4E4E4E', a: 1.0 },
				{ x: 0.4612, y: 0.9131, s: 0.063, c: '5A5A5A', a: 1.0 },
				{ x: 0.4518, y: 0.9036, s: 0.06, c: '666666', a: 1.0 },
				{ x: 0.4596, y: 0.9052, s: 0.067, c: '898989', a: 1.0 },
				{ x: 0.4512, y: 0.8897, s: 0.083, c: '696969', a: 1.0 },
				{ x: 0.4557, y: 0.8974, s: 0.028, c: '373737', a: 1.0 },
				{ x: 0.4542, y: 0.8839, s: 0.077, c: '686868', a: 1.0 },
				{ x: 0.4591, y: 0.8736, s: 0.057, c: '898989', a: 1.0 },
				{ x: 0.4502, y: 0.8523, s: 0.11, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4576, y: 0.8599, s: 0.053, c: '535353', a: 1.0 },
				{ x: 0.4625, y: 0.8444, s: 0.064, c: '535353', a: 1.0 },
				{ x: 0.4536, y: 0.8461, s: 0.091, c: '767676', a: 1.0 },
				{ x: 0.461, y: 0.8366, s: 0.088, c: '8E8E8E', a: 1.0 },
				{ x: 0.4522, y: 0.8203, s: 0.061, c: '9B9B9B', a: 1.0 },
				{ x: 0.4571, y: 0.8228, s: 0.121, c: 'A2A2A2', a: 1.0 },
				{ x: 0.4515, y: 0.8125, s: 0.056, c: '565656', a: 1.0 },
				{ x: 0.4555, y: 0.8203, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.46, y: 0.7989, s: 0.074, c: '6B6B6B', a: 1.0 },
				{ x: 0.4549, y: 0.7888, s: 0.053, c: '8B8B8B', a: 1.0 },
				{ x: 0.4504, y: 0.775, s: 0.087, c: 'B9B9B9', a: 1.0 },
				{ x: 0.4626, y: 0.7732, s: 0.068, c: '8C8C8C', a: 1.0 },
				{ x: 0.4535, y: 0.7756, s: 0.085, c: '818181', a: 1.0 },
				{ x: 0.4617, y: 0.7654, s: 0.052, c: '646464', a: 1.0 },
				{ x: 0.4526, y: 0.7493, s: 0.102, c: '8E8E8E', a: 1.0 },
				{ x: 0.4573, y: 0.7517, s: 0.09, c: '8E8E8E', a: 1.0 },
				{ x: 0.4515, y: 0.7415, s: 0.086, c: '9B9B9B', a: 1.0 },
				{ x: 0.4562, y: 0.7499, s: 0.036, c: '393939', a: 1.0 },
				{ x: 0.4548, y: 0.7124, s: 0.08, c: '6F6F6F', a: 1.0 },
				{ x: 0.4595, y: 0.72, s: 0.083, c: '8F8F8F', a: 1.0 },
				{ x: 0.4504, y: 0.698, s: 0.094, c: '808080', a: 1.0 },
				{ x: 0.4541, y: 0.6921, s: 0.078, c: '8F8F8F', a: 1.0 },
				{ x: 0.4583, y: 0.683, s: 0.052, c: '868686', a: 1.0 },
				{ x: 0.453, y: 0.6612, s: 0.049, c: '575757', a: 1.0 },
				{ x: 0.4575, y: 0.6685, s: 0.037, c: '3A3A3A', a: 1.0 },
				{ x: 0.4617, y: 0.5156, s: 0.035, c: '3D3D3D', a: 1.0 },
				{ x: 0.4564, y: 0.5185, s: 0.051, c: '444444', a: 1.0 },
				{ x: 0.4607, y: 0.5026, s: 0.05, c: '5B5B5B', a: 1.0 },
				{ x: 0.452, y: 0.492, s: 0.056, c: '6B6B6B', a: 1.0 },
				{ x: 0.4596, y: 0.4948, s: 0.084, c: '757575', a: 1.0 },
				{ x: 0.451, y: 0.479, s: 0.062, c: '7E7E7E', a: 1.0 },
				{ x: 0.4552, y: 0.4922, s: 0.064, c: '8B8B8B', a: 1.0 },
				{ x: 0.4633, y: 0.4703, s: 0.085, c: '8C8C8C', a: 1.0 },
				{ x: 0.4586, y: 0.4693, s: 0.048, c: '7C7C7C', a: 1.0 },
				{ x: 0.4533, y: 0.4467, s: 0.056, c: '6C6C6C', a: 1.0 },
				{ x: 0.4576, y: 0.4548, s: 0.043, c: '424242', a: 1.0 },
				{ x: 0.4566, y: 0.4239, s: 0.068, c: '595959', a: 1.0 },
				{ x: 0.4611, y: 0.407, s: 0.063, c: '6A6A6A', a: 1.0 },
				{ x: 0.4523, y: 0.3979, s: 0.074, c: '6C6C6C', a: 1.0 },
				{ x: 0.4556, y: 0.3975, s: 0.053, c: '656565', a: 1.0 },
				{ x: 0.46, y: 0.3765, s: 0.062, c: '707070', a: 1.0 },
				{ x: 0.4545, y: 0.3666, s: 0.046, c: '757575', a: 1.0 },
				{ x: 0.4502, y: 0.3521, s: 0.074, c: '777777', a: 1.0 },
				{ x: 0.4625, y: 0.35, s: 0.097, c: '7B7B7B', a: 1.0 },
				{ x: 0.4524, y: 0.3273, s: 0.101, c: '7F7F7F', a: 1.0 },
				{ x: 0.4548, y: 0.2949, s: 0.048, c: '7D7D7D', a: 1.0 },
				{ x: 0.4593, y: 0.3034, s: 0.078, c: '616161', a: 1.0 },
				{ x: 0.4504, y: 0.2819, s: 0.033, c: '5A5A5A', a: 1.0 },
				{ x: 0.4582, y: 0.2948, s: 0.067, c: '565656', a: 1.0 },
				{ x: 0.466, y: 0.9602, s: 0.076, c: '6E6E6E', a: 1.0 },
				{ x: 0.4572, y: 0.9508, s: 0.065, c: '686868', a: 1.0 },
				{ x: 0.465, y: 0.9219, s: 0.032, c: '3B3B3B', a: 1.0 },
				{ x: 0.4561, y: 0.9243, s: 0.059, c: '4A4A4A', a: 1.0 },
				{ x: 0.4606, y: 0.915, s: 0.027, c: '4A4A4A', a: 1.0 },
				{ x: 0.465, y: 0.9219, s: 0.066, c: '606060', a: 1.0 },
				{ x: 0.4595, y: 0.9005, s: 0.108, c: '898989', a: 1.0 },
				{ x: 0.464, y: 0.8911, s: 0.066, c: '747474', a: 1.0 },
				{ x: 0.4549, y: 0.8816, s: 0.057, c: '5D5D5D', a: 1.0 },
				{ x: 0.4604, y: 0.8647, s: 0.048, c: '656565', a: 1.0 },
				{ x: 0.456, y: 0.879, s: 0.048, c: '797979', a: 1.0 },
				{ x: 0.4581, y: 0.8577, s: 0.132, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4637, y: 0.866, s: 0.05, c: '666666', a: 1.0 },
				{ x: 0.4592, y: 0.8491, s: 0.035, c: '3E3E3E', a: 1.0 },
				{ x: 0.4536, y: 0.8362, s: 0.078, c: '888888', a: 1.0 },
				{ x: 0.4625, y: 0.8252, s: 0.094, c: '9A9A9A', a: 1.0 },
				{ x: 0.4569, y: 0.8123, s: 0.044, c: '737373', a: 1.0 },
				{ x: 0.4657, y: 0.8028, s: 0.042, c: '434343', a: 1.0 },
				{ x: 0.4546, y: 0.8049, s: 0.048, c: '545454', a: 1.0 },
				{ x: 0.4602, y: 0.7877, s: 0.088, c: '6E6E6E', a: 1.0 },
				{ x: 0.4557, y: 0.8031, s: 0.063, c: '8F8F8F', a: 1.0 },
				{ x: 0.4579, y: 0.7812, s: 0.105, c: 'ADADAD', a: 1.0 },
				{ x: 0.4634, y: 0.7877, s: 0.074, c: '9F9F9F', a: 1.0 },
				{ x: 0.4589, y: 0.7794, s: 0.052, c: '858585', a: 1.0 },
				{ x: 0.461, y: 0.7561, s: 0.075, c: '5C5C5C', a: 1.0 },
				{ x: 0.4566, y: 0.7641, s: 0.055, c: '979797', a: 1.0 },
				{ x: 0.4623, y: 0.7557, s: 0.137, c: 'ADADAD', a: 1.0 },
				{ x: 0.4645, y: 0.7562, s: 0.046, c: '606060', a: 1.0 },
				{ x: 0.46, y: 0.7478, s: 0.087, c: '979797', a: 1.0 },
				{ x: 0.4543, y: 0.7206, s: 0.062, c: '7B7B7B', a: 1.0 },
				{ x: 0.4631, y: 0.7122, s: 0.129, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4553, y: 0.7202, s: 0.089, c: '8A8A8A', a: 1.0 },
				{ x: 0.4575, y: 0.6969, s: 0.032, c: '505050', a: 1.0 },
				{ x: 0.4609, y: 0.6733, s: 0.099, c: 'AAAAAA', a: 1.0 },
				{ x: 0.4564, y: 0.6888, s: 0.066, c: '8B8B8B', a: 1.0 },
				{ x: 0.462, y: 0.6715, s: 0.052, c: '595959', a: 1.0 },
				{ x: 0.464, y: 0.675, s: 0.077, c: '646464', a: 1.0 },
				{ x: 0.4598, y: 0.5279, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.4651, y: 0.5106, s: 0.041, c: '393939', a: 1.0 },
				{ x: 0.4541, y: 0.5142, s: 0.034, c: '424242', a: 1.0 },
				{ x: 0.4628, y: 0.5043, s: 0.051, c: '555555', a: 1.0 },
				{ x: 0.455, y: 0.511, s: 0.067, c: '656565', a: 1.0 },
				{ x: 0.4574, y: 0.4907, s: 0.075, c: '727272', a: 1.0 },
				{ x: 0.4661, y: 0.4793, s: 0.07, c: '7B7B7B', a: 1.0 },
				{ x: 0.4585, y: 0.4873, s: 0.069, c: '828282', a: 1.0 },
				{ x: 0.4582, y: 0.4633, s: 0.06, c: '808080', a: 1.0 },
				{ x: 0.4593, y: 0.4555, s: 0.037, c: '525252', a: 1.0 },
				{ x: 0.4617, y: 0.4176, s: 0.044, c: '383838', a: 1.0 },
				{ x: 0.4539, y: 0.4252, s: 0.034, c: '4E4E4E', a: 1.0 },
				{ x: 0.4626, y: 0.4143, s: 0.067, c: '626262', a: 1.0 },
				{ x: 0.4569, y: 0.4006, s: 0.051, c: '666666', a: 1.0 },
				{ x: 0.466, y: 0.3906, s: 0.059, c: '5E5E5E', a: 1.0 },
				{ x: 0.4546, y: 0.3938, s: 0.047, c: '5E5E5E', a: 1.0 },
				{ x: 0.4603, y: 0.3768, s: 0.074, c: '666666', a: 1.0 },
				{ x: 0.4556, y: 0.3904, s: 0.066, c: '6F6F6F', a: 1.0 },
				{ x: 0.4637, y: 0.3765, s: 0.081, c: '757575', a: 1.0 },
				{ x: 0.4614, y: 0.3464, s: 0.074, c: '777777', a: 1.0 },
				{ x: 0.4534, y: 0.3534, s: 0.074, c: '7B7B7B', a: 1.0 },
				{ x: 0.4644, y: 0.3464, s: 0.088, c: '7E7E7E', a: 1.0 },
				{ x: 0.4568, y: 0.3294, s: 0.093, c: '818181', a: 1.0 },
				{ x: 0.4658, y: 0.3207, s: 0.048, c: '858585', a: 1.0 },
				{ x: 0.4542, y: 0.3217, s: 0.102, c: '838383', a: 1.0 },
				{ x: 0.4602, y: 0.3055, s: 0.087, c: '727272', a: 1.0 },
				{ x: 0.4558, y: 0.3214, s: 0.064, c: '777777', a: 1.0 },
				{ x: 0.4664, y: 0.2897, s: 0.08, c: '666666', a: 1.0 },
				{ x: 0.459, y: 0.2973, s: 0.067, c: '585858', a: 1.0 },
				{ x: 0.4612, y: 0.2739, s: 0.048, c: '555555', a: 1.0 },
				{ x: 0.4597, y: 0.952, s: 0.049, c: '6E6E6E', a: 1.0 },
				{ x: 0.4652, y: 0.953, s: 0.056, c: '535353', a: 1.0 },
				{ x: 0.4678, y: 0.9265, s: 0.031, c: '3B3B3B', a: 1.0 },
				{ x: 0.4685, y: 0.9109, s: 0.06, c: '595959', a: 1.0 },
				{ x: 0.4577, y: 0.9026, s: 0.065, c: '838383', a: 1.0 },
				{ x: 0.4606, y: 0.8669, s: 0.04, c: '656565', a: 1.0 },
				{ x: 0.4698, y: 0.8742, s: 0.045, c: '6C6C6C', a: 1.0 },
				{ x: 0.462, y: 0.854, s: 0.093, c: '9D9D9D', a: 1.0 },
				{ x: 0.4638, y: 0.8671, s: 0.059, c: '7B7B7B', a: 1.0 },
				{ x: 0.4654, y: 0.8481, s: 0.057, c: '616161', a: 1.0 },
				{ x: 0.4672, y: 0.8367, s: 0.06, c: '7F7F7F', a: 1.0 },
				{ x: 0.4627, y: 0.8202, s: 0.12, c: '969696', a: 1.0 },
				{ x: 0.4686, y: 0.8244, s: 0.082, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4574, y: 0.8131, s: 0.066, c: '888888', a: 1.0 },
				{ x: 0.468, y: 0.7999, s: 0.043, c: '393939', a: 1.0 },
				{ x: 0.4607, y: 0.7893, s: 0.064, c: '545454', a: 1.0 },
				{ x: 0.4581, y: 0.7763, s: 0.065, c: '848484', a: 1.0 },
				{ x: 0.4594, y: 0.7693, s: 0.051, c: '787878', a: 1.0 },
				{ x: 0.4614, y: 0.7703, s: 0.078, c: '808080', a: 1.0 },
				{ x: 0.4667, y: 0.7589, s: 0.106, c: '979797', a: 1.0 },
				{ x: 0.4629, y: 0.7395, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.4568, y: 0.7175, s: 0.109, c: '868686', a: 1.0 },
				{ x: 0.4655, y: 0.7212, s: 0.061, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4601, y: 0.6962, s: 0.069, c: '676767', a: 1.0 },
				{ x: 0.4583, y: 0.6802, s: 0.072, c: '8B8B8B', a: 1.0 },
				{ x: 0.4589, y: 0.6735, s: 0.048, c: '858585', a: 1.0 },
				{ x: 0.4609, y: 0.6804, s: 0.066, c: '5F5F5F', a: 1.0 },
				{ x: 0.4671, y: 0.6724, s: 0.087, c: '707070', a: 1.0 },
				{ x: 0.4624, y: 0.5125, s: 0.041, c: '373737', a: 1.0 },
				{ x: 0.4643, y: 0.5194, s: 0.032, c: '373737', a: 1.0 },
				{ x: 0.4571, y: 0.5114, s: 0.029, c: '3D3D3D', a: 1.0 },
				{ x: 0.4657, y: 0.5123, s: 0.031, c: '505050', a: 1.0 },
				{ x: 0.4677, y: 0.5043, s: 0.044, c: '616161', a: 1.0 },
				{ x: 0.463, y: 0.4877, s: 0.086, c: '6E6E6E', a: 1.0 },
				{ x: 0.4691, y: 0.4886, s: 0.051, c: '787878', a: 1.0 },
				{ x: 0.4577, y: 0.4806, s: 0.099, c: '7F7F7F', a: 1.0 },
				{ x: 0.4664, y: 0.4875, s: 0.084, c: '838383', a: 1.0 },
				{ x: 0.4584, y: 0.4646, s: 0.068, c: '808080', a: 1.0 },
				{ x: 0.4612, y: 0.4565, s: 0.098, c: '818181', a: 1.0 },
				{ x: 0.4697, y: 0.4634, s: 0.085, c: '767676', a: 1.0 },
				{ x: 0.4617, y: 0.4406, s: 0.055, c: '5B5B5B', a: 1.0 },
				{ x: 0.4646, y: 0.4564, s: 0.031, c: '3A3A3A', a: 1.0 },
				{ x: 0.4599, y: 0.4277, s: 0.029, c: '414141', a: 1.0 },
				{ x: 0.4651, y: 0.4286, s: 0.039, c: '565656', a: 1.0 },
				{ x: 0.4671, y: 0.4206, s: 0.061, c: '666666', a: 1.0 },
				{ x: 0.4626, y: 0.4037, s: 0.057, c: '6A6A6A', a: 1.0 },
				{ x: 0.4569, y: 0.3967, s: 0.037, c: '5D5D5D', a: 1.0 },
				{ x: 0.4659, y: 0.4036, s: 0.076, c: '5E5E5E', a: 1.0 },
				{ x: 0.4589, y: 0.3837, s: 0.037, c: '666666', a: 1.0 },
				{ x: 0.4602, y: 0.3727, s: 0.085, c: '6E6E6E', a: 1.0 },
				{ x: 0.4699, y: 0.3797, s: 0.07, c: '717171', a: 1.0 },
				{ x: 0.4621, y: 0.3598, s: 0.06, c: '747474', a: 1.0 },
				{ x: 0.4635, y: 0.3727, s: 0.091, c: '767676', a: 1.0 },
				{ x: 0.4599, y: 0.3557, s: 0.049, c: '777777', a: 1.0 },
				{ x: 0.4612, y: 0.3596, s: 0.089, c: '757575', a: 1.0 },
				{ x: 0.4631, y: 0.3289, s: 0.062, c: '7B7B7B', a: 1.0 },
				{ x: 0.4645, y: 0.334, s: 0.093, c: '7F7F7F', a: 1.0 },
				{ x: 0.4567, y: 0.3271, s: 0.072, c: '7B7B7B', a: 1.0 },
				{ x: 0.4678, y: 0.3102, s: 0.087, c: '6E6E6E', a: 1.0 },
				{ x: 0.4608, y: 0.3033, s: 0.071, c: '777777', a: 1.0 },
				{ x: 0.4696, y: 0.3054, s: 0.046, c: '666666', a: 1.0 },
				{ x: 0.4576, y: 0.2866, s: 0.077, c: '606060', a: 1.0 },
				{ x: 0.464, y: 0.3035, s: 0.036, c: '555555', a: 1.0 },
				{ x: 0.4587, y: 0.2817, s: 0.052, c: '555555', a: 1.0 },
				{ x: 0.4644, y: 0.9197, s: 0.036, c: '3B3B3B', a: 1.0 },
				{ x: 0.4707, y: 0.9009, s: 0.036, c: '595959', a: 1.0 },
				{ x: 0.4676, y: 0.896, s: 0.093, c: '838383', a: 1.0 },
				{ x: 0.4605, y: 0.889, s: 0.031, c: '4A4A4A', a: 1.0 },
				{ x: 0.4686, y: 0.8702, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.4638, y: 0.8654, s: 0.088, c: '949494', a: 1.0 },
				{ x: 0.4616, y: 0.8487, s: 0.046, c: '565656', a: 1.0 },
				{ x: 0.4672, y: 0.83, s: 0.065, c: '737373', a: 1.0 },
				{ x: 0.4617, y: 0.8346, s: 0.102, c: '919191', a: 1.0 },
				{ x: 0.4649, y: 0.8248, s: 0.061, c: 'A7A7A7', a: 1.0 },
				{ x: 0.468, y: 0.7952, s: 0.039, c: '393939', a: 1.0 },
				{ x: 0.4629, y: 0.8004, s: 0.046, c: '4F4F4F', a: 1.0 },
				{ x: 0.469, y: 0.7905, s: 0.067, c: '676767', a: 1.0 },
				{ x: 0.4713, y: 0.7717, s: 0.089, c: '848484', a: 1.0 },
				{ x: 0.4662, y: 0.7767, s: 0.052, c: '858585', a: 1.0 },
				{ x: 0.4723, y: 0.767, s: 0.081, c: '787878', a: 1.0 },
				{ x: 0.4614, y: 0.7719, s: 0.068, c: '606060', a: 1.0 },
				{ x: 0.4692, y: 0.7527, s: 0.079, c: '898989', a: 1.0 },
				{ x: 0.4625, y: 0.7433, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.4636, y: 0.7301, s: 0.058, c: '6E6E6E', a: 1.0 },
				{ x: 0.4654, y: 0.7251, s: 0.122, c: 'A1A1A1', a: 1.0 },
				{ x: 0.467, y: 0.7067, s: 0.074, c: '8A8A8A', a: 1.0 },
				{ x: 0.4627, y: 0.7084, s: 0.047, c: '727272', a: 1.0 },
				{ x: 0.4689, y: 0.7018, s: 0.057, c: '6A6A6A', a: 1.0 },
				{ x: 0.4704, y: 0.683, s: 0.08, c: '9E9E9E', a: 1.0 },
				{ x: 0.4665, y: 0.6847, s: 0.138, c: 'B1B1B1', a: 1.0 },
				{ x: 0.4722, y: 0.6781, s: 0.045, c: '787878', a: 1.0 },
				{ x: 0.46, y: 0.6828, s: 0.062, c: '6C6C6C', a: 1.0 },
				{ x: 0.4699, y: 0.6613, s: 0.091, c: '7C7C7C', a: 1.0 },
				{ x: 0.4711, y: 0.5112, s: 0.043, c: '373737', a: 1.0 },
				{ x: 0.4635, y: 0.5137, s: 0.039, c: '3B3B3B', a: 1.0 },
				{ x: 0.4733, y: 0.4946, s: 0.044, c: '474747', a: 1.0 },
				{ x: 0.4611, y: 0.5119, s: 0.066, c: '585858', a: 1.0 },
				{ x: 0.4669, y: 0.4898, s: 0.081, c: '686868', a: 1.0 },
				{ x: 0.463, y: 0.4945, s: 0.055, c: '727272', a: 1.0 },
				{ x: 0.4706, y: 0.4658, s: 0.059, c: '808080', a: 1.0 },
				{ x: 0.4666, y: 0.4712, s: 0.054, c: '808080', a: 1.0 },
				{ x: 0.4605, y: 0.4665, s: 0.07, c: '747474', a: 1.0 },
				{ x: 0.4698, y: 0.4473, s: 0.076, c: '616161', a: 1.0 },
				{ x: 0.4712, y: 0.4378, s: 0.026, c: '484848', a: 1.0 },
				{ x: 0.4638, y: 0.4426, s: 0.047, c: '3A3A3A', a: 1.0 },
				{ x: 0.4718, y: 0.4234, s: 0.024, c: '3A3A3A', a: 1.0 },
				{ x: 0.4611, y: 0.4378, s: 0.036, c: '4B4B4B', a: 1.0 },
				{ x: 0.4617, y: 0.4235, s: 0.062, c: '666666', a: 1.0 },
				{ x: 0.4648, y: 0.4143, s: 0.063, c: '666666', a: 1.0 },
				{ x: 0.4707, y: 0.3955, s: 0.037, c: '616161', a: 1.0 },
				{ x: 0.465, y: 0.3998, s: 0.071, c: '5C5C5C', a: 1.0 },
				{ x: 0.468, y: 0.3899, s: 0.039, c: '5E5E5E', a: 1.0 },
				{ x: 0.4607, y: 0.3957, s: 0.078, c: '646464', a: 1.0 },
				{ x: 0.4687, y: 0.376, s: 0.079, c: '6A6A6A', a: 1.0 },
				{ x: 0.4713, y: 0.3662, s: 0.063, c: '717171', a: 1.0 },
				{ x: 0.466, y: 0.372, s: 0.054, c: '6D6D6D', a: 1.0 },
				{ x: 0.4719, y: 0.3621, s: 0.088, c: '6F6F6F', a: 1.0 },
				{ x: 0.4616, y: 0.3663, s: 0.042, c: '747474', a: 1.0 },
				{ x: 0.4692, y: 0.3475, s: 0.093, c: '727272', a: 1.0 },
				{ x: 0.462, y: 0.3384, s: 0.044, c: '747474', a: 1.0 },
				{ x: 0.465, y: 0.3434, s: 0.081, c: '777777', a: 1.0 },
				{ x: 0.4726, y: 0.3239, s: 0.081, c: '777777', a: 1.0 },
				{ x: 0.4682, y: 0.3196, s: 0.046, c: '707070', a: 1.0 },
				{ x: 0.4688, y: 0.314, s: 0.046, c: '666666', a: 1.0 },
				{ x: 0.4701, y: 0.296, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.4661, y: 0.2981, s: 0.068, c: '696969', a: 1.0 },
				{ x: 0.4724, y: 0.2905, s: 0.059, c: '636363', a: 1.0 },
				{ x: 0.46, y: 0.2955, s: 0.06, c: '656565', a: 1.0 },
				{ x: 0.4729, y: 0.9095, s: 0.036, c: '333333', a: 1.0 },
				{ x: 0.4656, y: 0.9145, s: 0.031, c: '515151', a: 1.0 },
				{ x: 0.4668, y: 0.8935, s: 0.06, c: '7A7A7A', a: 1.0 },
				{ x: 0.4763, y: 0.9104, s: 0.077, c: '838383', a: 1.0 },
				{ x: 0.4691, y: 0.8789, s: 0.048, c: '3B3B3B', a: 1.0 },
				{ x: 0.4703, y: 0.8811, s: 0.037, c: '575757', a: 1.0 },
				{ x: 0.4664, y: 0.875, s: 0.068, c: '656565', a: 1.0 },
				{ x: 0.4676, y: 0.8531, s: 0.071, c: '878787', a: 1.0 },
				{ x: 0.4697, y: 0.8509, s: 0.04, c: '333333', a: 1.0 },
				{ x: 0.4709, y: 0.8474, s: 0.023, c: '3E3E3E', a: 1.0 },
				{ x: 0.4743, y: 0.8235, s: 0.105, c: 'A2A2A2', a: 1.0 },
				{ x: 0.4671, y: 0.8049, s: 0.099, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4766, y: 0.8207, s: 0.048, c: '434343', a: 1.0 },
				{ x: 0.4644, y: 0.7874, s: 0.042, c: '363636', a: 1.0 },
				{ x: 0.4705, y: 0.7928, s: 0.054, c: '4C4C4C', a: 1.0 },
				{ x: 0.4667, y: 0.7833, s: 0.048, c: '757575', a: 1.0 },
				{ x: 0.4684, y: 0.7536, s: 0.048, c: '545454', a: 1.0 },
				{ x: 0.4712, y: 0.7338, s: 0.077, c: '7B7B7B', a: 1.0 },
				{ x: 0.464, y: 0.7153, s: 0.075, c: '9D9D9D', a: 1.0 },
				{ x: 0.4718, y: 0.7059, s: 0.129, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4746, y: 0.7112, s: 0.054, c: '8A8A8A', a: 1.0 },
				{ x: 0.4673, y: 0.6914, s: 0.084, c: '727272', a: 1.0 },
				{ x: 0.4646, y: 0.6873, s: 0.123, c: 'B1B1B1', a: 1.0 },
				{ x: 0.4708, y: 0.6913, s: 0.101, c: 'AAAAAA', a: 1.0 },
				{ x: 0.467, y: 0.6634, s: 0.058, c: '7F7F7F', a: 1.0 },
				{ x: 0.4696, y: 0.5091, s: 0.022, c: '3B3B3B', a: 1.0 },
				{ x: 0.4702, y: 0.5145, s: 0.057, c: '474747', a: 1.0 },
				{ x: 0.4657, y: 0.505, s: 0.039, c: '545454', a: 1.0 },
				{ x: 0.473, y: 0.4866, s: 0.051, c: '616161', a: 1.0 },
				{ x: 0.469, y: 0.4811, s: 0.088, c: '757575', a: 1.0 },
				{ x: 0.4762, y: 0.4865, s: 0.051, c: '7B7B7B', a: 1.0 },
				{ x: 0.4634, y: 0.4665, s: 0.076, c: '7E7E7E', a: 1.0 },
				{ x: 0.4661, y: 0.4615, s: 0.07, c: '747474', a: 1.0 },
				{ x: 0.4683, y: 0.4412, s: 0.05, c: '656565', a: 1.0 },
				{ x: 0.4755, y: 0.4582, s: 0.049, c: '565656', a: 1.0 },
				{ x: 0.4694, y: 0.438, s: 0.052, c: '4D4D4D', a: 1.0 },
				{ x: 0.4716, y: 0.4415, s: 0.038, c: '4D4D4D', a: 1.0 },
				{ x: 0.4687, y: 0.4093, s: 0.078, c: '6A6A6A', a: 1.0 },
				{ x: 0.4759, y: 0.4143, s: 0.054, c: '636363', a: 1.0 },
				{ x: 0.4647, y: 0.3941, s: 0.056, c: '5A5A5A', a: 1.0 },
				{ x: 0.4719, y: 0.3857, s: 0.052, c: '5A5A5A', a: 1.0 },
				{ x: 0.4659, y: 0.3891, s: 0.079, c: '646464', a: 1.0 },
				{ x: 0.4681, y: 0.3704, s: 0.037, c: '686868', a: 1.0 },
				{ x: 0.4753, y: 0.3856, s: 0.078, c: '6A6A6A', a: 1.0 },
				{ x: 0.4714, y: 0.3704, s: 0.053, c: '717171', a: 1.0 },
				{ x: 0.4651, y: 0.362, s: 0.069, c: '727272', a: 1.0 },
				{ x: 0.4673, y: 0.3418, s: 0.083, c: '727272', a: 1.0 },
				{ x: 0.4745, y: 0.3453, s: 0.091, c: '747474', a: 1.0 },
				{ x: 0.4705, y: 0.342, s: 0.061, c: '7B7B7B', a: 1.0 },
				{ x: 0.4644, y: 0.3217, s: 0.095, c: '797979', a: 1.0 },
				{ x: 0.4718, y: 0.3146, s: 0.071, c: '767676', a: 1.0 },
				{ x: 0.4738, y: 0.3181, s: 0.057, c: '686868', a: 1.0 },
				{ x: 0.4678, y: 0.2978, s: 0.064, c: '6F6F6F', a: 1.0 },
				{ x: 0.4766, y: 0.3133, s: 0.06, c: '808080', a: 1.0 },
				{ x: 0.4639, y: 0.2945, s: 0.078, c: '6F6F6F', a: 1.0 },
				{ x: 0.4666, y: 0.2898, s: 0.041, c: '606060', a: 1.0 },
				{ x: 0.467, y: 0.2041, s: 0.041, c: '6A6A6A', a: 1.0 },
				{ x: 0.4775, y: 0.9503, s: 0.052, c: '4F4F4F', a: 1.0 },
				{ x: 0.4732, y: 0.9185, s: 0.042, c: '4C4C4C', a: 1.0 },
				{ x: 0.4736, y: 0.8993, s: 0.048, c: '696969', a: 1.0 },
				{ x: 0.4676, y: 0.8913, s: 0.061, c: '818181', a: 1.0 },
				{ x: 0.4763, y: 0.8826, s: 0.026, c: '373737', a: 1.0 },
				{ x: 0.4723, y: 0.8791, s: 0.058, c: '5F5F5F', a: 1.0 },
				{ x: 0.4797, y: 0.8592, s: 0.053, c: '7C7C7C', a: 1.0 },
				{ x: 0.4667, y: 0.8505, s: 0.094, c: '979797', a: 1.0 },
				{ x: 0.4757, y: 0.8544, s: 0.052, c: '4A4A4A', a: 1.0 },
				{ x: 0.4698, y: 0.8296, s: 0.036, c: '363636', a: 1.0 },
				{ x: 0.4791, y: 0.8247, s: 0.077, c: '858585', a: 1.0 },
				{ x: 0.4734, y: 0.8214, s: 0.066, c: 'A5A5A5', a: 1.0 },
				{ x: 0.4688, y: 0.8007, s: 0.046, c: '5A5A5A', a: 1.0 },
				{ x: 0.4722, y: 0.7835, s: 0.051, c: '7E7E7E', a: 1.0 },
				{ x: 0.4796, y: 0.7628, s: 0.059, c: '494949', a: 1.0 },
				{ x: 0.4756, y: 0.7417, s: 0.041, c: '323232', a: 1.0 },
				{ x: 0.4695, y: 0.721, s: 0.044, c: '585858', a: 1.0 },
				{ x: 0.4713, y: 0.7368, s: 0.08, c: '8B8B8B', a: 1.0 },
				{ x: 0.4785, y: 0.7178, s: 0.079, c: 'A7A7A7', a: 1.0 },
				{ x: 0.4728, y: 0.7217, s: 0.122, c: '9B9B9B', a: 1.0 },
				{ x: 0.475, y: 0.7129, s: 0.047, c: '818181', a: 1.0 },
				{ x: 0.4684, y: 0.693, s: 0.067, c: '6E6E6E', a: 1.0 },
				{ x: 0.4761, y: 0.6978, s: 0.123, c: '989898', a: 1.0 },
				{ x: 0.4783, y: 0.6891, s: 0.074, c: 'B7B7B7', a: 1.0 },
				{ x: 0.4739, y: 0.6737, s: 0.067, c: '686868', a: 1.0 },
				{ x: 0.4682, y: 0.6653, s: 0.059, c: '919191', a: 1.0 },
				{ x: 0.4754, y: 0.6695, s: 0.05, c: '7B7B7B', a: 1.0 },
				{ x: 0.4771, y: 0.5064, s: 0.038, c: '373737', a: 1.0 },
				{ x: 0.471, y: 0.5226, s: 0.032, c: '3E3E3E', a: 1.0 },
				{ x: 0.4786, y: 0.5023, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.4671, y: 0.5064, s: 0.061, c: '545454', a: 1.0 },
				{ x: 0.4744, y: 0.4989, s: 0.054, c: '5B5B5B', a: 1.0 },
				{ x: 0.4686, y: 0.4786, s: 0.073, c: '656565', a: 1.0 },
				{ x: 0.4708, y: 0.4828, s: 0.067, c: '6C6C6C', a: 1.0 },
				{ x: 0.4776, y: 0.4744, s: 0.076, c: '777777', a: 1.0 },
				{ x: 0.4731, y: 0.4787, s: 0.065, c: '757575', a: 1.0 },
				{ x: 0.474, y: 0.4584, s: 0.067, c: '757575', a: 1.0 },
				{ x: 0.4678, y: 0.4507, s: 0.061, c: '757575', a: 1.0 },
				{ x: 0.4763, y: 0.4543, s: 0.055, c: '6D6D6D', a: 1.0 },
				{ x: 0.4773, y: 0.4349, s: 0.051, c: '626262', a: 1.0 },
				{ x: 0.4712, y: 0.4508, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.4669, y: 0.4348, s: 0.075, c: '5D5D5D', a: 1.0 },
				{ x: 0.4745, y: 0.4264, s: 0.038, c: '686868', a: 1.0 },
				{ x: 0.4699, y: 0.4069, s: 0.085, c: '6B6B6B', a: 1.0 },
				{ x: 0.4789, y: 0.4028, s: 0.061, c: '676767', a: 1.0 },
				{ x: 0.4733, y: 0.4064, s: 0.069, c: '5F5F5F', a: 1.0 },
				{ x: 0.4735, y: 0.3987, s: 0.035, c: '5B5B5B', a: 1.0 },
				{ x: 0.4766, y: 0.3825, s: 0.053, c: '646464', a: 1.0 },
				{ x: 0.4722, y: 0.3784, s: 0.082, c: '6A6A6A', a: 1.0 },
				{ x: 0.4793, y: 0.3589, s: 0.07, c: '707070', a: 1.0 },
				{ x: 0.4671, y: 0.3506, s: 0.074, c: '6F6F6F', a: 1.0 },
				{ x: 0.4757, y: 0.3545, s: 0.087, c: '717171', a: 1.0 },
				{ x: 0.4694, y: 0.3347, s: 0.055, c: '6C6C6C', a: 1.0 },
				{ x: 0.4713, y: 0.3505, s: 0.053, c: '6F6F6F', a: 1.0 },
				{ x: 0.479, y: 0.3309, s: 0.093, c: '747474', a: 1.0 },
				{ x: 0.4726, y: 0.3348, s: 0.05, c: '747474', a: 1.0 },
				{ x: 0.4746, y: 0.3268, s: 0.078, c: '707070', a: 1.0 },
				{ x: 0.4691, y: 0.3069, s: 0.058, c: '626262', a: 1.0 },
				{ x: 0.4781, y: 0.3027, s: 0.053, c: '737373', a: 1.0 },
				{ x: 0.4717, y: 0.3066, s: 0.069, c: '656565', a: 1.0 },
				{ x: 0.4681, y: 0.2787, s: 0.053, c: '525252', a: 1.0 },
				{ x: 0.4751, y: 0.2171, s: 0.043, c: '686868', a: 1.0 },
				{ x: 0.4729, y: 0.9633, s: 0.055, c: '616161', a: 1.0 },
				{ x: 0.4749, y: 0.9315, s: 0.043, c: '4A4A4A', a: 1.0 },
				{ x: 0.4818, y: 0.9175, s: 0.038, c: '4C4C4C', a: 1.0 },
				{ x: 0.4705, y: 0.9096, s: 0.047, c: '696969', a: 1.0 },
				{ x: 0.4782, y: 0.8896, s: 0.091, c: '757575', a: 1.0 },
				{ x: 0.4719, y: 0.8757, s: 0.031, c: '505050', a: 1.0 },
				{ x: 0.4739, y: 0.8677, s: 0.074, c: '5F5F5F', a: 1.0 },
				{ x: 0.4809, y: 0.8717, s: 0.084, c: '767676', a: 1.0 },
				{ x: 0.4753, y: 0.8518, s: 0.092, c: '979797', a: 1.0 },
				{ x: 0.4772, y: 0.8438, s: 0.048, c: '606060', a: 1.0 },
				{ x: 0.4709, y: 0.8358, s: 0.045, c: '484848', a: 1.0 },
				{ x: 0.4788, y: 0.8159, s: 0.08, c: '787878', a: 1.0 },
				{ x: 0.4801, y: 0.8318, s: 0.066, c: '8F8F8F', a: 1.0 },
				{ x: 0.4749, y: 0.8119, s: 0.109, c: '9A9A9A', a: 1.0 },
				{ x: 0.4829, y: 0.8158, s: 0.086, c: '717171', a: 1.0 },
				{ x: 0.4701, y: 0.7899, s: 0.052, c: '5F5F5F', a: 1.0 },
				{ x: 0.4734, y: 0.7577, s: 0.03, c: '494949', a: 1.0 },
				{ x: 0.4814, y: 0.7658, s: 0.041, c: '3E3E3E', a: 1.0 },
				{ x: 0.4713, y: 0.7539, s: 0.042, c: '565656', a: 1.0 },
				{ x: 0.4793, y: 0.7262, s: 0.053, c: '585858', a: 1.0 },
				{ x: 0.4754, y: 0.7184, s: 0.063, c: 'ABABAB', a: 1.0 },
				{ x: 0.4826, y: 0.7144, s: 0.089, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4707, y: 0.7224, s: 0.121, c: '959595', a: 1.0 },
				{ x: 0.4787, y: 0.7067, s: 0.047, c: '7B7B7B', a: 1.0 },
				{ x: 0.4726, y: 0.7027, s: 0.08, c: '6E6E6E', a: 1.0 },
				{ x: 0.4771, y: 0.6751, s: 0.054, c: '707070', a: 1.0 },
				{ x: 0.4718, y: 0.6832, s: 0.112, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4798, y: 0.6555, s: 0.056, c: '6B6B6B', a: 1.0 },
				{ x: 0.4805, y: 0.5679, s: 0.02, c: '343434', a: 1.0 },
				{ x: 0.4752, y: 0.5521, s: 0.028, c: '353535', a: 1.0 },
				{ x: 0.4832, y: 0.5483, s: 0.031, c: '363636', a: 1.0 },
				{ x: 0.4712, y: 0.5265, s: 0.043, c: '393939', a: 1.0 },
				{ x: 0.4784, y: 0.5107, s: 0.047, c: '3D3D3D', a: 1.0 },
				{ x: 0.473, y: 0.5068, s: 0.047, c: '464646', a: 1.0 },
				{ x: 0.4744, y: 0.4911, s: 0.033, c: '4F4F4F', a: 1.0 },
				{ x: 0.4823, y: 0.499, s: 0.05, c: '545454', a: 1.0 },
				{ x: 0.4764, y: 0.4951, s: 0.07, c: '5E5E5E', a: 1.0 },
				{ x: 0.4779, y: 0.479, s: 0.06, c: '656565', a: 1.0 },
				{ x: 0.4723, y: 0.487, s: 0.063, c: '6B6B6B', a: 1.0 },
				{ x: 0.4797, y: 0.4593, s: 0.043, c: '707070', a: 1.0 },
				{ x: 0.4808, y: 0.4673, s: 0.084, c: '747474', a: 1.0 },
				{ x: 0.4757, y: 0.4515, s: 0.073, c: '757575', a: 1.0 },
				{ x: 0.477, y: 0.4477, s: 0.041, c: '6F6F6F', a: 1.0 },
				{ x: 0.471, y: 0.4554, s: 0.079, c: '656565', a: 1.0 },
				{ x: 0.4788, y: 0.44, s: 0.047, c: '606060', a: 1.0 },
				{ x: 0.4804, y: 0.4357, s: 0.063, c: '626262', a: 1.0 },
				{ x: 0.4749, y: 0.4198, s: 0.076, c: '646464', a: 1.0 },
				{ x: 0.4703, y: 0.4239, s: 0.071, c: '6B6B6B', a: 1.0 },
				{ x: 0.4722, y: 0.4161, s: 0.075, c: '676767', a: 1.0 },
				{ x: 0.4734, y: 0.3886, s: 0.043, c: '636363', a: 1.0 },
				{ x: 0.4816, y: 0.3963, s: 0.055, c: '5B5B5B', a: 1.0 },
				{ x: 0.4761, y: 0.3808, s: 0.042, c: '5B5B5B', a: 1.0 },
				{ x: 0.4768, y: 0.3765, s: 0.074, c: '5E5E5E', a: 1.0 },
				{ x: 0.4713, y: 0.3845, s: 0.044, c: '646464', a: 1.0 },
				{ x: 0.4795, y: 0.369, s: 0.064, c: '6D6D6D', a: 1.0 },
				{ x: 0.4802, y: 0.3647, s: 0.076, c: '676767', a: 1.0 },
				{ x: 0.4747, y: 0.3492, s: 0.072, c: '666666', a: 1.0 },
				{ x: 0.4829, y: 0.3568, s: 0.066, c: '6A6A6A', a: 1.0 },
				{ x: 0.4707, y: 0.3533, s: 0.068, c: '686868', a: 1.0 },
				{ x: 0.478, y: 0.3372, s: 0.041, c: '666666', a: 1.0 },
				{ x: 0.4819, y: 0.3259, s: 0.076, c: '626262', a: 1.0 },
				{ x: 0.4759, y: 0.3216, s: 0.043, c: '545454', a: 1.0 },
				{ x: 0.4775, y: 0.3055, s: 0.071, c: '616161', a: 1.0 },
				{ x: 0.4807, y: 0.2942, s: 0.074, c: '656565', a: 1.0 },
				{ x: 0.4751, y: 0.2066, s: 0.036, c: '616161', a: 1.0 },
				{ x: 0.4864, y: 0.9428, s: 0.074, c: '6E6E6E', a: 1.0 },
				{ x: 0.474, y: 0.9274, s: 0.063, c: '5C5C5C', a: 1.0 },
				{ x: 0.482, y: 0.9108, s: 0.046, c: '3C3C3C', a: 1.0 },
				{ x: 0.4764, y: 0.8958, s: 0.048, c: '5D5D5D', a: 1.0 },
				{ x: 0.4773, y: 0.9038, s: 0.068, c: '696969', a: 1.0 },
				{ x: 0.4853, y: 0.8813, s: 0.049, c: '484848', a: 1.0 },
				{ x: 0.4796, y: 0.8655, s: 0.068, c: '5F5F5F', a: 1.0 },
				{ x: 0.481, y: 0.8741, s: 0.073, c: '717171', a: 1.0 },
				{ x: 0.4753, y: 0.8464, s: 0.053, c: '8C8C8C', a: 1.0 },
				{ x: 0.4833, y: 0.8537, s: 0.083, c: '6A6A6A', a: 1.0 },
				{ x: 0.4789, y: 0.8227, s: 0.052, c: '585858', a: 1.0 },
				{ x: 0.4865, y: 0.83, s: 0.054, c: '787878', a: 1.0 },
				{ x: 0.4823, y: 0.811, s: 0.045, c: '7C7C7C', a: 1.0 },
				{ x: 0.4765, y: 0.7773, s: 0.073, c: '696969', a: 1.0 },
				{ x: 0.4779, y: 0.7845, s: 0.09, c: '898989', a: 1.0 },
				{ x: 0.4735, y: 0.7656, s: 0.058, c: '6F6F6F', a: 1.0 },
				{ x: 0.4758, y: 0.7452, s: 0.045, c: '3E3E3E', a: 1.0 },
				{ x: 0.4767, y: 0.7535, s: 0.09, c: '8C8C8C', a: 1.0 },
				{ x: 0.4791, y: 0.7331, s: 0.108, c: '8B8B8B', a: 1.0 },
				{ x: 0.4748, y: 0.7261, s: 0.084, c: 'B7B7B7', a: 1.0 },
				{ x: 0.4824, y: 0.7223, s: 0.111, c: 'B7B7B7', a: 1.0 },
				{ x: 0.4781, y: 0.7136, s: 0.044, c: '747474', a: 1.0 },
				{ x: 0.4737, y: 0.6937, s: 0.078, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4814, y: 0.7017, s: 0.112, c: 'AEAEAE', a: 1.0 },
				{ x: 0.4759, y: 0.6747, s: 0.063, c: '707070', a: 1.0 },
				{ x: 0.477, y: 0.6827, s: 0.082, c: '808080', a: 1.0 },
				{ x: 0.4848, y: 0.6659, s: 0.094, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4793, y: 0.6624, s: 0.066, c: '565656', a: 1.0 },
				{ x: 0.4805, y: 0.5815, s: 0.03, c: '353535', a: 1.0 },
				{ x: 0.475, y: 0.5542, s: 0.026, c: '373737', a: 1.0 },
				{ x: 0.4828, y: 0.5611, s: 0.044, c: '373737', a: 1.0 },
				{ x: 0.4784, y: 0.5423, s: 0.032, c: '383838', a: 1.0 },
				{ x: 0.4861, y: 0.5314, s: 0.032, c: '373737', a: 1.0 },
				{ x: 0.4739, y: 0.5159, s: 0.032, c: '393939', a: 1.0 },
				{ x: 0.4817, y: 0.5124, s: 0.045, c: '393939', a: 1.0 },
				{ x: 0.4773, y: 0.5038, s: 0.046, c: '454545', a: 1.0 },
				{ x: 0.4851, y: 0.5002, s: 0.061, c: '4C4C4C', a: 1.0 },
				{ x: 0.4796, y: 0.4848, s: 0.035, c: '535353', a: 1.0 },
				{ x: 0.4807, y: 0.492, s: 0.055, c: '5E5E5E', a: 1.0 },
				{ x: 0.4752, y: 0.4646, s: 0.064, c: '676767', a: 1.0 },
				{ x: 0.483, y: 0.4729, s: 0.085, c: '6E6E6E', a: 1.0 },
				{ x: 0.4841, y: 0.4575, s: 0.053, c: '727272', a: 1.0 },
				{ x: 0.4865, y: 0.4609, s: 0.084, c: '6F6F6F', a: 1.0 },
				{ x: 0.4742, y: 0.4454, s: 0.076, c: '6A6A6A', a: 1.0 },
				{ x: 0.482, y: 0.4419, s: 0.056, c: '666666', a: 1.0 },
				{ x: 0.4765, y: 0.425, s: 0.06, c: '686868', a: 1.0 },
				{ x: 0.4777, y: 0.4334, s: 0.046, c: '6B6B6B', a: 1.0 },
				{ x: 0.4799, y: 0.413, s: 0.079, c: '6D6D6D', a: 1.0 },
				{ x: 0.4857, y: 0.4213, s: 0.052, c: '696969', a: 1.0 },
				{ x: 0.4778, y: 0.394, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.4834, y: 0.4025, s: 0.071, c: '636363', a: 1.0 },
				{ x: 0.4822, y: 0.3856, s: 0.05, c: '5A5A5A', a: 1.0 },
				{ x: 0.4745, y: 0.382, s: 0.04, c: '545454', a: 1.0 },
				{ x: 0.4788, y: 0.3736, s: 0.042, c: '5E5E5E', a: 1.0 },
				{ x: 0.4843, y: 0.3695, s: 0.057, c: '5B5B5B', a: 1.0 },
				{ x: 0.4832, y: 0.3552, s: 0.064, c: '565656', a: 1.0 },
				{ x: 0.4754, y: 0.3618, s: 0.035, c: '595959', a: 1.0 },
				{ x: 0.4809, y: 0.3578, s: 0.048, c: '626262', a: 1.0 },
				{ x: 0.4798, y: 0.3435, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.4854, y: 0.3499, s: 0.055, c: '646464', a: 1.0 },
				{ x: 0.4776, y: 0.3237, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.4764, y: 0.3317, s: 0.064, c: '5D5D5D', a: 1.0 },
				{ x: 0.482, y: 0.3084, s: 0.037, c: '4C4C4C', a: 1.0 },
				{ x: 0.4741, y: 0.3059, s: 0.036, c: '5D5D5D', a: 1.0 },
				{ x: 0.4863, y: 0.314, s: 0.056, c: '636363', a: 1.0 },
				{ x: 0.4786, y: 0.2966, s: 0.057, c: '656565', a: 1.0 },
				{ x: 0.4842, y: 0.2942, s: 0.046, c: '636363', a: 1.0 },
				{ x: 0.4863, y: 0.9575, s: 0.076, c: '616161', a: 1.0 },
				{ x: 0.4785, y: 0.9551, s: 0.085, c: '858585', a: 1.0 },
				{ x: 0.484, y: 0.9378, s: 0.044, c: '696969', a: 1.0 },
				{ x: 0.4829, y: 0.9354, s: 0.059, c: '4A4A4A', a: 1.0 },
				{ x: 0.4883, y: 0.8955, s: 0.041, c: '505050', a: 1.0 },
				{ x: 0.4806, y: 0.902, s: 0.053, c: '5D5D5D', a: 1.0 },
				{ x: 0.4851, y: 0.866, s: 0.06, c: '545454', a: 1.0 },
				{ x: 0.4773, y: 0.8724, s: 0.04, c: '6B6B6B', a: 1.0 },
				{ x: 0.4895, y: 0.8463, s: 0.063, c: '777777', a: 1.0 },
				{ x: 0.4817, y: 0.8528, s: 0.086, c: '6A6A6A', a: 1.0 },
				{ x: 0.4872, y: 0.8191, s: 0.025, c: '424242', a: 1.0 },
				{ x: 0.4859, y: 0.8167, s: 0.07, c: '636363', a: 1.0 },
				{ x: 0.4783, y: 0.8232, s: 0.069, c: '787878', a: 1.0 },
				{ x: 0.4836, y: 0.8072, s: 0.057, c: '7C7C7C', a: 1.0 },
				{ x: 0.4827, y: 0.7869, s: 0.084, c: '696969', a: 1.0 },
				{ x: 0.4883, y: 0.7696, s: 0.067, c: '939393', a: 1.0 },
				{ x: 0.4803, y: 0.7794, s: 0.082, c: '939393', a: 1.0 },
				{ x: 0.4793, y: 0.7749, s: 0.113, c: '959595', a: 1.0 },
				{ x: 0.4846, y: 0.758, s: 0.11, c: '8F8F8F', a: 1.0 },
				{ x: 0.477, y: 0.7671, s: 0.075, c: '707070', a: 1.0 },
				{ x: 0.4858, y: 0.7265, s: 0.105, c: 'AFAFAF', a: 1.0 },
				{ x: 0.478, y: 0.7341, s: 0.11, c: 'BBBBBB', a: 1.0 },
				{ x: 0.4878, y: 0.7004, s: 0.065, c: '6E6E6E', a: 1.0 },
				{ x: 0.4802, y: 0.708, s: 0.066, c: '898989', a: 1.0 },
				{ x: 0.4788, y: 0.703, s: 0.069, c: 'B3B3B3', a: 1.0 },
				{ x: 0.4845, y: 0.6882, s: 0.115, c: '919191', a: 1.0 },
				{ x: 0.4831, y: 0.6962, s: 0.039, c: '686868', a: 1.0 },
				{ x: 0.4889, y: 0.6673, s: 0.125, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4809, y: 0.6764, s: 0.117, c: '999999', a: 1.0 },
				{ x: 0.4799, y: 0.6595, s: 0.051, c: '4D4D4D', a: 1.0 },
				{ x: 0.4776, y: 0.6651, s: 0.031, c: '4D4D4D', a: 1.0 },
				{ x: 0.49, y: 0.576, s: 0.031, c: '333333', a: 1.0 },
				{ x: 0.4819, y: 0.574, s: 0.03, c: '383838', a: 1.0 },
				{ x: 0.4876, y: 0.5578, s: 0.035, c: '393939', a: 1.0 },
				{ x: 0.4863, y: 0.564, s: 0.045, c: '393939', a: 1.0 },
				{ x: 0.4787, y: 0.562, s: 0.026, c: '373737', a: 1.0 },
				{ x: 0.484, y: 0.5459, s: 0.034, c: '393939', a: 1.0 },
				{ x: 0.4833, y: 0.5526, s: 0.041, c: '383838', a: 1.0 },
				{ x: 0.4884, y: 0.5261, s: 0.027, c: '373737', a: 1.0 },
				{ x: 0.4805, y: 0.5271, s: 0.024, c: '353535', a: 1.0 },
				{ x: 0.4798, y: 0.5109, s: 0.04, c: '353535', a: 1.0 },
				{ x: 0.4853, y: 0.5089, s: 0.03, c: '353535', a: 1.0 },
				{ x: 0.4772, y: 0.5155, s: 0.028, c: '393939', a: 1.0 },
				{ x: 0.4894, y: 0.4893, s: 0.039, c: '3E3E3E', a: 1.0 },
				{ x: 0.4819, y: 0.4964, s: 0.047, c: '454545', a: 1.0 },
				{ x: 0.4875, y: 0.4798, s: 0.033, c: '4C4C4C', a: 1.0 },
				{ x: 0.486, y: 0.4775, s: 0.055, c: '565656', a: 1.0 },
				{ x: 0.4785, y: 0.4847, s: 0.045, c: '606060', a: 1.0 },
				{ x: 0.4841, y: 0.4673, s: 0.078, c: '656565', a: 1.0 },
				{ x: 0.4825, y: 0.4656, s: 0.042, c: '6B6B6B', a: 1.0 },
				{ x: 0.4881, y: 0.4484, s: 0.066, c: '6C6C6C', a: 1.0 },
				{ x: 0.4807, y: 0.4556, s: 0.061, c: '6B6B6B', a: 1.0 },
				{ x: 0.4795, y: 0.4532, s: 0.077, c: '6A6A6A', a: 1.0 },
				{ x: 0.4846, y: 0.4365, s: 0.038, c: '666666', a: 1.0 },
				{ x: 0.4768, y: 0.4438, s: 0.081, c: '6A6A6A', a: 1.0 },
				{ x: 0.4894, y: 0.4175, s: 0.062, c: '6F6F6F', a: 1.0 },
				{ x: 0.4814, y: 0.4248, s: 0.044, c: '6F6F6F', a: 1.0 },
				{ x: 0.4869, y: 0.4104, s: 0.046, c: '6D6D6D', a: 1.0 },
				{ x: 0.4783, y: 0.4123, s: 0.052, c: '676767', a: 1.0 },
				{ x: 0.4834, y: 0.3988, s: 0.047, c: '5F5F5F', a: 1.0 },
				{ x: 0.4822, y: 0.3934, s: 0.051, c: '565656', a: 1.0 },
				{ x: 0.4882, y: 0.3765, s: 0.052, c: '4C4C4C', a: 1.0 },
				{ x: 0.4804, y: 0.3867, s: 0.03, c: '4A4A4A', a: 1.0 },
				{ x: 0.4788, y: 0.3813, s: 0.061, c: '4D4D4D', a: 1.0 },
				{ x: 0.4849, y: 0.3648, s: 0.037, c: '474747', a: 1.0 },
				{ x: 0.4771, y: 0.3743, s: 0.039, c: '444444', a: 1.0 },
				{ x: 0.4888, y: 0.346, s: 0.054, c: '505050', a: 1.0 },
				{ x: 0.481, y: 0.3555, s: 0.033, c: '595959', a: 1.0 },
				{ x: 0.4871, y: 0.3388, s: 0.045, c: '555555', a: 1.0 },
				{ x: 0.4857, y: 0.3334, s: 0.065, c: '555555', a: 1.0 },
				{ x: 0.4777, y: 0.3437, s: 0.038, c: '545454', a: 1.0 },
				{ x: 0.4897, y: 0.315, s: 0.045, c: '545454', a: 1.0 },
				{ x: 0.4825, y: 0.3096, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.4876, y: 0.2959, s: 0.066, c: '5F5F5F', a: 1.0 },
				{ x: 0.4863, y: 0.3028, s: 0.038, c: '636363', a: 1.0 },
				{ x: 0.4791, y: 0.2976, s: 0.037, c: '555555', a: 1.0 },
				{ x: 0.4878, y: 0.9632, s: 0.074, c: '5B5B5B', a: 1.0 },
				{ x: 0.4864, y: 0.9374, s: 0.045, c: '6D6D6D', a: 1.0 },
				{ x: 0.4917, y: 0.9323, s: 0.039, c: '525252', a: 1.0 },
				{ x: 0.4845, y: 0.8978, s: 0.037, c: '4A4A4A', a: 1.0 },
				{ x: 0.4832, y: 0.8958, s: 0.06, c: '5F5F5F', a: 1.0 },
				{ x: 0.4885, y: 0.9026, s: 0.037, c: '3C3C3C', a: 1.0 },
				{ x: 0.4811, y: 0.8679, s: 0.027, c: '444444', a: 1.0 },
				{ x: 0.4931, y: 0.8658, s: 0.061, c: '5E5E5E', a: 1.0 },
				{ x: 0.4852, y: 0.8488, s: 0.072, c: '6E6E6E', a: 1.0 },
				{ x: 0.4905, y: 0.8557, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.4819, y: 0.8188, s: 0.048, c: '505050', a: 1.0 },
				{ x: 0.4872, y: 0.8259, s: 0.066, c: '656565', a: 1.0 },
				{ x: 0.4858, y: 0.8001, s: 0.095, c: '787878', a: 1.0 },
				{ x: 0.492, y: 0.807, s: 0.053, c: '484848', a: 1.0 },
				{ x: 0.484, y: 0.793, s: 0.046, c: '737373', a: 1.0 },
				{ x: 0.4826, y: 0.7761, s: 0.109, c: '9F9F9F', a: 1.0 },
				{ x: 0.4887, y: 0.783, s: 0.124, c: '9F9F9F', a: 1.0 },
				{ x: 0.4807, y: 0.7572, s: 0.101, c: '999999', a: 1.0 },
				{ x: 0.4846, y: 0.7472, s: 0.062, c: '979797', a: 1.0 },
				{ x: 0.4814, y: 0.7352, s: 0.062, c: 'ACACAC', a: 1.0 },
				{ x: 0.4875, y: 0.7331, s: 0.134, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4864, y: 0.7161, s: 0.077, c: 'B0B0B0', a: 1.0 },
				{ x: 0.4911, y: 0.7262, s: 0.097, c: 'A6A6A6', a: 1.0 },
				{ x: 0.4841, y: 0.7211, s: 0.1, c: '8C8C8C', a: 1.0 },
				{ x: 0.4829, y: 0.7036, s: 0.089, c: '717171', a: 1.0 },
				{ x: 0.4876, y: 0.7116, s: 0.108, c: '969696', a: 1.0 },
				{ x: 0.4807, y: 0.6868, s: 0.09, c: 'A8A8A8', a: 1.0 },
				{ x: 0.4921, y: 0.6917, s: 0.057, c: '7A7A7A', a: 1.0 },
				{ x: 0.4843, y: 0.6759, s: 0.048, c: '7A7A7A', a: 1.0 },
				{ x: 0.4808, y: 0.6641, s: 0.058, c: '4C4C4C', a: 1.0 },
				{ x: 0.4872, y: 0.6632, s: 0.037, c: '646464', a: 1.0 },
				{ x: 0.4852, y: 0.6474, s: 0.07, c: '5D5D5D', a: 1.0 },
				{ x: 0.4916, y: 0.5809, s: 0.028, c: '353535', a: 1.0 },
				{ x: 0.4818, y: 0.5642, s: 0.041, c: '393939', a: 1.0 },
				{ x: 0.4881, y: 0.5692, s: 0.033, c: '383838', a: 1.0 },
				{ x: 0.4861, y: 0.5444, s: 0.026, c: '393939', a: 1.0 },
				{ x: 0.4919, y: 0.5524, s: 0.022, c: '383838', a: 1.0 },
				{ x: 0.4849, y: 0.5098, s: 0.044, c: '363636', a: 1.0 },
				{ x: 0.4829, y: 0.5029, s: 0.024, c: '373737', a: 1.0 },
				{ x: 0.4884, y: 0.5109, s: 0.04, c: '3C3C3C', a: 1.0 },
				{ x: 0.4927, y: 0.4882, s: 0.046, c: '464646', a: 1.0 },
				{ x: 0.4913, y: 0.4801, s: 0.053, c: '565656', a: 1.0 },
				{ x: 0.4893, y: 0.4762, s: 0.036, c: '5F5F5F', a: 1.0 },
				{ x: 0.4823, y: 0.4634, s: 0.057, c: '676767', a: 1.0 },
				{ x: 0.486, y: 0.4408, s: 0.082, c: '686868', a: 1.0 },
				{ x: 0.4835, y: 0.433, s: 0.061, c: '686868', a: 1.0 },
				{ x: 0.4827, y: 0.429, s: 0.07, c: '6F6F6F', a: 1.0 },
				{ x: 0.4888, y: 0.4398, s: 0.069, c: '707070', a: 1.0 },
				{ x: 0.4804, y: 0.421, s: 0.072, c: '707070', a: 1.0 },
				{ x: 0.4932, y: 0.4174, s: 0.066, c: '6A6A6A', a: 1.0 },
				{ x: 0.4856, y: 0.4042, s: 0.04, c: '6D6D6D', a: 1.0 },
				{ x: 0.4903, y: 0.4007, s: 0.078, c: '676767', a: 1.0 },
				{ x: 0.4898, y: 0.4051, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.4822, y: 0.3927, s: 0.041, c: '525252', a: 1.0 },
				{ x: 0.4867, y: 0.3885, s: 0.059, c: '4D4D4D', a: 1.0 },
				{ x: 0.4866, y: 0.3403, s: 0.026, c: '494949', a: 1.0 },
				{ x: 0.4911, y: 0.3509, s: 0.043, c: '4C4C4C', a: 1.0 },
				{ x: 0.4835, y: 0.3469, s: 0.055, c: '4D4D4D', a: 1.0 },
				{ x: 0.483, y: 0.3166, s: 0.06, c: '4B4B4B', a: 1.0 },
				{ x: 0.4879, y: 0.3212, s: 0.039, c: '555555', a: 1.0 },
				{ x: 0.4801, y: 0.2938, s: 0.05, c: '585858', a: 1.0 },
				{ x: 0.493, y: 0.2984, s: 0.058, c: '565656', a: 1.0 },
				{ x: 0.4879, y: 0.9483, s: 0.051, c: '525252', a: 1.0 },
				{ x: 0.494, y: 0.9537, s: 0.034, c: '525252', a: 1.0 },
				{ x: 0.4931, y: 0.9377, s: 0.064, c: '5B5B5B', a: 1.0 },
				{ x: 0.4842, y: 0.9364, s: 0.057, c: '525252', a: 1.0 },
				{ x: 0.4908, y: 0.918, s: 0.043, c: '686868', a: 1.0 },
				{ x: 0.4885, y: 0.9078, s: 0.036, c: '444444', a: 1.0 },
				{ x: 0.4943, y: 0.9072, s: 0.053, c: '5F5F5F', a: 1.0 },
				{ x: 0.4875, y: 0.8881, s: 0.024, c: '3C3C3C', a: 1.0 },
				{ x: 0.4853, y: 0.8787, s: 0.044, c: '3A3A3A', a: 1.0 },
				{ x: 0.491, y: 0.8535, s: 0.032, c: '4F4F4F', a: 1.0 },
				{ x: 0.4839, y: 0.8619, s: 0.072, c: '616161', a: 1.0 },
				{ x: 0.4939, y: 0.8262, s: 0.054, c: '5E5E5E', a: 1.0 },
				{ x: 0.4917, y: 0.807, s: 0.078, c: '787878', a: 1.0 },
				{ x: 0.4847, y: 0.8064, s: 0.039, c: '484848', a: 1.0 },
				{ x: 0.496, y: 0.7783, s: 0.087, c: '737373', a: 1.0 },
				{ x: 0.4946, y: 0.7822, s: 0.08, c: '9D9D9D', a: 1.0 },
				{ x: 0.4852, y: 0.7722, s: 0.094, c: '9A9A9A', a: 1.0 },
				{ x: 0.4916, y: 0.7445, s: 0.081, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4956, y: 0.7365, s: 0.061, c: 'A1A1A1', a: 1.0 },
				{ x: 0.4882, y: 0.7327, s: 0.097, c: 'A6A6A6', a: 1.0 },
				{ x: 0.4862, y: 0.7429, s: 0.136, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4848, y: 0.7209, s: 0.107, c: 'A3A3A3', a: 1.0 },
				{ x: 0.4888, y: 0.7122, s: 0.079, c: '757575', a: 1.0 },
				{ x: 0.4935, y: 0.7083, s: 0.065, c: '919191', a: 1.0 },
				{ x: 0.4858, y: 0.7005, s: 0.087, c: '6D6D6D', a: 1.0 },
				{ x: 0.49, y: 0.6728, s: 0.063, c: '919191', a: 1.0 },
				{ x: 0.4897, y: 0.6844, s: 0.096, c: 'A9A9A9', a: 1.0 },
				{ x: 0.4868, y: 0.661, s: 0.044, c: '5D5D5D', a: 1.0 },
				{ x: 0.4924, y: 0.6451, s: 0.078, c: '646464', a: 1.0 },
				{ x: 0.4837, y: 0.5787, s: 0.029, c: '343434', a: 1.0 },
				{ x: 0.4963, y: 0.5648, s: 0.024, c: '373737', a: 1.0 },
				{ x: 0.4876, y: 0.5616, s: 0.027, c: '383838', a: 1.0 },
				{ x: 0.4936, y: 0.5666, s: 0.027, c: '383838', a: 1.0 },
				{ x: 0.4933, y: 0.553, s: 0.032, c: '3B3B3B', a: 1.0 },
				{ x: 0.4842, y: 0.5491, s: 0.023, c: '383838', a: 1.0 },
				{ x: 0.4903, y: 0.5312, s: 0.044, c: '373737', a: 1.0 },
				{ x: 0.49, y: 0.5333, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.4943, y: 0.5316, s: 0.044, c: '383838', a: 1.0 },
				{ x: 0.4871, y: 0.4949, s: 0.021, c: '363636', a: 1.0 },
				{ x: 0.4867, y: 0.5034, s: 0.025, c: '3A3A3A', a: 1.0 },
				{ x: 0.4911, y: 0.4778, s: 0.038, c: '424242', a: 1.0 },
				{ x: 0.4839, y: 0.4832, s: 0.04, c: '4A4A4A', a: 1.0 },
				{ x: 0.4951, y: 0.4678, s: 0.054, c: '4E4E4E', a: 1.0 },
				{ x: 0.4879, y: 0.4672, s: 0.064, c: '565656', a: 1.0 },
				{ x: 0.4939, y: 0.471, s: 0.05, c: '616161', a: 1.0 },
				{ x: 0.4917, y: 0.4556, s: 0.048, c: '656565', a: 1.0 },
				{ x: 0.4845, y: 0.4551, s: 0.069, c: '676767', a: 1.0 },
				{ x: 0.4907, y: 0.4396, s: 0.052, c: '676767', a: 1.0 },
				{ x: 0.4885, y: 0.4435, s: 0.068, c: '696969', a: 1.0 },
				{ x: 0.4946, y: 0.4432, s: 0.085, c: '6F6F6F', a: 1.0 },
				{ x: 0.4875, y: 0.4278, s: 0.063, c: '717171', a: 1.0 },
				{ x: 0.4853, y: 0.4316, s: 0.05, c: '707070', a: 1.0 },
				{ x: 0.4915, y: 0.4073, s: 0.081, c: '6C6C6C', a: 1.0 },
				{ x: 0.4842, y: 0.4156, s: 0.067, c: '696969', a: 1.0 },
				{ x: 0.4953, y: 0.3972, s: 0.061, c: '676767', a: 1.0 },
				{ x: 0.4881, y: 0.3951, s: 0.059, c: '636363', a: 1.0 },
				{ x: 0.492, y: 0.3852, s: 0.053, c: '444444', a: 1.0 },
				{ x: 0.4848, y: 0.3475, s: 0.029, c: '4F4F4F', a: 1.0 },
				{ x: 0.496, y: 0.3321, s: 0.059, c: '494949', a: 1.0 },
				{ x: 0.4888, y: 0.3137, s: 0.032, c: '505050', a: 1.0 },
				{ x: 0.4949, y: 0.3102, s: 0.034, c: '525252', a: 1.0 },
				{ x: 0.496, y: 0.9624, s: 0.066, c: '818181', a: 1.0 },
				{ x: 0.4888, y: 0.9351, s: 0.091, c: '8A8A8A', a: 1.0 },
				{ x: 0.495, y: 0.9463, s: 0.1, c: '818181', a: 1.0 },
				{ x: 0.4928, y: 0.9265, s: 0.056, c: '818181', a: 1.0 },
				{ x: 0.499, y: 0.9231, s: 0.073, c: '5D5D5D', a: 1.0 },
				{ x: 0.49, y: 0.9225, s: 0.023, c: '404040', a: 1.0 },
				{ x: 0.4895, y: 0.9026, s: 0.064, c: '515151', a: 1.0 },
				{ x: 0.496, y: 0.899, s: 0.069, c: '5F5F5F', a: 1.0 },
				{ x: 0.4882, y: 0.8627, s: 0.037, c: '3F3F3F', a: 1.0 },
				{ x: 0.4987, y: 0.8594, s: 0.034, c: '444444', a: 1.0 },
				{ x: 0.4927, y: 0.8644, s: 0.039, c: '5C5C5C', a: 1.0 },
				{ x: 0.4982, y: 0.8501, s: 0.05, c: '616161', a: 1.0 },
				{ x: 0.4953, y: 0.8239, s: 0.06, c: '5E5E5E', a: 1.0 },
				{ x: 0.4892, y: 0.805, s: 0.075, c: '6C6C6C', a: 1.0 },
				{ x: 0.4948, y: 0.8145, s: 0.048, c: '787878', a: 1.0 },
				{ x: 0.4919, y: 0.7942, s: 0.076, c: '737373', a: 1.0 },
				{ x: 0.4975, y: 0.774, s: 0.08, c: '9D9D9D', a: 1.0 },
				{ x: 0.4879, y: 0.7478, s: 0.118, c: 'A4A4A4', a: 1.0 },
				{ x: 0.4985, y: 0.7469, s: 0.125, c: '9E9E9E', a: 1.0 },
				{ x: 0.4872, y: 0.7147, s: 0.072, c: '999999', a: 1.0 },
				{ x: 0.4973, y: 0.703, s: 0.045, c: '717171', a: 1.0 },
				{ x: 0.4911, y: 0.7125, s: 0.058, c: '7F7F7F', a: 1.0 },
				{ x: 0.49, y: 0.6864, s: 0.065, c: '757575', a: 1.0 },
				{ x: 0.4938, y: 0.6958, s: 0.068, c: '686868', a: 1.0 },
				{ x: 0.4877, y: 0.6768, s: 0.123, c: 'A2A2A2', a: 1.0 },
				{ x: 0.4998, y: 0.6744, s: 0.056, c: '979797', a: 1.0 },
				{ x: 0.4975, y: 0.665, s: 0.073, c: '6B6B6B', a: 1.0 },
				{ x: 0.4964, y: 0.6626, s: 0.06, c: '757575', a: 1.0 },
				{ x: 0.487, y: 0.6484, s: 0.06, c: '555555', a: 1.0 },
				{ x: 0.4942, y: 0.5805, s: 0.032, c: '343434', a: 1.0 },
				{ x: 0.4929, y: 0.5796, s: 0.024, c: '373737', a: 1.0 },
				{ x: 0.497, y: 0.5652, s: 0.029, c: '383838', a: 1.0 },
				{ x: 0.4956, y: 0.5687, s: 0.026, c: '393939', a: 1.0 },
				{ x: 0.4898, y: 0.5436, s: 0.048, c: '3B3B3B', a: 1.0 },
				{ x: 0.4934, y: 0.5535, s: 0.021, c: '3A3A3A', a: 1.0 },
				{ x: 0.4925, y: 0.5329, s: 0.042, c: '3A3A3A', a: 1.0 },
				{ x: 0.4994, y: 0.5308, s: 0.032, c: '3A3A3A', a: 1.0 },
				{ x: 0.4902, y: 0.5413, s: 0.034, c: '373737', a: 1.0 },
				{ x: 0.4891, y: 0.5214, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.496, y: 0.4949, s: 0.036, c: '383838', a: 1.0 },
				{ x: 0.4868, y: 0.4809, s: 0.043, c: '3E3E3E', a: 1.0 },
				{ x: 0.4988, y: 0.4855, s: 0.029, c: '444444', a: 1.0 },
				{ x: 0.4929, y: 0.483, s: 0.029, c: '4B4B4B', a: 1.0 },
				{ x: 0.4982, y: 0.4691, s: 0.046, c: '545454', a: 1.0 },
				{ x: 0.4956, y: 0.4737, s: 0.051, c: '5C5C5C', a: 1.0 },
				{ x: 0.4893, y: 0.4478, s: 0.074, c: '656565', a: 1.0 },
				{ x: 0.4949, y: 0.4569, s: 0.054, c: '676767', a: 1.0 },
				{ x: 0.4993, y: 0.4358, s: 0.052, c: '6A6A6A', a: 1.0 },
				{ x: 0.4916, y: 0.4456, s: 0.083, c: '6A6A6A', a: 1.0 },
				{ x: 0.496, y: 0.4238, s: 0.062, c: '707070', a: 1.0 },
				{ x: 0.4879, y: 0.4098, s: 0.063, c: '6C6C6C', a: 1.0 },
				{ x: 0.4987, y: 0.4071, s: 0.039, c: '656565', a: 1.0 },
				{ x: 0.4907, y: 0.411, s: 0.079, c: '636363', a: 1.0 },
				{ x: 0.4981, y: 0.3978, s: 0.043, c: '565656', a: 1.0 },
				{ x: 0.4874, y: 0.3276, s: 0.047, c: '494949', a: 1.0 },
				{ x: 0.4948, y: 0.3374, s: 0.046, c: '4B4B4B', a: 1.0 },
				{ x: 0.4918, y: 0.3301, s: 0.049, c: '4E4E4E', a: 1.0 },
				{ x: 0.4975, y: 0.3096, s: 0.035, c: '545454', a: 1.0 },
				{ x: 0.491, y: 0.3135, s: 0.03, c: '4C4C4C', a: 1.0 },
				{ x: 0.492, y: 0.953, s: 0.067, c: '525252', a: 1.0 },
				{ x: 0.4909, y: 0.9364, s: 0.1, c: 'A7A7A7', a: 1.0 },
				{ x: 0.5031, y: 0.9407, s: 0.044, c: '525252', a: 1.0 },
				{ x: 0.4941, y: 0.9145, s: 0.029, c: '343434', a: 1.0 },
				{ x: 0.5009, y: 0.9128, s: 0.046, c: '565656', a: 1.0 },
				{ x: 0.4906, y: 0.9027, s: 0.048, c: '5F5F5F', a: 1.0 },
				{ x: 0.4979, y: 0.8771, s: 0.055, c: '4F4F4F', a: 1.0 },
				{ x: 0.4963, y: 0.8628, s: 0.044, c: '545454', a: 1.0 },
				{ x: 0.4945, y: 0.8408, s: 0.053, c: '4E4E4E', a: 1.0 },
				{ x: 0.4933, y: 0.8332, s: 0.036, c: '3C3C3C', a: 1.0 },
				{ x: 0.4968, y: 0.8129, s: 0.088, c: '737373', a: 1.0 },
				{ x: 0.4911, y: 0.8112, s: 0.1, c: '818181', a: 1.0 },
				{ x: 0.5033, y: 0.8207, s: 0.046, c: '787878', a: 1.0 },
				{ x: 0.4934, y: 0.7833, s: 0.083, c: '6A6A6A', a: 1.0 },
				{ x: 0.4922, y: 0.7815, s: 0.057, c: '969696', a: 1.0 },
				{ x: 0.4903, y: 0.7715, s: 0.098, c: 'A2A2A2', a: 1.0 },
				{ x: 0.5021, y: 0.7691, s: 0.074, c: '9E9E9E', a: 1.0 },
				{ x: 0.496, y: 0.7555, s: 0.069, c: '979797', a: 1.0 },
				{ x: 0.5004, y: 0.759, s: 0.115, c: '909090', a: 1.0 },
				{ x: 0.4988, y: 0.7336, s: 0.078, c: '8C8C8C', a: 1.0 },
				{ x: 0.4927, y: 0.7431, s: 0.055, c: '858585', a: 1.0 },
				{ x: 0.497, y: 0.7233, s: 0.055, c: '898989', a: 1.0 },
				{ x: 0.5025, y: 0.731, s: 0.095, c: '969696', a: 1.0 },
				{ x: 0.4947, y: 0.7115, s: 0.115, c: '969696', a: 1.0 },
				{ x: 0.4923, y: 0.7091, s: 0.086, c: '717171', a: 1.0 },
				{ x: 0.4995, y: 0.6957, s: 0.06, c: '717171', a: 1.0 },
				{ x: 0.4914, y: 0.6932, s: 0.061, c: '636363', a: 1.0 },
				{ x: 0.5024, y: 0.6975, s: 0.039, c: '686868', a: 1.0 },
				{ x: 0.4961, y: 0.6833, s: 0.113, c: '9C9C9C', a: 1.0 },
				{ x: 0.5014, y: 0.6815, s: 0.071, c: '7A7A7A', a: 1.0 },
				{ x: 0.4983, y: 0.6616, s: 0.061, c: '5C5C5C', a: 1.0 },
				{ x: 0.4929, y: 0.6715, s: 0.047, c: '7C7C7C', a: 1.0 },
				{ x: 0.4982, y: 0.6694, s: 0.075, c: '6B6B6B', a: 1.0 },
				{ x: 0.4952, y: 0.5662, s: 0.029, c: '343434', a: 1.0 },
				{ x: 0.5005, y: 0.5759, s: 0.03, c: '393939', a: 1.0 },
				{ x: 0.495, y: 0.5501, s: 0.045, c: '3A3A3A', a: 1.0 },
				{ x: 0.4918, y: 0.554, s: 0.032, c: '3B3B3B', a: 1.0 },
				{ x: 0.4971, y: 0.54, s: 0.03, c: '3A3A3A', a: 1.0 },
				{ x: 0.4916, y: 0.5383, s: 0.023, c: '3A3A3A', a: 1.0 },
				{ x: 0.4939, y: 0.5282, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.5009, y: 0.5262, s: 0.042, c: '363636', a: 1.0 },
				{ x: 0.4987, y: 0.5062, s: 0.021, c: '373737', a: 1.0 },
				{ x: 0.4906, y: 0.4923, s: 0.042, c: '3A3A3A', a: 1.0 },
				{ x: 0.4976, y: 0.4903, s: 0.039, c: '424242', a: 1.0 },
				{ x: 0.4954, y: 0.4704, s: 0.039, c: '4B4B4B', a: 1.0 },
				{ x: 0.5007, y: 0.4802, s: 0.033, c: '545454', a: 1.0 },
				{ x: 0.493, y: 0.4584, s: 0.062, c: '616161', a: 1.0 },
				{ x: 0.4911, y: 0.4424, s: 0.042, c: '666666', a: 1.0 },
				{ x: 0.503, y: 0.4523, s: 0.065, c: '696969', a: 1.0 },
				{ x: 0.4934, y: 0.4325, s: 0.06, c: '6A6A6A', a: 1.0 },
				{ x: 0.4998, y: 0.4165, s: 0.062, c: '717171', a: 1.0 },
				{ x: 0.4901, y: 0.4203, s: 0.077, c: '696969', a: 1.0 },
				{ x: 0.4979, y: 0.4183, s: 0.034, c: '5E5E5E', a: 1.0 },
				{ x: 0.4965, y: 0.4045, s: 0.064, c: '525252', a: 1.0 },
				{ x: 0.5002, y: 0.4084, s: 0.044, c: '404040', a: 1.0 },
				{ x: 0.4987, y: 0.3289, s: 0.045, c: '4F4F4F', a: 1.0 },
				{ x: 0.4926, y: 0.322, s: 0.06, c: '535353', a: 1.0 },
				{ x: 0.4973, y: 0.2943, s: 0.028, c: '4C4C4C', a: 1.0 },
				{ x: 0.4953, y: 0.2961, s: 0.042, c: '565656', a: 1.0 },
				{ x: 0.5059, y: 0.9372, s: 0.065, c: '636363', a: 1.0 },
				{ x: 0.4972, y: 0.9392, s: 0.102, c: '7E7E7E', a: 1.0 },
				{ x: 0.4952, y: 0.9173, s: 0.035, c: '515151', a: 1.0 },
				{ x: 0.5052, y: 0.8997, s: 0.061, c: '787878', a: 1.0 },
				{ x: 0.5046, y: 0.868, s: 0.045, c: '383838', a: 1.0 },
				{ x: 0.4965, y: 0.8721, s: 0.045, c: '727272', a: 1.0 },
				{ x: 0.5012, y: 0.8562, s: 0.057, c: '787878', a: 1.0 },
				{ x: 0.4984, y: 0.8345, s: 0.044, c: '4C4C4C', a: 1.0 },
				{ x: 0.5064, y: 0.8125, s: 0.058, c: '878787', a: 1.0 },
				{ x: 0.4978, y: 0.8205, s: 0.095, c: '959595', a: 1.0 },
				{ x: 0.4958, y: 0.7988, s: 0.086, c: '818181', a: 1.0 },
				{ x: 0.503, y: 0.783, s: 0.042, c: '5B5B5B', a: 1.0 },
				{ x: 0.5056, y: 0.7693, s: 0.053, c: '7E7E7E', a: 1.0 },
				{ x: 0.497, y: 0.7714, s: 0.084, c: '878787', a: 1.0 },
				{ x: 0.5044, y: 0.7556, s: 0.081, c: '858585', a: 1.0 },
				{ x: 0.5024, y: 0.7576, s: 0.058, c: '858585', a: 1.0 },
				{ x: 0.4937, y: 0.7593, s: 0.104, c: '818181', a: 1.0 },
				{ x: 0.5009, y: 0.7436, s: 0.052, c: '747474', a: 1.0 },
				{ x: 0.5035, y: 0.7238, s: 0.083, c: '737373', a: 1.0 },
				{ x: 0.4983, y: 0.7319, s: 0.059, c: '787878', a: 1.0 },
				{ x: 0.4954, y: 0.7102, s: 0.068, c: '7C7C7C', a: 1.0 },
				{ x: 0.4948, y: 0.7199, s: 0.084, c: '6B6B6B', a: 1.0 },
				{ x: 0.5056, y: 0.6986, s: 0.072, c: '6B6B6B', a: 1.0 },
				{ x: 0.4967, y: 0.7004, s: 0.048, c: '626262', a: 1.0 },
				{ x: 0.5049, y: 0.6843, s: 0.041, c: '676767', a: 1.0 },
				{ x: 0.5027, y: 0.6867, s: 0.092, c: '818181', a: 1.0 },
				{ x: 0.4935, y: 0.6884, s: 0.058, c: '616161', a: 1.0 },
				{ x: 0.5013, y: 0.667, s: 0.067, c: '747474', a: 1.0 },
				{ x: 0.504, y: 0.6532, s: 0.029, c: '4E4E4E', a: 1.0 },
				{ x: 0.4981, y: 0.5595, s: 0.042, c: '373737', a: 1.0 },
				{ x: 0.4962, y: 0.5441, s: 0.026, c: '383838', a: 1.0 },
				{ x: 0.5006, y: 0.5461, s: 0.038, c: '383838', a: 1.0 },
				{ x: 0.4947, y: 0.5478, s: 0.03, c: '383838', a: 1.0 },
				{ x: 0.5059, y: 0.5323, s: 0.03, c: '383838', a: 1.0 },
				{ x: 0.4975, y: 0.534, s: 0.025, c: '373737', a: 1.0 },
				{ x: 0.4953, y: 0.5066, s: 0.04, c: '363636', a: 1.0 },
				{ x: 0.5026, y: 0.4904, s: 0.034, c: '3B3B3B', a: 1.0 },
				{ x: 0.4938, y: 0.4929, s: 0.036, c: '434343', a: 1.0 },
				{ x: 0.5053, y: 0.4708, s: 0.046, c: '4D4D4D', a: 1.0 },
				{ x: 0.4994, y: 0.4792, s: 0.036, c: '545454', a: 1.0 },
				{ x: 0.5039, y: 0.457, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.502, y: 0.4588, s: 0.044, c: '606060', a: 1.0 },
				{ x: 0.4965, y: 0.4433, s: 0.075, c: '5E5E5E', a: 1.0 },
				{ x: 0.4984, y: 0.4474, s: 0.059, c: '616161', a: 1.0 },
				{ x: 0.5066, y: 0.4313, s: 0.042, c: '5E5E5E', a: 1.0 },
				{ x: 0.4977, y: 0.4338, s: 0.04, c: '666666', a: 1.0 },
				{ x: 0.4951, y: 0.4116, s: 0.062, c: '6C6C6C', a: 1.0 },
				{ x: 0.5033, y: 0.414, s: 0.051, c: '616161', a: 1.0 },
				{ x: 0.4944, y: 0.4216, s: 0.045, c: '4F4F4F', a: 1.0 },
				{ x: 0.5052, y: 0.3996, s: 0.049, c: '404040', a: 1.0 },
				{ x: 0.4997, y: 0.3425, s: 0.039, c: '4E4E4E', a: 1.0 },
				{ x: 0.5042, y: 0.2905, s: 0.044, c: '4D4D4D', a: 1.0 },
				{ x: 0.5056, y: 0.962, s: 0.052, c: '484848', a: 1.0 },
				{ x: 0.4999, y: 0.9461, s: 0.078, c: '979797', a: 1.0 },
				{ x: 0.5045, y: 0.9474, s: 0.087, c: '979797', a: 1.0 },
				{ x: 0.5021, y: 0.9257, s: 0.091, c: '7E7E7E', a: 1.0 },
				{ x: 0.5098, y: 0.9344, s: 0.049, c: '6C6C6C', a: 1.0 },
				{ x: 0.5012, y: 0.9058, s: 0.028, c: '3F3F3F', a: 1.0 },
				{ x: 0.4988, y: 0.9079, s: 0.07, c: '6C6C6C', a: 1.0 },
				{ x: 0.5035, y: 0.9166, s: 0.094, c: '808080', a: 1.0 },
				{ x: 0.4977, y: 0.8948, s: 0.066, c: '5E5E5E', a: 1.0 },
				{ x: 0.5091, y: 0.8783, s: 0.047, c: '474747', a: 1.0 },
				{ x: 0.5001, y: 0.8624, s: 0.066, c: '727272', a: 1.0 },
				{ x: 0.5081, y: 0.8652, s: 0.098, c: '7F7F7F', a: 1.0 },
				{ x: 0.5057, y: 0.8672, s: 0.045, c: '787878', a: 1.0 },
				{ x: 0.5047, y: 0.8294, s: 0.061, c: '8E8E8E', a: 1.0 },
				{ x: 0.5024, y: 0.8077, s: 0.082, c: '9F9F9F', a: 1.0 },
				{ x: 0.5013, y: 0.7754, s: 0.05, c: '545454', a: 1.0 },
				{ x: 0.4993, y: 0.7782, s: 0.081, c: '707070', a: 1.0 },
				{ x: 0.5036, y: 0.7803, s: 0.082, c: '707070', a: 1.0 },
				{ x: 0.4983, y: 0.7637, s: 0.086, c: '777777', a: 1.0 },
				{ x: 0.5005, y: 0.7447, s: 0.093, c: '797979', a: 1.0 },
				{ x: 0.5083, y: 0.7527, s: 0.088, c: '747474', a: 1.0 },
				{ x: 0.5059, y: 0.7538, s: 0.055, c: '6A6A6A', a: 1.0 },
				{ x: 0.4973, y: 0.7328, s: 0.049, c: '606060', a: 1.0 },
				{ x: 0.5049, y: 0.7407, s: 0.07, c: '656565', a: 1.0 },
				{ x: 0.5029, y: 0.7182, s: 0.073, c: '656565', a: 1.0 },
				{ x: 0.5071, y: 0.7204, s: 0.043, c: '6E6E6E', a: 1.0 },
				{ x: 0.5051, y: 0.7053, s: 0.092, c: '737373', a: 1.0 },
				{ x: 0.4994, y: 0.7074, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.504, y: 0.7084, s: 0.084, c: '757575', a: 1.0 },
				{ x: 0.5017, y: 0.693, s: 0.056, c: '626262', a: 1.0 },
				{ x: 0.5095, y: 0.6956, s: 0.071, c: '616161', a: 1.0 },
				{ x: 0.5006, y: 0.6727, s: 0.054, c: '676767', a: 1.0 },
				{ x: 0.4984, y: 0.6812, s: 0.075, c: '616161', a: 1.0 },
				{ x: 0.5063, y: 0.6836, s: 0.045, c: '7B7B7B', a: 1.0 },
				{ x: 0.4975, y: 0.6622, s: 0.071, c: '5B5B5B', a: 1.0 },
				{ x: 0.5086, y: 0.5618, s: 0.041, c: '363636', a: 1.0 },
				{ x: 0.5031, y: 0.5405, s: 0.031, c: '363636', a: 1.0 },
				{ x: 0.5076, y: 0.5428, s: 0.027, c: '373737', a: 1.0 },
				{ x: 0.5052, y: 0.5452, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.4997, y: 0.5286, s: 0.023, c: '373737', a: 1.0 },
				{ x: 0.5042, y: 0.5251, s: 0.045, c: '373737', a: 1.0 },
				{ x: 0.502, y: 0.5037, s: 0.022, c: '363636', a: 1.0 },
				{ x: 0.5098, y: 0.4986, s: 0.029, c: '353535', a: 1.0 },
				{ x: 0.501, y: 0.4772, s: 0.032, c: '3B3B3B', a: 1.0 },
				{ x: 0.5066, y: 0.488, s: 0.047, c: '494949', a: 1.0 },
				{ x: 0.4977, y: 0.4652, s: 0.064, c: '515151', a: 1.0 },
				{ x: 0.5089, y: 0.4676, s: 0.033, c: '585858', a: 1.0 },
				{ x: 0.5078, y: 0.4532, s: 0.056, c: '5B5B5B', a: 1.0 },
				{ x: 0.5056, y: 0.4556, s: 0.067, c: '585858', a: 1.0 },
				{ x: 0.4967, y: 0.4401, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.5045, y: 0.4426, s: 0.041, c: '555555', a: 1.0 },
				{ x: 0.5023, y: 0.4198, s: 0.034, c: '555555', a: 1.0 },
				{ x: 0.5068, y: 0.4282, s: 0.034, c: '4F4F4F', a: 1.0 },
				{ x: 0.5013, y: 0.4067, s: 0.06, c: '4A4A4A', a: 1.0 },
				{ x: 0.4991, y: 0.4092, s: 0.024, c: '424242', a: 1.0 },
				{ x: 0.5035, y: 0.3506, s: 0.063, c: '515151', a: 1.0 },
				{ x: 0.498, y: 0.3234, s: 0.039, c: '4A4A4A', a: 1.0 },
				{ x: 0.5125, y: 0.9397, s: 0.075, c: '7E7E7E', a: 1.0 },
				{ x: 0.5064, y: 0.9432, s: 0.085, c: 'C9C9C9', a: 1.0 },
				{ x: 0.5119, y: 0.9436, s: 0.076, c: '979797', a: 1.0 },
				{ x: 0.5075, y: 0.9234, s: 0.063, c: '515151', a: 1.0 },
				{ x: 0.5085, y: 0.9022, s: 0.041, c: '6C6C6C', a: 1.0 },
				{ x: 0.504, y: 0.9058, s: 0.076, c: '787878', a: 1.0 },
				{ x: 0.513, y: 0.8898, s: 0.047, c: '4C4C4C', a: 1.0 },
				{ x: 0.5051, y: 0.8726, s: 0.057, c: '555555', a: 1.0 },
				{ x: 0.5006, y: 0.876, s: 0.054, c: '7F7F7F', a: 1.0 },
				{ x: 0.5095, y: 0.8587, s: 0.086, c: '8D8D8D', a: 1.0 },
				{ x: 0.5017, y: 0.8608, s: 0.072, c: '676767', a: 1.0 },
				{ x: 0.5106, y: 0.8167, s: 0.037, c: '626262', a: 1.0 },
				{ x: 0.5016, y: 0.8267, s: 0.088, c: '9F9F9F', a: 1.0 },
				{ x: 0.5072, y: 0.805, s: 0.058, c: '656565', a: 1.0 },
				{ x: 0.5027, y: 0.7993, s: 0.053, c: '474747', a: 1.0 },
				{ x: 0.5117, y: 0.7791, s: 0.064, c: '626262', a: 1.0 },
				{ x: 0.5038, y: 0.7811, s: 0.069, c: '7E7E7E', a: 1.0 },
				{ x: 0.5127, y: 0.7639, s: 0.064, c: '707070', a: 1.0 },
				{ x: 0.5003, y: 0.768, s: 0.08, c: '707070', a: 1.0 },
				{ x: 0.5047, y: 0.7557, s: 0.051, c: '6C6C6C', a: 1.0 },
				{ x: 0.5102, y: 0.7325, s: 0.042, c: '6A6A6A', a: 1.0 },
				{ x: 0.5058, y: 0.736, s: 0.081, c: '656565', a: 1.0 },
				{ x: 0.5034, y: 0.7089, s: 0.065, c: '767676', a: 1.0 },
				{ x: 0.5123, y: 0.7121, s: 0.052, c: '7E7E7E', a: 1.0 },
				{ x: 0.5078, y: 0.6952, s: 0.081, c: '6B6B6B', a: 1.0 },
				{ x: 0.5002, y: 0.6969, s: 0.053, c: '616161', a: 1.0 },
				{ x: 0.5088, y: 0.677, s: 0.047, c: '5A5A5A', a: 1.0 },
				{ x: 0.5044, y: 0.6833, s: 0.077, c: '676767', a: 1.0 },
				{ x: 0.5101, y: 0.6612, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.5054, y: 0.5342, s: 0.032, c: '363636', a: 1.0 },
				{ x: 0.5012, y: 0.5403, s: 0.039, c: '373737', a: 1.0 },
				{ x: 0.5098, y: 0.5203, s: 0.043, c: '393939', a: 1.0 },
				{ x: 0.5023, y: 0.522, s: 0.036, c: '383838', a: 1.0 },
				{ x: 0.5109, y: 0.5051, s: 0.034, c: '373737', a: 1.0 },
				{ x: 0.5067, y: 0.4903, s: 0.021, c: '393939', a: 1.0 },
				{ x: 0.512, y: 0.4913, s: 0.05, c: '404040', a: 1.0 },
				{ x: 0.5075, y: 0.4754, s: 0.048, c: '474747', a: 1.0 },
				{ x: 0.5032, y: 0.4786, s: 0.052, c: '4F4F4F', a: 1.0 },
				{ x: 0.5086, y: 0.4557, s: 0.036, c: '525252', a: 1.0 },
				{ x: 0.5043, y: 0.4632, s: 0.069, c: '565656', a: 1.0 },
				{ x: 0.513, y: 0.4433, s: 0.056, c: '585858', a: 1.0 },
				{ x: 0.5054, y: 0.4436, s: 0.035, c: '4F4F4F', a: 1.0 },
				{ x: 0.5007, y: 0.4475, s: 0.035, c: '4F4F4F', a: 1.0 },
				{ x: 0.5097, y: 0.4313, s: 0.048, c: '4A4A4A', a: 1.0 },
				{ x: 0.5017, y: 0.4323, s: 0.04, c: '444444', a: 1.0 },
				{ x: 0.5141, y: 0.9431, s: 0.072, c: '636363', a: 1.0 },
				{ x: 0.5098, y: 0.9441, s: 0.068, c: '636363', a: 1.0 },
				{ x: 0.5151, y: 0.9115, s: 0.027, c: '383838', a: 1.0 },
				{ x: 0.5108, y: 0.9184, s: 0.074, c: '656565', a: 1.0 },
				{ x: 0.5061, y: 0.8964, s: 0.042, c: '666666', a: 1.0 },
				{ x: 0.5118, y: 0.8943, s: 0.031, c: '4C4C4C', a: 1.0 },
				{ x: 0.5071, y: 0.8707, s: 0.026, c: '2C2C2C', a: 1.0 },
				{ x: 0.5161, y: 0.8746, s: 0.058, c: '646464', a: 1.0 },
				{ x: 0.5115, y: 0.8762, s: 0.056, c: '8D8D8D', a: 1.0 },
				{ x: 0.5039, y: 0.8593, s: 0.08, c: '8D8D8D', a: 1.0 },
				{ x: 0.5129, y: 0.8628, s: 0.042, c: '454545', a: 1.0 },
				{ x: 0.5082, y: 0.8166, s: 0.053, c: '626262', a: 1.0 },
				{ x: 0.514, y: 0.8231, s: 0.116, c: '919191', a: 1.0 },
				{ x: 0.5095, y: 0.8272, s: 0.081, c: '9C9C9C', a: 1.0 },
				{ x: 0.5046, y: 0.8039, s: 0.042, c: '474747', a: 1.0 },
				{ x: 0.5102, y: 0.7993, s: 0.045, c: '656565', a: 1.0 },
				{ x: 0.5061, y: 0.7791, s: 0.107, c: '858585', a: 1.0 },
				{ x: 0.515, y: 0.7803, s: 0.087, c: '7E7E7E', a: 1.0 },
				{ x: 0.5067, y: 0.7637, s: 0.057, c: '696969', a: 1.0 },
				{ x: 0.5161, y: 0.7673, s: 0.039, c: '626262', a: 1.0 },
				{ x: 0.5034, y: 0.7482, s: 0.057, c: '6C6C6C', a: 1.0 },
				{ x: 0.5122, y: 0.7555, s: 0.06, c: '707070', a: 1.0 },
				{ x: 0.5082, y: 0.7322, s: 0.087, c: '707070', a: 1.0 },
				{ x: 0.5137, y: 0.7365, s: 0.038, c: '6A6A6A', a: 1.0 },
				{ x: 0.5088, y: 0.7431, s: 0.058, c: '676767', a: 1.0 },
				{ x: 0.5044, y: 0.7206, s: 0.086, c: '6A6A6A', a: 1.0 },
				{ x: 0.5103, y: 0.7245, s: 0.042, c: '6C6C6C', a: 1.0 },
				{ x: 0.5055, y: 0.7073, s: 0.07, c: '6A6A6A', a: 1.0 },
				{ x: 0.5144, y: 0.7085, s: 0.066, c: '737373', a: 1.0 },
				{ x: 0.5158, y: 0.6956, s: 0.052, c: '676767', a: 1.0 },
				{ x: 0.5109, y: 0.6992, s: 0.076, c: '616161', a: 1.0 },
				{ x: 0.5064, y: 0.6767, s: 0.03, c: '545454', a: 1.0 },
				{ x: 0.5123, y: 0.6832, s: 0.077, c: '626262', a: 1.0 },
				{ x: 0.5078, y: 0.5267, s: 0.04, c: '353535', a: 1.0 },
				{ x: 0.5163, y: 0.5278, s: 0.035, c: '373737', a: 1.0 },
				{ x: 0.5085, y: 0.5343, s: 0.035, c: '383838', a: 1.0 },
				{ x: 0.5045, y: 0.5148, s: 0.023, c: '393939', a: 1.0 },
				{ x: 0.5052, y: 0.4868, s: 0.031, c: '353535', a: 1.0 },
				{ x: 0.5145, y: 0.4905, s: 0.045, c: '383838', a: 1.0 },
				{ x: 0.515, y: 0.4716, s: 0.047, c: '434343', a: 1.0 },
				{ x: 0.5105, y: 0.4785, s: 0.044, c: '4D4D4D', a: 1.0 },
				{ x: 0.5066, y: 0.4556, s: 0.035, c: '515151', a: 1.0 },
				{ x: 0.5119, y: 0.4598, s: 0.065, c: '515151', a: 1.0 },
				{ x: 0.5071, y: 0.4428, s: 0.049, c: '4C4C4C', a: 1.0 },
				{ x: 0.5166, y: 0.4438, s: 0.034, c: '434343', a: 1.0 },
				{ x: 0.5086, y: 0.2215, s: 0.047, c: '606060', a: 1.0 },
				{ x: 0.5072, y: 0.9554, s: 0.051, c: '6C6C6C', a: 1.0 },
				{ x: 0.5159, y: 0.9058, s: 0.028, c: '303030', a: 1.0 },
				{ x: 0.5087, y: 0.9126, s: 0.04, c: '525252', a: 1.0 },
				{ x: 0.5173, y: 0.9165, s: 0.039, c: '4C4C4C', a: 1.0 },
				{ x: 0.5127, y: 0.8761, s: 0.035, c: '343434', a: 1.0 },
				{ x: 0.508, y: 0.883, s: 0.043, c: '626262', a: 1.0 },
				{ x: 0.514, y: 0.863, s: 0.112, c: '8B8B8B', a: 1.0 },
				{ x: 0.5093, y: 0.8639, s: 0.048, c: '7C7C7C', a: 1.0 },
				{ x: 0.5179, y: 0.8172, s: 0.075, c: '6C6C6C', a: 1.0 },
				{ x: 0.5108, y: 0.8212, s: 0.084, c: '939393', a: 1.0 },
				{ x: 0.5147, y: 0.7933, s: 0.061, c: '4B4B4B', a: 1.0 },
				{ x: 0.5067, y: 0.7972, s: 0.049, c: '7C7C7C', a: 1.0 },
				{ x: 0.5162, y: 0.7744, s: 0.104, c: '898989', a: 1.0 },
				{ x: 0.5115, y: 0.7813, s: 0.049, c: '6F6F6F', a: 1.0 },
				{ x: 0.5082, y: 0.7662, s: 0.065, c: '6C6C6C', a: 1.0 },
				{ x: 0.5135, y: 0.7494, s: 0.092, c: '747474', a: 1.0 },
				{ x: 0.5088, y: 0.7503, s: 0.084, c: '717171', a: 1.0 },
				{ x: 0.5182, y: 0.7542, s: 0.053, c: '6A6A6A', a: 1.0 },
				{ x: 0.5102, y: 0.7373, s: 0.053, c: '6A6A6A', a: 1.0 },
				{ x: 0.5189, y: 0.741, s: 0.084, c: '6B6B6B', a: 1.0 },
				{ x: 0.5142, y: 0.719, s: 0.053, c: '6A6A6A', a: 1.0 },
				{ x: 0.507, y: 0.7241, s: 0.06, c: '696969', a: 1.0 },
				{ x: 0.5156, y: 0.7053, s: 0.059, c: '606060', a: 1.0 },
				{ x: 0.5116, y: 0.7074, s: 0.037, c: '5E5E5E', a: 1.0 },
				{ x: 0.5171, y: 0.7123, s: 0.069, c: '686868', a: 1.0 },
				{ x: 0.5118, y: 0.6905, s: 0.063, c: '616161', a: 1.0 },
				{ x: 0.5162, y: 0.6767, s: 0.051, c: '565656', a: 1.0 },
				{ x: 0.5084, y: 0.6788, s: 0.038, c: '3F3F3F', a: 1.0 },
				{ x: 0.5181, y: 0.529, s: 0.038, c: '363636', a: 1.0 },
				{ x: 0.5128, y: 0.5043, s: 0.034, c: '383838', a: 1.0 },
				{ x: 0.5184, y: 0.5063, s: 0.031, c: '3B3B3B', a: 1.0 },
				{ x: 0.5147, y: 0.4875, s: 0.035, c: '3A3A3A', a: 1.0 },
				{ x: 0.5094, y: 0.4924, s: 0.038, c: '3A3A3A', a: 1.0 },
				{ x: 0.5113, y: 0.4758, s: 0.044, c: '414141', a: 1.0 },
				{ x: 0.5193, y: 0.4778, s: 0.037, c: '464646', a: 1.0 },
				{ x: 0.5124, y: 0.4591, s: 0.052, c: '444444', a: 1.0 },
				{ x: 0.5071, y: 0.4637, s: 0.037, c: '414141', a: 1.0 },
				{ x: 0.5192, y: 0.953, s: 0.083, c: '838383', a: 1.0 },
				{ x: 0.5124, y: 0.958, s: 0.063, c: '6C6C6C', a: 1.0 },
				{ x: 0.5204, y: 0.9125, s: 0.022, c: '3A3A3A', a: 1.0 },
				{ x: 0.5159, y: 0.9176, s: 0.059, c: '5A5A5A', a: 1.0 },
				{ x: 0.5222, y: 0.8988, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.5169, y: 0.8829, s: 0.026, c: '343434', a: 1.0 },
				{ x: 0.5133, y: 0.8642, s: 0.07, c: '6B6B6B', a: 1.0 },
				{ x: 0.5188, y: 0.869, s: 0.073, c: '8B8B8B', a: 1.0 },
				{ x: 0.5135, y: 0.871, s: 0.051, c: '5F5F5F', a: 1.0 },
				{ x: 0.5232, y: 0.8224, s: 0.085, c: '6C6C6C', a: 1.0 },
				{ x: 0.5178, y: 0.8244, s: 0.078, c: '939393', a: 1.0 },
				{ x: 0.5102, y: 0.8056, s: 0.065, c: '808080', a: 1.0 },
				{ x: 0.5199, y: 0.7989, s: 0.071, c: '6C6C6C', a: 1.0 },
				{ x: 0.5201, y: 0.7822, s: 0.13, c: 'A3A3A3', a: 1.0 },
				{ x: 0.5112, y: 0.7655, s: 0.069, c: '626262', a: 1.0 },
				{ x: 0.5174, y: 0.7704, s: 0.087, c: '6F6F6F', a: 1.0 },
				{ x: 0.5131, y: 0.7512, s: 0.083, c: '747474', a: 1.0 },
				{ x: 0.5209, y: 0.7536, s: 0.067, c: '727272', a: 1.0 },
				{ x: 0.514, y: 0.7583, s: 0.08, c: '6D6D6D', a: 1.0 },
				{ x: 0.5175, y: 0.7415, s: 0.075, c: '6B6B6B', a: 1.0 },
				{ x: 0.5108, y: 0.7231, s: 0.045, c: '696969', a: 1.0 },
				{ x: 0.5186, y: 0.7247, s: 0.067, c: '686868', a: 1.0 },
				{ x: 0.5143, y: 0.7301, s: 0.044, c: '606060', a: 1.0 },
				{ x: 0.5205, y: 0.7113, s: 0.046, c: '595959', a: 1.0 },
				{ x: 0.5154, y: 0.7128, s: 0.067, c: '646464', a: 1.0 },
				{ x: 0.5116, y: 0.6944, s: 0.063, c: '656565', a: 1.0 },
				{ x: 0.5171, y: 0.6991, s: 0.085, c: '6C6C6C', a: 1.0 },
				{ x: 0.512, y: 0.7015, s: 0.043, c: '767676', a: 1.0 },
				{ x: 0.5215, y: 0.6824, s: 0.06, c: '4A4A4A', a: 1.0 },
				{ x: 0.5139, y: 0.5122, s: 0.022, c: '373737', a: 1.0 },
				{ x: 0.5183, y: 0.4985, s: 0.034, c: '3B3B3B', a: 1.0 },
				{ x: 0.5127, y: 0.4764, s: 0.039, c: '3C3C3C', a: 1.0 },
				{ x: 0.5184, y: 0.4811, s: 0.038, c: '3D3D3D', a: 1.0 },
				{ x: 0.5146, y: 0.4865, s: 0.026, c: '3F3F3F', a: 1.0 },
				{ x: 0.5228, y: 0.4643, s: 0.05, c: '3F3F3F', a: 1.0 },
				{ x: 0.5185, y: 0.909, s: 0.039, c: '5A5A5A', a: 1.0 },
				{ x: 0.5146, y: 0.9114, s: 0.087, c: '727272', a: 1.0 },
				{ x: 0.5229, y: 0.8922, s: 0.045, c: '464646', a: 1.0 },
				{ x: 0.5157, y: 0.871, s: 0.079, c: '747474', a: 1.0 },
				{ x: 0.5247, y: 0.8751, s: 0.06, c: '8B8B8B', a: 1.0 },
				{ x: 0.5192, y: 0.8571, s: 0.052, c: '404040', a: 1.0 },
				{ x: 0.5258, y: 0.8294, s: 0.039, c: '6C6C6C', a: 1.0 },
				{ x: 0.5202, y: 0.8099, s: 0.112, c: '8A8A8A', a: 1.0 },
				{ x: 0.516, y: 0.8149, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.5221, y: 0.8057, s: 0.08, c: '7C7C7C', a: 1.0 },
				{ x: 0.5168, y: 0.7868, s: 0.078, c: '8B8B8B', a: 1.0 },
				{ x: 0.5191, y: 0.7694, s: 0.041, c: '696969', a: 1.0 },
				{ x: 0.5134, y: 0.7752, s: 0.091, c: '6F6F6F', a: 1.0 },
				{ x: 0.5231, y: 0.7794, s: 0.048, c: '767676', a: 1.0 },
				{ x: 0.5157, y: 0.7576, s: 0.073, c: '6D6D6D', a: 1.0 },
				{ x: 0.5237, y: 0.7633, s: 0.068, c: '6B6B6B', a: 1.0 },
				{ x: 0.5197, y: 0.7415, s: 0.062, c: '696969', a: 1.0 },
				{ x: 0.5203, y: 0.727, s: 0.082, c: '696969', a: 1.0 },
				{ x: 0.5163, y: 0.7298, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.5243, y: 0.7349, s: 0.061, c: '656565', a: 1.0 },
				{ x: 0.5169, y: 0.7154, s: 0.069, c: '636363', a: 1.0 },
				{ x: 0.5266, y: 0.7178, s: 0.082, c: '676767', a: 1.0 },
				{ x: 0.5209, y: 0.699, s: 0.053, c: '6B6B6B', a: 1.0 },
				{ x: 0.5139, y: 0.7034, s: 0.059, c: '6B6B6B', a: 1.0 },
				{ x: 0.5231, y: 0.7054, s: 0.051, c: '767676', a: 1.0 },
				{ x: 0.5176, y: 0.6873, s: 0.042, c: '6B6B6B', a: 1.0 },
				{ x: 0.5239, y: 0.5169, s: 0.045, c: '383838', a: 1.0 },
				{ x: 0.5199, y: 0.4974, s: 0.021, c: '363636', a: 1.0 },
				{ x: 0.5145, y: 0.5023, s: 0.044, c: '373737', a: 1.0 },
				{ x: 0.5205, y: 0.5051, s: 0.036, c: '3D3D3D', a: 1.0 },
				{ x: 0.5151, y: 0.4854, s: 0.038, c: '3F3F3F', a: 1.0 },
				{ x: 0.5244, y: 0.4904, s: 0.031, c: '414141', a: 1.0 },
				{ x: 0.5174, y: 0.4694, s: 0.05, c: '414141', a: 1.0 },
				{ x: 0.525, y: 0.2247, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.5211, y: 0.2048, s: 0.059, c: '656565', a: 1.0 },
				{ x: 0.5175, y: 0.9327, s: 0.025, c: '424242', a: 1.0 },
				{ x: 0.5251, y: 0.9114, s: 0.077, c: '727272', a: 1.0 },
				{ x: 0.5214, y: 0.9152, s: 0.073, c: '6A6A6A', a: 1.0 },
				{ x: 0.5274, y: 0.873, s: 0.042, c: '464646', a: 1.0 },
				{ x: 0.522, y: 0.8757, s: 0.079, c: '747474', a: 1.0 },
				{ x: 0.5181, y: 0.8796, s: 0.05, c: '6D6D6D', a: 1.0 },
				{ x: 0.5187, y: 0.8279, s: 0.044, c: '757575', a: 1.0 },
				{ x: 0.5282, y: 0.8094, s: 0.066, c: '585858', a: 1.0 },
				{ x: 0.5225, y: 0.8133, s: 0.032, c: '393939', a: 1.0 },
				{ x: 0.5287, y: 0.7919, s: 0.046, c: '4B4B4B', a: 1.0 },
				{ x: 0.5193, y: 0.7878, s: 0.047, c: '575757', a: 1.0 },
				{ x: 0.5255, y: 0.7681, s: 0.053, c: '6F6F6F', a: 1.0 },
				{ x: 0.5216, y: 0.7735, s: 0.08, c: '696969', a: 1.0 },
				{ x: 0.5294, y: 0.7521, s: 0.039, c: '666666', a: 1.0 },
				{ x: 0.5223, y: 0.756, s: 0.079, c: '666666', a: 1.0 },
				{ x: 0.5168, y: 0.7615, s: 0.053, c: '666666', a: 1.0 },
				{ x: 0.5261, y: 0.7401, s: 0.068, c: '696969', a: 1.0 },
				{ x: 0.5229, y: 0.728, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.529, y: 0.7097, s: 0.074, c: '6A6A6A', a: 1.0 },
				{ x: 0.5235, y: 0.7136, s: 0.07, c: '676767', a: 1.0 },
				{ x: 0.5196, y: 0.716, s: 0.06, c: '646464', a: 1.0 },
				{ x: 0.5257, y: 0.6976, s: 0.06, c: '676767', a: 1.0 },
				{ x: 0.5202, y: 0.7, s: 0.047, c: '676767', a: 1.0 },
				{ x: 0.5297, y: 0.6802, s: 0.044, c: '3F3F3F', a: 1.0 },
				{ x: 0.5225, y: 0.513, s: 0.026, c: '363636', a: 1.0 },
				{ x: 0.5169, y: 0.5099, s: 0.039, c: '383838', a: 1.0 },
				{ x: 0.5264, y: 0.4897, s: 0.029, c: '414141', a: 1.0 },
				{ x: 0.5209, y: 0.4945, s: 0.052, c: '434343', a: 1.0 },
				{ x: 0.527, y: 0.4743, s: 0.045, c: '454545', a: 1.0 },
				{ x: 0.5231, y: 0.4778, s: 0.043, c: '444444', a: 1.0 },
				{ x: 0.5176, y: 0.2091, s: 0.067, c: '686868', a: 1.0 },
				{ x: 0.5238, y: 0.2126, s: 0.061, c: '6A6A6A', a: 1.0 },
				{ x: 0.5217, y: 0.916, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.5307, y: 0.9209, s: 0.045, c: '7E7E7E', a: 1.0 },
				{ x: 0.5245, y: 0.9007, s: 0.077, c: '626262', a: 1.0 },
				{ x: 0.5317, y: 0.8804, s: 0.05, c: '444444', a: 1.0 },
				{ x: 0.5272, y: 0.8854, s: 0.059, c: '646464', a: 1.0 },
				{ x: 0.5211, y: 0.8651, s: 0.055, c: '525252', a: 1.0 },
				{ x: 0.53, y: 0.8389, s: 0.045, c: '3B3B3B', a: 1.0 },
				{ x: 0.5238, y: 0.8186, s: 0.066, c: '5C5C5C', a: 1.0 },
				{ x: 0.531, y: 0.8236, s: 0.052, c: '717171', a: 1.0 },
				{ x: 0.5265, y: 0.8271, s: 0.052, c: '5F5F5F', a: 1.0 },
				{ x: 0.5204, y: 0.8069, s: 0.061, c: '505050', a: 1.0 },
				{ x: 0.5232, y: 0.7916, s: 0.071, c: '6C6C6C', a: 1.0 },
				{ x: 0.5304, y: 0.7949, s: 0.046, c: '505050', a: 1.0 },
				{ x: 0.5331, y: 0.7737, s: 0.073, c: '666666', a: 1.0 },
				{ x: 0.5296, y: 0.7606, s: 0.047, c: '686868', a: 1.0 },
				{ x: 0.5236, y: 0.7418, s: 0.061, c: '686868', a: 1.0 },
				{ x: 0.5325, y: 0.7453, s: 0.049, c: '6E6E6E', a: 1.0 },
				{ x: 0.5263, y: 0.7488, s: 0.046, c: '6A6A6A', a: 1.0 },
				{ x: 0.5202, y: 0.7298, s: 0.056, c: '6A6A6A', a: 1.0 },
				{ x: 0.529, y: 0.7333, s: 0.061, c: '676767', a: 1.0 },
				{ x: 0.5228, y: 0.713, s: 0.082, c: '676767', a: 1.0 },
				{ x: 0.53, y: 0.7169, s: 0.061, c: '666666', a: 1.0 },
				{ x: 0.5256, y: 0.6977, s: 0.051, c: '616161', a: 1.0 },
				{ x: 0.5327, y: 0.7015, s: 0.042, c: '545454', a: 1.0 },
				{ x: 0.5267, y: 0.5082, s: 0.046, c: '3B3B3B', a: 1.0 },
				{ x: 0.5222, y: 0.4884, s: 0.042, c: '424242', a: 1.0 },
				{ x: 0.5294, y: 0.493, s: 0.05, c: '4A4A4A', a: 1.0 },
				{ x: 0.525, y: 0.4726, s: 0.034, c: '4C4C4C', a: 1.0 },
				{ x: 0.5322, y: 0.4765, s: 0.028, c: '494949', a: 1.0 },
				{ x: 0.5259, y: 0.4812, s: 0.029, c: '3F3F3F', a: 1.0 },
				{ x: 0.5216, y: 0.2172, s: 0.062, c: '666666', a: 1.0 },
				{ x: 0.5286, y: 0.2204, s: 0.08, c: '6C6C6C', a: 1.0 },
				{ x: 0.526, y: 0.9253, s: 0.042, c: '707070', a: 1.0 },
				{ x: 0.5347, y: 0.9054, s: 0.042, c: '555555', a: 1.0 },
				{ x: 0.5286, y: 0.8788, s: 0.072, c: '5A5A5A', a: 1.0 },
				{ x: 0.536, y: 0.8828, s: 0.046, c: '7B7B7B', a: 1.0 },
				{ x: 0.5313, y: 0.8637, s: 0.054, c: '484848', a: 1.0 },
				{ x: 0.5253, y: 0.843, s: 0.03, c: '363636', a: 1.0 },
				{ x: 0.5281, y: 0.8278, s: 0.054, c: '858585', a: 1.0 },
				{ x: 0.5308, y: 0.8112, s: 0.034, c: '5F5F5F', a: 1.0 },
				{ x: 0.5245, y: 0.815, s: 0.067, c: '5B5B5B', a: 1.0 },
				{ x: 0.5317, y: 0.7959, s: 0.072, c: '5B5B5B', a: 1.0 },
				{ x: 0.5275, y: 0.7998, s: 0.058, c: '7A7A7A', a: 1.0 },
				{ x: 0.5344, y: 0.8031, s: 0.079, c: '898989', a: 1.0 },
				{ x: 0.5285, y: 0.7839, s: 0.078, c: '696969', a: 1.0 },
				{ x: 0.5238, y: 0.7878, s: 0.037, c: '636363', a: 1.0 },
				{ x: 0.5312, y: 0.7671, s: 0.051, c: '666666', a: 1.0 },
				{ x: 0.5265, y: 0.771, s: 0.074, c: '636363', a: 1.0 },
				{ x: 0.5339, y: 0.752, s: 0.054, c: '636363', a: 1.0 },
				{ x: 0.5275, y: 0.7553, s: 0.079, c: '686868', a: 1.0 },
				{ x: 0.5365, y: 0.7596, s: 0.065, c: '686868', a: 1.0 },
				{ x: 0.5242, y: 0.7434, s: 0.081, c: '676767', a: 1.0 },
				{ x: 0.5333, y: 0.7239, s: 0.058, c: '636363', a: 1.0 },
				{ x: 0.527, y: 0.7274, s: 0.056, c: '5C5C5C', a: 1.0 },
				{ x: 0.5343, y: 0.7318, s: 0.044, c: '525252', a: 1.0 },
				{ x: 0.5296, y: 0.7115, s: 0.037, c: '424242', a: 1.0 },
				{ x: 0.5237, y: 0.5073, s: 0.032, c: '3B3B3B', a: 1.0 },
				{ x: 0.5322, y: 0.4871, s: 0.042, c: '424242', a: 1.0 },
				{ x: 0.5266, y: 0.4913, s: 0.033, c: '4C4C4C', a: 1.0 },
				{ x: 0.5334, y: 0.471, s: 0.046, c: '535353', a: 1.0 },
				{ x: 0.5289, y: 0.4753, s: 0.038, c: '535353', a: 1.0 },
				{ x: 0.5303, y: 0.4592, s: 0.028, c: '494949', a: 1.0 },
				{ x: 0.5255, y: 0.4635, s: 0.047, c: '3F3F3F', a: 1.0 },
				{ x: 0.5327, y: 0.211, s: 0.07, c: '727272', a: 1.0 },
				{ x: 0.5392, y: 0.9196, s: 0.057, c: '484848', a: 1.0 },
				{ x: 0.5326, y: 0.8934, s: 0.029, c: '4D4D4D', a: 1.0 },
				{ x: 0.5269, y: 0.8738, s: 0.102, c: '868686', a: 1.0 },
				{ x: 0.5357, y: 0.8778, s: 0.065, c: '868686', a: 1.0 },
				{ x: 0.5292, y: 0.8278, s: 0.041, c: '4A4A4A', a: 1.0 },
				{ x: 0.5381, y: 0.832, s: 0.077, c: '717171', a: 1.0 },
				{ x: 0.5324, y: 0.8356, s: 0.085, c: '979797', a: 1.0 },
				{ x: 0.5346, y: 0.8197, s: 0.074, c: '5F5F5F', a: 1.0 },
				{ x: 0.5285, y: 0.8002, s: 0.043, c: '5B5B5B', a: 1.0 },
				{ x: 0.536, y: 0.8037, s: 0.052, c: '5B5B5B', a: 1.0 },
				{ x: 0.5313, y: 0.808, s: 0.073, c: '5B5B5B', a: 1.0 },
				{ x: 0.5385, y: 0.7882, s: 0.047, c: '636363', a: 1.0 },
				{ x: 0.5328, y: 0.792, s: 0.06, c: '636363', a: 1.0 },
				{ x: 0.5283, y: 0.7721, s: 0.058, c: '636363', a: 1.0 },
				{ x: 0.5351, y: 0.776, s: 0.078, c: '636363', a: 1.0 },
				{ x: 0.5305, y: 0.7561, s: 0.043, c: '636363', a: 1.0 },
				{ x: 0.5381, y: 0.7599, s: 0.069, c: '636363', a: 1.0 },
				{ x: 0.532, y: 0.7638, s: 0.047, c: '5D5D5D', a: 1.0 },
				{ x: 0.5271, y: 0.7439, s: 0.055, c: '575757', a: 1.0 },
				{ x: 0.5348, y: 0.7478, s: 0.037, c: '494949', a: 1.0 },
				{ x: 0.5287, y: 0.4901, s: 0.035, c: '393939', a: 1.0 },
				{ x: 0.5372, y: 0.494, s: 0.041, c: '474747', a: 1.0 },
				{ x: 0.5309, y: 0.4979, s: 0.038, c: '4C4C4C', a: 1.0 },
				{ x: 0.5277, y: 0.462, s: 0.034, c: '555555', a: 1.0 },
				{ x: 0.5363, y: 0.4658, s: 0.058, c: '505050', a: 1.0 },
				{ x: 0.5308, y: 0.4697, s: 0.043, c: '494949', a: 1.0 },
				{ x: 0.5378, y: 0.4499, s: 0.042, c: '3B3B3B', a: 1.0 },
				{ x: 0.5329, y: 0.2277, s: 0.05, c: '6D6D6D', a: 1.0 },
				{ x: 0.5307, y: 0.8962, s: 0.042, c: '424242', a: 1.0 },
				{ x: 0.5378, y: 0.8764, s: 0.066, c: '6A6A6A', a: 1.0 },
				{ x: 0.5331, y: 0.8803, s: 0.068, c: '919191', a: 1.0 },
				{ x: 0.5401, y: 0.8842, s: 0.056, c: '4F4F4F', a: 1.0 },
				{ x: 0.5346, y: 0.8405, s: 0.049, c: '4A4A4A', a: 1.0 },
				{ x: 0.5432, y: 0.8445, s: 0.061, c: '5F5F5F', a: 1.0 },
				{ x: 0.5369, y: 0.8245, s: 0.087, c: '8E8E8E', a: 1.0 },
				{ x: 0.5322, y: 0.8284, s: 0.056, c: '858585', a: 1.0 },
				{ x: 0.5399, y: 0.8325, s: 0.05, c: '5F5F5F', a: 1.0 },
				{ x: 0.5335, y: 0.8125, s: 0.072, c: '5F5F5F', a: 1.0 },
				{ x: 0.5422, y: 0.8165, s: 0.059, c: '5B5B5B', a: 1.0 },
				{ x: 0.5366, y: 0.7965, s: 0.041, c: '5B5B5B', a: 1.0 },
				{ x: 0.5302, y: 0.8004, s: 0.054, c: '5B5B5B', a: 1.0 },
				{ x: 0.5389, y: 0.8028, s: 0.061, c: '5B5B5B', a: 1.0 },
				{ x: 0.5326, y: 0.787, s: 0.074, c: '5D5D5D', a: 1.0 },
				{ x: 0.5403, y: 0.7712, s: 0.032, c: '5A5A5A', a: 1.0 },
				{ x: 0.5357, y: 0.7791, s: 0.052, c: '515151', a: 1.0 },
				{ x: 0.5426, y: 0.7512, s: 0.07, c: '575757', a: 1.0 },
				{ x: 0.537, y: 0.5092, s: 0.026, c: '3E3E3E', a: 1.0 },
				{ x: 0.5324, y: 0.4933, s: 0.052, c: '515151', a: 1.0 },
				{ x: 0.5394, y: 0.4775, s: 0.056, c: '535353', a: 1.0 },
				{ x: 0.5347, y: 0.4856, s: 0.063, c: '515151', a: 1.0 },
				{ x: 0.5424, y: 0.4698, s: 0.062, c: '595959', a: 1.0 },
				{ x: 0.5361, y: 0.4778, s: 0.043, c: '5C5C5C', a: 1.0 },
				{ x: 0.5311, y: 0.462, s: 0.058, c: '555555', a: 1.0 },
				{ x: 0.5391, y: 0.47, s: 0.041, c: '555555', a: 1.0 },
				{ x: 0.5331, y: 0.4539, s: 0.036, c: '4E4E4E', a: 1.0 },
				{ x: 0.5411, y: 0.4381, s: 0.035, c: '3B3B3B', a: 1.0 },
				{ x: 0.5358, y: 0.2259, s: 0.06, c: '727272', a: 1.0 },
				{ x: 0.5429, y: 0.2101, s: 0.077, c: '616161', a: 1.0 },
				{ x: 0.5376, y: 0.2181, s: 0.068, c: '616161', a: 1.0 },
				{ x: 0.5357, y: 0.8829, s: 0.057, c: '6C6C6C', a: 1.0 },
				{ x: 0.5437, y: 0.8908, s: 0.05, c: '838383', a: 1.0 },
				{ x: 0.5376, y: 0.875, s: 0.079, c: '838383', a: 1.0 },
				{ x: 0.5456, y: 0.8533, s: 0.071, c: '6E6E6E', a: 1.0 },
				{ x: 0.5403, y: 0.8374, s: 0.073, c: '818181', a: 1.0 },
				{ x: 0.5422, y: 0.8296, s: 0.04, c: '666666', a: 1.0 },
				{ x: 0.5369, y: 0.8138, s: 0.069, c: '5B5B5B', a: 1.0 },
				{ x: 0.5449, y: 0.8217, s: 0.048, c: '5B5B5B', a: 1.0 },
				{ x: 0.5388, y: 0.8058, s: 0.035, c: '5A5A5A', a: 1.0 },
				{ x: 0.5335, y: 0.8138, s: 0.06, c: '555555', a: 1.0 },
				{ x: 0.5415, y: 0.798, s: 0.049, c: '505050', a: 1.0 },
				{ x: 0.5362, y: 0.7823, s: 0.055, c: '4B4B4B', a: 1.0 },
				{ x: 0.5434, y: 0.7899, s: 0.054, c: '444444', a: 1.0 },
				{ x: 0.5382, y: 0.7744, s: 0.041, c: '3C3C3C', a: 1.0 },
				{ x: 0.5462, y: 0.7642, s: 0.054, c: '696969', a: 1.0 },
				{ x: 0.5401, y: 0.4987, s: 0.027, c: '484848', a: 1.0 },
				{ x: 0.5348, y: 0.4825, s: 0.064, c: '5B5B5B', a: 1.0 },
				{ x: 0.5428, y: 0.491, s: 0.044, c: '515151', a: 1.0 },
				{ x: 0.5374, y: 0.4749, s: 0.035, c: '484848', a: 1.0 },
				{ x: 0.5446, y: 0.4832, s: 0.033, c: '545454', a: 1.0 },
				{ x: 0.5393, y: 0.467, s: 0.073, c: '5A5A5A', a: 1.0 },
				{ x: 0.534, y: 0.4747, s: 0.034, c: '545454', a: 1.0 },
				{ x: 0.5413, y: 0.4593, s: 0.052, c: '4D4D4D', a: 1.0 },
				{ x: 0.536, y: 0.4431, s: 0.055, c: '494949', a: 1.0 },
				{ x: 0.5441, y: 0.4515, s: 0.043, c: '414141', a: 1.0 },
				{ x: 0.5493, y: 0.8978, s: 0.07, c: '5D5D5D', a: 1.0 },
				{ x: 0.5438, y: 0.8823, s: 0.034, c: '5D5D5D', a: 1.0 },
				{ x: 0.5387, y: 0.8542, s: 0.034, c: '424242', a: 1.0 },
				{ x: 0.5465, y: 0.8209, s: 0.057, c: '555555', a: 1.0 },
				{ x: 0.5406, y: 0.8289, s: 0.073, c: '5B5B5B', a: 1.0 },
				{ x: 0.5487, y: 0.8127, s: 0.042, c: '4F4F4F', a: 1.0 },
				{ x: 0.5431, y: 0.821, s: 0.047, c: '4B4B4B', a: 1.0 },
				{ x: 0.5372, y: 0.8048, s: 0.03, c: '404040', a: 1.0 },
				{ x: 0.545, y: 0.7893, s: 0.025, c: '404040', a: 1.0 },
				{ x: 0.5399, y: 0.7969, s: 0.048, c: '3F3F3F', a: 1.0 },
				{ x: 0.5478, y: 0.7815, s: 0.024, c: '3C3C3C', a: 1.0 },
				{ x: 0.5418, y: 0.7653, s: 0.103, c: '868686', a: 1.0 },
				{ x: 0.5497, y: 0.7499, s: 0.074, c: '696969', a: 1.0 },
				{ x: 0.5446, y: 0.5672, s: 0.05, c: '494949', a: 1.0 },
				{ x: 0.539, y: 0.5154, s: 0.06, c: '5E5E5E', a: 1.0 },
				{ x: 0.5463, y: 0.5, s: 0.061, c: '555555', a: 1.0 },
				{ x: 0.5412, y: 0.5017, s: 0.043, c: '3F3F3F', a: 1.0 },
				{ x: 0.549, y: 0.4864, s: 0.05, c: '4D4D4D', a: 1.0 },
				{ x: 0.5431, y: 0.4937, s: 0.043, c: '515151', a: 1.0 },
				{ x: 0.5375, y: 0.4778, s: 0.038, c: '606060', a: 1.0 },
				{ x: 0.5458, y: 0.4627, s: 0.057, c: '4D4D4D', a: 1.0 },
				{ x: 0.5477, y: 0.4539, s: 0.037, c: '3A3A3A', a: 1.0 },
				{ x: 0.5421, y: 0.4567, s: 0.027, c: '454545', a: 1.0 },
				{ x: 0.537, y: 0.4409, s: 0.056, c: '454545', a: 1.0 },
				{ x: 0.5443, y: 0.2101, s: 0.043, c: '787878', a: 1.0 },
				{ x: 0.5388, y: 0.2121, s: 0.083, c: '6C6C6C', a: 1.0 },
				{ x: 0.5449, y: 0.8493, s: 0.045, c: '424242', a: 1.0 },
				{ x: 0.5471, y: 0.8359, s: 0.042, c: '5E5E5E', a: 1.0 },
				{ x: 0.5413, y: 0.8194, s: 0.064, c: '555555', a: 1.0 },
				{ x: 0.5493, y: 0.8275, s: 0.042, c: '494949', a: 1.0 },
				{ x: 0.5437, y: 0.8065, s: 0.028, c: '3B3B3B', a: 1.0 },
				{ x: 0.546, y: 0.7979, s: 0.041, c: '484848', a: 1.0 },
				{ x: 0.5402, y: 0.7821, s: 0.04, c: '464646', a: 1.0 },
				{ x: 0.5483, y: 0.7907, s: 0.049, c: '444444', a: 1.0 },
				{ x: 0.5426, y: 0.775, s: 0.042, c: '404040', a: 1.0 },
				{ x: 0.5506, y: 0.7644, s: 0.053, c: '868686', a: 1.0 },
				{ x: 0.5449, y: 0.7492, s: 0.138, c: 'ACACAC', a: 1.0 },
				{ x: 0.5529, y: 0.7334, s: 0.038, c: '606060', a: 1.0 },
				{ x: 0.5472, y: 0.6097, s: 0.056, c: '575757', a: 1.0 },
				{ x: 0.5415, y: 0.5939, s: 0.068, c: '777777', a: 1.0 },
				{ x: 0.5495, y: 0.6025, s: 0.067, c: '808080', a: 1.0 },
				{ x: 0.5438, y: 0.5867, s: 0.075, c: '808080', a: 1.0 },
				{ x: 0.5518, y: 0.594, s: 0.099, c: '808080', a: 1.0 },
				{ x: 0.5461, y: 0.5782, s: 0.061, c: '797979', a: 1.0 },
				{ x: 0.5408, y: 0.563, s: 0.06, c: '6E6E6E', a: 1.0 },
				{ x: 0.5484, y: 0.57, s: 0.076, c: '5F5F5F', a: 1.0 },
				{ x: 0.543, y: 0.5545, s: 0.044, c: '5F5F5F', a: 1.0 },
				{ x: 0.5506, y: 0.5629, s: 0.056, c: '5F5F5F', a: 1.0 },
				{ x: 0.5451, y: 0.5475, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.5531, y: 0.5307, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.5474, y: 0.539, s: 0.076, c: '626262', a: 1.0 },
				{ x: 0.5421, y: 0.5117, s: 0.031, c: '555555', a: 1.0 },
				{ x: 0.5496, y: 0.5201, s: 0.08, c: '686868', a: 1.0 },
				{ x: 0.5443, y: 0.5031, s: 0.072, c: '5E5E5E', a: 1.0 },
				{ x: 0.5519, y: 0.4937, s: 0.04, c: '4D4D4D', a: 1.0 },
				{ x: 0.5466, y: 0.4783, s: 0.034, c: '3A3A3A', a: 1.0 },
				{ x: 0.5409, y: 0.4376, s: 0.042, c: '414141', a: 1.0 },
				{ x: 0.5486, y: 0.4459, s: 0.063, c: '525252', a: 1.0 },
				{ x: 0.5432, y: 0.2162, s: 0.048, c: '6F6F6F', a: 1.0 },
				{ x: 0.5543, y: 0.8922, s: 0.049, c: '4E4E4E', a: 1.0 },
				{ x: 0.5488, y: 0.8767, s: 0.077, c: '616161', a: 1.0 },
				{ x: 0.5566, y: 0.8553, s: 0.061, c: '5B5B5B', a: 1.0 },
				{ x: 0.5511, y: 0.8387, s: 0.069, c: '747474', a: 1.0 },
				{ x: 0.5456, y: 0.8471, s: 0.064, c: '747474', a: 1.0 },
				{ x: 0.5534, y: 0.8316, s: 0.03, c: '4E4E4E', a: 1.0 },
				{ x: 0.5479, y: 0.7983, s: 0.044, c: '3F3F3F', a: 1.0 },
				{ x: 0.5555, y: 0.8052, s: 0.042, c: '434343', a: 1.0 },
				{ x: 0.5445, y: 0.798, s: 0.03, c: '484848', a: 1.0 },
				{ x: 0.5523, y: 0.7826, s: 0.046, c: '484848', a: 1.0 },
				{ x: 0.5468, y: 0.7895, s: 0.046, c: '444444', a: 1.0 },
				{ x: 0.5546, y: 0.7503, s: 0.051, c: '7D7D7D', a: 1.0 },
				{ x: 0.5491, y: 0.735, s: 0.037, c: '575757', a: 1.0 },
				{ x: 0.5436, y: 0.6169, s: 0.077, c: '878787', a: 1.0 },
				{ x: 0.5514, y: 0.6015, s: 0.088, c: '777777', a: 1.0 },
				{ x: 0.5458, y: 0.5255, s: 0.068, c: '5E5E5E', a: 1.0 },
				{ x: 0.5536, y: 0.5113, s: 0.044, c: '5E5E5E', a: 1.0 },
				{ x: 0.5481, y: 0.4955, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.5559, y: 0.502, s: 0.043, c: '3A3A3A', a: 1.0 },
				{ x: 0.5504, y: 0.4817, s: 0.036, c: '444444', a: 1.0 },
				{ x: 0.5448, y: 0.4466, s: 0.049, c: '454545', a: 1.0 },
				{ x: 0.5526, y: 0.2162, s: 0.068, c: '787878', a: 1.0 },
				{ x: 0.5471, y: 0.2257, s: 0.045, c: '737373', a: 1.0 },
				{ x: 0.5583, y: 0.9426, s: 0.025, c: '3C3C3C', a: 1.0 },
				{ x: 0.5527, y: 0.9521, s: 0.034, c: '3A3A3A', a: 1.0 },
				{ x: 0.5472, y: 0.9348, s: 0.04, c: '3A3A3A', a: 1.0 },
				{ x: 0.555, y: 0.9443, s: 0.023, c: '3A3A3A', a: 1.0 },
				{ x: 0.5495, y: 0.9285, s: 0.048, c: '3B3B3B', a: 1.0 },
				{ x: 0.5573, y: 0.9113, s: 0.033, c: '3D3D3D', a: 1.0 },
				{ x: 0.5518, y: 0.9204, s: 0.028, c: '3D3D3D', a: 1.0 },
				{ x: 0.5471, y: 0.9047, s: 0.047, c: '3B3B3B', a: 1.0 },
				{ x: 0.5526, y: 0.9112, s: 0.032, c: '3A3A3A', a: 1.0 },
				{ x: 0.556, y: 0.8875, s: 0.054, c: '494949', a: 1.0 },
				{ x: 0.5482, y: 0.8732, s: 0.025, c: '414141', a: 1.0 },
				{ x: 0.5537, y: 0.8559, s: 0.068, c: '666666', a: 1.0 },
				{ x: 0.5593, y: 0.8415, s: 0.083, c: '666666', a: 1.0 },
				{ x: 0.5514, y: 0.8495, s: 0.039, c: '5C5C5C', a: 1.0 },
				{ x: 0.5569, y: 0.8143, s: 0.04, c: '404040', a: 1.0 },
				{ x: 0.5491, y: 0.8, s: 0.05, c: '474747', a: 1.0 },
				{ x: 0.5546, y: 0.808, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.5468, y: 0.7907, s: 0.055, c: '444444', a: 1.0 },
				{ x: 0.5525, y: 0.8, s: 0.031, c: '4A4A4A', a: 1.0 },
				{ x: 0.558, y: 0.7828, s: 0.046, c: '484848', a: 1.0 },
				{ x: 0.5502, y: 0.7908, s: 0.053, c: '454545', a: 1.0 },
				{ x: 0.5479, y: 0.7352, s: 0.05, c: '5C5C5C', a: 1.0 },
				{ x: 0.5534, y: 0.743, s: 0.062, c: '525252', a: 1.0 },
				{ x: 0.5589, y: 0.61, s: 0.046, c: '5E5E5E', a: 1.0 },
				{ x: 0.5511, y: 0.5327, s: 0.036, c: '3F3F3F', a: 1.0 },
				{ x: 0.5567, y: 0.5188, s: 0.086, c: '898989', a: 1.0 },
				{ x: 0.5488, y: 0.5027, s: 0.053, c: '585858', a: 1.0 },
				{ x: 0.5544, y: 0.5096, s: 0.046, c: '4A4A4A', a: 1.0 },
				{ x: 0.5599, y: 0.4949, s: 0.043, c: '4C4C4C', a: 1.0 },
				{ x: 0.5521, y: 0.5018, s: 0.029, c: '3E3E3E', a: 1.0 },
				{ x: 0.5499, y: 0.2091, s: 0.05, c: '747474', a: 1.0 },
				{ x: 0.5554, y: 0.216, s: 0.085, c: '6A6A6A', a: 1.0 },
				{ x: 0.5509, y: 0.9597, s: 0.026, c: '444444', a: 1.0 },
				{ x: 0.5564, y: 0.9421, s: 0.055, c: '464646', a: 1.0 },
				{ x: 0.5619, y: 0.9519, s: 0.048, c: '464646', a: 1.0 },
				{ x: 0.5543, y: 0.9357, s: 0.037, c: '464646', a: 1.0 },
				{ x: 0.5596, y: 0.9187, s: 0.053, c: '484848', a: 1.0 },
				{ x: 0.5521, y: 0.9278, s: 0.027, c: '4A4A4A', a: 1.0 },
				{ x: 0.5574, y: 0.912, s: 0.049, c: '4A4A4A', a: 1.0 },
				{ x: 0.5631, y: 0.9189, s: 0.044, c: '4D4D4D', a: 1.0 },
				{ x: 0.555, y: 0.9042, s: 0.053, c: '4F4F4F', a: 1.0 },
				{ x: 0.5607, y: 0.8872, s: 0.058, c: '4F4F4F', a: 1.0 },
				{ x: 0.5528, y: 0.8949, s: 0.042, c: '494949', a: 1.0 },
				{ x: 0.5585, y: 0.8808, s: 0.05, c: '464646', a: 1.0 },
				{ x: 0.5508, y: 0.8869, s: 0.055, c: '464646', a: 1.0 },
				{ x: 0.5561, y: 0.873, s: 0.03, c: '414141', a: 1.0 },
				{ x: 0.5619, y: 0.8628, s: 0.045, c: '525252', a: 1.0 },
				{ x: 0.5538, y: 0.8459, s: 0.057, c: '484848', a: 1.0 },
				{ x: 0.5595, y: 0.8314, s: 0.051, c: '5C5C5C', a: 1.0 },
				{ x: 0.5515, y: 0.839, s: 0.043, c: '4F4F4F', a: 1.0 },
				{ x: 0.5572, y: 0.8215, s: 0.043, c: '4F4F4F', a: 1.0 },
				{ x: 0.5626, y: 0.8138, s: 0.051, c: '424242', a: 1.0 },
				{ x: 0.555, y: 0.7967, s: 0.028, c: '444444', a: 1.0 },
				{ x: 0.5603, y: 0.7801, s: 0.048, c: '474747', a: 1.0 },
				{ x: 0.5525, y: 0.7896, s: 0.037, c: '484848', a: 1.0 },
				{ x: 0.5582, y: 0.773, s: 0.049, c: '414141', a: 1.0 },
				{ x: 0.5503, y: 0.7587, s: 0.057, c: '808080', a: 1.0 },
				{ x: 0.556, y: 0.7419, s: 0.082, c: '8B8B8B', a: 1.0 },
				{ x: 0.5613, y: 0.7491, s: 0.067, c: '858585', a: 1.0 },
				{ x: 0.5537, y: 0.6158, s: 0.064, c: '525252', a: 1.0 },
				{ x: 0.559, y: 0.5992, s: 0.03, c: '525252', a: 1.0 },
				{ x: 0.5514, y: 0.5344, s: 0.08, c: '666666', a: 1.0 },
				{ x: 0.5567, y: 0.5207, s: 0.075, c: 'A0A0A0', a: 1.0 },
				{ x: 0.5623, y: 0.5273, s: 0.065, c: 'A0A0A0', a: 1.0 },
				{ x: 0.5547, y: 0.5108, s: 0.045, c: '585858', a: 1.0 },
				{ x: 0.56, y: 0.4965, s: 0.041, c: '3F3F3F', a: 1.0 },
				{ x: 0.5524, y: 0.5035, s: 0.04, c: '5A5A5A', a: 1.0 },
				{ x: 0.5576, y: 0.487, s: 0.037, c: '494949', a: 1.0 },
				{ x: 0.5502, y: 0.4964, s: 0.038, c: '3E3E3E', a: 1.0 },
				{ x: 0.5558, y: 0.4799, s: 0.047, c: '494949', a: 1.0 },
				{ x: 0.5609, y: 0.4655, s: 0.035, c: '505050', a: 1.0 },
				{ x: 0.553, y: 0.4548, s: 0.045, c: '3E3E3E', a: 1.0 },
				{ x: 0.5591, y: 0.2114, s: 0.061, c: '676767', a: 1.0 },
				{ x: 0.5542, y: 0.9484, s: 0.037, c: '464646', a: 1.0 },
				{ x: 0.5598, y: 0.9555, s: 0.051, c: '484848', a: 1.0 },
				{ x: 0.5657, y: 0.9419, s: 0.03, c: '4E4E4E', a: 1.0 },
				{ x: 0.5579, y: 0.9246, s: 0.053, c: '505050', a: 1.0 },
				{ x: 0.5629, y: 0.9319, s: 0.062, c: '515151', a: 1.0 },
				{ x: 0.5552, y: 0.9176, s: 0.038, c: '535353', a: 1.0 },
				{ x: 0.5611, y: 0.9247, s: 0.048, c: '555555', a: 1.0 },
				{ x: 0.5666, y: 0.9104, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.5585, y: 0.8937, s: 0.066, c: '555555', a: 1.0 },
				{ x: 0.5645, y: 0.9006, s: 0.03, c: '535353', a: 1.0 },
				{ x: 0.5566, y: 0.8866, s: 0.044, c: '4F4F4F', a: 1.0 },
				{ x: 0.5617, y: 0.8937, s: 0.061, c: '4B4B4B', a: 1.0 },
				{ x: 0.5539, y: 0.8767, s: 0.029, c: '4B4B4B', a: 1.0 },
				{ x: 0.5598, y: 0.8865, s: 0.039, c: '4B4B4B', a: 1.0 },
				{ x: 0.5654, y: 0.8696, s: 0.042, c: '464646', a: 1.0 },
				{ x: 0.5572, y: 0.8409, s: 0.05, c: '434343', a: 1.0 },
				{ x: 0.5627, y: 0.8507, s: 0.041, c: '434343', a: 1.0 },
				{ x: 0.5553, y: 0.8338, s: 0.028, c: '434343', a: 1.0 },
				{ x: 0.5604, y: 0.8437, s: 0.061, c: '555555', a: 1.0 },
				{ x: 0.566, y: 0.8268, s: 0.097, c: '9D9D9D', a: 1.0 },
				{ x: 0.5641, y: 0.8198, s: 0.047, c: '4F4F4F', a: 1.0 },
				{ x: 0.5559, y: 0.7969, s: 0.038, c: '474747', a: 1.0 },
				{ x: 0.5614, y: 0.7979, s: 0.045, c: '424242', a: 1.0 },
				{ x: 0.554, y: 0.784, s: 0.05, c: '414141', a: 1.0 },
				{ x: 0.5596, y: 0.7611, s: 0.056, c: '5C5C5C', a: 1.0 },
				{ x: 0.5647, y: 0.7441, s: 0.052, c: '8B8B8B', a: 1.0 },
				{ x: 0.5575, y: 0.7301, s: 0.108, c: '979797', a: 1.0 },
				{ x: 0.5548, y: 0.5894, s: 0.06, c: '696969', a: 1.0 },
				{ x: 0.5601, y: 0.5993, s: 0.052, c: '696969', a: 1.0 },
				{ x: 0.5662, y: 0.5824, s: 0.041, c: '696969', a: 1.0 },
				{ x: 0.5581, y: 0.5684, s: 0.072, c: '707070', a: 1.0 },
				{ x: 0.5634, y: 0.5753, s: 0.077, c: '727272', a: 1.0 },
				{ x: 0.5554, y: 0.5583, s: 0.042, c: '727272', a: 1.0 },
				{ x: 0.5616, y: 0.5681, s: 0.091, c: '7A7A7A', a: 1.0 },
				{ x: 0.5535, y: 0.5512, s: 0.071, c: '838383', a: 1.0 },
				{ x: 0.5588, y: 0.5581, s: 0.088, c: '8D8D8D', a: 1.0 },
				{ x: 0.565, y: 0.5444, s: 0.117, c: '969696', a: 1.0 },
				{ x: 0.5569, y: 0.5274, s: 0.113, c: '969696', a: 1.0 },
				{ x: 0.5622, y: 0.5341, s: 0.071, c: '787878', a: 1.0 },
				{ x: 0.5542, y: 0.5183, s: 0.038, c: '585858', a: 1.0 },
				{ x: 0.5657, y: 0.5136, s: 0.042, c: '585858', a: 1.0 },
				{ x: 0.5577, y: 0.4948, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.5556, y: 0.4899, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.5609, y: 0.4949, s: 0.036, c: '626262', a: 1.0 },
				{ x: 0.5663, y: 0.4818, s: 0.095, c: '7A7A7A', a: 1.0 },
				{ x: 0.5591, y: 0.466, s: 0.041, c: '555555', a: 1.0 },
				{ x: 0.5645, y: 0.4592, s: 0.037, c: '505050', a: 1.0 },
				{ x: 0.5565, y: 0.4463, s: 0.055, c: '595959', a: 1.0 },
				{ x: 0.5617, y: 0.4543, s: 0.038, c: '363636', a: 1.0 },
				{ x: 0.5545, y: 0.2153, s: 0.042, c: '6D6D6D', a: 1.0 },
				{ x: 0.5632, y: 0.9546, s: 0.033, c: '4C4C4C', a: 1.0 },
				{ x: 0.5684, y: 0.9357, s: 0.063, c: '4E4E4E', a: 1.0 },
				{ x: 0.5612, y: 0.9436, s: 0.034, c: '565656', a: 1.0 },
				{ x: 0.5665, y: 0.9308, s: 0.055, c: '565656', a: 1.0 },
				{ x: 0.5591, y: 0.9358, s: 0.043, c: '575757', a: 1.0 },
				{ x: 0.5636, y: 0.92, s: 0.05, c: '5C5C5C', a: 1.0 },
				{ x: 0.5692, y: 0.9071, s: 0.039, c: '5C5C5C', a: 1.0 },
				{ x: 0.5622, y: 0.9121, s: 0.056, c: '5A5A5A', a: 1.0 },
				{ x: 0.5599, y: 0.9073, s: 0.059, c: '555555', a: 1.0 },
				{ x: 0.5656, y: 0.8914, s: 0.068, c: '575757', a: 1.0 },
				{ x: 0.5569, y: 0.8963, s: 0.063, c: '555555', a: 1.0 },
				{ x: 0.5633, y: 0.8835, s: 0.049, c: '575757', a: 1.0 },
				{ x: 0.5688, y: 0.8677, s: 0.05, c: '525252', a: 1.0 },
				{ x: 0.5602, y: 0.8549, s: 0.05, c: '4C4C4C', a: 1.0 },
				{ x: 0.5665, y: 0.8421, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.5578, y: 0.8499, s: 0.046, c: '4C4C4C', a: 1.0 },
				{ x: 0.5634, y: 0.8314, s: 0.039, c: '484848', a: 1.0 },
				{ x: 0.5612, y: 0.8265, s: 0.062, c: '5C5C5C', a: 1.0 },
				{ x: 0.5667, y: 0.8074, s: 0.054, c: '5E5E5E', a: 1.0 },
				{ x: 0.5597, y: 0.8181, s: 0.057, c: '898989', a: 1.0 },
				{ x: 0.5644, y: 0.8027, s: 0.101, c: '7E7E7E', a: 1.0 },
				{ x: 0.5574, y: 0.8073, s: 0.026, c: '474747', a: 1.0 },
				{ x: 0.563, y: 0.7859, s: 0.055, c: '4E4E4E', a: 1.0 },
				{ x: 0.5677, y: 0.7312, s: 0.064, c: '525252', a: 1.0 },
				{ x: 0.5607, y: 0.5222, s: 0.046, c: '3F3F3F', a: 1.0 },
				{ x: 0.5654, y: 0.5061, s: 0.058, c: '646464', a: 1.0 },
				{ x: 0.5576, y: 0.5175, s: 0.086, c: 'BABABA', a: 1.0 },
				{ x: 0.564, y: 0.4983, s: 0.122, c: 'ADADAD', a: 1.0 },
				{ x: 0.5687, y: 0.4822, s: 0.037, c: '3E3E3E', a: 1.0 },
				{ x: 0.5608, y: 0.4935, s: 0.052, c: '6E6E6E', a: 1.0 },
				{ x: 0.5672, y: 0.4744, s: 0.095, c: '7A7A7A', a: 1.0 },
				{ x: 0.5586, y: 0.4828, s: 0.047, c: '454545', a: 1.0 },
				{ x: 0.5572, y: 0.4422, s: 0.07, c: '6A6A6A', a: 1.0 },
				{ x: 0.5617, y: 0.4469, s: 0.036, c: '424242', a: 1.0 },
				{ x: 0.5683, y: 0.2141, s: 0.047, c: '7A7A7A', a: 1.0 },
				{ x: 0.5639, y: 0.9469, s: 0.066, c: '555555', a: 1.0 },
				{ x: 0.5684, y: 0.9583, s: 0.037, c: '585858', a: 1.0 },
				{ x: 0.5617, y: 0.9421, s: 0.067, c: '585858', a: 1.0 },
				{ x: 0.5661, y: 0.9237, s: 0.053, c: '5A5A5A', a: 1.0 },
				{ x: 0.5646, y: 0.9187, s: 0.05, c: '646464', a: 1.0 },
				{ x: 0.5695, y: 0.9234, s: 0.063, c: '5F5F5F', a: 1.0 },
				{ x: 0.5623, y: 0.908, s: 0.048, c: '5A5A5A', a: 1.0 },
				{ x: 0.568, y: 0.8948, s: 0.062, c: '585858', a: 1.0 },
				{ x: 0.5729, y: 0.8997, s: 0.037, c: '5C5C5C', a: 1.0 },
				{ x: 0.5657, y: 0.8844, s: 0.05, c: '5F5F5F', a: 1.0 },
				{ x: 0.5714, y: 0.8946, s: 0.056, c: '5F5F5F', a: 1.0 },
				{ x: 0.5626, y: 0.8758, s: 0.047, c: '565656', a: 1.0 },
				{ x: 0.5691, y: 0.8845, s: 0.034, c: '4C4C4C', a: 1.0 },
				{ x: 0.5603, y: 0.8539, s: 0.064, c: '525252', a: 1.0 },
				{ x: 0.566, y: 0.8344, s: 0.031, c: '515151', a: 1.0 },
				{ x: 0.5722, y: 0.8424, s: 0.057, c: '505050', a: 1.0 },
				{ x: 0.5637, y: 0.8303, s: 0.061, c: '4D4D4D', a: 1.0 },
				{ x: 0.5621, y: 0.8185, s: 0.047, c: '505050', a: 1.0 },
				{ x: 0.567, y: 0.8064, s: 0.048, c: '4F4F4F', a: 1.0 },
				{ x: 0.5655, y: 0.7949, s: 0.049, c: '6E6E6E', a: 1.0 },
				{ x: 0.5633, y: 0.7909, s: 0.092, c: '727272', a: 1.0 },
				{ x: 0.5678, y: 0.7959, s: 0.069, c: '979797', a: 1.0 },
				{ x: 0.5602, y: 0.7822, s: 0.055, c: '5F5F5F', a: 1.0 },
				{ x: 0.5663, y: 0.7366, s: 0.038, c: '494949', a: 1.0 },
				{ x: 0.5711, y: 0.7424, s: 0.039, c: '626262', a: 1.0 },
				{ x: 0.5635, y: 0.7288, s: 0.055, c: '626262', a: 1.0 },
				{ x: 0.57, y: 0.5224, s: 0.07, c: '5F5F5F', a: 1.0 },
				{ x: 0.5609, y: 0.5044, s: 0.072, c: 'A2A2A2', a: 1.0 },
				{ x: 0.5672, y: 0.4886, s: 0.046, c: '707070', a: 1.0 },
				{ x: 0.5731, y: 0.4988, s: 0.042, c: '505050', a: 1.0 },
				{ x: 0.5645, y: 0.4799, s: 0.041, c: '444444', a: 1.0 },
				{ x: 0.5705, y: 0.4887, s: 0.029, c: '444444', a: 1.0 },
				{ x: 0.5618, y: 0.464, s: 0.025, c: '404040', a: 1.0 },
				{ x: 0.5679, y: 0.4681, s: 0.086, c: '6A6A6A', a: 1.0 },
				{ x: 0.5605, y: 0.4531, s: 0.036, c: '5E5E5E', a: 1.0 },
				{ x: 0.5652, y: 0.22, s: 0.086, c: '6F6F6F', a: 1.0 },
				{ x: 0.5711, y: 0.2243, s: 0.046, c: '6F6F6F', a: 1.0 },
				{ x: 0.5674, y: 0.9641, s: 0.051, c: '5E5E5E', a: 1.0 },
				{ x: 0.5717, y: 0.9486, s: 0.062, c: '5F5F5F', a: 1.0 },
				{ x: 0.5647, y: 0.9287, s: 0.047, c: '5D5D5D', a: 1.0 },
				{ x: 0.5706, y: 0.94, s: 0.066, c: '5E5E5E', a: 1.0 },
				{ x: 0.568, y: 0.9286, s: 0.043, c: '666666', a: 1.0 },
				{ x: 0.5653, y: 0.9007, s: 0.063, c: '636363', a: 1.0 },
				{ x: 0.5713, y: 0.9061, s: 0.061, c: '636363', a: 1.0 },
				{ x: 0.576, y: 0.8922, s: 0.074, c: '636363', a: 1.0 },
				{ x: 0.575, y: 0.8823, s: 0.043, c: '555555', a: 1.0 },
				{ x: 0.5659, y: 0.8906, s: 0.045, c: '565656', a: 1.0 },
				{ x: 0.5649, y: 0.8583, s: 0.054, c: '565656', a: 1.0 },
				{ x: 0.5692, y: 0.8667, s: 0.046, c: '4E4E4E', a: 1.0 },
				{ x: 0.5756, y: 0.8528, s: 0.042, c: '575757', a: 1.0 },
				{ x: 0.5681, y: 0.8582, s: 0.059, c: '565656', a: 1.0 },
				{ x: 0.5655, y: 0.8303, s: 0.03, c: '515151', a: 1.0 },
				{ x: 0.5702, y: 0.8342, s: 0.063, c: '4E4E4E', a: 1.0 },
				{ x: 0.5762, y: 0.8187, s: 0.032, c: '525252', a: 1.0 },
				{ x: 0.5735, y: 0.8104, s: 0.056, c: '585858', a: 1.0 },
				{ x: 0.5662, y: 0.8187, s: 0.065, c: '565656', a: 1.0 },
				{ x: 0.5697, y: 0.7948, s: 0.074, c: '626262', a: 1.0 },
				{ x: 0.5757, y: 0.7822, s: 0.041, c: '6E6E6E', a: 1.0 },
				{ x: 0.5669, y: 0.7906, s: 0.082, c: '6E6E6E', a: 1.0 },
				{ x: 0.5731, y: 0.7722, s: 0.076, c: '7C7C7C', a: 1.0 },
				{ x: 0.5642, y: 0.7583, s: 0.087, c: '7C7C7C', a: 1.0 },
				{ x: 0.5703, y: 0.7674, s: 0.045, c: '606060', a: 1.0 },
				{ x: 0.5676, y: 0.7581, s: 0.045, c: '494949', a: 1.0 },
				{ x: 0.5665, y: 0.5211, s: 0.038, c: '383838', a: 1.0 },
				{ x: 0.571, y: 0.5068, s: 0.04, c: '525252', a: 1.0 },
				{ x: 0.5638, y: 0.494, s: 0.034, c: '3F3F3F', a: 1.0 },
				{ x: 0.57, y: 0.4975, s: 0.03, c: '464646', a: 1.0 },
				{ x: 0.5745, y: 0.4832, s: 0.033, c: '525252', a: 1.0 },
				{ x: 0.5673, y: 0.4927, s: 0.045, c: '3F3F3F', a: 1.0 },
				{ x: 0.5732, y: 0.4617, s: 0.042, c: '585858', a: 1.0 },
				{ x: 0.5644, y: 0.4474, s: 0.073, c: '5D5D5D', a: 1.0 },
				{ x: 0.5705, y: 0.2307, s: 0.087, c: '767676', a: 1.0 },
				{ x: 0.5783, y: 0.9596, s: 0.06, c: '636363', a: 1.0 },
				{ x: 0.5712, y: 0.9453, s: 0.068, c: '646464', a: 1.0 },
				{ x: 0.5774, y: 0.9308, s: 0.037, c: '626262', a: 1.0 },
				{ x: 0.5747, y: 0.9215, s: 0.057, c: '646464', a: 1.0 },
				{ x: 0.5675, y: 0.931, s: 0.083, c: '676767', a: 1.0 },
				{ x: 0.578, y: 0.9216, s: 0.056, c: '6A6A6A', a: 1.0 },
				{ x: 0.5709, y: 0.9073, s: 0.063, c: '666666', a: 1.0 },
				{ x: 0.5764, y: 0.887, s: 0.066, c: '5C5C5C', a: 1.0 },
				{ x: 0.567, y: 0.8979, s: 0.059, c: '4E4E4E', a: 1.0 },
				{ x: 0.5724, y: 0.8836, s: 0.034, c: '5A5A5A', a: 1.0 },
				{ x: 0.5796, y: 0.8872, s: 0.075, c: '666666', a: 1.0 },
				{ x: 0.5701, y: 0.8728, s: 0.069, c: '666666', a: 1.0 },
				{ x: 0.5695, y: 0.8634, s: 0.058, c: '626262', a: 1.0 },
				{ x: 0.5735, y: 0.8491, s: 0.067, c: '5C5C5C', a: 1.0 },
				{ x: 0.5729, y: 0.8399, s: 0.048, c: '565656', a: 1.0 },
				{ x: 0.5767, y: 0.8491, s: 0.047, c: '555555', a: 1.0 },
				{ x: 0.5689, y: 0.8352, s: 0.066, c: '525252', a: 1.0 },
				{ x: 0.5761, y: 0.816, s: 0.034, c: '545454', a: 1.0 },
				{ x: 0.5683, y: 0.8258, s: 0.056, c: '575757', a: 1.0 },
				{ x: 0.5721, y: 0.8113, s: 0.057, c: '595959', a: 1.0 },
				{ x: 0.5794, y: 0.8159, s: 0.059, c: '5A5A5A', a: 1.0 },
				{ x: 0.5716, y: 0.802, s: 0.034, c: '5A5A5A', a: 1.0 },
				{ x: 0.5754, y: 0.7873, s: 0.066, c: '5F5F5F', a: 1.0 },
				{ x: 0.5693, y: 0.7971, s: 0.057, c: '5D5D5D', a: 1.0 },
				{ x: 0.5748, y: 0.778, s: 0.034, c: '595959', a: 1.0 },
				{ x: 0.5787, y: 0.7879, s: 0.037, c: '515151', a: 1.0 },
				{ x: 0.5726, y: 0.7732, s: 0.039, c: '424242', a: 1.0 },
				{ x: 0.5781, y: 0.7652, s: 0.063, c: '8E8E8E', a: 1.0 },
				{ x: 0.5686, y: 0.752, s: 0.116, c: '959595', a: 1.0 },
				{ x: 0.5741, y: 0.7374, s: 0.047, c: '606060', a: 1.0 },
				{ x: 0.568, y: 0.7414, s: 0.077, c: '787878', a: 1.0 },
				{ x: 0.5719, y: 0.7282, s: 0.081, c: '979797', a: 1.0 },
				{ x: 0.5774, y: 0.738, s: 0.084, c: '6E6E6E', a: 1.0 },
				{ x: 0.5713, y: 0.5031, s: 0.033, c: '383838', a: 1.0 },
				{ x: 0.5751, y: 0.4891, s: 0.055, c: '525252', a: 1.0 },
				{ x: 0.5674, y: 0.4997, s: 0.037, c: '3F3F3F', a: 1.0 },
				{ x: 0.5744, y: 0.4678, s: 0.023, c: '3A3A3A', a: 1.0 },
				{ x: 0.5785, y: 0.477, s: 0.051, c: '404040', a: 1.0 },
				{ x: 0.5705, y: 0.464, s: 0.025, c: '3A3A3A', a: 1.0 },
				{ x: 0.5779, y: 0.2358, s: 0.062, c: '6F6F6F', a: 1.0 },
				{ x: 0.5712, y: 0.9358, s: 0.076, c: '676767', a: 1.0 },
				{ x: 0.5765, y: 0.945, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.5806, y: 0.931, s: 0.05, c: '686868', a: 1.0 },
				{ x: 0.5742, y: 0.9117, s: 0.084, c: '676767', a: 1.0 },
				{ x: 0.5702, y: 0.9074, s: 0.061, c: '676767', a: 1.0 },
				{ x: 0.5776, y: 0.9117, s: 0.049, c: '555555', a: 1.0 },
				{ x: 0.5833, y: 0.8854, s: 0.067, c: '626262', a: 1.0 },
				{ x: 0.5736, y: 0.8719, s: 0.053, c: '6A6A6A', a: 1.0 },
				{ x: 0.581, y: 0.8755, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.573, y: 0.862, s: 0.063, c: '666666', a: 1.0 },
				{ x: 0.577, y: 0.8715, s: 0.076, c: '6A6A6A', a: 1.0 },
				{ x: 0.5824, y: 0.8519, s: 0.05, c: '606060', a: 1.0 },
				{ x: 0.5801, y: 0.8475, s: 0.052, c: '5C5C5C', a: 1.0 },
				{ x: 0.5725, y: 0.828, s: 0.055, c: '565656', a: 1.0 },
				{ x: 0.5797, y: 0.8375, s: 0.068, c: '555555', a: 1.0 },
				{ x: 0.57, y: 0.8239, s: 0.06, c: '585858', a: 1.0 },
				{ x: 0.5757, y: 0.8275, s: 0.033, c: '585858', a: 1.0 },
				{ x: 0.5827, y: 0.8139, s: 0.07, c: '5B5B5B', a: 1.0 },
				{ x: 0.5735, y: 0.7995, s: 0.04, c: '5F5F5F', a: 1.0 },
				{ x: 0.5788, y: 0.8038, s: 0.06, c: '5F5F5F', a: 1.0 },
				{ x: 0.5729, y: 0.7894, s: 0.047, c: '616161', a: 1.0 },
				{ x: 0.5782, y: 0.7996, s: 0.042, c: '686868', a: 1.0 },
				{ x: 0.5822, y: 0.7801, s: 0.048, c: '606060', a: 1.0 },
				{ x: 0.5762, y: 0.7895, s: 0.069, c: '595959', a: 1.0 },
				{ x: 0.5814, y: 0.776, s: 0.028, c: '424242', a: 1.0 },
				{ x: 0.5724, y: 0.7437, s: 0.04, c: '676767', a: 1.0 },
				{ x: 0.5796, y: 0.748, s: 0.05, c: '676767', a: 1.0 },
				{ x: 0.5714, y: 0.7336, s: 0.075, c: '818181', a: 1.0 },
				{ x: 0.5827, y: 0.7237, s: 0.109, c: '8B8B8B', a: 1.0 },
				{ x: 0.5749, y: 0.7099, s: 0.065, c: '626262', a: 1.0 },
				{ x: 0.5784, y: 0.4999, s: 0.031, c: '464646', a: 1.0 },
				{ x: 0.5705, y: 0.4797, s: 0.039, c: '464646', a: 1.0 },
				{ x: 0.5817, y: 0.9518, s: 0.046, c: '6C6C6C', a: 1.0 },
				{ x: 0.5851, y: 0.9559, s: 0.067, c: '6C6C6C', a: 1.0 },
				{ x: 0.5773, y: 0.9419, s: 0.073, c: '696969', a: 1.0 },
				{ x: 0.5849, y: 0.9279, s: 0.072, c: '696969', a: 1.0 },
				{ x: 0.5754, y: 0.9319, s: 0.039, c: '666666', a: 1.0 },
				{ x: 0.5805, y: 0.918, s: 0.076, c: '666666', a: 1.0 },
				{ x: 0.5743, y: 0.9279, s: 0.048, c: '5B5B5B', a: 1.0 },
				{ x: 0.5786, y: 0.9079, s: 0.044, c: '505050', a: 1.0 },
				{ x: 0.5842, y: 0.8762, s: 0.065, c: '5E5E5E', a: 1.0 },
				{ x: 0.5776, y: 0.886, s: 0.068, c: '6D6D6D', a: 1.0 },
				{ x: 0.5741, y: 0.8761, s: 0.041, c: '686868', a: 1.0 },
				{ x: 0.5809, y: 0.8621, s: 0.085, c: '686868', a: 1.0 },
				{ x: 0.5864, y: 0.8482, s: 0.037, c: '646464', a: 1.0 },
				{ x: 0.5774, y: 0.8521, s: 0.074, c: '616161', a: 1.0 },
				{ x: 0.5846, y: 0.8383, s: 0.042, c: '616161', a: 1.0 },
				{ x: 0.5763, y: 0.8482, s: 0.055, c: '5B5B5B', a: 1.0 },
				{ x: 0.5802, y: 0.8282, s: 0.063, c: '585858', a: 1.0 },
				{ x: 0.5745, y: 0.8381, s: 0.045, c: '5B5B5B', a: 1.0 },
				{ x: 0.5796, y: 0.8241, s: 0.04, c: '5C5C5C', a: 1.0 },
				{ x: 0.5835, y: 0.8042, s: 0.055, c: '5B5B5B', a: 1.0 },
				{ x: 0.5777, y: 0.814, s: 0.074, c: '626262', a: 1.0 },
				{ x: 0.5832, y: 0.8, s: 0.074, c: '5F5F5F', a: 1.0 },
				{ x: 0.5734, y: 0.804, s: 0.048, c: '606060', a: 1.0 },
				{ x: 0.5788, y: 0.7903, s: 0.057, c: '656565', a: 1.0 },
				{ x: 0.5866, y: 0.7763, s: 0.055, c: '666666', a: 1.0 },
				{ x: 0.5769, y: 0.7803, s: 0.053, c: '5B5B5B', a: 1.0 },
				{ x: 0.5766, y: 0.7522, s: 0.047, c: '454545', a: 1.0 },
				{ x: 0.5803, y: 0.7323, s: 0.028, c: '4A4A4A', a: 1.0 },
				{ x: 0.5856, y: 0.7422, s: 0.053, c: '484848', a: 1.0 },
				{ x: 0.5792, y: 0.73, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.5837, y: 0.7142, s: 0.066, c: '919191', a: 1.0 },
				{ x: 0.5757, y: 0.716, s: 0.097, c: '7E7E7E', a: 1.0 },
				{ x: 0.5779, y: 0.9483, s: 0.068, c: '6D6D6D', a: 1.0 },
				{ x: 0.5824, y: 0.9385, s: 0.082, c: '6C6C6C', a: 1.0 },
				{ x: 0.5894, y: 0.9406, s: 0.082, c: '696969', a: 1.0 },
				{ x: 0.5813, y: 0.9248, s: 0.054, c: '686868', a: 1.0 },
				{ x: 0.5858, y: 0.9388, s: 0.053, c: '666666', a: 1.0 },
				{ x: 0.5794, y: 0.917, s: 0.053, c: '5B5B5B', a: 1.0 },
				{ x: 0.5847, y: 0.8949, s: 0.044, c: '585858', a: 1.0 },
				{ x: 0.5884, y: 0.8851, s: 0.054, c: '6E6E6E', a: 1.0 },
				{ x: 0.5882, y: 0.8713, s: 0.044, c: '6D6D6D', a: 1.0 },
				{ x: 0.5782, y: 0.8477, s: 0.053, c: '656565', a: 1.0 },
				{ x: 0.5871, y: 0.8398, s: 0.064, c: '5F5F5F', a: 1.0 },
				{ x: 0.5816, y: 0.8241, s: 0.056, c: '5C5C5C', a: 1.0 },
				{ x: 0.5853, y: 0.8379, s: 0.043, c: '5C5C5C', a: 1.0 },
				{ x: 0.5773, y: 0.8162, s: 0.065, c: '5D5D5D', a: 1.0 },
				{ x: 0.5842, y: 0.8241, s: 0.047, c: '5B5B5B', a: 1.0 },
				{ x: 0.5887, y: 0.8143, s: 0.049, c: '5E5E5E', a: 1.0 },
				{ x: 0.5883, y: 0.8004, s: 0.041, c: '606060', a: 1.0 },
				{ x: 0.5788, y: 0.7906, s: 0.079, c: '646464', a: 1.0 },
				{ x: 0.5835, y: 0.7927, s: 0.041, c: '666666', a: 1.0 },
				{ x: 0.5828, y: 0.7668, s: 0.053, c: '4F4F4F', a: 1.0 },
				{ x: 0.5814, y: 0.7472, s: 0.033, c: '4B4B4B', a: 1.0 },
				{ x: 0.5861, y: 0.7548, s: 0.061, c: '525252', a: 1.0 },
				{ x: 0.5774, y: 0.7336, s: 0.06, c: '535353', a: 1.0 },
				{ x: 0.5848, y: 0.7234, s: 0.042, c: '505050', a: 1.0 },
				{ x: 0.5895, y: 0.7318, s: 0.027, c: '424242', a: 1.0 },
				{ x: 0.588, y: 0.7239, s: 0.088, c: '8B8B8B', a: 1.0 },
				{ x: 0.5793, y: 0.7078, s: 0.059, c: '6C6C6C', a: 1.0 },
				{ x: 0.5887, y: 0.7001, s: 0.102, c: '8B8B8B', a: 1.0 },
				{ x: 0.5873, y: 0.6863, s: 0.096, c: '787878', a: 1.0 },
				{ x: 0.5786, y: 0.6761, s: 0.044, c: '5C5C5C', a: 1.0 },
				{ x: 0.5892, y: 0.9481, s: 0.07, c: '6C6C6C', a: 1.0 },
				{ x: 0.5806, y: 0.9386, s: 0.065, c: '6C6C6C', a: 1.0 },
				{ x: 0.5933, y: 0.9243, s: 0.041, c: '5F5F5F', a: 1.0 },
				{ x: 0.5885, y: 0.8867, s: 0.041, c: '515151', a: 1.0 },
				{ x: 0.5832, y: 0.8891, s: 0.06, c: '737373', a: 1.0 },
				{ x: 0.5879, y: 0.8788, s: 0.068, c: '727272', a: 1.0 },
				{ x: 0.5918, y: 0.8574, s: 0.061, c: '727272', a: 1.0 },
				{ x: 0.5865, y: 0.865, s: 0.055, c: '717171', a: 1.0 },
				{ x: 0.5912, y: 0.8556, s: 0.041, c: '696969', a: 1.0 },
				{ x: 0.5817, y: 0.8572, s: 0.083, c: '666666', a: 1.0 },
				{ x: 0.5897, y: 0.8413, s: 0.053, c: '626262', a: 1.0 },
				{ x: 0.5812, y: 0.8318, s: 0.05, c: '616161', a: 1.0 },
				{ x: 0.5856, y: 0.8335, s: 0.039, c: '5E5E5E', a: 1.0 },
				{ x: 0.593, y: 0.8181, s: 0.044, c: '5C5C5C', a: 1.0 },
				{ x: 0.5842, y: 0.8315, s: 0.055, c: '5D5D5D', a: 1.0 },
				{ x: 0.589, y: 0.8101, s: 0.04, c: '5D5D5D', a: 1.0 },
				{ x: 0.5831, y: 0.8184, s: 0.055, c: '5F5F5F', a: 1.0 },
				{ x: 0.5876, y: 0.8085, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.5924, y: 0.786, s: 0.044, c: '626262', a: 1.0 },
				{ x: 0.5836, y: 0.7945, s: 0.059, c: '636363', a: 1.0 },
				{ x: 0.591, y: 0.7847, s: 0.073, c: '6A6A6A', a: 1.0 },
				{ x: 0.5821, y: 0.7859, s: 0.058, c: '666666', a: 1.0 },
				{ x: 0.587, y: 0.7701, s: 0.061, c: '575757', a: 1.0 },
				{ x: 0.5904, y: 0.7347, s: 0.047, c: '555555', a: 1.0 },
				{ x: 0.5848, y: 0.7487, s: 0.063, c: '535353', a: 1.0 },
				{ x: 0.5889, y: 0.7276, s: 0.062, c: '535353', a: 1.0 },
				{ x: 0.58, y: 0.7346, s: 0.051, c: '4E4E4E', a: 1.0 },
				{ x: 0.5883, y: 0.7247, s: 0.036, c: '424242', a: 1.0 },
				{ x: 0.5928, y: 0.7037, s: 0.037, c: '404040', a: 1.0 },
				{ x: 0.5914, y: 0.7012, s: 0.057, c: '9A9A9A', a: 1.0 },
				{ x: 0.5829, y: 0.7032, s: 0.136, c: 'A9A9A9', a: 1.0 },
				{ x: 0.5868, y: 0.6941, s: 0.057, c: '949494', a: 1.0 },
				{ x: 0.5813, y: 0.6782, s: 0.068, c: '818181', a: 1.0 },
				{ x: 0.5895, y: 0.9501, s: 0.06, c: '6B6B6B', a: 1.0 },
				{ x: 0.594, y: 0.9581, s: 0.072, c: '666666', a: 1.0 },
				{ x: 0.588, y: 0.9356, s: 0.068, c: '575757', a: 1.0 },
				{ x: 0.5926, y: 0.8722, s: 0.079, c: '737373', a: 1.0 },
				{ x: 0.5841, y: 0.8809, s: 0.069, c: '727272', a: 1.0 },
				{ x: 0.5886, y: 0.859, s: 0.041, c: '727272', a: 1.0 },
				{ x: 0.5961, y: 0.8722, s: 0.089, c: '727272', a: 1.0 },
				{ x: 0.5871, y: 0.8565, s: 0.071, c: '696969', a: 1.0 },
				{ x: 0.5918, y: 0.8593, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.5861, y: 0.8494, s: 0.042, c: '646464', a: 1.0 },
				{ x: 0.5908, y: 0.8327, s: 0.069, c: '606060', a: 1.0 },
				{ x: 0.5951, y: 0.8352, s: 0.063, c: '606060', a: 1.0 },
				{ x: 0.5897, y: 0.8257, s: 0.039, c: '606060', a: 1.0 },
				{ x: 0.594, y: 0.8326, s: 0.074, c: '5D5D5D', a: 1.0 },
				{ x: 0.5853, y: 0.8114, s: 0.042, c: '606060', a: 1.0 },
				{ x: 0.5929, y: 0.8019, s: 0.059, c: '626262', a: 1.0 },
				{ x: 0.584, y: 0.8043, s: 0.046, c: '636363', a: 1.0 },
				{ x: 0.5887, y: 0.7873, s: 0.08, c: '656565', a: 1.0 },
				{ x: 0.5963, y: 0.8017, s: 0.05, c: '656565', a: 1.0 },
				{ x: 0.5877, y: 0.7803, s: 0.073, c: '666666', a: 1.0 },
				{ x: 0.5919, y: 0.7872, s: 0.037, c: '666666', a: 1.0 },
				{ x: 0.5866, y: 0.7778, s: 0.068, c: '575757', a: 1.0 },
				{ x: 0.5909, y: 0.7564, s: 0.04, c: '3C3C3C', a: 1.0 },
				{ x: 0.5956, y: 0.7529, s: 0.047, c: '4E4E4E', a: 1.0 },
				{ x: 0.5899, y: 0.7419, s: 0.035, c: '555555', a: 1.0 },
				{ x: 0.5946, y: 0.7444, s: 0.034, c: '535353', a: 1.0 },
				{ x: 0.5855, y: 0.7289, s: 0.044, c: '535353', a: 1.0 },
				{ x: 0.5931, y: 0.7193, s: 0.065, c: '505050', a: 1.0 },
				{ x: 0.5845, y: 0.7206, s: 0.026, c: '454545', a: 1.0 },
				{ x: 0.5888, y: 0.7051, s: 0.036, c: '404040', a: 1.0 },
				{ x: 0.5935, y: 0.7195, s: 0.038, c: '404040', a: 1.0 },
				{ x: 0.5925, y: 0.7049, s: 0.083, c: '7D7D7D', a: 1.0 },
				{ x: 0.5834, y: 0.6954, s: 0.077, c: '676767', a: 1.0 },
				{ x: 0.5947, y: 0.9547, s: 0.032, c: '585858', a: 1.0 },
				{ x: 0.5991, y: 0.9452, s: 0.059, c: '4C4C4C', a: 1.0 },
				{ x: 0.59, y: 0.8881, s: 0.07, c: '6F6F6F', a: 1.0 },
				{ x: 0.598, y: 0.8714, s: 0.076, c: '737373', a: 1.0 },
				{ x: 0.5892, y: 0.8619, s: 0.077, c: '747474', a: 1.0 },
				{ x: 0.588, y: 0.8549, s: 0.046, c: '6E6E6E', a: 1.0 },
				{ x: 0.5925, y: 0.8616, s: 0.059, c: '6C6C6C', a: 1.0 },
				{ x: 0.587, y: 0.8161, s: 0.06, c: '656565', a: 1.0 },
				{ x: 0.5993, y: 0.8141, s: 0.037, c: '626262', a: 1.0 },
				{ x: 0.5905, y: 0.816, s: 0.055, c: '626262', a: 1.0 },
				{ x: 0.5983, y: 0.8077, s: 0.074, c: '646464', a: 1.0 },
				{ x: 0.5939, y: 0.794, s: 0.041, c: '656565', a: 1.0 },
				{ x: 0.5983, y: 0.7841, s: 0.063, c: '686868', a: 1.0 },
				{ x: 0.5928, y: 0.7907, s: 0.054, c: '6C6C6C', a: 1.0 },
				{ x: 0.5972, y: 0.7704, s: 0.067, c: '5C5C5C', a: 1.0 },
				{ x: 0.5884, y: 0.7602, s: 0.026, c: '404040', a: 1.0 },
				{ x: 0.5962, y: 0.7549, s: 0.052, c: '4E4E4E', a: 1.0 },
				{ x: 0.5873, y: 0.7346, s: 0.052, c: '525252', a: 1.0 },
				{ x: 0.5918, y: 0.7471, s: 0.031, c: '515151', a: 1.0 },
				{ x: 0.5908, y: 0.7348, s: 0.046, c: '4E4E4E', a: 1.0 },
				{ x: 0.5953, y: 0.7235, s: 0.042, c: '4B4B4B', a: 1.0 },
				{ x: 0.5898, y: 0.7031, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.5941, y: 0.7112, s: 0.042, c: '474747', a: 1.0 },
				{ x: 0.5964, y: 0.8719, s: 0.07, c: '757575', a: 1.0 },
				{ x: 0.5921, y: 0.8642, s: 0.073, c: '747474', a: 1.0 },
				{ x: 0.5999, y: 0.8468, s: 0.077, c: '737373', a: 1.0 },
				{ x: 0.591, y: 0.8607, s: 0.045, c: '6F6F6F', a: 1.0 },
				{ x: 0.5945, y: 0.8405, s: 0.045, c: '696969', a: 1.0 },
				{ x: 0.5957, y: 0.8386, s: 0.041, c: '6A6A6A', a: 1.0 },
				{ x: 0.5979, y: 0.8169, s: 0.074, c: '686868', a: 1.0 },
				{ x: 0.5901, y: 0.823, s: 0.057, c: '646464', a: 1.0 },
				{ x: 0.6011, y: 0.8166, s: 0.049, c: '646464', a: 1.0 },
				{ x: 0.6021, y: 0.7911, s: 0.077, c: '646464', a: 1.0 },
				{ x: 0.5909, y: 0.792, s: 0.049, c: '656565', a: 1.0 },
				{ x: 0.5998, y: 0.7758, s: 0.059, c: '6A6A6A', a: 1.0 },
				{ x: 0.5922, y: 0.7916, s: 0.078, c: '6C6C6C', a: 1.0 },
				{ x: 0.5944, y: 0.7681, s: 0.059, c: '5E5E5E', a: 1.0 },
				{ x: 0.6032, y: 0.7757, s: 0.038, c: '434343', a: 1.0 },
				{ x: 0.5954, y: 0.7558, s: 0.059, c: '4B4B4B', a: 1.0 },
				{ x: 0.5976, y: 0.7322, s: 0.059, c: '525252', a: 1.0 },
				{ x: 0.5931, y: 0.748, s: 0.045, c: '525252', a: 1.0 },
				{ x: 0.5986, y: 0.7319, s: 0.041, c: '505050', a: 1.0 },
				{ x: 0.6008, y: 0.7328, s: 0.03, c: '4E4E4E', a: 1.0 },
				{ x: 0.5964, y: 0.724, s: 0.051, c: '494949', a: 1.0 },
				{ x: 0.6019, y: 0.707, s: 0.039, c: '474747', a: 1.0 },
				{ x: 0.5907, y: 0.7091, s: 0.049, c: '414141', a: 1.0 },
				{ x: 0.5973, y: 0.8616, s: 0.057, c: '737373', a: 1.0 },
				{ x: 0.6062, y: 0.8676, s: 0.044, c: '737373', a: 1.0 },
				{ x: 0.5984, y: 0.8477, s: 0.055, c: '747474', a: 1.0 },
				{ x: 0.6006, y: 0.8613, s: 0.068, c: '717171', a: 1.0 },
				{ x: 0.5983, y: 0.8478, s: 0.087, c: '6E6E6E', a: 1.0 },
				{ x: 0.6039, y: 0.8375, s: 0.071, c: '6E6E6E', a: 1.0 },
				{ x: 0.6015, y: 0.8238, s: 0.073, c: '696969', a: 1.0 },
				{ x: 0.594, y: 0.8129, s: 0.041, c: '656565', a: 1.0 },
				{ x: 0.6025, y: 0.8203, s: 0.049, c: '646464', a: 1.0 },
				{ x: 0.6049, y: 0.8, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.5969, y: 0.7894, s: 0.058, c: '656565', a: 1.0 },
				{ x: 0.606, y: 0.7929, s: 0.038, c: '646464', a: 1.0 },
				{ x: 0.5946, y: 0.7764, s: 0.066, c: '686868', a: 1.0 },
				{ x: 0.596, y: 0.7691, s: 0.058, c: '636363', a: 1.0 },
				{ x: 0.598, y: 0.7762, s: 0.057, c: '4C4C4C', a: 1.0 },
				{ x: 0.6037, y: 0.753, s: 0.042, c: '484848', a: 1.0 },
				{ x: 0.599, y: 0.7336, s: 0.06, c: '555555', a: 1.0 },
				{ x: 0.6014, y: 0.7401, s: 0.032, c: '535353', a: 1.0 },
				{ x: 0.5934, y: 0.7294, s: 0.064, c: '4E4E4E', a: 1.0 },
				{ x: 0.6044, y: 0.7165, s: 0.032, c: '494949', a: 1.0 },
				{ x: 0.5967, y: 0.7055, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.6057, y: 0.7091, s: 0.032, c: '3F3F3F', a: 1.0 },
				{ x: 0.5944, y: 0.4367, s: 0.051, c: '4F4F4F', a: 1.0 },
				{ x: 0.6001, y: 0.2616, s: 0.046, c: '616161', a: 1.0 },
				{ x: 0.5988, y: 0.9599, s: 0.041, c: '262626', a: 1.0 },
				{ x: 0.6012, y: 0.8868, s: 0.026, c: '484848', a: 1.0 },
				{ x: 0.6098, y: 0.8635, s: 0.079, c: '707070', a: 1.0 },
				{ x: 0.6023, y: 0.8708, s: 0.091, c: '717171', a: 1.0 },
				{ x: 0.6042, y: 0.8631, s: 0.051, c: '737373', a: 1.0 },
				{ x: 0.6, y: 0.8636, s: 0.067, c: '717171', a: 1.0 },
				{ x: 0.6032, y: 0.84, s: 0.061, c: '707070', a: 1.0 },
				{ x: 0.6085, y: 0.8315, s: 0.084, c: '717171', a: 1.0 },
				{ x: 0.5977, y: 0.8388, s: 0.041, c: '717171', a: 1.0 },
				{ x: 0.6063, y: 0.8155, s: 0.085, c: '6E6E6E', a: 1.0 },
				{ x: 0.6006, y: 0.8147, s: 0.056, c: '6C6C6C', a: 1.0 },
				{ x: 0.6098, y: 0.7919, s: 0.07, c: '6C6C6C', a: 1.0 },
				{ x: 0.6017, y: 0.8077, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.5999, y: 0.7917, s: 0.072, c: '656565', a: 1.0 },
				{ x: 0.6054, y: 0.7838, s: 0.078, c: '636363', a: 1.0 },
				{ x: 0.6072, y: 0.7669, s: 0.049, c: '636363', a: 1.0 },
				{ x: 0.6026, y: 0.7708, s: 0.049, c: '545454', a: 1.0 },
				{ x: 0.5974, y: 0.7548, s: 0.033, c: '525252', a: 1.0 },
				{ x: 0.6059, y: 0.735, s: 0.068, c: '545454', a: 1.0 },
				{ x: 0.5986, y: 0.724, s: 0.042, c: '525252', a: 1.0 },
				{ x: 0.6008, y: 0.7309, s: 0.035, c: '4D4D4D', a: 1.0 },
				{ x: 0.6093, y: 0.711, s: 0.037, c: '4A4A4A', a: 1.0 },
				{ x: 0.5981, y: 0.7239, s: 0.038, c: '474747', a: 1.0 },
				{ x: 0.604, y: 0.4569, s: 0.049, c: '4A4A4A', a: 1.0 },
				{ x: 0.5995, y: 0.4608, s: 0.055, c: '898989', a: 1.0 },
				{ x: 0.6013, y: 0.4498, s: 0.072, c: '898989', a: 1.0 },
				{ x: 0.6069, y: 0.2989, s: 0.066, c: '616161', a: 1.0 },
				{ x: 0.6028, y: 0.2585, s: 0.057, c: '787878', a: 1.0 },
				{ x: 0.6079, y: 0.9121, s: 0.04, c: '0D0D0D', a: 1.0 },
				{ x: 0.6001, y: 0.8714, s: 0.051, c: '707070', a: 1.0 },
				{ x: 0.6094, y: 0.8604, s: 0.065, c: '707070', a: 1.0 },
				{ x: 0.6116, y: 0.8643, s: 0.059, c: '707070', a: 1.0 },
				{ x: 0.6034, y: 0.8473, s: 0.045, c: '747474', a: 1.0 },
				{ x: 0.6123, y: 0.8602, s: 0.094, c: '737373', a: 1.0 },
				{ x: 0.6016, y: 0.8403, s: 0.042, c: '707070', a: 1.0 },
				{ x: 0.6022, y: 0.8364, s: 0.051, c: '707070', a: 1.0 },
				{ x: 0.6043, y: 0.8165, s: 0.063, c: '707070', a: 1.0 },
				{ x: 0.6104, y: 0.8234, s: 0.055, c: '6F6F6F', a: 1.0 },
				{ x: 0.6056, y: 0.8125, s: 0.068, c: '6F6F6F', a: 1.0 },
				{ x: 0.6076, y: 0.8177, s: 0.087, c: '6F6F6F', a: 1.0 },
				{ x: 0.6004, y: 0.7989, s: 0.066, c: '6D6D6D', a: 1.0 },
				{ x: 0.611, y: 0.794, s: 0.056, c: '6C6C6C', a: 1.0 },
				{ x: 0.6063, y: 0.7752, s: 0.072, c: '656565', a: 1.0 },
				{ x: 0.6124, y: 0.7889, s: 0.06, c: '626262', a: 1.0 },
				{ x: 0.6011, y: 0.7702, s: 0.054, c: '626262', a: 1.0 },
				{ x: 0.6097, y: 0.7752, s: 0.056, c: '5A5A5A', a: 1.0 },
				{ x: 0.6025, y: 0.7474, s: 0.033, c: '4E4E4E', a: 1.0 },
				{ x: 0.6044, y: 0.7287, s: 0.062, c: '555555', a: 1.0 },
				{ x: 0.6131, y: 0.7427, s: 0.051, c: '545454', a: 1.0 },
				{ x: 0.6051, y: 0.7239, s: 0.034, c: '4F4F4F', a: 1.0 },
				{ x: 0.6079, y: 0.7289, s: 0.044, c: '4B4B4B', a: 1.0 },
				{ x: 0.6032, y: 0.7191, s: 0.032, c: '424242', a: 1.0 },
				{ x: 0.6085, y: 0.4559, s: 0.047, c: '3D3D3D', a: 1.0 },
				{ x: 0.6105, y: 0.4611, s: 0.051, c: '585858', a: 1.0 },
				{ x: 0.6065, y: 0.4512, s: 0.074, c: '888888', a: 1.0 },
				{ x: 0.6118, y: 0.4562, s: 0.08, c: '7E7E7E', a: 1.0 },
				{ x: 0.6038, y: 0.868, s: 0.065, c: '666666', a: 1.0 },
				{ x: 0.6052, y: 0.8512, s: 0.062, c: '707070', a: 1.0 },
				{ x: 0.6073, y: 0.8682, s: 0.05, c: '757575', a: 1.0 },
				{ x: 0.6159, y: 0.8493, s: 0.094, c: '747474', a: 1.0 },
				{ x: 0.6087, y: 0.8513, s: 0.058, c: '707070', a: 1.0 },
				{ x: 0.6107, y: 0.8445, s: 0.066, c: '6C6C6C', a: 1.0 },
				{ x: 0.606, y: 0.8257, s: 0.058, c: '6D6D6D', a: 1.0 },
				{ x: 0.612, y: 0.8277, s: 0.048, c: '707070', a: 1.0 },
				{ x: 0.614, y: 0.8207, s: 0.067, c: '6F6F6F', a: 1.0 },
				{ x: 0.6093, y: 0.8257, s: 0.053, c: '6F6F6F', a: 1.0 },
				{ x: 0.6113, y: 0.804, s: 0.05, c: '6D6D6D', a: 1.0 },
				{ x: 0.6042, y: 0.797, s: 0.074, c: '6E6E6E', a: 1.0 },
				{ x: 0.613, y: 0.8018, s: 0.058, c: '707070', a: 1.0 },
				{ x: 0.6144, y: 0.7804, s: 0.065, c: '6B6B6B', a: 1.0 },
				{ x: 0.6074, y: 0.7969, s: 0.08, c: '676767', a: 1.0 },
				{ x: 0.6163, y: 0.7755, s: 0.056, c: '656565', a: 1.0 },
				{ x: 0.6044, y: 0.7802, s: 0.063, c: '646464', a: 1.0 },
				{ x: 0.6064, y: 0.7517, s: 0.025, c: '3D3D3D', a: 1.0 },
				{ x: 0.6077, y: 0.7451, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.614, y: 0.7379, s: 0.03, c: '525252', a: 1.0 },
				{ x: 0.6087, y: 0.7403, s: 0.063, c: '515151', a: 1.0 },
				{ x: 0.6109, y: 0.7212, s: 0.058, c: '4E4E4E', a: 1.0 },
				{ x: 0.6039, y: 0.7139, s: 0.043, c: '464646', a: 1.0 },
				{ x: 0.6119, y: 0.7164, s: 0.032, c: '3E3E3E', a: 1.0 },
				{ x: 0.6143, y: 0.4532, s: 0.048, c: '3D3D3D', a: 1.0 },
				{ x: 0.6073, y: 0.4675, s: 0.084, c: '727272', a: 1.0 },
				{ x: 0.6049, y: 0.4537, s: 0.041, c: '6A6A6A', a: 1.0 },
				{ x: 0.6138, y: 0.8655, s: 0.044, c: '464646', a: 1.0 },
				{ x: 0.6085, y: 0.8705, s: 0.053, c: '666666', a: 1.0 },
				{ x: 0.6117, y: 0.8465, s: 0.068, c: '6F6F6F', a: 1.0 },
				{ x: 0.6148, y: 0.837, s: 0.08, c: '6F6F6F', a: 1.0 },
				{ x: 0.6095, y: 0.8416, s: 0.038, c: '696969', a: 1.0 },
				{ x: 0.615, y: 0.832, s: 0.085, c: '6A6A6A', a: 1.0 },
				{ x: 0.618, y: 0.8368, s: 0.048, c: '6D6D6D', a: 1.0 },
				{ x: 0.6127, y: 0.8183, s: 0.064, c: '6F6F6F', a: 1.0 },
				{ x: 0.6191, y: 0.8083, s: 0.052, c: '717171', a: 1.0 },
				{ x: 0.608, y: 0.813, s: 0.073, c: '6E6E6E', a: 1.0 },
				{ x: 0.609, y: 0.8086, s: 0.053, c: '717171', a: 1.0 },
				{ x: 0.6104, y: 0.7898, s: 0.089, c: '6F6F6F', a: 1.0 },
				{ x: 0.6192, y: 0.7943, s: 0.048, c: '696969', a: 1.0 },
				{ x: 0.6125, y: 0.7844, s: 0.069, c: '676767', a: 1.0 },
				{ x: 0.6136, y: 0.7663, s: 0.055, c: '696969', a: 1.0 },
				{ x: 0.6094, y: 0.7684, s: 0.075, c: '626262', a: 1.0 },
				{ x: 0.6154, y: 0.7607, s: 0.029, c: '494949', a: 1.0 },
				{ x: 0.617, y: 0.7543, s: 0.049, c: '3D3D3D', a: 1.0 },
				{ x: 0.6131, y: 0.7325, s: 0.026, c: '494949', a: 1.0 },
				{ x: 0.6189, y: 0.725, s: 0.062, c: '4E4E4E', a: 1.0 },
				{ x: 0.6067, y: 0.73, s: 0.034, c: '4C4C4C', a: 1.0 },
				{ x: 0.6165, y: 0.709, s: 0.041, c: '454545', a: 1.0 },
				{ x: 0.609, y: 0.47, s: 0.04, c: '585858', a: 1.0 },
				{ x: 0.6101, y: 0.4505, s: 0.045, c: '747474', a: 1.0 },
				{ x: 0.62, y: 0.3216, s: 0.048, c: '696969', a: 1.0 },
				{ x: 0.6111, y: 0.8612, s: 0.075, c: '5C5C5C', a: 1.0 },
				{ x: 0.6129, y: 0.8571, s: 0.066, c: '646464', a: 1.0 },
				{ x: 0.6146, y: 0.8591, s: 0.063, c: '676767', a: 1.0 },
				{ x: 0.6207, y: 0.8395, s: 0.062, c: '6B6B6B', a: 1.0 },
				{ x: 0.6178, y: 0.8355, s: 0.083, c: '686868', a: 1.0 },
				{ x: 0.6106, y: 0.8166, s: 0.038, c: '686868', a: 1.0 },
				{ x: 0.6197, y: 0.8328, s: 0.077, c: '6B6B6B', a: 1.0 },
				{ x: 0.6141, y: 0.8167, s: 0.077, c: '6B6B6B', a: 1.0 },
				{ x: 0.622, y: 0.8091, s: 0.065, c: '6D6D6D', a: 1.0 },
				{ x: 0.611, y: 0.7874, s: 0.05, c: '717171', a: 1.0 },
				{ x: 0.6172, y: 0.7931, s: 0.044, c: '6F6F6F', a: 1.0 },
				{ x: 0.6119, y: 0.7831, s: 0.051, c: '6C6C6C', a: 1.0 },
				{ x: 0.6143, y: 0.7874, s: 0.085, c: '696969', a: 1.0 },
				{ x: 0.6204, y: 0.7689, s: 0.043, c: '6E6E6E', a: 1.0 },
				{ x: 0.6153, y: 0.7594, s: 0.082, c: '6B6B6B', a: 1.0 },
				{ x: 0.6181, y: 0.7635, s: 0.05, c: '545454', a: 1.0 },
				{ x: 0.6106, y: 0.7272, s: 0.035, c: '3F3F3F', a: 1.0 },
				{ x: 0.6187, y: 0.7415, s: 0.028, c: '464646', a: 1.0 },
				{ x: 0.6213, y: 0.723, s: 0.056, c: '464646', a: 1.0 },
				{ x: 0.616, y: 0.727, s: 0.04, c: '404040', a: 1.0 },
				{ x: 0.6219, y: 0.3188, s: 0.048, c: '696969', a: 1.0 },
				{ x: 0.6113, y: 0.2706, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.6227, y: 0.9436, s: 0.033, c: '070707', a: 1.0 },
				{ x: 0.6153, y: 0.8776, s: 0.05, c: '575757', a: 1.0 },
				{ x: 0.6183, y: 0.8681, s: 0.062, c: '656565', a: 1.0 },
				{ x: 0.6259, y: 0.8482, s: 0.071, c: '656565', a: 1.0 },
				{ x: 0.6189, y: 0.8537, s: 0.046, c: '656565', a: 1.0 },
				{ x: 0.6215, y: 0.8442, s: 0.077, c: '666666', a: 1.0 },
				{ x: 0.6162, y: 0.8496, s: 0.038, c: '676767', a: 1.0 },
				{ x: 0.6221, y: 0.8297, s: 0.073, c: '656565', a: 1.0 },
				{ x: 0.6249, y: 0.8202, s: 0.056, c: '616161', a: 1.0 },
				{ x: 0.6196, y: 0.8256, s: 0.05, c: '626262', a: 1.0 },
				{ x: 0.6135, y: 0.8203, s: 0.053, c: '676767', a: 1.0 },
				{ x: 0.6158, y: 0.8042, s: 0.08, c: '6C6C6C', a: 1.0 },
				{ x: 0.6167, y: 0.7963, s: 0.046, c: '717171', a: 1.0 },
				{ x: 0.6265, y: 0.7779, s: 0.08, c: '717171', a: 1.0 },
				{ x: 0.619, y: 0.7802, s: 0.066, c: '6D6D6D', a: 1.0 },
				{ x: 0.62, y: 0.7736, s: 0.084, c: '707070', a: 1.0 },
				{ x: 0.6164, y: 0.7776, s: 0.088, c: '707070', a: 1.0 },
				{ x: 0.6223, y: 0.7562, s: 0.061, c: '5C5C5C', a: 1.0 },
				{ x: 0.6237, y: 0.7499, s: 0.024, c: '3C3C3C', a: 1.0 },
				{ x: 0.6196, y: 0.736, s: 0.048, c: '404040', a: 1.0 },
				{ x: 0.621, y: 0.7154, s: 0.043, c: '404040', a: 1.0 },
				{ x: 0.617, y: 0.8653, s: 0.044, c: '4B4B4B', a: 1.0 },
				{ x: 0.6266, y: 0.8705, s: 0.063, c: '5F5F5F', a: 1.0 },
				{ x: 0.6177, y: 0.8382, s: 0.07, c: '646464', a: 1.0 },
				{ x: 0.6238, y: 0.8418, s: 0.047, c: '626262', a: 1.0 },
				{ x: 0.62, y: 0.8215, s: 0.066, c: '5F5F5F', a: 1.0 },
				{ x: 0.6217, y: 0.7979, s: 0.063, c: '626262', a: 1.0 },
				{ x: 0.6245, y: 0.8134, s: 0.056, c: '636363', a: 1.0 },
				{ x: 0.6173, y: 0.7946, s: 0.069, c: '696969', a: 1.0 },
				{ x: 0.6251, y: 0.7981, s: 0.041, c: '707070', a: 1.0 },
				{ x: 0.6279, y: 0.7896, s: 0.086, c: '737373', a: 1.0 },
				{ x: 0.6207, y: 0.7708, s: 0.069, c: '6F6F6F', a: 1.0 },
				{ x: 0.6285, y: 0.7743, s: 0.078, c: '6F6F6F', a: 1.0 },
				{ x: 0.618, y: 0.7659, s: 0.078, c: '707070', a: 1.0 },
				{ x: 0.6241, y: 0.7695, s: 0.072, c: '626262', a: 1.0 },
				{ x: 0.6186, y: 0.7506, s: 0.043, c: '484848', a: 1.0 },
				{ x: 0.6214, y: 0.7006, s: 0.031, c: '4E4E4E', a: 1.0 },
				{ x: 0.6326, y: 0.8624, s: 0.049, c: '575757', a: 1.0 },
				{ x: 0.6252, y: 0.8674, s: 0.063, c: '5D5D5D', a: 1.0 },
				{ x: 0.628, y: 0.847, s: 0.056, c: '5F5F5F', a: 1.0 },
				{ x: 0.6225, y: 0.8386, s: 0.071, c: '606060', a: 1.0 },
				{ x: 0.6287, y: 0.8437, s: 0.054, c: '616161', a: 1.0 },
				{ x: 0.6322, y: 0.8185, s: 0.045, c: '5B5B5B', a: 1.0 },
				{ x: 0.6216, y: 0.8234, s: 0.042, c: '616161', a: 1.0 },
				{ x: 0.6294, y: 0.8154, s: 0.055, c: '606060', a: 1.0 },
				{ x: 0.6221, y: 0.7947, s: 0.05, c: '626262', a: 1.0 },
				{ x: 0.6249, y: 0.7996, s: 0.04, c: '676767', a: 1.0 },
				{ x: 0.6255, y: 0.7947, s: 0.071, c: '717171', a: 1.0 },
				{ x: 0.6283, y: 0.7748, s: 0.076, c: '707070', a: 1.0 },
				{ x: 0.6221, y: 0.7675, s: 0.085, c: '6D6D6D', a: 1.0 },
				{ x: 0.6293, y: 0.7715, s: 0.062, c: '696969', a: 1.0 },
				{ x: 0.6315, y: 0.7509, s: 0.064, c: '626262', a: 1.0 },
				{ x: 0.6253, y: 0.7667, s: 0.033, c: '4F4F4F', a: 1.0 },
				{ x: 0.6325, y: 0.7059, s: 0.083, c: '676767', a: 1.0 },
				{ x: 0.6215, y: 0.3289, s: 0.062, c: '6F6F6F', a: 1.0 },
				{ x: 0.6287, y: 0.2963, s: 0.062, c: '6B6B6B', a: 1.0 },
				{ x: 0.6259, y: 0.8644, s: 0.032, c: '515151', a: 1.0 },
				{ x: 0.6281, y: 0.8558, s: 0.04, c: '5B5B5B', a: 1.0 },
				{ x: 0.6352, y: 0.8596, s: 0.054, c: '5D5D5D', a: 1.0 },
				{ x: 0.6241, y: 0.8405, s: 0.064, c: '5D5D5D', a: 1.0 },
				{ x: 0.6313, y: 0.8324, s: 0.074, c: '5D5D5D', a: 1.0 },
				{ x: 0.6251, y: 0.8356, s: 0.033, c: '5A5A5A', a: 1.0 },
				{ x: 0.6273, y: 0.8157, s: 0.055, c: '575757', a: 1.0 },
				{ x: 0.6285, y: 0.8119, s: 0.038, c: '5E5E5E', a: 1.0 },
				{ x: 0.6307, y: 0.8158, s: 0.063, c: '5F5F5F', a: 1.0 },
				{ x: 0.6245, y: 0.8085, s: 0.06, c: '606060', a: 1.0 },
				{ x: 0.6317, y: 0.7885, s: 0.072, c: '646464', a: 1.0 },
				{ x: 0.6339, y: 0.7917, s: 0.041, c: '6B6B6B', a: 1.0 },
				{ x: 0.6278, y: 0.7837, s: 0.086, c: '6B6B6B', a: 1.0 },
				{ x: 0.6238, y: 0.7685, s: 0.087, c: '6E6E6E', a: 1.0 },
				{ x: 0.6266, y: 0.7644, s: 0.058, c: '626262', a: 1.0 },
				{ x: 0.6271, y: 0.7441, s: 0.047, c: '555555', a: 1.0 },
				{ x: 0.6343, y: 0.7245, s: 0.071, c: '5A5A5A', a: 1.0 },
				{ x: 0.6298, y: 0.7043, s: 0.05, c: '8B8B8B', a: 1.0 },
				{ x: 0.6304, y: 0.3277, s: 0.076, c: '767676', a: 1.0 },
				{ x: 0.6243, y: 0.2956, s: 0.093, c: '767676', a: 1.0 },
				{ x: 0.6364, y: 0.8748, s: 0.035, c: '3E3E3E', a: 1.0 },
				{ x: 0.637, y: 0.8549, s: 0.056, c: '555555', a: 1.0 },
				{ x: 0.631, y: 0.8592, s: 0.045, c: '595959', a: 1.0 },
				{ x: 0.6396, y: 0.8508, s: 0.037, c: '5B5B5B', a: 1.0 },
				{ x: 0.627, y: 0.8314, s: 0.075, c: '5C5C5C', a: 1.0 },
				{ x: 0.6357, y: 0.8349, s: 0.046, c: '5A5A5A', a: 1.0 },
				{ x: 0.6298, y: 0.8273, s: 0.05, c: '585858', a: 1.0 },
				{ x: 0.63, y: 0.8309, s: 0.047, c: '595959', a: 1.0 },
				{ x: 0.6391, y: 0.8113, s: 0.052, c: '5B5B5B', a: 1.0 },
				{ x: 0.6327, y: 0.8028, s: 0.055, c: '5C5C5C', a: 1.0 },
				{ x: 0.6334, y: 0.8071, s: 0.068, c: '5D5D5D', a: 1.0 },
				{ x: 0.6288, y: 0.7876, s: 0.037, c: '616161', a: 1.0 },
				{ x: 0.6361, y: 0.803, s: 0.061, c: '646464', a: 1.0 },
				{ x: 0.6369, y: 0.7834, s: 0.055, c: '666666', a: 1.0 },
				{ x: 0.6282, y: 0.759, s: 0.064, c: '636363', a: 1.0 },
				{ x: 0.6356, y: 0.7632, s: 0.047, c: '5E5E5E', a: 1.0 },
				{ x: 0.6292, y: 0.7549, s: 0.034, c: '565656', a: 1.0 },
				{ x: 0.6317, y: 0.7592, s: 0.054, c: '434343', a: 1.0 },
				{ x: 0.6386, y: 0.7098, s: 0.046, c: '7E7E7E', a: 1.0 },
				{ x: 0.6325, y: 0.7014, s: 0.099, c: '7E7E7E', a: 1.0 },
				{ x: 0.6349, y: 0.3247, s: 0.049, c: '666666', a: 1.0 },
				{ x: 0.6286, y: 0.2866, s: 0.056, c: '636363', a: 1.0 },
				{ x: 0.636, y: 0.3027, s: 0.06, c: '6A6A6A', a: 1.0 },
				{ x: 0.6413, y: 0.8699, s: 0.032, c: '3E3E3E', a: 1.0 },
				{ x: 0.6354, y: 0.8619, s: 0.064, c: '505050', a: 1.0 },
				{ x: 0.6374, y: 0.842, s: 0.057, c: '535353', a: 1.0 },
				{ x: 0.6314, y: 0.846, s: 0.035, c: '555555', a: 1.0 },
				{ x: 0.6384, y: 0.8381, s: 0.055, c: '585858', a: 1.0 },
				{ x: 0.6407, y: 0.8419, s: 0.066, c: '575757', a: 1.0 },
				{ x: 0.6347, y: 0.822, s: 0.047, c: '555555', a: 1.0 },
				{ x: 0.6417, y: 0.8141, s: 0.043, c: '555555', a: 1.0 },
				{ x: 0.6305, y: 0.818, s: 0.051, c: '585858', a: 1.0 },
				{ x: 0.6377, y: 0.7981, s: 0.07, c: '5A5A5A', a: 1.0 },
				{ x: 0.6319, y: 0.814, s: 0.037, c: '5A5A5A', a: 1.0 },
				{ x: 0.6341, y: 0.7941, s: 0.065, c: '5B5B5B', a: 1.0 },
				{ x: 0.6409, y: 0.798, s: 0.049, c: '5F5F5F', a: 1.0 },
				{ x: 0.6364, y: 0.79, s: 0.059, c: '606060', a: 1.0 },
				{ x: 0.6373, y: 0.7701, s: 0.06, c: '616161', a: 1.0 },
				{ x: 0.6309, y: 0.7741, s: 0.063, c: '616161', a: 1.0 },
				{ x: 0.6398, y: 0.7661, s: 0.053, c: '5E5E5E', a: 1.0 },
				{ x: 0.6407, y: 0.77, s: 0.046, c: '585858', a: 1.0 },
				{ x: 0.6345, y: 0.7501, s: 0.05, c: '525252', a: 1.0 },
				{ x: 0.643, y: 0.742, s: 0.053, c: '464646', a: 1.0 },
				{ x: 0.6301, y: 0.7221, s: 0.037, c: '535353', a: 1.0 },
				{ x: 0.6377, y: 0.7141, s: 0.078, c: '7E7E7E', a: 1.0 },
				{ x: 0.6332, y: 0.3076, s: 0.051, c: '6A6A6A', a: 1.0 },
				{ x: 0.6367, y: 0.9464, s: 0.069, c: '585858', a: 1.0 },
				{ x: 0.6444, y: 0.9503, s: 0.057, c: '818181', a: 1.0 },
				{ x: 0.6399, y: 0.9243, s: 0.063, c: '5D5D5D', a: 1.0 },
				{ x: 0.64, y: 0.8806, s: 0.031, c: '363636', a: 1.0 },
				{ x: 0.6356, y: 0.8607, s: 0.036, c: '4A4A4A', a: 1.0 },
				{ x: 0.6432, y: 0.8646, s: 0.05, c: '4D4D4D', a: 1.0 },
				{ x: 0.6437, y: 0.8567, s: 0.046, c: '555555', a: 1.0 },
				{ x: 0.6388, y: 0.8416, s: 0.061, c: '555555', a: 1.0 },
				{ x: 0.646, y: 0.8496, s: 0.05, c: '535353', a: 1.0 },
				{ x: 0.6336, y: 0.8218, s: 0.038, c: '535353', a: 1.0 },
				{ x: 0.6421, y: 0.8298, s: 0.054, c: '525252', a: 1.0 },
				{ x: 0.636, y: 0.814, s: 0.066, c: '535353', a: 1.0 },
				{ x: 0.6457, y: 0.8182, s: 0.049, c: '575757', a: 1.0 },
				{ x: 0.6392, y: 0.8024, s: 0.059, c: '555555', a: 1.0 },
				{ x: 0.6415, y: 0.7985, s: 0.061, c: '585858', a: 1.0 },
				{ x: 0.6357, y: 0.7824, s: 0.069, c: '5C5C5C', a: 1.0 },
				{ x: 0.6427, y: 0.7904, s: 0.032, c: '5A5A5A', a: 1.0 },
				{ x: 0.6447, y: 0.7865, s: 0.069, c: '5B5B5B', a: 1.0 },
				{ x: 0.6391, y: 0.7707, s: 0.07, c: '5A5A5A', a: 1.0 },
				{ x: 0.6461, y: 0.7787, s: 0.044, c: '585858', a: 1.0 },
				{ x: 0.6347, y: 0.7511, s: 0.044, c: '525252', a: 1.0 },
				{ x: 0.6418, y: 0.759, s: 0.059, c: '4D4D4D', a: 1.0 },
				{ x: 0.6362, y: 0.7431, s: 0.055, c: '464646', a: 1.0 },
				{ x: 0.6381, y: 0.7392, s: 0.036, c: '3C3C3C', a: 1.0 },
				{ x: 0.6451, y: 0.7293, s: 0.046, c: '666666', a: 1.0 },
				{ x: 0.6338, y: 0.3147, s: 0.066, c: '626262', a: 1.0 },
				{ x: 0.6416, y: 0.3108, s: 0.054, c: '6A6A6A', a: 1.0 },
				{ x: 0.6352, y: 0.295, s: 0.057, c: '636363', a: 1.0 },
				{ x: 0.6483, y: 0.9498, s: 0.047, c: '5D5D5D', a: 1.0 },
				{ x: 0.6419, y: 0.9578, s: 0.101, c: '818181', a: 1.0 },
				{ x: 0.6439, y: 0.8706, s: 0.029, c: '2C2C2C', a: 1.0 },
				{ x: 0.6376, y: 0.8786, s: 0.022, c: '363636', a: 1.0 },
				{ x: 0.6454, y: 0.8627, s: 0.029, c: '4A4A4A', a: 1.0 },
				{ x: 0.6474, y: 0.8587, s: 0.03, c: '2C2C2C', a: 1.0 },
				{ x: 0.641, y: 0.8668, s: 0.036, c: '464646', a: 1.0 },
				{ x: 0.6497, y: 0.851, s: 0.042, c: '4D4D4D', a: 1.0 },
				{ x: 0.6373, y: 0.8469, s: 0.047, c: '505050', a: 1.0 },
				{ x: 0.6396, y: 0.8391, s: 0.065, c: '525252', a: 1.0 },
				{ x: 0.6408, y: 0.8355, s: 0.041, c: '535353', a: 1.0 },
				{ x: 0.6431, y: 0.8271, s: 0.049, c: '535353', a: 1.0 },
				{ x: 0.6434, y: 0.7997, s: 0.06, c: '535353', a: 1.0 },
				{ x: 0.6379, y: 0.8073, s: 0.063, c: '525252', a: 1.0 },
				{ x: 0.6465, y: 0.8038, s: 0.061, c: '555555', a: 1.0 },
				{ x: 0.6412, y: 0.796, s: 0.035, c: '555555', a: 1.0 },
				{ x: 0.6494, y: 0.768, s: 0.033, c: '535353', a: 1.0 },
				{ x: 0.6374, y: 0.7764, s: 0.054, c: '555555', a: 1.0 },
				{ x: 0.6454, y: 0.7602, s: 0.055, c: '535353', a: 1.0 },
				{ x: 0.6392, y: 0.756, s: 0.032, c: '505050', a: 1.0 },
				{ x: 0.6405, y: 0.7643, s: 0.03, c: '4A4A4A', a: 1.0 },
				{ x: 0.6486, y: 0.7483, s: 0.054, c: '434343', a: 1.0 },
				{ x: 0.6433, y: 0.7447, s: 0.023, c: '3C3C3C', a: 1.0 },
				{ x: 0.6439, y: 0.7107, s: 0.079, c: '707070', a: 1.0 },
				{ x: 0.65, y: 0.8838, s: 0.03, c: '2A2A2A', a: 1.0 },
				{ x: 0.6505, y: 0.8914, s: 0.03, c: '393939', a: 1.0 },
				{ x: 0.6532, y: 0.8719, s: 0.018, c: '2F2F2F', a: 1.0 },
				{ x: 0.6412, y: 0.8558, s: 0.033, c: '242424', a: 1.0 },
				{ x: 0.6484, y: 0.8523, s: 0.043, c: '383838', a: 1.0 },
				{ x: 0.643, y: 0.8599, s: 0.049, c: '404040', a: 1.0 },
				{ x: 0.6445, y: 0.8443, s: 0.04, c: '464646', a: 1.0 },
				{ x: 0.6517, y: 0.84, s: 0.038, c: '4C4C4C', a: 1.0 },
				{ x: 0.6464, y: 0.8246, s: 0.031, c: '4F4F4F', a: 1.0 },
				{ x: 0.6477, y: 0.8323, s: 0.034, c: '505050', a: 1.0 },
				{ x: 0.6424, y: 0.8283, s: 0.061, c: '4F4F4F', a: 1.0 },
				{ x: 0.651, y: 0.8202, s: 0.064, c: '515151', a: 1.0 },
				{ x: 0.6457, y: 0.7924, s: 0.054, c: '525252', a: 1.0 },
				{ x: 0.647, y: 0.8012, s: 0.047, c: '535353', a: 1.0 },
				{ x: 0.6409, y: 0.7855, s: 0.061, c: '535353', a: 1.0 },
				{ x: 0.649, y: 0.7809, s: 0.059, c: '515151', a: 1.0 },
				{ x: 0.6442, y: 0.7738, s: 0.046, c: '525252', a: 1.0 },
				{ x: 0.6522, y: 0.7699, s: 0.036, c: '4F4F4F', a: 1.0 },
				{ x: 0.6402, y: 0.753, s: 0.033, c: '4C4C4C', a: 1.0 },
				{ x: 0.6483, y: 0.7618, s: 0.045, c: '474747', a: 1.0 },
				{ x: 0.6422, y: 0.7579, s: 0.035, c: '404040', a: 1.0 },
				{ x: 0.6434, y: 0.7413, s: 0.041, c: '3E3E3E', a: 1.0 },
				{ x: 0.6516, y: 0.7374, s: 0.029, c: '4A4A4A', a: 1.0 },
				{ x: 0.6456, y: 0.7105, s: 0.081, c: '646464', a: 1.0 },
				{ x: 0.6501, y: 0.9459, s: 0.042, c: '757575', a: 1.0 },
				{ x: 0.645, y: 0.942, s: 0.04, c: '303030', a: 1.0 },
				{ x: 0.6528, y: 0.9507, s: 0.041, c: '404040', a: 1.0 },
				{ x: 0.6535, y: 0.9341, s: 0.036, c: '404040', a: 1.0 },
				{ x: 0.6479, y: 0.9302, s: 0.038, c: '141414', a: 1.0 },
				{ x: 0.6562, y: 0.9151, s: 0.021, c: '181818', a: 1.0 },
				{ x: 0.644, y: 0.9052, s: 0.039, c: '181818', a: 1.0 },
				{ x: 0.6514, y: 0.9124, s: 0.026, c: '262626', a: 1.0 },
				{ x: 0.6458, y: 0.8966, s: 0.025, c: '303030', a: 1.0 },
				{ x: 0.6474, y: 0.8935, s: 0.039, c: '303030', a: 1.0 },
				{ x: 0.6548, y: 0.8777, s: 0.03, c: '252525', a: 1.0 },
				{ x: 0.6492, y: 0.8849, s: 0.037, c: '353535', a: 1.0 },
				{ x: 0.6508, y: 0.8816, s: 0.04, c: '2B2B2B', a: 1.0 },
				{ x: 0.6453, y: 0.8658, s: 0.034, c: '383838', a: 1.0 },
				{ x: 0.6527, y: 0.8731, s: 0.025, c: '393939', a: 1.0 },
				{ x: 0.6538, y: 0.8336, s: 0.052, c: '404040', a: 1.0 },
				{ x: 0.6487, y: 0.842, s: 0.029, c: '464646', a: 1.0 },
				{ x: 0.6565, y: 0.8266, s: 0.046, c: '4A4A4A', a: 1.0 },
				{ x: 0.6438, y: 0.8216, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.652, y: 0.8299, s: 0.033, c: '4D4D4D', a: 1.0 },
				{ x: 0.6465, y: 0.8145, s: 0.046, c: '4E4E4E', a: 1.0 },
				{ x: 0.6472, y: 0.8096, s: 0.058, c: '505050', a: 1.0 },
				{ x: 0.6551, y: 0.7941, s: 0.036, c: '515151', a: 1.0 },
				{ x: 0.65, y: 0.8025, s: 0.048, c: '525252', a: 1.0 },
				{ x: 0.6452, y: 0.7821, s: 0.044, c: '4F4F4F', a: 1.0 },
				{ x: 0.653, y: 0.7905, s: 0.048, c: '505050', a: 1.0 },
				{ x: 0.6544, y: 0.7631, s: 0.041, c: '4D4D4D', a: 1.0 },
				{ x: 0.6486, y: 0.7716, s: 0.043, c: '4D4D4D', a: 1.0 },
				{ x: 0.6566, y: 0.7546, s: 0.053, c: '4A4A4A', a: 1.0 },
				{ x: 0.6443, y: 0.7511, s: 0.026, c: '464646', a: 1.0 },
				{ x: 0.6523, y: 0.7597, s: 0.052, c: '434343', a: 1.0 },
				{ x: 0.6465, y: 0.7249, s: 0.058, c: '545454', a: 1.0 },
				{ x: 0.6478, y: 0.7213, s: 0.059, c: '5C5C5C', a: 1.0 },
				{ x: 0.6588, y: 0.9582, s: 0.094, c: 'A1A1A1', a: 1.0 },
				{ x: 0.6468, y: 0.9532, s: 0.105, c: 'A1A1A1', a: 1.0 },
				{ x: 0.6546, y: 0.9377, s: 0.075, c: '6A6A6A', a: 1.0 },
				{ x: 0.6488, y: 0.9461, s: 0.031, c: '4E4E4E', a: 1.0 },
				{ x: 0.6502, y: 0.9175, s: 0.034, c: '202020', a: 1.0 },
				{ x: 0.6524, y: 0.9105, s: 0.031, c: '101010', a: 1.0 },
				{ x: 0.6534, y: 0.907, s: 0.032, c: '1C1C1C', a: 1.0 },
				{ x: 0.6481, y: 0.9138, s: 0.027, c: '111111', a: 1.0 },
				{ x: 0.6556, y: 0.8983, s: 0.022, c: '161616', a: 1.0 },
				{ x: 0.6571, y: 0.8947, s: 0.038, c: '2A2A2A', a: 1.0 },
				{ x: 0.6514, y: 0.8734, s: 0.028, c: '323232', a: 1.0 },
				{ x: 0.659, y: 0.8801, s: 0.02, c: '262626', a: 1.0 },
				{ x: 0.647, y: 0.8777, s: 0.026, c: '2B2B2B', a: 1.0 },
				{ x: 0.6546, y: 0.8602, s: 0.027, c: '323232', a: 1.0 },
				{ x: 0.6493, y: 0.8444, s: 0.053, c: '454545', a: 1.0 },
				{ x: 0.6583, y: 0.8246, s: 0.04, c: '4C4C4C', a: 1.0 },
				{ x: 0.6526, y: 0.8223, s: 0.055, c: '4E4E4E', a: 1.0 },
				{ x: 0.6539, y: 0.8065, s: 0.059, c: '4C4C4C', a: 1.0 },
				{ x: 0.6482, y: 0.813, s: 0.053, c: '4D4D4D', a: 1.0 },
				{ x: 0.6559, y: 0.7868, s: 0.046, c: '4F4F4F', a: 1.0 },
				{ x: 0.6572, y: 0.7933, s: 0.056, c: '4E4E4E', a: 1.0 },
				{ x: 0.6515, y: 0.7772, s: 0.058, c: '4A4A4A', a: 1.0 },
				{ x: 0.6595, y: 0.7748, s: 0.038, c: '4C4C4C', a: 1.0 },
				{ x: 0.6472, y: 0.7813, s: 0.052, c: '4C4C4C', a: 1.0 },
				{ x: 0.655, y: 0.7655, s: 0.035, c: '4A4A4A', a: 1.0 },
				{ x: 0.6495, y: 0.7631, s: 0.029, c: '484848', a: 1.0 },
				{ x: 0.6507, y: 0.7458, s: 0.034, c: '434343', a: 1.0 },
				{ x: 0.6585, y: 0.7553, s: 0.04, c: '434343', a: 1.0 },
				{ x: 0.6529, y: 0.7513, s: 0.048, c: '3E3E3E', a: 1.0 },
				{ x: 0.654, y: 0.7221, s: 0.043, c: '747474', a: 1.0 },
				{ x: 0.6608, y: 0.9341, s: 0.051, c: '6A6A6A', a: 1.0 },
				{ x: 0.6552, y: 0.9228, s: 0.037, c: '1B1B1B', a: 1.0 },
				{ x: 0.6508, y: 0.9104, s: 0.031, c: '1B1B1B', a: 1.0 },
				{ x: 0.6586, y: 0.905, s: 0.019, c: '303030', a: 1.0 },
				{ x: 0.6531, y: 0.8907, s: 0.039, c: '1B1B1B', a: 1.0 },
				{ x: 0.6621, y: 0.8872, s: 0.046, c: '3C3C3C', a: 1.0 },
				{ x: 0.6565, y: 0.8669, s: 0.039, c: '262626', a: 1.0 },
				{ x: 0.6577, y: 0.8746, s: 0.027, c: '272727', a: 1.0 },
				{ x: 0.6521, y: 0.822, s: 0.034, c: '414141', a: 1.0 },
				{ x: 0.6611, y: 0.8143, s: 0.027, c: '4A4A4A', a: 1.0 },
				{ x: 0.6556, y: 0.81, s: 0.061, c: '4B4B4B', a: 1.0 },
				{ x: 0.6567, y: 0.8199, s: 0.029, c: '4B4B4B', a: 1.0 },
				{ x: 0.6511, y: 0.8022, s: 0.051, c: '4B4B4B', a: 1.0 },
				{ x: 0.6589, y: 0.7981, s: 0.055, c: '4D4D4D', a: 1.0 },
				{ x: 0.6545, y: 0.7902, s: 0.032, c: '494949', a: 1.0 },
				{ x: 0.6624, y: 0.7882, s: 0.059, c: '494949', a: 1.0 },
				{ x: 0.6502, y: 0.7721, s: 0.034, c: '4A4A4A', a: 1.0 },
				{ x: 0.658, y: 0.779, s: 0.045, c: '484848', a: 1.0 },
				{ x: 0.6525, y: 0.7523, s: 0.044, c: '454545', a: 1.0 },
				{ x: 0.6536, y: 0.7593, s: 0.04, c: '434343', a: 1.0 },
				{ x: 0.6587, y: 0.7431, s: 0.039, c: '414141', a: 1.0 },
				{ x: 0.6509, y: 0.7286, s: 0.05, c: '4A4A4A', a: 1.0 },
				{ x: 0.6631, y: 0.7355, s: 0.05, c: '7E7E7E', a: 1.0 },
				{ x: 0.6586, y: 0.9553, s: 0.036, c: '4F4F4F', a: 1.0 },
				{ x: 0.6642, y: 0.9376, s: 0.111, c: 'CBCBCB', a: 1.0 },
				{ x: 0.6551, y: 0.9431, s: 0.021, c: '343434', a: 1.0 },
				{ x: 0.6607, y: 0.9262, s: 0.036, c: '222222', a: 1.0 },
				{ x: 0.6652, y: 0.9075, s: 0.026, c: '3D3D3D', a: 1.0 },
				{ x: 0.6574, y: 0.9143, s: 0.058, c: '4A4A4A', a: 1.0 },
				{ x: 0.6562, y: 0.9116, s: 0.019, c: '2F2F2F', a: 1.0 },
				{ x: 0.6617, y: 0.8887, s: 0.038, c: '202020', a: 1.0 },
				{ x: 0.6539, y: 0.8964, s: 0.03, c: '202020', a: 1.0 },
				{ x: 0.6661, y: 0.8704, s: 0.035, c: '353535', a: 1.0 },
				{ x: 0.6583, y: 0.8765, s: 0.032, c: '242424', a: 1.0 },
				{ x: 0.6627, y: 0.8582, s: 0.04, c: '303030', a: 1.0 },
				{ x: 0.6549, y: 0.8647, s: 0.038, c: '222222', a: 1.0 },
				{ x: 0.6593, y: 0.8284, s: 0.044, c: '454545', a: 1.0 },
				{ x: 0.6648, y: 0.8111, s: 0.055, c: '464646', a: 1.0 },
				{ x: 0.657, y: 0.8213, s: 0.043, c: '4B4B4B', a: 1.0 },
				{ x: 0.6559, y: 0.816, s: 0.047, c: '4D4D4D', a: 1.0 },
				{ x: 0.6614, y: 0.7994, s: 0.037, c: '4B4B4B', a: 1.0 },
				{ x: 0.658, y: 0.79, s: 0.053, c: '494949', a: 1.0 },
				{ x: 0.6636, y: 0.7731, s: 0.039, c: '474747', a: 1.0 },
				{ x: 0.6624, y: 0.7684, s: 0.051, c: '474747', a: 1.0 },
				{ x: 0.6546, y: 0.778, s: 0.039, c: '464646', a: 1.0 },
				{ x: 0.6601, y: 0.7614, s: 0.038, c: '444444', a: 1.0 },
				{ x: 0.6591, y: 0.7561, s: 0.031, c: '434343', a: 1.0 },
				{ x: 0.6644, y: 0.7424, s: 0.05, c: '404040', a: 1.0 },
				{ x: 0.6568, y: 0.749, s: 0.024, c: '404040', a: 1.0 },
				{ x: 0.6555, y: 0.7383, s: 0.062, c: '4E4E4E', a: 1.0 },
				{ x: 0.6612, y: 0.724, s: 0.059, c: '818181', a: 1.0 },
				{ x: 0.6568, y: 0.9408, s: 0.106, c: 'DADADA', a: 1.0 },
				{ x: 0.6688, y: 0.9503, s: 0.146, c: 'E6E6E6', a: 1.0 },
				{ x: 0.6612, y: 0.9337, s: 0.16, c: 'DADADA', a: 1.0 },
				{ x: 0.6599, y: 0.9314, s: 0.07, c: 'A8A8A8', a: 1.0 },
				{ x: 0.6656, y: 0.9384, s: 0.058, c: '646464', a: 1.0 },
				{ x: 0.6575, y: 0.9212, s: 0.066, c: '646464', a: 1.0 },
				{ x: 0.6699, y: 0.9195, s: 0.045, c: '4A4A4A', a: 1.0 },
				{ x: 0.6619, y: 0.9022, s: 0.041, c: '575757', a: 1.0 },
				{ x: 0.6676, y: 0.9094, s: 0.031, c: '202020', a: 1.0 },
				{ x: 0.6586, y: 0.8727, s: 0.025, c: '323232', a: 1.0 },
				{ x: 0.663, y: 0.8536, s: 0.021, c: '323232', a: 1.0 },
				{ x: 0.6687, y: 0.8606, s: 0.052, c: '444444', a: 1.0 },
				{ x: 0.6607, y: 0.8467, s: 0.044, c: '3B3B3B', a: 1.0 },
				{ x: 0.6598, y: 0.8297, s: 0.033, c: '3F3F3F', a: 1.0 },
				{ x: 0.6651, y: 0.8366, s: 0.042, c: '464646', a: 1.0 },
				{ x: 0.6575, y: 0.8107, s: 0.039, c: '434343', a: 1.0 },
				{ x: 0.6695, y: 0.8177, s: 0.055, c: '454545', a: 1.0 },
				{ x: 0.6617, y: 0.8008, s: 0.028, c: '4D4D4D', a: 1.0 },
				{ x: 0.6674, y: 0.7988, s: 0.053, c: '4B4B4B', a: 1.0 },
				{ x: 0.6661, y: 0.8057, s: 0.06, c: '4B4B4B', a: 1.0 },
				{ x: 0.6584, y: 0.7888, s: 0.033, c: '4B4B4B', a: 1.0 },
				{ x: 0.6638, y: 0.7868, s: 0.042, c: '494949', a: 1.0 },
				{ x: 0.6629, y: 0.7698, s: 0.05, c: '474747', a: 1.0 },
				{ x: 0.6682, y: 0.7797, s: 0.055, c: '464646', a: 1.0 },
				{ x: 0.6606, y: 0.7746, s: 0.04, c: '464646', a: 1.0 },
				{ x: 0.6595, y: 0.758, s: 0.033, c: '444444', a: 1.0 },
				{ x: 0.6573, y: 0.7389, s: 0.039, c: '414141', a: 1.0 },
				{ x: 0.6696, y: 0.7458, s: 0.034, c: '424242', a: 1.0 },
				{ x: 0.6613, y: 0.7319, s: 0.041, c: '464646', a: 1.0 },
				{ x: 0.6668, y: 0.7268, s: 0.045, c: '5E5E5E', a: 1.0 },
				{ x: 0.666, y: 0.7337, s: 0.091, c: '818181', a: 1.0 },
				{ x: 0.6667, y: 0.9361, s: 0.054, c: '757575', a: 1.0 },
				{ x: 0.6623, y: 0.9339, s: 0.025, c: '222222', a: 1.0 },
				{ x: 0.6682, y: 0.899, s: 0.029, c: '3D3D3D', a: 1.0 },
				{ x: 0.6604, y: 0.9036, s: 0.023, c: '2F2F2F', a: 1.0 },
				{ x: 0.6721, y: 0.8848, s: 0.039, c: '363636', a: 1.0 },
				{ x: 0.6643, y: 0.8839, s: 0.032, c: '181818', a: 1.0 },
				{ x: 0.6703, y: 0.8859, s: 0.021, c: '323232', a: 1.0 },
				{ x: 0.6692, y: 0.8609, s: 0.034, c: '292929', a: 1.0 },
				{ x: 0.661, y: 0.86, s: 0.041, c: '3E3E3E', a: 1.0 },
				{ x: 0.6669, y: 0.8382, s: 0.041, c: '3F3F3F', a: 1.0 },
				{ x: 0.6657, y: 0.8432, s: 0.049, c: '3F3F3F', a: 1.0 },
				{ x: 0.6697, y: 0.8266, s: 0.031, c: '454545', a: 1.0 },
				{ x: 0.6624, y: 0.8316, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.6663, y: 0.8149, s: 0.045, c: '4C4C4C', a: 1.0 },
				{ x: 0.6718, y: 0.7958, s: 0.033, c: '4B4B4B', a: 1.0 },
				{ x: 0.6644, y: 0.7919, s: 0.03, c: '4C4C4C', a: 1.0 },
				{ x: 0.6629, y: 0.8029, s: 0.06, c: '4B4B4B', a: 1.0 },
				{ x: 0.6685, y: 0.7842, s: 0.027, c: '4A4A4A', a: 1.0 },
				{ x: 0.661, y: 0.7802, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.6732, y: 0.7674, s: 0.037, c: '4B4B4B', a: 1.0 },
				{ x: 0.6651, y: 0.7635, s: 0.04, c: '494949', a: 1.0 },
				{ x: 0.6704, y: 0.7684, s: 0.037, c: '494949', a: 1.0 },
				{ x: 0.6699, y: 0.7556, s: 0.054, c: '464646', a: 1.0 },
				{ x: 0.6619, y: 0.7517, s: 0.025, c: '454545', a: 1.0 },
				{ x: 0.6672, y: 0.7328, s: 0.039, c: '464646', a: 1.0 },
				{ x: 0.6666, y: 0.7438, s: 0.063, c: '4E4E4E', a: 1.0 },
				{ x: 0.6639, y: 0.7212, s: 0.07, c: '717171', a: 1.0 },
				{ x: 0.6626, y: 0.4522, s: 0.031, c: '333333', a: 1.0 },
				{ x: 0.6687, y: 0.4245, s: 0.027, c: '3E3E3E', a: 1.0 },
				{ x: 0.6607, y: 0.4296, s: 0.022, c: '363636', a: 1.0 },
				{ x: 0.6741, y: 0.9378, s: 0.04, c: '282828', a: 1.0 },
				{ x: 0.6727, y: 0.9364, s: 0.051, c: '434343', a: 1.0 },
				{ x: 0.6646, y: 0.918, s: 0.114, c: 'B3B3B3', a: 1.0 },
				{ x: 0.6707, y: 0.9258, s: 0.056, c: '525252', a: 1.0 },
				{ x: 0.6694, y: 0.9252, s: 0.032, c: '151515', a: 1.0 },
				{ x: 0.6747, y: 0.906, s: 0.056, c: '575757', a: 1.0 },
				{ x: 0.6667, y: 0.9143, s: 0.046, c: '515151', a: 1.0 },
				{ x: 0.6662, y: 0.8893, s: 0.064, c: '6E6E6E', a: 1.0 },
				{ x: 0.6715, y: 0.894, s: 0.027, c: '343434', a: 1.0 },
				{ x: 0.6635, y: 0.8786, s: 0.024, c: '2A2A2A', a: 1.0 },
				{ x: 0.6762, y: 0.8773, s: 0.034, c: '3C3C3C', a: 1.0 },
				{ x: 0.6682, y: 0.8857, s: 0.028, c: '323232', a: 1.0 },
				{ x: 0.6735, y: 0.8606, s: 0.02, c: '2B2B2B', a: 1.0 },
				{ x: 0.6721, y: 0.86, s: 0.046, c: '393939', a: 1.0 },
				{ x: 0.6649, y: 0.8379, s: 0.026, c: '484848', a: 1.0 },
				{ x: 0.6703, y: 0.8432, s: 0.053, c: '444444', a: 1.0 },
				{ x: 0.6689, y: 0.8419, s: 0.051, c: '454545', a: 1.0 },
				{ x: 0.6742, y: 0.826, s: 0.043, c: '454545', a: 1.0 },
				{ x: 0.6671, y: 0.8315, s: 0.05, c: '484848', a: 1.0 },
				{ x: 0.6651, y: 0.8063, s: 0.029, c: '4A4A4A', a: 1.0 },
				{ x: 0.6716, y: 0.8146, s: 0.055, c: '4B4B4B', a: 1.0 },
				{ x: 0.6638, y: 0.7955, s: 0.041, c: '4C4C4C', a: 1.0 },
				{ x: 0.6752, y: 0.7919, s: 0.04, c: '4D4D4D', a: 1.0 },
				{ x: 0.6682, y: 0.8025, s: 0.061, c: '4E4E4E', a: 1.0 },
				{ x: 0.6662, y: 0.7841, s: 0.05, c: '4E4E4E', a: 1.0 },
				{ x: 0.6717, y: 0.7798, s: 0.05, c: '4F4F4F', a: 1.0 },
				{ x: 0.6647, y: 0.7668, s: 0.06, c: '4F4F4F', a: 1.0 },
				{ x: 0.6761, y: 0.7722, s: 0.041, c: '4E4E4E', a: 1.0 },
				{ x: 0.6691, y: 0.768, s: 0.034, c: '4C4C4C', a: 1.0 },
				{ x: 0.6748, y: 0.7556, s: 0.06, c: '4B4B4B', a: 1.0 },
				{ x: 0.6713, y: 0.744, s: 0.051, c: '565656', a: 1.0 },
				{ x: 0.6693, y: 0.7401, s: 0.083, c: '767676', a: 1.0 },
				{ x: 0.6757, y: 0.7206, s: 0.052, c: '717171', a: 1.0 },
				{ x: 0.667, y: 0.4463, s: 0.037, c: '373737', a: 1.0 },
				{ x: 0.6659, y: 0.4186, s: 0.034, c: '424242', a: 1.0 },
				{ x: 0.6723, y: 0.4229, s: 0.034, c: '343434', a: 1.0 },
				{ x: 0.6637, y: 0.3326, s: 0.043, c: '6A6A6A', a: 1.0 },
				{ x: 0.6759, y: 0.3295, s: 0.064, c: '747474', a: 1.0 },
				{ x: 0.6722, y: 0.952, s: 0.083, c: '8E8E8E', a: 1.0 },
				{ x: 0.6769, y: 0.9481, s: 0.094, c: 'B9B9B9', a: 1.0 },
				{ x: 0.6766, y: 0.93, s: 0.08, c: 'B9B9B9', a: 1.0 },
				{ x: 0.6688, y: 0.938, s: 0.161, c: 'CFCFCF', a: 1.0 },
				{ x: 0.6735, y: 0.9361, s: 0.08, c: 'CFCFCF', a: 1.0 },
				{ x: 0.6732, y: 0.918, s: 0.139, c: 'B3B3B3', a: 1.0 },
				{ x: 0.6779, y: 0.9261, s: 0.086, c: '747474', a: 1.0 },
				{ x: 0.6701, y: 0.9006, s: 0.054, c: '5F5F5F', a: 1.0 },
				{ x: 0.6698, y: 0.9056, s: 0.026, c: '313131', a: 1.0 },
				{ x: 0.6745, y: 0.8905, s: 0.044, c: '484848', a: 1.0 },
				{ x: 0.6669, y: 0.8896, s: 0.034, c: '232323', a: 1.0 },
				{ x: 0.6797, y: 0.8938, s: 0.028, c: '3C3C3C', a: 1.0 },
				{ x: 0.6712, y: 0.878, s: 0.039, c: '393939', a: 1.0 },
				{ x: 0.6773, y: 0.8778, s: 0.04, c: '272727', a: 1.0 },
				{ x: 0.6764, y: 0.8582, s: 0.027, c: '272727', a: 1.0 },
				{ x: 0.6675, y: 0.8662, s: 0.034, c: '393939', a: 1.0 },
				{ x: 0.6731, y: 0.8502, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.6776, y: 0.8544, s: 0.048, c: '4C4C4C', a: 1.0 },
				{ x: 0.6708, y: 0.8296, s: 0.052, c: '4C4C4C', a: 1.0 },
				{ x: 0.6686, y: 0.8384, s: 0.029, c: '4A4A4A', a: 1.0 },
				{ x: 0.6743, y: 0.8196, s: 0.033, c: '484848', a: 1.0 },
				{ x: 0.6671, y: 0.818, s: 0.044, c: '4B4B4B', a: 1.0 },
				{ x: 0.6715, y: 0.8079, s: 0.029, c: '4C4C4C', a: 1.0 },
				{ x: 0.6772, y: 0.8058, s: 0.035, c: '4C4C4C', a: 1.0 },
				{ x: 0.6753, y: 0.7904, s: 0.062, c: '4C4C4C', a: 1.0 },
				{ x: 0.6681, y: 0.7959, s: 0.029, c: '4D4D4D', a: 1.0 },
				{ x: 0.6739, y: 0.7924, s: 0.057, c: '4D4D4D', a: 1.0 },
				{ x: 0.6717, y: 0.7784, s: 0.039, c: '4D4D4D', a: 1.0 },
				{ x: 0.6783, y: 0.7838, s: 0.051, c: '4D4D4D', a: 1.0 },
				{ x: 0.6761, y: 0.7565, s: 0.056, c: '4E4E4E', a: 1.0 },
				{ x: 0.6685, y: 0.7664, s: 0.038, c: '4E4E4E', a: 1.0 },
				{ x: 0.6747, y: 0.748, s: 0.054, c: '4E4E4E', a: 1.0 },
				{ x: 0.6729, y: 0.7445, s: 0.042, c: '4D4D4D', a: 1.0 },
				{ x: 0.6785, y: 0.7558, s: 0.029, c: '4C4C4C', a: 1.0 },
				{ x: 0.6713, y: 0.736, s: 0.045, c: '565656', a: 1.0 },
				{ x: 0.6695, y: 0.7324, s: 0.081, c: '8A8A8A', a: 1.0 },
				{ x: 0.6756, y: 0.7199, s: 0.078, c: '6C6C6C', a: 1.0 },
				{ x: 0.668, y: 0.4187, s: 0.052, c: '424242', a: 1.0 },
				{ x: 0.6793, y: 0.4227, s: 0.038, c: '353535', a: 1.0 },
				{ x: 0.6758, y: 0.9546, s: 0.082, c: 'B9B9B9', a: 1.0 },
				{ x: 0.6801, y: 0.9346, s: 0.083, c: '8E8E8E', a: 1.0 },
				{ x: 0.6794, y: 0.946, s: 0.11, c: '8E8E8E', a: 1.0 },
				{ x: 0.6724, y: 0.9424, s: 0.099, c: 'A4A4A4', a: 1.0 },
				{ x: 0.6761, y: 0.9338, s: 0.025, c: '3F3F3F', a: 1.0 },
				{ x: 0.6825, y: 0.9065, s: 0.087, c: '7A7A7A', a: 1.0 },
				{ x: 0.6734, y: 0.9119, s: 0.034, c: '282828', a: 1.0 },
				{ x: 0.673, y: 0.8922, s: 0.019, c: '313131', a: 1.0 },
				{ x: 0.679, y: 0.8887, s: 0.047, c: '3C3C3C', a: 1.0 },
				{ x: 0.6703, y: 0.8941, s: 0.038, c: '545454', a: 1.0 },
				{ x: 0.6829, y: 0.8787, s: 0.031, c: '2E2E2E', a: 1.0 },
				{ x: 0.6743, y: 0.8719, s: 0.042, c: '393939', a: 1.0 },
				{ x: 0.6804, y: 0.8517, s: 0.04, c: '1D1D1D', a: 1.0 },
				{ x: 0.6797, y: 0.8612, s: 0.036, c: '343434', a: 1.0 },
				{ x: 0.671, y: 0.8587, s: 0.038, c: '626262', a: 1.0 },
				{ x: 0.6769, y: 0.8399, s: 0.06, c: '515151', a: 1.0 },
				{ x: 0.6766, y: 0.8492, s: 0.034, c: '535353', a: 1.0 },
				{ x: 0.6809, y: 0.823, s: 0.051, c: '4F4F4F', a: 1.0 },
				{ x: 0.6739, y: 0.828, s: 0.038, c: '4D4D4D', a: 1.0 },
				{ x: 0.6732, y: 0.8137, s: 0.058, c: '4B4B4B', a: 1.0 },
				{ x: 0.6779, y: 0.8113, s: 0.034, c: '4C4C4C', a: 1.0 },
				{ x: 0.6705, y: 0.8208, s: 0.042, c: '4C4C4C', a: 1.0 },
				{ x: 0.6832, y: 0.802, s: 0.054, c: '4B4B4B', a: 1.0 },
				{ x: 0.6745, y: 0.7997, s: 0.053, c: '4A4A4A', a: 1.0 },
				{ x: 0.6804, y: 0.7853, s: 0.047, c: '4A4A4A', a: 1.0 },
				{ x: 0.6784, y: 0.7888, s: 0.045, c: '494949', a: 1.0 },
				{ x: 0.6711, y: 0.7876, s: 0.032, c: '4A4A4A', a: 1.0 },
				{ x: 0.6775, y: 0.7734, s: 0.03, c: '4B4B4B', a: 1.0 },
				{ x: 0.6751, y: 0.7769, s: 0.038, c: '4E4E4E', a: 1.0 },
				{ x: 0.6814, y: 0.7522, s: 0.06, c: '4F4F4F', a: 1.0 },
				{ x: 0.6741, y: 0.7616, s: 0.04, c: '4F4F4F', a: 1.0 },
				{ x: 0.6717, y: 0.7413, s: 0.061, c: '515151', a: 1.0 },
				{ x: 0.678, y: 0.7389, s: 0.053, c: '535353', a: 1.0 },
				{ x: 0.6708, y: 0.7499, s: 0.05, c: '676767', a: 1.0 },
				{ x: 0.682, y: 0.7295, s: 0.107, c: '939393', a: 1.0 },
				{ x: 0.678, y: 0.9464, s: 0.061, c: 'A4A4A4', a: 1.0 },
				{ x: 0.6758, y: 0.9499, s: 0.048, c: '4C4C4C', a: 1.0 },
				{ x: 0.682, y: 0.9237, s: 0.061, c: '5B5B5B', a: 1.0 },
				{ x: 0.6748, y: 0.9094, s: 0.071, c: '5B5B5B', a: 1.0 },
				{ x: 0.6787, y: 0.888, s: 0.052, c: '545454', a: 1.0 },
				{ x: 0.6849, y: 0.8976, s: 0.056, c: '545454', a: 1.0 },
				{ x: 0.6827, y: 0.8954, s: 0.044, c: '3C3C3C', a: 1.0 },
				{ x: 0.6755, y: 0.8764, s: 0.04, c: '3A3A3A', a: 1.0 },
				{ x: 0.6816, y: 0.8855, s: 0.019, c: '222222', a: 1.0 },
				{ x: 0.6794, y: 0.8596, s: 0.063, c: '505050', a: 1.0 },
				{ x: 0.6767, y: 0.8443, s: 0.051, c: '595959', a: 1.0 },
				{ x: 0.6762, y: 0.8417, s: 0.039, c: '515151', a: 1.0 },
				{ x: 0.6822, y: 0.8456, s: 0.067, c: '555555', a: 1.0 },
				{ x: 0.6733, y: 0.8324, s: 0.031, c: '545454', a: 1.0 },
				{ x: 0.679, y: 0.8097, s: 0.049, c: '4D4D4D', a: 1.0 },
				{ x: 0.6835, y: 0.8203, s: 0.06, c: '4C4C4C', a: 1.0 },
				{ x: 0.683, y: 0.8183, s: 0.036, c: '4B4B4B', a: 1.0 },
				{ x: 0.6758, y: 0.7977, s: 0.041, c: '4B4B4B', a: 1.0 },
				{ x: 0.6803, y: 0.8075, s: 0.052, c: '494949', a: 1.0 },
				{ x: 0.6798, y: 0.7825, s: 0.045, c: '454545', a: 1.0 },
				{ x: 0.6858, y: 0.7864, s: 0.029, c: '474747', a: 1.0 },
				{ x: 0.6769, y: 0.7716, s: 0.055, c: '484848', a: 1.0 },
				{ x: 0.6764, y: 0.7695, s: 0.042, c: '494949', a: 1.0 },
				{ x: 0.6808, y: 0.7742, s: 0.034, c: '4E4E4E', a: 1.0 },
				{ x: 0.6737, y: 0.7599, s: 0.044, c: '4E4E4E', a: 1.0 },
				{ x: 0.6773, y: 0.7386, s: 0.033, c: '545454', a: 1.0 },
				{ x: 0.6845, y: 0.7484, s: 0.07, c: '585858', a: 1.0 },
				{ x: 0.6817, y: 0.7456, s: 0.05, c: '707070', a: 1.0 },
				{ x: 0.6739, y: 0.7316, s: 0.095, c: '939393', a: 1.0 },
				{ x: 0.6845, y: 0.9426, s: 0.075, c: '878787', a: 1.0 },
				{ x: 0.6817, y: 0.9517, s: 0.049, c: '494949', a: 1.0 },
				{ x: 0.6811, y: 0.9188, s: 0.091, c: '7A7A7A', a: 1.0 },
				{ x: 0.6838, y: 0.9081, s: 0.092, c: 'CFCFCF', a: 1.0 },
				{ x: 0.6776, y: 0.9065, s: 0.087, c: '6C6C6C', a: 1.0 },
				{ x: 0.6898, y: 0.8923, s: 0.043, c: '6C6C6C', a: 1.0 },
				{ x: 0.6803, y: 0.8966, s: 0.029, c: '202020', a: 1.0 },
				{ x: 0.6877, y: 0.8881, s: 0.047, c: '505050', a: 1.0 },
				{ x: 0.677, y: 0.8786, s: 0.055, c: '454545', a: 1.0 },
				{ x: 0.6842, y: 0.8464, s: 0.019, c: '343434', a: 1.0 },
				{ x: 0.6831, y: 0.8566, s: 0.055, c: '595959', a: 1.0 },
				{ x: 0.6869, y: 0.8364, s: 0.064, c: '4F4F4F', a: 1.0 },
				{ x: 0.6858, y: 0.8347, s: 0.035, c: '585858', a: 1.0 },
				{ x: 0.6797, y: 0.8442, s: 0.052, c: '585858', a: 1.0 },
				{ x: 0.6824, y: 0.8223, s: 0.062, c: '515151', a: 1.0 },
				{ x: 0.6801, y: 0.8127, s: 0.037, c: '4B4B4B', a: 1.0 },
				{ x: 0.679, y: 0.8104, s: 0.052, c: '484848', a: 1.0 },
				{ x: 0.6862, y: 0.7969, s: 0.052, c: '484848', a: 1.0 },
				{ x: 0.6768, y: 0.7944, s: 0.037, c: '454545', a: 1.0 },
				{ x: 0.689, y: 0.7749, s: 0.041, c: '454545', a: 1.0 },
				{ x: 0.6828, y: 0.7843, s: 0.032, c: '474747', a: 1.0 },
				{ x: 0.6883, y: 0.7826, s: 0.048, c: '494949', a: 1.0 },
				{ x: 0.6855, y: 0.7623, s: 0.057, c: '4C4C4C', a: 1.0 },
				{ x: 0.6796, y: 0.7726, s: 0.042, c: '4E4E4E', a: 1.0 },
				{ x: 0.6823, y: 0.7505, s: 0.064, c: '565656', a: 1.0 },
				{ x: 0.6816, y: 0.7345, s: 0.067, c: '828282', a: 1.0 },
				{ x: 0.6786, y: 0.7388, s: 0.056, c: '8A8A8A', a: 1.0 },
				{ x: 0.6813, y: 0.9345, s: 0.095, c: 'A1A1A1', a: 1.0 },
				{ x: 0.692, y: 0.9447, s: 0.055, c: '494949', a: 1.0 },
				{ x: 0.686, y: 0.9427, s: 0.028, c: '494949', a: 1.0 },
				{ x: 0.6913, y: 0.9229, s: 0.032, c: '464646', a: 1.0 },
				{ x: 0.6887, y: 0.9327, s: 0.054, c: '5B5B5B', a: 1.0 },
				{ x: 0.6807, y: 0.9068, s: 0.111, c: 'C7C7C7', a: 1.0 },
				{ x: 0.6881, y: 0.9107, s: 0.095, c: '818181', a: 1.0 },
				{ x: 0.685, y: 0.8968, s: 0.074, c: '676767', a: 1.0 },
				{ x: 0.6908, y: 0.8949, s: 0.054, c: '666666', a: 1.0 },
				{ x: 0.6845, y: 0.8988, s: 0.02, c: '262626', a: 1.0 },
				{ x: 0.6819, y: 0.8789, s: 0.05, c: '5A5A5A', a: 1.0 },
				{ x: 0.6811, y: 0.8629, s: 0.026, c: '1B1B1B', a: 1.0 },
				{ x: 0.6918, y: 0.8668, s: 0.041, c: '353535', a: 1.0 },
				{ x: 0.6838, y: 0.8648, s: 0.034, c: '2E2E2E', a: 1.0 },
				{ x: 0.6912, y: 0.8509, s: 0.024, c: '3A3A3A', a: 1.0 },
				{ x: 0.6899, y: 0.8548, s: 0.068, c: '565656', a: 1.0 },
				{ x: 0.6806, y: 0.8289, s: 0.045, c: '575757', a: 1.0 },
				{ x: 0.6876, y: 0.8388, s: 0.053, c: '5E5E5E', a: 1.0 },
				{ x: 0.6866, y: 0.8188, s: 0.052, c: '5C5C5C', a: 1.0 },
				{ x: 0.6842, y: 0.8267, s: 0.031, c: '525252', a: 1.0 },
				{ x: 0.6832, y: 0.8071, s: 0.038, c: '4F4F4F', a: 1.0 },
				{ x: 0.6869, y: 0.805, s: 0.06, c: '4A4A4A', a: 1.0 },
				{ x: 0.681, y: 0.791, s: 0.028, c: '4A4A4A', a: 1.0 },
				{ x: 0.6932, y: 0.795, s: 0.05, c: '454545', a: 1.0 },
				{ x: 0.6833, y: 0.7928, s: 0.036, c: '434343', a: 1.0 },
				{ x: 0.6822, y: 0.7789, s: 0.034, c: '454545', a: 1.0 },
				{ x: 0.6898, y: 0.7828, s: 0.056, c: '484848', a: 1.0 },
				{ x: 0.6801, y: 0.757, s: 0.036, c: '4C4C4C', a: 1.0 },
				{ x: 0.6922, y: 0.7668, s: 0.041, c: '4E4E4E', a: 1.0 },
				{ x: 0.6865, y: 0.7471, s: 0.06, c: '525252', a: 1.0 },
				{ x: 0.6904, y: 0.7451, s: 0.07, c: '595959', a: 1.0 },
				{ x: 0.6826, y: 0.7292, s: 0.087, c: '8D8D8D', a: 1.0 },
				{ x: 0.6869, y: 0.7373, s: 0.065, c: '7C7C7C', a: 1.0 },
				{ x: 0.6891, y: 0.9498, s: 0.101, c: 'BCBCBC', a: 1.0 },
				{ x: 0.6958, y: 0.9577, s: 0.095, c: 'A0A0A0', a: 1.0 },
				{ x: 0.6858, y: 0.9199, s: 0.082, c: '7F7F7F', a: 1.0 },
				{ x: 0.6895, y: 0.8924, s: 0.021, c: '353535', a: 1.0 },
				{ x: 0.6946, y: 0.8945, s: 0.069, c: '575757', a: 1.0 },
				{ x: 0.6918, y: 0.8727, s: 0.029, c: '4E4E4E', a: 1.0 },
				{ x: 0.6861, y: 0.8748, s: 0.04, c: '353535', a: 1.0 },
				{ x: 0.6917, y: 0.853, s: 0.051, c: '414141', a: 1.0 },
				{ x: 0.6884, y: 0.8489, s: 0.035, c: '222222', a: 1.0 },
				{ x: 0.6961, y: 0.8569, s: 0.053, c: '555555', a: 1.0 },
				{ x: 0.6883, y: 0.8352, s: 0.037, c: '575757', a: 1.0 },
				{ x: 0.685, y: 0.8372, s: 0.056, c: '5E5E5E', a: 1.0 },
				{ x: 0.6905, y: 0.8213, s: 0.049, c: '5E5E5E', a: 1.0 },
				{ x: 0.6849, y: 0.8234, s: 0.053, c: '595959', a: 1.0 },
				{ x: 0.6954, y: 0.8254, s: 0.069, c: '565656', a: 1.0 },
				{ x: 0.6871, y: 0.8036, s: 0.037, c: '545454', a: 1.0 },
				{ x: 0.6919, y: 0.7899, s: 0.053, c: '4C4C4C', a: 1.0 },
				{ x: 0.6839, y: 0.7918, s: 0.035, c: '474747', a: 1.0 },
				{ x: 0.6909, y: 0.776, s: 0.028, c: '444444', a: 1.0 },
				{ x: 0.6887, y: 0.7781, s: 0.05, c: '444444', a: 1.0 },
				{ x: 0.6941, y: 0.7801, s: 0.039, c: '454545', a: 1.0 },
				{ x: 0.6876, y: 0.7642, s: 0.036, c: '4B4B4B', a: 1.0 },
				{ x: 0.6863, y: 0.7662, s: 0.05, c: '4E4E4E', a: 1.0 },
				{ x: 0.6908, y: 0.7448, s: 0.055, c: '555555', a: 1.0 },
				{ x: 0.6844, y: 0.7523, s: 0.04, c: '595959', a: 1.0 },
				{ x: 0.6964, y: 0.7548, s: 0.07, c: '6E6E6E', a: 1.0 },
				{ x: 0.6875, y: 0.7328, s: 0.068, c: '959595', a: 1.0 },
				{ x: 0.6978, y: 0.9452, s: 0.04, c: '2C2C2C', a: 1.0 },
				{ x: 0.6867, y: 0.9314, s: 0.117, c: 'BCBCBC', a: 1.0 },
				{ x: 0.6945, y: 0.9331, s: 0.058, c: '606060', a: 1.0 },
				{ x: 0.6932, y: 0.9356, s: 0.064, c: '5B5B5B', a: 1.0 },
				{ x: 0.6955, y: 0.9219, s: 0.096, c: '7F7F7F', a: 1.0 },
				{ x: 0.69, y: 0.8998, s: 0.092, c: '999999', a: 1.0 },
				{ x: 0.6935, y: 0.9074, s: 0.067, c: 'A2A2A2', a: 1.0 },
				{ x: 0.6921, y: 0.9098, s: 0.076, c: 'BEBEBE', a: 1.0 },
				{ x: 0.6903, y: 0.8902, s: 0.064, c: '767676', a: 1.0 },
				{ x: 0.6871, y: 0.878, s: 0.063, c: '5A5A5A', a: 1.0 },
				{ x: 0.697, y: 0.8365, s: 0.043, c: '545454', a: 1.0 },
				{ x: 0.6957, y: 0.8448, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.6893, y: 0.8227, s: 0.062, c: '5E5E5E', a: 1.0 },
				{ x: 0.6946, y: 0.8251, s: 0.036, c: '5E5E5E', a: 1.0 },
				{ x: 0.6918, y: 0.8326, s: 0.045, c: '5C5C5C', a: 1.0 },
				{ x: 0.6997, y: 0.8112, s: 0.067, c: '585858', a: 1.0 },
				{ x: 0.6911, y: 0.813, s: 0.039, c: '565656', a: 1.0 },
				{ x: 0.6891, y: 0.7975, s: 0.044, c: '545454', a: 1.0 },
				{ x: 0.6963, y: 0.7992, s: 0.047, c: '4F4F4F', a: 1.0 },
				{ x: 0.6878, y: 0.8011, s: 0.049, c: '4A4A4A', a: 1.0 },
				{ x: 0.6991, y: 0.7851, s: 0.028, c: '474747', a: 1.0 },
				{ x: 0.693, y: 0.7878, s: 0.028, c: '464646', a: 1.0 },
				{ x: 0.6977, y: 0.766, s: 0.057, c: '464646', a: 1.0 },
				{ x: 0.6957, y: 0.7734, s: 0.032, c: '4A4A4A', a: 1.0 },
				{ x: 0.687, y: 0.7517, s: 0.037, c: '4E4E4E', a: 1.0 },
				{ x: 0.6942, y: 0.7544, s: 0.04, c: '555555', a: 1.0 },
				{ x: 0.6922, y: 0.7565, s: 0.057, c: '606060', a: 1.0 },
				{ x: 0.6969, y: 0.7399, s: 0.071, c: '757575', a: 1.0 },
				{ x: 0.6916, y: 0.7424, s: 0.061, c: '9B9B9B', a: 1.0 },
				{ x: 0.6889, y: 0.4647, s: 0.063, c: '656565', a: 1.0 },
				{ x: 0.6969, y: 0.9621, s: 0.034, c: '2C2C2C', a: 1.0 },
				{ x: 0.6916, y: 0.9411, s: 0.077, c: 'BCBCBC', a: 1.0 },
				{ x: 0.6935, y: 0.9266, s: 0.1, c: 'A0A0A0', a: 1.0 },
				{ x: 0.7015, y: 0.9287, s: 0.08, c: '7F7F7F', a: 1.0 },
				{ x: 0.6901, y: 0.9029, s: 0.145, c: 'BEBEBE', a: 1.0 },
				{ x: 0.6981, y: 0.9049, s: 0.099, c: 'F5F5F5', a: 1.0 },
				{ x: 0.6962, y: 0.8899, s: 0.144, c: 'D9D9D9', a: 1.0 },
				{ x: 0.6947, y: 0.8693, s: 0.125, c: 'B5B5B5', a: 1.0 },
				{ x: 0.6927, y: 0.8773, s: 0.105, c: 'B5B5B5', a: 1.0 },
				{ x: 0.6974, y: 0.8801, s: 0.058, c: '848484', a: 1.0 },
				{ x: 0.6913, y: 0.8583, s: 0.038, c: '414141', a: 1.0 },
				{ x: 0.7027, y: 0.8656, s: 0.039, c: '222222', a: 1.0 },
				{ x: 0.694, y: 0.8438, s: 0.029, c: '505050', a: 1.0 },
				{ x: 0.6919, y: 0.8465, s: 0.067, c: '545454', a: 1.0 },
				{ x: 0.702, y: 0.8348, s: 0.063, c: '5C5C5C', a: 1.0 },
				{ x: 0.696, y: 0.8129, s: 0.072, c: '5C5C5C', a: 1.0 },
				{ x: 0.7005, y: 0.8201, s: 0.068, c: '5B5B5B', a: 1.0 },
				{ x: 0.6987, y: 0.7987, s: 0.053, c: '5C5C5C', a: 1.0 },
				{ x: 0.6931, y: 0.8011, s: 0.044, c: '595959', a: 1.0 },
				{ x: 0.6972, y: 0.8095, s: 0.032, c: '545454', a: 1.0 },
				{ x: 0.7032, y: 0.7891, s: 0.042, c: '4A4A4A', a: 1.0 },
				{ x: 0.694, y: 0.7737, s: 0.055, c: '4B4B4B', a: 1.0 },
				{ x: 0.7, y: 0.7771, s: 0.056, c: '4C4C4C', a: 1.0 },
				{ x: 0.6911, y: 0.7616, s: 0.045, c: '515151', a: 1.0 },
				{ x: 0.6963, y: 0.7412, s: 0.076, c: '666666', a: 1.0 },
				{ x: 0.7012, y: 0.7496, s: 0.071, c: '838383', a: 1.0 },
				{ x: 0.6991, y: 0.7283, s: 0.065, c: '878787', a: 1.0 },
				{ x: 0.6964, y: 0.9638, s: 0.075, c: 'C0C0C0', a: 1.0 },
				{ x: 0.7011, y: 0.9424, s: 0.165, c: 'CCCCCC', a: 1.0 },
				{ x: 0.7064, y: 0.9279, s: 0.034, c: '2E2E2E', a: 1.0 },
				{ x: 0.6976, y: 0.9303, s: 0.02, c: '212121', a: 1.0 },
				{ x: 0.6958, y: 0.9327, s: 0.079, c: '717171', a: 1.0 },
				{ x: 0.6944, y: 0.9185, s: 0.052, c: '565656', a: 1.0 },
				{ x: 0.7055, y: 0.8912, s: 0.066, c: 'AEAEAE', a: 1.0 },
				{ x: 0.7043, y: 0.8766, s: 0.137, c: 'CBCBCB', a: 1.0 },
				{ x: 0.7021, y: 0.8791, s: 0.186, c: 'E9E9E9', a: 1.0 },
				{ x: 0.6937, y: 0.8813, s: 0.089, c: 'D0D0D0', a: 1.0 },
				{ x: 0.699, y: 0.8669, s: 0.13, c: 'D0D0D0', a: 1.0 },
				{ x: 0.6979, y: 0.8538, s: 0.123, c: 'BDBDBD', a: 1.0 },
				{ x: 0.7003, y: 0.8345, s: 0.024, c: '404040', a: 1.0 },
				{ x: 0.6946, y: 0.841, s: 0.067, c: '575757', a: 1.0 },
				{ x: 0.697, y: 0.8229, s: 0.051, c: '5F5F5F', a: 1.0 },
				{ x: 0.705, y: 0.8056, s: 0.074, c: '626262', a: 1.0 },
				{ x: 0.7026, y: 0.8091, s: 0.035, c: '606060', a: 1.0 },
				{ x: 0.6939, y: 0.8097, s: 0.049, c: '5D5D5D', a: 1.0 },
				{ x: 0.7015, y: 0.7939, s: 0.061, c: '595959', a: 1.0 },
				{ x: 0.7038, y: 0.7738, s: 0.035, c: '505050', a: 1.0 },
				{ x: 0.6982, y: 0.7819, s: 0.049, c: '505050', a: 1.0 },
				{ x: 0.6962, y: 0.7854, s: 0.053, c: '505050', a: 1.0 },
				{ x: 0.7004, y: 0.7622, s: 0.05, c: '515151', a: 1.0 },
				{ x: 0.6985, y: 0.7658, s: 0.035, c: '585858', a: 1.0 },
				{ x: 0.7061, y: 0.7499, s: 0.063, c: '5F5F5F', a: 1.0 },
				{ x: 0.6974, y: 0.7504, s: 0.078, c: '6E6E6E', a: 1.0 },
				{ x: 0.6951, y: 0.7539, s: 0.058, c: '939393', a: 1.0 },
				{ x: 0.6974, y: 0.9386, s: 0.073, c: '7F7F7F', a: 1.0 },
				{ x: 0.7031, y: 0.9233, s: 0.039, c: '222222', a: 1.0 },
				{ x: 0.7073, y: 0.9268, s: 0.035, c: '565656', a: 1.0 },
				{ x: 0.7044, y: 0.9151, s: 0.027, c: '3D3D3D', a: 1.0 },
				{ x: 0.702, y: 0.8976, s: 0.052, c: '575757', a: 1.0 },
				{ x: 0.71, y: 0.9012, s: 0.111, c: 'AEAEAE', a: 1.0 },
				{ x: 0.701, y: 0.9032, s: 0.125, c: 'E7E7E7', a: 1.0 },
				{ x: 0.6988, y: 0.886, s: 0.178, c: 'E7E7E7', a: 1.0 },
				{ x: 0.7065, y: 0.8895, s: 0.096, c: 'C1C1C1', a: 1.0 },
				{ x: 0.6977, y: 0.8664, s: 0.066, c: '808080', a: 1.0 },
				{ x: 0.7078, y: 0.8543, s: 0.098, c: 'B8B8B8', a: 1.0 },
				{ x: 0.7055, y: 0.8582, s: 0.18, c: 'F1F1F1', a: 1.0 },
				{ x: 0.6967, y: 0.8422, s: 0.044, c: '757575', a: 1.0 },
				{ x: 0.7045, y: 0.8423, s: 0.034, c: '404040', a: 1.0 },
				{ x: 0.7023, y: 0.8224, s: 0.07, c: '565656', a: 1.0 },
				{ x: 0.7068, y: 0.8301, s: 0.036, c: '5E5E5E', a: 1.0 },
				{ x: 0.7012, y: 0.831, s: 0.066, c: '626262', a: 1.0 },
				{ x: 0.6991, y: 0.8104, s: 0.058, c: '626262', a: 1.0 },
				{ x: 0.698, y: 0.7952, s: 0.043, c: '606060', a: 1.0 },
				{ x: 0.7091, y: 0.7991, s: 0.041, c: '5D5D5D', a: 1.0 },
				{ x: 0.7003, y: 0.7815, s: 0.071, c: '595959', a: 1.0 },
				{ x: 0.7081, y: 0.7831, s: 0.038, c: '575757', a: 1.0 },
				{ x: 0.7059, y: 0.7871, s: 0.049, c: '575757', a: 1.0 },
				{ x: 0.6971, y: 0.7695, s: 0.055, c: '555555', a: 1.0 },
				{ x: 0.7047, y: 0.7734, s: 0.044, c: '575757', a: 1.0 },
				{ x: 0.7025, y: 0.7512, s: 0.051, c: '5F5F5F', a: 1.0 },
				{ x: 0.7015, y: 0.7612, s: 0.077, c: '7E7E7E', a: 1.0 },
				{ x: 0.6994, y: 0.7383, s: 0.062, c: '878787', a: 1.0 },
				{ x: 0.7039, y: 0.9345, s: 0.079, c: 'B3B3B3', a: 1.0 },
				{ x: 0.7116, y: 0.9346, s: 0.09, c: '717171', a: 1.0 },
				{ x: 0.7094, y: 0.9146, s: 0.06, c: '999999', a: 1.0 },
				{ x: 0.7028, y: 0.9223, s: 0.058, c: '494949', a: 1.0 },
				{ x: 0.7038, y: 0.8973, s: 0.071, c: 'AEAEAE', a: 1.0 },
				{ x: 0.7092, y: 0.8679, s: 0.095, c: '7B7B7B', a: 1.0 },
				{ x: 0.7059, y: 0.8563, s: 0.105, c: '9C9C9C', a: 1.0 },
				{ x: 0.7014, y: 0.8599, s: 0.073, c: '9C9C9C', a: 1.0 },
				{ x: 0.7069, y: 0.8374, s: 0.05, c: '525252', a: 1.0 },
				{ x: 0.7024, y: 0.8443, s: 0.048, c: '404040', a: 1.0 },
				{ x: 0.7034, y: 0.8254, s: 0.04, c: '5D5D5D', a: 1.0 },
				{ x: 0.7123, y: 0.8319, s: 0.07, c: '616161', a: 1.0 },
				{ x: 0.7079, y: 0.8124, s: 0.062, c: '626262', a: 1.0 },
				{ x: 0.7001, y: 0.813, s: 0.056, c: '5E5E5E', a: 1.0 },
				{ x: 0.709, y: 0.7964, s: 0.063, c: '626262', a: 1.0 },
				{ x: 0.7045, y: 0.7999, s: 0.063, c: '626262', a: 1.0 },
				{ x: 0.7101, y: 0.8012, s: 0.074, c: '5F5F5F', a: 1.0 },
				{ x: 0.7056, y: 0.7846, s: 0.033, c: '5A5A5A', a: 1.0 },
				{ x: 0.71, y: 0.7656, s: 0.039, c: '5A5A5A', a: 1.0 },
				{ x: 0.7022, y: 0.7691, s: 0.038, c: '5C5C5C', a: 1.0 },
				{ x: 0.711, y: 0.7525, s: 0.049, c: '676767', a: 1.0 },
				{ x: 0.7121, y: 0.7573, s: 0.101, c: '868686', a: 1.0 },
				{ x: 0.7076, y: 0.74, s: 0.043, c: '626262', a: 1.0 },
				{ x: 0.7065, y: 0.9419, s: 0.174, c: 'DCDCDC', a: 1.0 },
				{ x: 0.7121, y: 0.9484, s: 0.074, c: 'CCCCCC', a: 1.0 },
				{ x: 0.7076, y: 0.9497, s: 0.058, c: '4A4A4A', a: 1.0 },
				{ x: 0.7087, y: 0.9364, s: 0.105, c: 'BEBEBE', a: 1.0 },
				{ x: 0.704, y: 0.9166, s: 0.059, c: '717171', a: 1.0 },
				{ x: 0.713, y: 0.9176, s: 0.076, c: 'B2B2B2', a: 1.0 },
				{ x: 0.7098, y: 0.9054, s: 0.08, c: '727272', a: 1.0 },
				{ x: 0.7151, y: 0.8827, s: 0.027, c: '474747', a: 1.0 },
				{ x: 0.7061, y: 0.8637, s: 0.106, c: 'C1C1C1', a: 1.0 },
				{ x: 0.7071, y: 0.8746, s: 0.106, c: '9F9F9F', a: 1.0 },
				{ x: 0.7161, y: 0.8517, s: 0.052, c: '7D7D7D', a: 1.0 },
				{ x: 0.7038, y: 0.8387, s: 0.04, c: '282828', a: 1.0 },
				{ x: 0.7129, y: 0.8396, s: 0.048, c: '404040', a: 1.0 },
				{ x: 0.7082, y: 0.8436, s: 0.046, c: '505050', a: 1.0 },
				{ x: 0.7139, y: 0.8268, s: 0.042, c: '5A5A5A', a: 1.0 },
				{ x: 0.7092, y: 0.8277, s: 0.045, c: '5F5F5F', a: 1.0 },
				{ x: 0.705, y: 0.8078, s: 0.041, c: '5F5F5F', a: 1.0 },
				{ x: 0.7103, y: 0.8147, s: 0.076, c: '5E5E5E', a: 1.0 },
				{ x: 0.7058, y: 0.7917, s: 0.04, c: '606060', a: 1.0 },
				{ x: 0.7149, y: 0.7956, s: 0.043, c: '606060', a: 1.0 },
				{ x: 0.7069, y: 0.8025, s: 0.051, c: '5F5F5F', a: 1.0 },
				{ x: 0.7113, y: 0.7838, s: 0.069, c: '5C5C5C', a: 1.0 },
				{ x: 0.7037, y: 0.7669, s: 0.035, c: '5D5D5D', a: 1.0 },
				{ x: 0.7091, y: 0.7586, s: 0.104, c: '8D8D8D', a: 1.0 },
				{ x: 0.708, y: 0.9569, s: 0.118, c: 'CECECE', a: 1.0 },
				{ x: 0.7137, y: 0.935, s: 0.056, c: '7A7A7A', a: 1.0 },
				{ x: 0.7088, y: 0.9398, s: 0.026, c: '0D0D0D', a: 1.0 },
				{ x: 0.7177, y: 0.9448, s: 0.052, c: '7A7A7A', a: 1.0 },
				{ x: 0.7102, y: 0.9231, s: 0.2, c: 'F5F5F5', a: 1.0 },
				{ x: 0.7142, y: 0.9063, s: 0.158, c: 'D7D7D7', a: 1.0 },
				{ x: 0.7157, y: 0.9165, s: 0.119, c: 'C3C3C3', a: 1.0 },
				{ x: 0.7109, y: 0.8947, s: 0.075, c: 'B7B7B7', a: 1.0 },
				{ x: 0.7198, y: 0.8997, s: 0.032, c: '282828', a: 1.0 },
				{ x: 0.7124, y: 0.8809, s: 0.081, c: '717171', a: 1.0 },
				{ x: 0.7079, y: 0.8826, s: 0.111, c: 'ECECEC', a: 1.0 },
				{ x: 0.7163, y: 0.8639, s: 0.093, c: 'F4F4F4', a: 1.0 },
				{ x: 0.7085, y: 0.8689, s: 0.102, c: 'BDBDBD', a: 1.0 },
				{ x: 0.7178, y: 0.871, s: 0.081, c: '888888', a: 1.0 },
				{ x: 0.7132, y: 0.8522, s: 0.117, c: 'A4A4A4', a: 1.0 },
				{ x: 0.7184, y: 0.8543, s: 0.103, c: 'C3C3C3', a: 1.0 },
				{ x: 0.7144, y: 0.8355, s: 0.064, c: '666666', a: 1.0 },
				{ x: 0.7099, y: 0.8404, s: 0.031, c: '414141', a: 1.0 },
				{ x: 0.715, y: 0.8425, s: 0.059, c: '4C4C4C', a: 1.0 },
				{ x: 0.7106, y: 0.8237, s: 0.049, c: '535353', a: 1.0 },
				{ x: 0.7198, y: 0.8287, s: 0.047, c: '5A5A5A', a: 1.0 },
				{ x: 0.712, y: 0.8069, s: 0.054, c: '5C5C5C', a: 1.0 },
				{ x: 0.7072, y: 0.8118, s: 0.038, c: '5F5F5F', a: 1.0 },
				{ x: 0.716, y: 0.7932, s: 0.074, c: '5E5E5E', a: 1.0 },
				{ x: 0.7086, y: 0.795, s: 0.05, c: '5F5F5F', a: 1.0 },
				{ x: 0.7175, y: 0.8001, s: 0.052, c: '5E5E5E', a: 1.0 },
				{ x: 0.7127, y: 0.7783, s: 0.058, c: '5B5B5B', a: 1.0 },
				{ x: 0.7186, y: 0.7834, s: 0.056, c: '5B5B5B', a: 1.0 },
				{ x: 0.7141, y: 0.7644, s: 0.056, c: '5E5E5E', a: 1.0 },
				{ x: 0.7092, y: 0.7665, s: 0.045, c: '666666', a: 1.0 },
				{ x: 0.7107, y: 0.7528, s: 0.114, c: '8C8C8C', a: 1.0 },
				{ x: 0.7194, y: 0.7545, s: 0.056, c: '7D7D7D', a: 1.0 },
				{ x: 0.7181, y: 0.9552, s: 0.106, c: 'B1B1B1', a: 1.0 },
				{ x: 0.7194, y: 0.9384, s: 0.079, c: '979797', a: 1.0 },
				{ x: 0.7148, y: 0.9408, s: 0.113, c: 'CECECE', a: 1.0 },
				{ x: 0.7201, y: 0.9218, s: 0.098, c: 'F5F5F5', a: 1.0 },
				{ x: 0.7115, y: 0.905, s: 0.105, c: '989898', a: 1.0 },
				{ x: 0.7168, y: 0.9097, s: 0.026, c: '202020', a: 1.0 },
				{ x: 0.7121, y: 0.9151, s: 0.063, c: '636363', a: 1.0 },
				{ x: 0.7183, y: 0.8817, s: 0.17, c: 'D8D8D8', a: 1.0 },
				{ x: 0.7189, y: 0.8674, s: 0.085, c: '6C6C6C', a: 1.0 },
				{ x: 0.7142, y: 0.8697, s: 0.048, c: '7F7F7F', a: 1.0 },
				{ x: 0.7204, y: 0.8506, s: 0.171, c: 'E3E3E3', a: 1.0 },
				{ x: 0.7157, y: 0.853, s: 0.125, c: 'C3C3C3', a: 1.0 },
				{ x: 0.711, y: 0.8338, s: 0.043, c: '575757', a: 1.0 },
				{ x: 0.7197, y: 0.8392, s: 0.026, c: '393939', a: 1.0 },
				{ x: 0.7123, y: 0.8408, s: 0.061, c: '4C4C4C', a: 1.0 },
				{ x: 0.7163, y: 0.8273, s: 0.037, c: '555555', a: 1.0 },
				{ x: 0.7224, y: 0.8052, s: 0.034, c: '585858', a: 1.0 },
				{ x: 0.7177, y: 0.8106, s: 0.057, c: '5C5C5C', a: 1.0 },
				{ x: 0.7131, y: 0.8153, s: 0.056, c: '5C5C5C', a: 1.0 },
				{ x: 0.7145, y: 0.7984, s: 0.072, c: '5C5C5C', a: 1.0 },
				{ x: 0.7152, y: 0.7815, s: 0.058, c: '5B5B5B', a: 1.0 },
				{ x: 0.7124, y: 0.7696, s: 0.068, c: '7D7D7D', a: 1.0 },
				{ x: 0.7204, y: 0.7508, s: 0.096, c: '959595', a: 1.0 },
				{ x: 0.7192, y: 0.9431, s: 0.075, c: 'C1C1C1', a: 1.0 },
				{ x: 0.7166, y: 0.9315, s: 0.05, c: '616161', a: 1.0 },
				{ x: 0.7221, y: 0.9336, s: 0.157, c: 'C7C7C7', a: 1.0 },
				{ x: 0.717, y: 0.914, s: 0.126, c: 'F5F5F5', a: 1.0 },
				{ x: 0.7135, y: 0.9021, s: 0.071, c: '585858', a: 1.0 },
				{ x: 0.7232, y: 0.9071, s: 0.081, c: 'D1D1D1', a: 1.0 },
				{ x: 0.7178, y: 0.886, s: 0.107, c: '888888', a: 1.0 },
				{ x: 0.7234, y: 0.8911, s: 0.046, c: '7C7C7C', a: 1.0 },
				{ x: 0.7198, y: 0.8715, s: 0.156, c: 'D0D0D0', a: 1.0 },
				{ x: 0.7145, y: 0.8735, s: 0.071, c: '7F7F7F', a: 1.0 },
				{ x: 0.7164, y: 0.8597, s: 0.069, c: 'ACACAC', a: 1.0 },
				{ x: 0.7244, y: 0.8618, s: 0.042, c: '616161', a: 1.0 },
				{ x: 0.7263, y: 0.8398, s: 0.046, c: '393939', a: 1.0 },
				{ x: 0.721, y: 0.8441, s: 0.028, c: '494949', a: 1.0 },
				{ x: 0.714, y: 0.8252, s: 0.049, c: '4E4E4E', a: 1.0 },
				{ x: 0.7221, y: 0.828, s: 0.048, c: '545454', a: 1.0 },
				{ x: 0.7176, y: 0.8092, s: 0.052, c: '5A5A5A', a: 1.0 },
				{ x: 0.7187, y: 0.7924, s: 0.069, c: '5B5B5B', a: 1.0 },
				{ x: 0.7205, y: 0.8013, s: 0.07, c: '5A5A5A', a: 1.0 },
				{ x: 0.7152, y: 0.78, s: 0.065, c: '5B5B5B', a: 1.0 },
				{ x: 0.7248, y: 0.7854, s: 0.057, c: '5E5E5E', a: 1.0 },
				{ x: 0.725, y: 0.768, s: 0.044, c: '747474', a: 1.0 },
				{ x: 0.7216, y: 0.7734, s: 0.063, c: '8C8C8C', a: 1.0 },
				{ x: 0.7161, y: 0.752, s: 0.073, c: '797979', a: 1.0 },
				{ x: 0.7295, y: 0.9299, s: 0.037, c: '373737', a: 1.0 },
				{ x: 0.7218, y: 0.9339, s: 0.03, c: '000000', a: 1.0 },
				{ x: 0.718, y: 0.9363, s: 0.071, c: '898989', a: 1.0 },
				{ x: 0.728, y: 0.9005, s: 0.083, c: 'A9A9A9', a: 1.0 },
				{ x: 0.7225, y: 0.9057, s: 0.073, c: 'B7B7B7', a: 1.0 },
				{ x: 0.7248, y: 0.8886, s: 0.052, c: '585858', a: 1.0 },
				{ x: 0.7258, y: 0.8725, s: 0.141, c: 'E1E1E1', a: 1.0 },
				{ x: 0.7202, y: 0.8779, s: 0.161, c: 'ECECEC', a: 1.0 },
				{ x: 0.7222, y: 0.8604, s: 0.086, c: '757575', a: 1.0 },
				{ x: 0.7171, y: 0.8658, s: 0.02, c: '222222', a: 1.0 },
				{ x: 0.7266, y: 0.8444, s: 0.033, c: '222222', a: 1.0 },
				{ x: 0.7188, y: 0.8426, s: 0.034, c: '393939', a: 1.0 },
				{ x: 0.7232, y: 0.8266, s: 0.063, c: '4E4E4E', a: 1.0 },
				{ x: 0.7289, y: 0.8305, s: 0.039, c: '545454', a: 1.0 },
				{ x: 0.7233, y: 0.8121, s: 0.053, c: '5A5A5A', a: 1.0 },
				{ x: 0.72, y: 0.8144, s: 0.066, c: '5B5B5B', a: 1.0 },
				{ x: 0.7278, y: 0.7948, s: 0.041, c: '585858', a: 1.0 },
				{ x: 0.7202, y: 0.7998, s: 0.051, c: '575757', a: 1.0 },
				{ x: 0.7297, y: 0.8033, s: 0.06, c: '585858', a: 1.0 },
				{ x: 0.7242, y: 0.7828, s: 0.072, c: '5B5B5B', a: 1.0 },
				{ x: 0.717, y: 0.7878, s: 0.067, c: '5E5E5E', a: 1.0 },
				{ x: 0.7266, y: 0.7675, s: 0.057, c: '6C6C6C', a: 1.0 },
				{ x: 0.7209, y: 0.7711, s: 0.054, c: '898989', a: 1.0 },
				{ x: 0.7273, y: 0.7507, s: 0.095, c: '828282', a: 1.0 },
				{ x: 0.7265, y: 0.9618, s: 0.131, c: 'D3D3D3', a: 1.0 },
				{ x: 0.7212, y: 0.9416, s: 0.094, c: 'A1A1A1', a: 1.0 },
				{ x: 0.731, y: 0.9295, s: 0.121, c: 'A0A0A0', a: 1.0 },
				{ x: 0.7319, y: 0.9143, s: 0.143, c: 'D0D0D0', a: 1.0 },
				{ x: 0.7208, y: 0.8976, s: 0.055, c: '606060', a: 1.0 },
				{ x: 0.7247, y: 0.8823, s: 0.091, c: '7B7B7B', a: 1.0 },
				{ x: 0.7307, y: 0.8858, s: 0.085, c: '8D8D8D', a: 1.0 },
				{ x: 0.7213, y: 0.8705, s: 0.116, c: 'BEBEBE', a: 1.0 },
				{ x: 0.722, y: 0.8538, s: 0.033, c: '1C1C1C', a: 1.0 },
				{ x: 0.7313, y: 0.8514, s: 0.025, c: '1F1F1F', a: 1.0 },
				{ x: 0.726, y: 0.8503, s: 0.046, c: '3B3B3B', a: 1.0 },
				{ x: 0.7283, y: 0.8335, s: 0.052, c: '515151', a: 1.0 },
				{ x: 0.7226, y: 0.8133, s: 0.04, c: '555555', a: 1.0 },
				{ x: 0.7289, y: 0.8183, s: 0.034, c: '585858', a: 1.0 },
				{ x: 0.7325, y: 0.8016, s: 0.049, c: '565656', a: 1.0 },
				{ x: 0.7256, y: 0.8062, s: 0.05, c: '565656', a: 1.0 },
				{ x: 0.7215, y: 0.7863, s: 0.068, c: '585858', a: 1.0 },
				{ x: 0.7223, y: 0.7697, s: 0.055, c: '646464', a: 1.0 },
				{ x: 0.73, y: 0.7743, s: 0.091, c: '7E7E7E', a: 1.0 },
				{ x: 0.7262, y: 0.7782, s: 0.067, c: '858585', a: 1.0 },
				{ x: 0.7357, y: 0.9587, s: 0.086, c: '9F9F9F', a: 1.0 },
				{ x: 0.7301, y: 0.9388, s: 0.123, c: 'B3B3B3', a: 1.0 },
				{ x: 0.7263, y: 0.942, s: 0.066, c: '8F8F8F', a: 1.0 },
				{ x: 0.7324, y: 0.9459, s: 0.044, c: '6B6B6B', a: 1.0 },
				{ x: 0.7268, y: 0.9268, s: 0.091, c: '979797', a: 1.0 },
				{ x: 0.7363, y: 0.9307, s: 0.101, c: '8E8E8E', a: 1.0 },
				{ x: 0.7291, y: 0.9101, s: 0.134, c: 'BEBEBE', a: 1.0 },
				{ x: 0.7236, y: 0.9141, s: 0.155, c: 'DCDCDC', a: 1.0 },
				{ x: 0.733, y: 0.8948, s: 0.1, c: 'ABABAB', a: 1.0 },
				{ x: 0.7275, y: 0.8987, s: 0.156, c: 'CFCFCF', a: 1.0 },
				{ x: 0.7243, y: 0.8868, s: 0.087, c: 'BEBEBE', a: 1.0 },
				{ x: 0.7303, y: 0.8662, s: 0.027, c: '2F2F2F', a: 1.0 },
				{ x: 0.7265, y: 0.8701, s: 0.022, c: '2F2F2F', a: 1.0 },
				{ x: 0.7343, y: 0.8747, s: 0.028, c: '1C1C1C', a: 1.0 },
				{ x: 0.7271, y: 0.8548, s: 0.035, c: '2A2A2A', a: 1.0 },
				{ x: 0.7366, y: 0.846, s: 0.048, c: '424242', a: 1.0 },
				{ x: 0.7311, y: 0.8262, s: 0.059, c: '4E4E4E', a: 1.0 },
				{ x: 0.7239, y: 0.831, s: 0.029, c: '515151', a: 1.0 },
				{ x: 0.7318, y: 0.8104, s: 0.065, c: '575757', a: 1.0 },
				{ x: 0.7277, y: 0.8144, s: 0.07, c: '5A5A5A', a: 1.0 },
				{ x: 0.7284, y: 0.7989, s: 0.048, c: '585858', a: 1.0 },
				{ x: 0.7245, y: 0.8028, s: 0.062, c: '5B5B5B', a: 1.0 },
				{ x: 0.7306, y: 0.7825, s: 0.07, c: '5F5F5F', a: 1.0 },
				{ x: 0.7337, y: 0.9492, s: 0.116, c: 'BDBDBD', a: 1.0 },
				{ x: 0.7276, y: 0.929, s: 0.133, c: 'BDBDBD', a: 1.0 },
				{ x: 0.7364, y: 0.9333, s: 0.057, c: '6B6B6B', a: 1.0 },
				{ x: 0.7303, y: 0.9369, s: 0.071, c: '5B5B5B', a: 1.0 },
				{ x: 0.7392, y: 0.9174, s: 0.03, c: '525252', a: 1.0 },
				{ x: 0.7329, y: 0.9209, s: 0.062, c: '525252', a: 1.0 },
				{ x: 0.7268, y: 0.9011, s: 0.17, c: 'DCDCDC', a: 1.0 },
				{ x: 0.7367, y: 0.8894, s: 0.044, c: '696969', a: 1.0 },
				{ x: 0.7324, y: 0.893, s: 0.042, c: '696969', a: 1.0 },
				{ x: 0.7396, y: 0.8734, s: 0.069, c: '555555', a: 1.0 },
				{ x: 0.7289, y: 0.8514, s: 0.028, c: '1C1C1C', a: 1.0 },
				{ x: 0.7361, y: 0.8549, s: 0.028, c: '2A2A2A', a: 1.0 },
				{ x: 0.7388, y: 0.8337, s: 0.046, c: '484848', a: 1.0 },
				{ x: 0.7327, y: 0.8372, s: 0.065, c: '535353', a: 1.0 },
				{ x: 0.7282, y: 0.8177, s: 0.032, c: '555555', a: 1.0 },
				{ x: 0.7354, y: 0.8212, s: 0.063, c: '5C5C5C', a: 1.0 },
				{ x: 0.7293, y: 0.8253, s: 0.058, c: '606060', a: 1.0 },
				{ x: 0.7382, y: 0.8051, s: 0.072, c: '5D5D5D', a: 1.0 },
				{ x: 0.7392, y: 0.7892, s: 0.052, c: '646464', a: 1.0 },
				{ x: 0.7348, y: 0.7934, s: 0.045, c: '6B6B6B', a: 1.0 },
				{ x: 0.7286, y: 0.7973, s: 0.051, c: '7E7E7E', a: 1.0 },
				{ x: 0.7375, y: 0.7774, s: 0.091, c: '707070', a: 1.0 },
				{ x: 0.7374, y: 0.93, s: 0.091, c: 'B3B3B3', a: 1.0 },
				{ x: 0.7313, y: 0.9339, s: 0.105, c: 'B3B3B3', a: 1.0 },
				{ x: 0.7384, y: 0.9378, s: 0.041, c: '5B5B5B', a: 1.0 },
				{ x: 0.7342, y: 0.918, s: 0.041, c: '525252', a: 1.0 },
				{ x: 0.7411, y: 0.9219, s: 0.072, c: '5B5B5B', a: 1.0 },
				{ x: 0.7351, y: 0.902, s: 0.092, c: 'A9A9A9', a: 1.0 },
				{ x: 0.7332, y: 0.8899, s: 0.034, c: '1E1E1E', a: 1.0 },
				{ x: 0.7405, y: 0.8939, s: 0.033, c: '1E1E1E', a: 1.0 },
				{ x: 0.7346, y: 0.874, s: 0.022, c: '2F2F2F', a: 1.0 },
				{ x: 0.7432, y: 0.8778, s: 0.031, c: '252525', a: 1.0 },
				{ x: 0.7372, y: 0.8579, s: 0.037, c: '1C1C1C', a: 1.0 },
				{ x: 0.7309, y: 0.8621, s: 0.019, c: '1C1C1C', a: 1.0 },
				{ x: 0.7399, y: 0.8541, s: 0.051, c: '484848', a: 1.0 },
				{ x: 0.7335, y: 0.8342, s: 0.042, c: '4E4E4E', a: 1.0 },
				{ x: 0.7409, y: 0.8381, s: 0.053, c: '5A5A5A', a: 1.0 },
				{ x: 0.7363, y: 0.8182, s: 0.067, c: '5C5C5C', a: 1.0 },
				{ x: 0.7302, y: 0.8221, s: 0.065, c: '636363', a: 1.0 },
				{ x: 0.7376, y: 0.8259, s: 0.056, c: '656565', a: 1.0 },
				{ x: 0.733, y: 0.806, s: 0.056, c: '646464', a: 1.0 },
				{ x: 0.7357, y: 0.7901, s: 0.085, c: '747474', a: 1.0 },
				{ x: 0.7431, y: 0.7942, s: 0.064, c: '797979', a: 1.0 },
				{ x: 0.7367, y: 0.7743, s: 0.049, c: '606060', a: 1.0 },
				{ x: 0.7358, y: 0.9607, s: 0.082, c: 'CACACA', a: 1.0 },
				{ x: 0.7428, y: 0.9521, s: 0.121, c: '979797', a: 1.0 },
				{ x: 0.7367, y: 0.9363, s: 0.04, c: '616161', a: 1.0 },
				{ x: 0.7458, y: 0.9443, s: 0.068, c: '616161', a: 1.0 },
				{ x: 0.7334, y: 0.9008, s: 0.031, c: '3C3C3C', a: 1.0 },
				{ x: 0.7421, y: 0.9085, s: 0.054, c: '5D5D5D', a: 1.0 },
				{ x: 0.7362, y: 0.8927, s: 0.027, c: '3E3E3E', a: 1.0 },
				{ x: 0.7449, y: 0.8948, s: 0.038, c: '1B1B1B', a: 1.0 },
				{ x: 0.739, y: 0.8789, s: 0.029, c: '242424', a: 1.0 },
				{ x: 0.7462, y: 0.8333, s: 0.037, c: '494949', a: 1.0 },
				{ x: 0.7414, y: 0.8415, s: 0.061, c: '525252', a: 1.0 },
				{ x: 0.7429, y: 0.8336, s: 0.058, c: '616161', a: 1.0 },
				{ x: 0.738, y: 0.8178, s: 0.069, c: '656565', a: 1.0 },
				{ x: 0.7452, y: 0.8256, s: 0.079, c: '686868', a: 1.0 },
				{ x: 0.7394, y: 0.8098, s: 0.075, c: '707070', a: 1.0 },
				{ x: 0.7349, y: 0.794, s: 0.073, c: '707070', a: 1.0 },
				{ x: 0.7417, y: 0.8021, s: 0.034, c: '5F5F5F', a: 1.0 },
				{ x: 0.7405, y: 0.9608, s: 0.159, c: 'CACACA', a: 1.0 },
				{ x: 0.7481, y: 0.945, s: 0.086, c: '7A7A7A', a: 1.0 },
				{ x: 0.7418, y: 0.9292, s: 0.044, c: '474747', a: 1.0 },
				{ x: 0.7448, y: 0.9095, s: 0.041, c: '151515', a: 1.0 },
				{ x: 0.7387, y: 0.9114, s: 0.074, c: '6C6C6C', a: 1.0 },
				{ x: 0.7472, y: 0.8956, s: 0.038, c: '4E4E4E', a: 1.0 },
				{ x: 0.741, y: 0.8798, s: 0.022, c: '303030', a: 1.0 },
				{ x: 0.7486, y: 0.8461, s: 0.048, c: '494949', a: 1.0 },
				{ x: 0.7442, y: 0.8302, s: 0.046, c: '525252', a: 1.0 },
				{ x: 0.7376, y: 0.8383, s: 0.06, c: '575757', a: 1.0 },
				{ x: 0.7452, y: 0.8224, s: 0.062, c: '5A5A5A', a: 1.0 },
				{ x: 0.7407, y: 0.8304, s: 0.043, c: '575757', a: 1.0 },
				{ x: 0.7475, y: 0.8145, s: 0.06, c: '505050', a: 1.0 },
				{ x: 0.7464, y: 0.9556, s: 0.031, c: '474747', a: 1.0 },
				{ x: 0.7406, y: 0.9275, s: 0.02, c: '161616', a: 1.0 },
				{ x: 0.7479, y: 0.924, s: 0.024, c: '181818', a: 1.0 },
				{ x: 0.743, y: 0.8959, s: 0.03, c: '2E2E2E', a: 1.0 },
				{ x: 0.7444, y: 0.8882, s: 0.028, c: '1B1B1B', a: 1.0 },
				{ x: 0.7529, y: 0.8727, s: 0.031, c: '303030', a: 1.0 },
				{ x: 0.7502, y: 0.9476, s: 0.027, c: '121212', a: 1.0 },
				{ x: 0.7446, y: 0.956, s: 0.041, c: '161616', a: 1.0 },
				{ x: 0.7532, y: 0.8921, s: 0.026, c: '282828', a: 1.0 },
				{ x: 0.7469, y: 0.8767, s: 0.028, c: '2E2E2E', a: 1.0 },
				{ x: 0.7588, y: 0.8869, s: 0.024, c: '2C2C2C', a: 1.0 },
				{ x: 0.7566, y: 0.9326, s: 0.04, c: '202020', a: 1.0 },
				{ x: 0.7502, y: 0.9402, s: 0.037, c: '2C2C2C', a: 1.0 }
			]
		};
	},

	debugLogo() {},

	ladyR() {
		let l = this.lady();
		l.points = l.points.map((p) => {
			p.s = 0.1 - p.s;
			p.a = 1;
			return p;
		});
		return l;
	},

	toMatrix(json) {
		var points = [];
		for (var i = 0; i < json.points.length; i++) {
			points.push([json.points[i].x, json.points[i].y, json.points[i].s, '#' + json.points[i].c, json.points[i].a]);
		}

		return points;
	},

	toPixelStyleData(json, ref) {
		var points = [];

		var height = json.h * 26;
		var width = json.w * 26;

		for (var i = 0; i < json.points.length; i++) {
			points.push({
				x: json.points[i].x,
				y: json.points[i].y,
				radius: json.points[i].s / 0.13,
				rgba: '#ffffff',
				alpha: json.points[i].s / 0.13,
				col: null,
				row: null
			});
		}

		return {
			ref: ref,
			size: { w: width, h: height },
			position: { x: -1000, y: 0 },
			frame: { w: width, h: height, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			pixelData: points
		};
	}
};
